(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var b2bApp = angular.module('b2bApp', [
    'b2bRegistrationFlowBundle',
]);

b2bApp.constant('skyapi', skyapi);
b2bApp.constant('isFreeRedirect', isFreeRedirect);
b2bApp.constant('spContactEmailSessionKey', 'sp-contact-email');

require('../../../src/B2bRegistrationFlowBundle/Resources/private/bundle.js');
window.Translator = require('./libraries/bazingajstranslation/js/translator');

},{"../../../src/B2bRegistrationFlowBundle/Resources/private/bundle.js":35,"./libraries/bazingajstranslation/js/translator":5}],2:[function(require,module,exports){
/** nmccready/angular-simple-logger/0.1.7 **/
!function e(r,n,o){function t(i,u){if(!n[i]){if(!r[i]){var a="function"==typeof require&&require;if(!u&&a)return a(i,!0);if(s)return s(i,!0);var c=new Error("Cannot find module '"+i+"'");throw c.code="MODULE_NOT_FOUND",c}var l=n[i]={exports:{}};r[i][0].call(l.exports,function(e){var n=r[i][1][e];return t(n?n:e)},l,l.exports,e,r,n,o)}return n[i].exports}for(var s="function"==typeof require&&require,i=0;i<o.length;i++)t(o[i]);return t}({1:[function(e,r,n){angular.module("nemLogging",[]),angular.module("nemLogging").provider("nemDebug",function(){var r=null;return r=e("debug"),this.$get=function(){return r},this.debug=r,this});var o=function(e,r){return function(){return e.apply(r,arguments)}},t=[].slice;angular.module("nemLogging").provider("nemSimpleLogger",["nemDebugProvider",function(e){var r,n,s,i,u,a,c,l,f,g,d,h;for(d=e.debug,s={},i=["debug","info","warn","error","log"],r={},f=l=0,g=i.length;g>l;f=++l)h=i[f],r[h]=f;return a=function(e,r,n){return e>=r?n():void 0},u=function(e){var r,n,o;if(r=!1,!e)return r;for(n=0,o=i.length;o>n&&(h=i[n],r=null!=e[h]&&"function"==typeof e[h],r);n++);return r},c=function(e,r){var n,o,t,u;for(null==s[e]&&(s[e]=d(e)),n=s[e],u={},o=0,t=i.length;t>o;o++)h=i[o],u[h]="debug"===h?n:r[h];return u},n=function(){function e(e){var n,s,c,l,f;if(this.$log=e,this.spawn=o(this.spawn,this),!this.$log)throw"internalLogger undefined";if(!u(this.$log))throw"@$log is invalid";for(this.doLog=!0,f={},n=function(e){return function(n){return f[n]=function(){var o;return o=1<=arguments.length?t.call(arguments,0):[],e.doLog?a(r[n],e.currentLevel,function(){var r;return(r=e.$log)[n].apply(r,o)}):void 0},e[n]=f[n]}}(this),s=0,c=i.length;c>s;s++)l=i[s],n(l);this.LEVELS=r,this.currentLevel=r.error}return e.prototype.spawn=function(r){if("string"==typeof r){if(!u(this.$log))throw"@$log is invalid";if(!d)throw"nemDebug is undefined this is probably the light version of this library sep debug logggers is not supported!";return c(r,this.$log)}return new e(r||this.$log)},e}(),this.decorator=["$log",function(e){var o;return o=new n(e),o.currentLevel=r.debug,o}],this.$get=["$log",function(e){return new n(e)}],this}])},{debug:2}],2:[function(e,r,n){function o(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}function t(){var e=arguments,r=this.useColors;if(e[0]=(r?"%c":"")+this.namespace+(r?" %c":" ")+e[0]+(r?"%c ":" ")+"+"+n.humanize(this.diff),!r)return e;var o="color: "+this.color;e=[e[0],o,"color: inherit"].concat(Array.prototype.slice.call(e,1));var t=0,s=0;return e[0].replace(/%[a-z%]/g,function(e){"%%"!==e&&(t++,"%c"===e&&(s=t))}),e.splice(s,0,o),e}function s(){return"object"==typeof console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function i(e){try{null==e?n.storage.removeItem("debug"):n.storage.debug=e}catch(r){}}function u(){var e;try{e=n.storage.debug}catch(r){}return e}function a(){try{return window.localStorage}catch(e){}}n=r.exports=e("./debug"),n.log=s,n.formatArgs=t,n.save=i,n.load=u,n.useColors=o,n.storage="undefined"!=typeof chrome&&"undefined"!=typeof chrome.storage?chrome.storage.local:a(),n.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],n.formatters.j=function(e){return JSON.stringify(e)},n.enable(u())},{"./debug":3}],3:[function(e,r,n){function o(){return n.colors[l++%n.colors.length]}function t(e){function r(){}function t(){var e=t,r=+new Date,s=r-(c||r);e.diff=s,e.prev=c,e.curr=r,c=r,null==e.useColors&&(e.useColors=n.useColors()),null==e.color&&e.useColors&&(e.color=o());var i=Array.prototype.slice.call(arguments);i[0]=n.coerce(i[0]),"string"!=typeof i[0]&&(i=["%o"].concat(i));var u=0;i[0]=i[0].replace(/%([a-z%])/g,function(r,o){if("%%"===r)return r;u++;var t=n.formatters[o];if("function"==typeof t){var s=i[u];r=t.call(e,s),i.splice(u,1),u--}return r}),"function"==typeof n.formatArgs&&(i=n.formatArgs.apply(e,i));var a=t.log||n.log||console.log.bind(console);a.apply(e,i)}r.enabled=!1,t.enabled=!0;var s=n.enabled(e)?t:r;return s.namespace=e,s}function s(e){n.save(e);for(var r=(e||"").split(/[\s,]+/),o=r.length,t=0;o>t;t++)r[t]&&(e=r[t].replace(/\*/g,".*?"),"-"===e[0]?n.skips.push(new RegExp("^"+e.substr(1)+"$")):n.names.push(new RegExp("^"+e+"$")))}function i(){n.enable("")}function u(e){var r,o;for(r=0,o=n.skips.length;o>r;r++)if(n.skips[r].test(e))return!1;for(r=0,o=n.names.length;o>r;r++)if(n.names[r].test(e))return!0;return!1}function a(e){return e instanceof Error?e.stack||e.message:e}n=r.exports=t,n.coerce=a,n.disable=i,n.enable=s,n.enabled=u,n.humanize=e("ms"),n.names=[],n.skips=[],n.formatters={};var c,l=0},{ms:4}],4:[function(e,r,n){function o(e){if(e=""+e,!(e.length>1e4)){var r=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);if(r){var n=parseFloat(r[1]),o=(r[2]||"ms").toLowerCase();switch(o){case"years":case"year":case"yrs":case"yr":case"y":return n*f;case"days":case"day":case"d":return n*l;case"hours":case"hour":case"hrs":case"hr":case"h":return n*c;case"minutes":case"minute":case"mins":case"min":case"m":return n*a;case"seconds":case"second":case"secs":case"sec":case"s":return n*u;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n}}}}function t(e){return e>=l?Math.round(e/l)+"d":e>=c?Math.round(e/c)+"h":e>=a?Math.round(e/a)+"m":e>=u?Math.round(e/u)+"s":e+"ms"}function s(e){return i(e,l,"day")||i(e,c,"hour")||i(e,a,"minute")||i(e,u,"second")||e+" ms"}function i(e,r,n){return r>e?void 0:1.5*r>e?Math.floor(e/r)+" "+n:Math.ceil(e/r)+" "+n+"s"}var u=1e3,a=60*u,c=60*a,l=24*c,f=365.25*l;r.exports=function(e,r){return r=r||{},"string"==typeof e?o(e):r["long"]?s(e):t(e)}},{}]},{},[1]);

},{}],3:[function(require,module,exports){
(function(){'use strict';function e(a){this.a=a;this.c="messages";this.locale=a.locale}e.$inject=["Translator"];e.prototype.trans=function(a,b,c){b=b||{};c=c||this.c;return this.a.get(c+":"+a,b)};e.prototype.transChoice=function(a,b,c,d){c=c||{};d=d||this.c;return this.a.get(d+":"+a,c,b)};function f(a){this.b=a;this.transChoice=this.transChoice.bind(this)}f.prototype.transChoice=function(a,b,c,d){return this.b.transChoice(a,b,c,d)};function g(a){return(new f(a)).transChoice}g.$inject=["TranslationService"];function h(a){this.b=a;this.trans=this.trans.bind(this)}h.prototype.trans=function(a,b,c){return this.b.trans(a,b,c)};function k(a){return(new h(a)).trans}k.$inject=["TranslationService"];function l(a,b){this.a=a;this.d=b;return this.a.hasOwnProperty("get")?this.d:this.a}l.$inject=["Translator","TranslatorAdapter1x"];function m(a){return a.Translator}m.$inject=["$window"];var n=angular.module("boxuk.translation.provider",[]).factory("Translator",m);var p=angular.module("boxuk.translation.adapter1x",[n.name]).service("TranslatorAdapter1x",e);var q=angular.module("boxuk.translation.translator",[p.name,n.name]).service("TranslationService",l);var r=angular.module("boxuk.translation.transchoice",[q.name]).filter("transChoice",g);var s=angular.module("boxuk.translation.trans",[q.name]).filter("trans",k);angular.module("boxuk.translation",[s.name,r.name,q.name]);})();

},{}],4:[function(require,module,exports){
/*! angular-google-maps 2.3.3 2016-05-13
 *  AngularJS directives for Google Maps
 *  git: https://github.com/angular-ui/angular-google-maps.git
 */
;
(function( window, angular, undefined ){
    'use strict';
    /*
     !
     The MIT License

     Copyright (c) 2010-2013 Google, Inc. http://angularjs.org

     Permission is hereby granted, free of charge, to any person obtaining a copy
     of this software and associated documentation files (the 'Software'), to deal
     in the Software without restriction, including without limitation the rights
     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     copies of the Software, and to permit persons to whom the Software is
     furnished to do so, subject to the following conditions:

     The above copyright notice and this permission notice shall be included in
     all copies or substantial portions of the Software.

     THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     THE SOFTWARE.

     angular-google-maps
     https://github.com/angular-ui/angular-google-maps

     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */

    (function() {
        angular.module('uiGmapgoogle-maps.providers', ['nemLogging']);

        angular.module('uiGmapgoogle-maps.wrapped', []);

        angular.module('uiGmapgoogle-maps.extensions', ['uiGmapgoogle-maps.wrapped', 'uiGmapgoogle-maps.providers']);

        angular.module('uiGmapgoogle-maps.directives.api.utils', ['uiGmapgoogle-maps.extensions']);

        angular.module('uiGmapgoogle-maps.directives.api.managers', []);

        angular.module('uiGmapgoogle-maps.directives.api.options', ['uiGmapgoogle-maps.directives.api.utils']);

        angular.module('uiGmapgoogle-maps.directives.api.options.builders', []);

        angular.module('uiGmapgoogle-maps.directives.api.models.child', ['uiGmapgoogle-maps.directives.api.utils', 'uiGmapgoogle-maps.directives.api.options', 'uiGmapgoogle-maps.directives.api.options.builders']);

        angular.module('uiGmapgoogle-maps.directives.api.models.parent', ['uiGmapgoogle-maps.directives.api.managers', 'uiGmapgoogle-maps.directives.api.models.child', 'uiGmapgoogle-maps.providers']);

        angular.module('uiGmapgoogle-maps.directives.api', ['uiGmapgoogle-maps.directives.api.models.parent']);

        angular.module('uiGmapgoogle-maps', ['uiGmapgoogle-maps.directives.api', 'uiGmapgoogle-maps.providers']);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.providers').factory('uiGmapMapScriptLoader', [
            '$q', 'uiGmapuuid', function($q, uuid) {
                var getScriptUrl, includeScript, isGoogleMapsLoaded, scriptId, usedConfiguration;
                scriptId = void 0;
                usedConfiguration = void 0;
                getScriptUrl = function(options) {
                    if (options.china) {
                        return 'http://maps.google.cn/maps/api/js?';
                    } else {
                        if (options.transport === 'auto') {
                            return '//maps.googleapis.com/maps/api/js?';
                        } else {
                            return options.transport + '://maps.googleapis.com/maps/api/js?';
                        }
                    }
                };
                includeScript = function(options) {
                    var omitOptions, query, script, scriptElem;
                    omitOptions = ['transport', 'isGoogleMapsForWork', 'china', 'preventLoad'];
                    if (options.isGoogleMapsForWork) {
                        omitOptions.push('key');
                    }
                    query = _.map(_.omit(options, omitOptions), function(v, k) {
                        return k + '=' + v;
                    });
                    if (scriptId) {
                        scriptElem = document.getElementById(scriptId);
                        scriptElem.parentNode.removeChild(scriptElem);
                    }
                    query = query.join('&');
                    script = document.createElement('script');
                    script.id = scriptId = "ui_gmap_map_load_" + (uuid.generate());
                    script.type = 'text/javascript';
                    script.src = getScriptUrl(options) + query;
                    return document.body.appendChild(script);
                };
                isGoogleMapsLoaded = function() {
                    return angular.isDefined(window.google) && angular.isDefined(window.google.maps);
                };
                return {
                    load: function(options) {
                        var deferred, randomizedFunctionName;
                        deferred = $q.defer();
                        if (isGoogleMapsLoaded()) {
                            deferred.resolve(window.google.maps);
                            return deferred.promise;
                        }
                        randomizedFunctionName = options.callback = 'onGoogleMapsReady' + Math.round(Math.random() * 1000);
                        window[randomizedFunctionName] = function() {
                            window[randomizedFunctionName] = null;
                            deferred.resolve(window.google.maps);
                        };
                        if (window.navigator.connection && window.Connection && window.navigator.connection.type === window.Connection.NONE && !options.preventLoad) {
                            document.addEventListener('online', function() {
                                if (!isGoogleMapsLoaded()) {
                                    return includeScript(options);
                                }
                            });
                        } else if (!options.preventLoad) {
                            includeScript(options);
                        }
                        usedConfiguration = options;
                        usedConfiguration.randomizedFunctionName = randomizedFunctionName;
                        return deferred.promise;
                    },
                    manualLoad: function() {
                        var config;
                        config = usedConfiguration;
                        if (!isGoogleMapsLoaded()) {
                            return includeScript(config);
                        } else {
                            if (window[config.randomizedFunctionName]) {
                                return window[config.randomizedFunctionName]();
                            }
                        }
                    }
                };
            }
        ]).provider('uiGmapGoogleMapApi', function() {
            this.options = {
                transport: 'https',
                isGoogleMapsForWork: false,
                china: false,
                v: '3',
                libraries: '',
                language: 'en',
                preventLoad: false
            };
            this.configure = function(options) {
                angular.extend(this.options, options);
            };
            this.$get = [
                'uiGmapMapScriptLoader', (function(_this) {
                    return function(loader) {
                        return loader.load(_this.options);
                    };
                })(this)
            ];
            return this;
        }).service('uiGmapGoogleMapApiManualLoader', [
            'uiGmapMapScriptLoader', function(loader) {
                return {
                    load: function() {
                        loader.manualLoad();
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.extensions').service('uiGmapExtendGWin', function() {
            return {
                init: _.once(function() {
                    var uiGmapInfoBox;
                    if (!(google || (typeof google !== "undefined" && google !== null ? google.maps : void 0) || (google.maps.InfoWindow != null))) {
                        return;
                    }
                    google.maps.InfoWindow.prototype._open = google.maps.InfoWindow.prototype.open;
                    google.maps.InfoWindow.prototype._close = google.maps.InfoWindow.prototype.close;
                    google.maps.InfoWindow.prototype._isOpen = false;
                    google.maps.InfoWindow.prototype.open = function(map, anchor, recurse) {
                        if (recurse != null) {
                            return;
                        }
                        this._isOpen = true;
                        this._open(map, anchor, true);
                    };
                    google.maps.InfoWindow.prototype.close = function(recurse) {
                        if (recurse != null) {
                            return;
                        }
                        this._isOpen = false;
                        this._close(true);
                    };
                    google.maps.InfoWindow.prototype.isOpen = function(val) {
                        if (val == null) {
                            val = void 0;
                        }
                        if (val == null) {
                            return this._isOpen;
                        } else {
                            return this._isOpen = val;
                        }
                    };

                    /*
                     Do the same for InfoBox
                     TODO: Clean this up so the logic is defined once, wait until develop becomes master as this will be easier
                     */
                    if (window.InfoBox) {
                        window.InfoBox.prototype._open = window.InfoBox.prototype.open;
                        window.InfoBox.prototype._close = window.InfoBox.prototype.close;
                        window.InfoBox.prototype._isOpen = false;
                        window.InfoBox.prototype.open = function(map, anchor) {
                            this._isOpen = true;
                            this._open(map, anchor);
                        };
                        window.InfoBox.prototype.close = function() {
                            this._isOpen = false;
                            this._close();
                        };
                        window.InfoBox.prototype.isOpen = function(val) {
                            if (val == null) {
                                val = void 0;
                            }
                            if (val == null) {
                                return this._isOpen;
                            } else {
                                return this._isOpen = val;
                            }
                        };
                        uiGmapInfoBox = (function(superClass) {
                            extend(uiGmapInfoBox, superClass);

                            function uiGmapInfoBox(opts) {
                                this.getOrigCloseBoxImg_ = bind(this.getOrigCloseBoxImg_, this);
                                this.getCloseBoxDiv_ = bind(this.getCloseBoxDiv_, this);
                                var box;
                                box = new window.InfoBox(opts);
                                _.extend(this, box);
                                if (opts.closeBoxDiv != null) {
                                    this.closeBoxDiv_ = opts.closeBoxDiv;
                                }
                            }

                            uiGmapInfoBox.prototype.getCloseBoxDiv_ = function() {
                                return this.closeBoxDiv_;
                            };

                            uiGmapInfoBox.prototype.getCloseBoxImg_ = function() {
                                var div, img;
                                div = this.getCloseBoxDiv_();
                                img = this.getOrigCloseBoxImg_();
                                return div || img;
                            };

                            uiGmapInfoBox.prototype.getOrigCloseBoxImg_ = function() {
                                var img;
                                img = "";
                                if (this.closeBoxURL_ !== "") {
                                    img = "<img";
                                    img += " src='" + this.closeBoxURL_ + "'";
                                    img += " align=right";
                                    img += " style='";
                                    img += " position: relative;";
                                    img += " cursor: pointer;";
                                    img += " margin: " + this.closeBoxMargin_ + ";";
                                    img += "'>";
                                }
                                return img;
                            };

                            return uiGmapInfoBox;

                        })(window.InfoBox);
                        window.uiGmapInfoBox = uiGmapInfoBox;
                    }
                    if (window.MarkerLabel_) {
                        return window.MarkerLabel_.prototype.setContent = function() {
                            var content;
                            content = this.marker_.get('labelContent');
                            if (!content || _.isEqual(this.oldContent, content)) {
                                return;
                            }
                            if (typeof (content != null ? content.nodeType : void 0) === 'undefined') {
                                this.labelDiv_.innerHTML = content;
                                this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
                                this.oldContent = content;
                            } else {
                                this.labelDiv_.innerHTML = '';
                                this.labelDiv_.appendChild(content);
                                content = content.cloneNode(true);
                                this.labelDiv_.innerHTML = '';
                                this.eventDiv_.appendChild(content);
                                this.oldContent = content;
                            }
                        };
                    }
                })
            };
        });

    }).call(this);
    ;
    /*global _:true, angular:true */

    (function() {
        angular.module('uiGmapgoogle-maps.extensions').service('uiGmapLodash', function() {
            var baseGet, baseToString, fixLodash, get, reEscapeChar, rePropName, toObject, toPath;
            rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
            reEscapeChar = /\\(\\)?/g;

            /*
             For Lodash 4 compatibility (some aliases are removed)
             */
            fixLodash = function(arg) {
                var isProto, missingName, swapName;
                missingName = arg.missingName, swapName = arg.swapName, isProto = arg.isProto;
                if (_[missingName] == null) {
                    _[missingName] = _[swapName];
                    if (isProto) {
                        return _.prototype[missingName] = _[swapName];
                    }
                }
            };
            [
                {
                    missingName: 'contains',
                    swapName: 'includes',
                    isProto: true
                }, {
                missingName: 'includes',
                swapName: 'contains',
                isProto: true
            }, {
                missingName: 'object',
                swapName: 'zipObject'
            }, {
                missingName: 'zipObject',
                swapName: 'object'
            }, {
                missingName: 'all',
                swapName: 'every'
            }, {
                missingName: 'every',
                swapName: 'all'
            }, {
                missingName: 'any',
                swapName: 'some'
            }, {
                missingName: 'some',
                swapName: 'any'
            }, {
                missingName: 'first',
                swapName: 'head'
            }, {
                missingName: 'head',
                swapName: 'first'
            }
            ].forEach(function(toMonkeyPatch) {
                return fixLodash(toMonkeyPatch);
            });
            if (_.get == null) {

                /**
                 * Converts `value` to an object if it's not one.
                 *
                 * @private
                 * @param {*} value The value to process.
                 * @returns {Object} Returns the object.
                 */
                toObject = function(value) {
                    if (_.isObject(value)) {
                        return value;
                    } else {
                        return Object(value);
                    }
                };

                /**
                 * Converts `value` to a string if it's not one. An empty string is returned
                 * for `null` or `undefined` values.
                 *
                 * @private
                 * @param {*} value The value to process.
                 * @returns {string} Returns the string.
                 */
                baseToString = function(value) {
                    if (value === null) {
                        return '';
                    } else {
                        return value + '';
                    }
                };

                /**
                 * Converts `value` to property path array if it's not one.
                 *
                 * @private
                 * @param {*} value The value to process.
                 * @returns {Array} Returns the property path array.
                 */
                toPath = function(value) {
                    var result;
                    if (_.isArray(value)) {
                        return value;
                    }
                    result = [];
                    baseToString(value).replace(rePropName, function(match, number, quote, string) {
                        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
                    });
                    return result;
                };

                /**
                 * The base implementation of `get` without support for string paths
                 * and default values.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array} path The path of the property to get.
                 * @param {string} [pathKey] The key representation of path.
                 * @returns {*} Returns the resolved value.
                 */
                baseGet = function(object, path, pathKey) {
                    var index, length;
                    if (object === null) {
                        return;
                    }
                    if (pathKey !== void 0 && pathKey in toObject(object)) {
                        path = [pathKey];
                    }
                    index = 0;
                    length = path.length;
                    while (!_.isUndefined(object) && index < length) {
                        object = object[path[index++]];
                    }
                    if (index && index === length) {
                        return object;
                    } else {
                        return void 0;
                    }
                };

                /**
                 * Gets the property value at `path` of `object`. If the resolved value is
                 * `undefined` the `defaultValue` is used in its place.
                 *
                 * @static
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path of the property to get.
                 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
                 * @returns {*} Returns the resolved value.
                 * @example
                 *
                 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                 *
                 * _.get(object, 'a[0].b.c');
                 * // => 3
                 *
                 * _.get(object, ['a', '0', 'b', 'c']);
                 * // => 3
                 *
                 * _.get(object, 'a.b.c', 'default');
                 * // => 'default'
                 */
                get = function(object, path, defaultValue) {
                    var result;
                    result = object === null ? void 0 : baseGet(object, toPath(path), path + '');
                    if (result === void 0) {
                        return defaultValue;
                    } else {
                        return result;
                    }
                };
                _.get = get;
            }

            /*
             Author Nick McCready
             Intersection of Objects if the arrays have something in common each intersecting object will be returned
             in an new array.
             */
            this.intersectionObjects = function(array1, array2, comparison) {
                var res;
                if (comparison == null) {
                    comparison = void 0;
                }
                res = _.map(array1, function(obj1) {
                    return _.find(array2, function(obj2) {
                        if (comparison != null) {
                            return comparison(obj1, obj2);
                        } else {
                            return _.isEqual(obj1, obj2);
                        }
                    });
                });
                return _.filter(res, function(o) {
                    return o != null;
                });
            };
            this.containsObject = _.includeObject = function(obj, target, comparison) {
                if (comparison == null) {
                    comparison = void 0;
                }
                if (obj === null) {
                    return false;
                }
                return _.some(obj, function(value) {
                    if (comparison != null) {
                        return comparison(value, target);
                    } else {
                        return _.isEqual(value, target);
                    }
                });
            };
            this.differenceObjects = function(array1, array2, comparison) {
                if (comparison == null) {
                    comparison = void 0;
                }
                return _.filter(array1, (function(_this) {
                    return function(value) {
                        return !_this.containsObject(array2, value, comparison);
                    };
                })(this));
            };
            this.withoutObjects = this.differenceObjects;
            this.indexOfObject = function(array, item, comparison, isSorted) {
                var i, length;
                if (array == null) {
                    return -1;
                }
                i = 0;
                length = array.length;
                if (isSorted) {
                    if (typeof isSorted === "number") {
                        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
                    } else {
                        i = _.sortedIndex(array, item);
                        return (array[i] === item ? i : -1);
                    }
                }
                while (i < length) {
                    if (comparison != null) {
                        if (comparison(array[i], item)) {
                            return i;
                        }
                    } else {
                        if (_.isEqual(array[i], item)) {
                            return i;
                        }
                    }
                    i++;
                }
                return -1;
            };
            this.isNullOrUndefined = function(thing) {
                return _.isNull(thing || _.isUndefined(thing));
            };
            return this;
        });

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.extensions').factory('uiGmapString', function() {
            return function(str) {
                this.contains = function(value, fromIndex) {
                    return str.indexOf(value, fromIndex) !== -1;
                };
                return this;
            };
        });

    }).call(this);
    ;
    /*global _:true,angular:true, */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmap_sync', [
            function() {
                return {
                    fakePromise: function() {
                        var _cb;
                        _cb = void 0;
                        return {
                            then: function(cb) {
                                return _cb = cb;
                            },
                            resolve: function() {
                                return _cb.apply(void 0, arguments);
                            }
                        };
                    }
                };
            }
        ]).service('uiGmap_async', [
            '$timeout', 'uiGmapPromise', 'uiGmapLogger', '$q', 'uiGmapDataStructures', 'uiGmapGmapUtil', function($timeout, uiGmapPromise, $log, $q, uiGmapDataStructures, uiGmapGmapUtil) {
                var ExposedPromise, PromiseQueueManager, SniffedPromise, _getIterateeValue, _ignoreFields, defaultChunkSize, doChunk, doSkippPromise, each, errorObject, getArrayAndKeys, isInProgress, kickPromise, logTryCatch, managePromiseQueue, map, maybeCancelPromises, promiseStatus, promiseTypes, tryCatch;
                promiseTypes = uiGmapPromise.promiseTypes;
                isInProgress = uiGmapPromise.isInProgress;
                promiseStatus = uiGmapPromise.promiseStatus;
                ExposedPromise = uiGmapPromise.ExposedPromise;
                SniffedPromise = uiGmapPromise.SniffedPromise;
                kickPromise = function(sniffedPromise, cancelCb) {
                    var promise;
                    promise = sniffedPromise.promise();
                    promise.promiseType = sniffedPromise.promiseType;
                    if (promise.$$state) {
                        $log.debug("promiseType: " + promise.promiseType + ", state: " + (promiseStatus(promise.$$state.status)));
                    }
                    promise.cancelCb = cancelCb;
                    return promise;
                };
                doSkippPromise = function(sniffedPromise, lastPromise) {
                    if (sniffedPromise.promiseType === promiseTypes.create && lastPromise.promiseType !== promiseTypes["delete"] && lastPromise.promiseType !== promiseTypes.init) {
                        $log.debug("lastPromise.promiseType " + lastPromise.promiseType + ", newPromiseType: " + sniffedPromise.promiseType + ", SKIPPED MUST COME AFTER DELETE ONLY");
                        return true;
                    }
                    return false;
                };
                maybeCancelPromises = function(queue, sniffedPromise, lastPromise) {
                    var first;
                    if (sniffedPromise.promiseType === promiseTypes["delete"] && lastPromise.promiseType !== promiseTypes["delete"]) {
                        if ((lastPromise.cancelCb != null) && _.isFunction(lastPromise.cancelCb) && isInProgress(lastPromise)) {
                            $log.debug("promiseType: " + sniffedPromise.promiseType + ", CANCELING LAST PROMISE type: " + lastPromise.promiseType);
                            lastPromise.cancelCb('cancel safe');
                            first = queue.peek();
                            if ((first != null) && isInProgress(first)) {
                                if (first.hasOwnProperty("cancelCb") && _.isFunction(first.cancelCb)) {
                                    $log.debug("promiseType: " + first.promiseType + ", CANCELING FIRST PROMISE type: " + first.promiseType);
                                    return first.cancelCb('cancel safe');
                                } else {
                                    return $log.warn('first promise was not cancelable');
                                }
                            }
                        }
                    }
                };

                /*
                 From a High Level:
                 This is a SniffedPromiseQueueManager (looking to rename) where the queue is existingPiecesObj.existingPieces.
                 This is a function and should not be considered a class.
                 So it is run to manage the state (cancel, skip, link) as needed.
                 Purpose:
                 The whole point is to check if there is existing async work going on. If so we wait on it.

                 arguments:
                 - existingPiecesObj =  Queue<Promises>
                 - sniffedPromise = object wrapper holding a function to a pending (function) promise (promise: fnPromise)
                 with its intended type.
                 - cancelCb = callback which accepts a string, this string is intended to be returned at the end of _async.each iterator

                 Where the cancelCb passed msg is 'cancel safe' _async.each will drop out and fall through. Thus canceling the promise
                 gracefully without messing up state.

                 Synopsis:

                 - Promises have been broken down to 4 states create, update,delete (3 main) and init. (Helps boil down problems in ordering)
                 where (init) is special to indicate that it is one of the first or to allow a create promise to work beyond being after a delete

                 - Every Promise that comes in is enqueued and linked to the last promise in the queue.

                 - A promise can be skipped or canceled to save cycles.

                 Saved Cycles:
                 - Skipped - This will only happen if async work comes in out of order. Where a pending create promise (un-executed) comes in
                 after a delete promise.
                 - Canceled - Where an incoming promise (un-executed promise) is of type delete and the any lastPromise is not a delete type.


                 NOTE:
                 - You should not muck with existingPieces as its state is dependent on this functional loop.
                 - PromiseQueueManager should not be thought of as a class that has a life expectancy (it has none). It's sole
                 purpose is to link, skip, and kill promises. It also manages the promise queue existingPieces.
                 */
                PromiseQueueManager = function(existingPiecesObj, sniffedPromise, cancelCb) {
                    var lastPromise, newPromise;
                    if (!existingPiecesObj.existingPieces) {
                        existingPiecesObj.existingPieces = new uiGmapDataStructures.Queue();
                        return existingPiecesObj.existingPieces.enqueue(kickPromise(sniffedPromise, cancelCb));
                    } else {
                        lastPromise = _.last(existingPiecesObj.existingPieces._content);
                        if (doSkippPromise(sniffedPromise, lastPromise)) {
                            return;
                        }
                        maybeCancelPromises(existingPiecesObj.existingPieces, sniffedPromise, lastPromise);
                        newPromise = ExposedPromise(lastPromise["finally"](function() {
                            return kickPromise(sniffedPromise, cancelCb);
                        }));
                        newPromise.cancelCb = cancelCb;
                        newPromise.promiseType = sniffedPromise.promiseType;
                        existingPiecesObj.existingPieces.enqueue(newPromise);
                        return lastPromise["finally"](function() {
                            return existingPiecesObj.existingPieces.dequeue();
                        });
                    }
                };
                managePromiseQueue = function(objectToLock, promiseType, msg, cancelCb, fnPromise) {
                    var cancelLogger;
                    if (msg == null) {
                        msg = '';
                    }
                    cancelLogger = function(msg) {
                        $log.debug(msg + ": " + msg);
                        if ((cancelCb != null) && _.isFunction(cancelCb)) {
                            return cancelCb(msg);
                        }
                    };
                    return PromiseQueueManager(objectToLock, SniffedPromise(fnPromise, promiseType), cancelLogger);
                };
                defaultChunkSize = 80;
                errorObject = {
                    value: null
                };
                tryCatch = function(fn, ctx, args) {
                    var e, error1;
                    try {
                        return fn.apply(ctx, args);
                    } catch (error1) {
                        e = error1;
                        errorObject.value = e;
                        return errorObject;
                    }
                };
                logTryCatch = function(fn, ctx, deferred, args) {
                    var msg, result;
                    result = tryCatch(fn, ctx, args);
                    if (result === errorObject) {
                        msg = "error within chunking iterator: " + errorObject.value;
                        $log.error(msg);
                        deferred.reject(msg);
                    }
                    if (result === 'cancel safe') {
                        return false;
                    }
                    return true;
                };
                _getIterateeValue = function(collection, array, index) {
                    var _isArray, valOrKey;
                    _isArray = collection === array;
                    valOrKey = array[index];
                    if (_isArray) {
                        return valOrKey;
                    }
                    return collection[valOrKey];
                };
                _ignoreFields = ['length', 'forEach', 'map'];
                getArrayAndKeys = function(collection, keys, bailOutCb, cb) {
                    var array, propName, val;
                    if (angular.isArray(collection)) {
                        array = collection;
                    } else {
                        if (keys) {
                            array = keys;
                        } else {
                            array = [];
                            for (propName in collection) {
                                val = collection[propName];
                                if (collection.hasOwnProperty(propName) && !_.includes(_ignoreFields, propName)) {
                                    array.push(propName);
                                }
                            }
                        }
                    }
                    if (cb == null) {
                        cb = bailOutCb;
                    }
                    if (angular.isArray(array) && !(array != null ? array.length : void 0)) {
                        if (cb !== bailOutCb) {
                            return bailOutCb();
                        }
                    }
                    return cb(array, keys);
                };

                /*
                 Author: Nicholas McCready & jfriend00
                 _async handles things asynchronous-like :), to allow the UI to be free'd to do other things
                 Code taken from http://stackoverflow.com/questions/10344498/best-way-to-iterate-over-an-array-without-blocking-the-ui

                 The design of any functionality of _async is to be like lodash/underscore and replicate it but call things
                 asynchronously underneath. Each should be sufficient for most things to be derived from.

                 Optional Asynchronous Chunking via promises.
                 */
                doChunk = function(collection, chunkSizeOrDontChunk, pauseMilli, chunkCb, pauseCb, overallD, index, _keys) {
                    return getArrayAndKeys(collection, _keys, function(array, keys) {
                        var cnt, i, keepGoing, val;
                        if (chunkSizeOrDontChunk && chunkSizeOrDontChunk < array.length) {
                            cnt = chunkSizeOrDontChunk;
                        } else {
                            cnt = array.length;
                        }
                        i = index;
                        keepGoing = true;
                        while (keepGoing && cnt-- && i < (array ? array.length : i + 1)) {
                            val = _getIterateeValue(collection, array, i);
                            keepGoing = angular.isFunction(val) ? true : logTryCatch(chunkCb, void 0, overallD, [val, i]);
                            ++i;
                        }
                        if (array) {
                            if (keepGoing && i < array.length) {
                                index = i;
                                if (chunkSizeOrDontChunk) {
                                    if ((pauseCb != null) && _.isFunction(pauseCb)) {
                                        logTryCatch(pauseCb, void 0, overallD, []);
                                    }
                                    return $timeout(function() {
                                        return doChunk(collection, chunkSizeOrDontChunk, pauseMilli, chunkCb, pauseCb, overallD, index, keys);
                                    }, pauseMilli, false);
                                }
                            } else {
                                return overallD.resolve();
                            }
                        }
                    });
                };
                each = function(collection, chunk, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, _keys) {
                    var error, overallD, ret;
                    if (chunkSizeOrDontChunk == null) {
                        chunkSizeOrDontChunk = defaultChunkSize;
                    }
                    if (index == null) {
                        index = 0;
                    }
                    if (pauseMilli == null) {
                        pauseMilli = 1;
                    }
                    ret = void 0;
                    overallD = uiGmapPromise.defer();
                    ret = overallD.promise;
                    if (!pauseMilli) {
                        error = 'pause (delay) must be set from _async!';
                        $log.error(error);
                        overallD.reject(error);
                        return ret;
                    }
                    return getArrayAndKeys(collection, _keys, function() {
                        overallD.resolve();
                        return ret;
                    }, function(array, keys) {
                        doChunk(collection, chunkSizeOrDontChunk, pauseMilli, chunk, pauseCb, overallD, index, keys);
                        return ret;
                    });
                };
                map = function(collection, iterator, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, _keys) {
                    var results;
                    results = [];
                    return getArrayAndKeys(collection, _keys, function() {
                        return uiGmapPromise.resolve(results);
                    }, function(array, keys) {
                        return each(collection, function(o) {
                            return results.push(iterator(o));
                        }, chunkSizeOrDontChunk, pauseCb, index, pauseMilli, keys).then(function() {
                            return results;
                        });
                    });
                };
                return {
                    each: each,
                    map: map,
                    managePromiseQueue: managePromiseQueue,
                    promiseLock: managePromiseQueue,
                    defaultChunkSize: defaultChunkSize,
                    getArrayAndKeys: getArrayAndKeys,
                    chunkSizeFrom: function(fromSize, ret) {
                        if (ret == null) {
                            ret = void 0;
                        }
                        if (_.isNumber(fromSize)) {
                            ret = fromSize;
                        }
                        if (uiGmapGmapUtil.isFalse(fromSize) || fromSize === false) {
                            ret = false;
                        }
                        return ret;
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

        angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapBaseObject', function() {
            var BaseObject, baseObjectKeywords;
            baseObjectKeywords = ['extended', 'included'];
            BaseObject = (function() {
                function BaseObject() {}

                BaseObject.extend = function(obj) {
                    var key, ref, value;
                    for (key in obj) {
                        value = obj[key];
                        if (indexOf.call(baseObjectKeywords, key) < 0) {
                            this[key] = value;
                        }
                    }
                    if ((ref = obj.extended) != null) {
                        ref.apply(this);
                    }
                    return this;
                };

                BaseObject.include = function(obj) {
                    var key, ref, value;
                    for (key in obj) {
                        value = obj[key];
                        if (indexOf.call(baseObjectKeywords, key) < 0) {
                            this.prototype[key] = value;
                        }
                    }
                    if ((ref = obj.included) != null) {
                        ref.apply(this);
                    }
                    return this;
                };

                return BaseObject;

            })();
            return BaseObject;
        });

    }).call(this);
    ;
    /*
     Useful function callbacks that should be defined at later time.
     Mainly to be used for specs to verify creation / linking.

     This is to lead a common design in notifying child stuff.
     */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapChildEvents', function() {
            return {
                onChildCreation: function(child) {}
            };
        });

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapCtrlHandle', [
            '$q', function($q) {
                var CtrlHandle;
                return CtrlHandle = {
                    handle: function($scope, $element) {
                        $scope.$on('$destroy', function() {
                            return CtrlHandle.handle($scope);
                        });
                        $scope.deferred = $q.defer();
                        return {
                            getScope: function() {
                                return $scope;
                            }
                        };
                    },
                    mapPromise: function(scope, ctrl) {
                        var mapScope;
                        mapScope = ctrl.getScope();
                        mapScope.deferred.promise.then(function(map) {
                            return scope.map = map;
                        });
                        return mapScope.deferred.promise;
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module("uiGmapgoogle-maps.directives.api.utils").service("uiGmapEventsHelper", [
            "uiGmapLogger", function($log) {
                var _getEventsObj, _hasEvents;
                _hasEvents = function(obj) {
                    return angular.isDefined(obj.events) && (obj.events != null) && angular.isObject(obj.events);
                };
                _getEventsObj = function(scope, model) {
                    if (_hasEvents(scope)) {
                        return scope;
                    }
                    if (_hasEvents(model)) {
                        return model;
                    }
                };
                return {
                    setEvents: function(gObject, scope, model, ignores) {
                        var eventObj;
                        eventObj = _getEventsObj(scope, model);
                        if (eventObj != null) {
                            return _.compact(_.map(eventObj.events, function(eventHandler, eventName) {
                                var doIgnore;
                                if (ignores) {
                                    doIgnore = _(ignores).includes(eventName);
                                }
                                if (eventObj.events.hasOwnProperty(eventName) && angular.isFunction(eventObj.events[eventName]) && !doIgnore) {
                                    return google.maps.event.addListener(gObject, eventName, function() {
                                        if (!scope.$evalAsync) {
                                            scope.$evalAsync = function() {};
                                        }
                                        return scope.$evalAsync(eventHandler.apply(scope, [gObject, eventName, model, arguments]));
                                    });
                                }
                            }));
                        }
                    },
                    removeEvents: function(listeners) {
                        var key, l;
                        if (!listeners) {
                            return;
                        }
                        for (key in listeners) {
                            l = listeners[key];
                            if (l && listeners.hasOwnProperty(key)) {
                                google.maps.event.removeListener(l);
                            }
                        }
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapFitHelper', [
            'uiGmapLogger', '$timeout', function($log, $timeout) {
                return {
                    fit: function(markersOrPoints, gMap) {
                        var bounds, everSet, key, markerOrPoint, point;
                        if (gMap && (markersOrPoints != null ? markersOrPoints.length : void 0)) {
                            bounds = new google.maps.LatLngBounds();
                            everSet = false;
                            for (key in markersOrPoints) {
                                markerOrPoint = markersOrPoints[key];
                                if (markerOrPoint) {
                                    if (!everSet) {
                                        everSet = true;
                                    }
                                    point = _.isFunction(markerOrPoint.getPosition) ? markerOrPoint.getPosition() : markerOrPoint;
                                }
                                bounds.extend(point);
                            }
                            if (everSet) {
                                return $timeout(function() {
                                    return gMap.fitBounds(bounds);
                                });
                            }
                        }
                    }
                };
            }
        ]);

    }).call(this);
    ;
    /*global _:true, angular:true, google:true */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapGmapUtil', [
            'uiGmapLogger', '$compile', function(Logger, $compile) {
                var _isFalse, _isTruthy, getCoords, getLatitude, getLongitude, validateCoords;
                _isTruthy = function(value, bool, optionsArray) {
                    return value === bool || optionsArray.indexOf(value) !== -1;
                };
                _isFalse = function(value) {
                    return _isTruthy(value, false, ['false', 'FALSE', 0, 'n', 'N', 'no', 'NO']);
                };
                getLatitude = function(value) {
                    if (Array.isArray(value) && value.length === 2) {
                        return value[1];
                    } else if (angular.isDefined(value.type) && value.type === 'Point') {
                        return value.coordinates[1];
                    } else {
                        return value.latitude;
                    }
                };
                getLongitude = function(value) {
                    if (Array.isArray(value) && value.length === 2) {
                        return value[0];
                    } else if (angular.isDefined(value.type) && value.type === 'Point') {
                        return value.coordinates[0];
                    } else {
                        return value.longitude;
                    }
                };
                getCoords = function(value) {
                    if (!value) {
                        return;
                    }
                    if (value instanceof google.maps.LatLng) {
                        return value;
                    } else if (Array.isArray(value) && value.length === 2) {
                        return new google.maps.LatLng(value[1], value[0]);
                    } else if (angular.isDefined(value.type) && value.type === 'Point') {
                        return new google.maps.LatLng(value.coordinates[1], value.coordinates[0]);
                    } else {
                        return new google.maps.LatLng(value.latitude, value.longitude);
                    }
                };
                validateCoords = function(coords) {
                    if (angular.isUndefined(coords)) {
                        return false;
                    }
                    if (_.isArray(coords)) {
                        if (coords.length === 2) {
                            return true;
                        }
                    } else if ((coords != null) && (coords != null ? coords.type : void 0)) {
                        if (coords.type === 'Point' && _.isArray(coords.coordinates) && coords.coordinates.length === 2) {
                            return true;
                        }
                    }
                    if (coords && angular.isDefined((coords != null ? coords.latitude : void 0) && angular.isDefined(coords != null ? coords.longitude : void 0))) {
                        return true;
                    }
                    return false;
                };
                return {
                    setCoordsFromEvent: function(prevValue, newLatLon) {
                        if (!prevValue) {
                            return;
                        }
                        if (Array.isArray(prevValue) && prevValue.length === 2) {
                            prevValue[1] = newLatLon.lat();
                            prevValue[0] = newLatLon.lng();
                        } else if (angular.isDefined(prevValue.type) && prevValue.type === 'Point') {
                            prevValue.coordinates[1] = newLatLon.lat();
                            prevValue.coordinates[0] = newLatLon.lng();
                        } else {
                            prevValue.latitude = newLatLon.lat();
                            prevValue.longitude = newLatLon.lng();
                        }
                        return prevValue;
                    },
                    getLabelPositionPoint: function(anchor) {
                        var xPos, yPos;
                        if (anchor === void 0) {
                            return void 0;
                        }
                        anchor = /^([-\d\.]+)\s([-\d\.]+)$/.exec(anchor);
                        xPos = parseFloat(anchor[1]);
                        yPos = parseFloat(anchor[2]);
                        if ((xPos != null) && (yPos != null)) {
                            return new google.maps.Point(xPos, yPos);
                        }
                    },
                    createWindowOptions: function(gMarker, scope, content, defaults) {
                        var options;
                        if ((content != null) && (defaults != null) && ($compile != null)) {
                            options = angular.extend({}, defaults, {
                                content: this.buildContent(scope, defaults, content),
                                position: defaults.position != null ? defaults.position : angular.isObject(gMarker) ? gMarker.getPosition() : getCoords(scope.coords)
                            });
                            if ((gMarker != null) && ((options != null ? options.pixelOffset : void 0) == null)) {
                                if (options.boxClass == null) {

                                } else {
                                    options.pixelOffset = {
                                        height: 0,
                                        width: -2
                                    };
                                }
                            }
                            return options;
                        } else {
                            if (!defaults) {
                                Logger.error('infoWindow defaults not defined');
                                if (!content) {
                                    return Logger.error('infoWindow content not defined');
                                }
                            } else {
                                return defaults;
                            }
                        }
                    },
                    buildContent: function(scope, defaults, content) {
                        var parsed, ret;
                        if (defaults.content != null) {
                            ret = defaults.content;
                        } else {
                            if ($compile != null) {
                                content = content.replace(/^\s+|\s+$/g, '');
                                parsed = content === '' ? '' : $compile(content)(scope);
                                if (parsed.length > 0) {
                                    ret = parsed[0];
                                }
                            } else {
                                ret = content;
                            }
                        }
                        return ret;
                    },
                    defaultDelay: 50,
                    isTrue: function(value) {
                        return _isTruthy(value, true, ['true', 'TRUE', 1, 'y', 'Y', 'yes', 'YES']);
                    },
                    isFalse: _isFalse,
                    isFalsy: function(value) {
                        return _isTruthy(value, false, [void 0, null]) || _isFalse(value);
                    },
                    getCoords: getCoords,
                    validateCoords: validateCoords,
                    equalCoords: function(coord1, coord2) {
                        return getLatitude(coord1) === getLatitude(coord2) && getLongitude(coord1) === getLongitude(coord2);
                    },
                    validatePath: function(path) {
                        var array, i, polygon, trackMaxVertices;
                        i = 0;
                        if (angular.isUndefined(path.type)) {
                            if (!Array.isArray(path) || path.length < 2) {
                                return false;
                            }
                            while (i < path.length) {
                                if (!((angular.isDefined(path[i].latitude) && angular.isDefined(path[i].longitude)) || (typeof path[i].lat === 'function' && typeof path[i].lng === 'function'))) {
                                    return false;
                                }
                                i++;
                            }
                            return true;
                        } else {
                            if (angular.isUndefined(path.coordinates)) {
                                return false;
                            }
                            if (path.type === 'Polygon') {
                                if (path.coordinates[0].length < 4) {
                                    return false;
                                }
                                array = path.coordinates[0];
                            } else if (path.type === 'MultiPolygon') {
                                trackMaxVertices = {
                                    max: 0,
                                    index: 0
                                };
                                _.forEach(path.coordinates, function(polygon, index) {
                                    if (polygon[0].length > this.max) {
                                        this.max = polygon[0].length;
                                        return this.index = index;
                                    }
                                }, trackMaxVertices);
                                polygon = path.coordinates[trackMaxVertices.index];
                                array = polygon[0];
                                if (array.length < 4) {
                                    return false;
                                }
                            } else if (path.type === 'LineString') {
                                if (path.coordinates.length < 2) {
                                    return false;
                                }
                                array = path.coordinates;
                            } else {
                                return false;
                            }
                            while (i < array.length) {
                                if (array[i].length !== 2) {
                                    return false;
                                }
                                i++;
                            }
                            return true;
                        }
                    },
                    convertPathPoints: function(path) {
                        var array, i, latlng, result, trackMaxVertices;
                        i = 0;
                        result = new google.maps.MVCArray();
                        if (angular.isUndefined(path.type)) {
                            while (i < path.length) {
                                latlng;
                                if (angular.isDefined(path[i].latitude) && angular.isDefined(path[i].longitude)) {
                                    latlng = new google.maps.LatLng(path[i].latitude, path[i].longitude);
                                } else if (typeof path[i].lat === 'function' && typeof path[i].lng === 'function') {
                                    latlng = path[i];
                                }
                                result.push(latlng);
                                i++;
                            }
                        } else {
                            array;
                            if (path.type === 'Polygon') {
                                array = path.coordinates[0];
                            } else if (path.type === 'MultiPolygon') {
                                trackMaxVertices = {
                                    max: 0,
                                    index: 0
                                };
                                _.forEach(path.coordinates, function(polygon, index) {
                                    if (polygon[0].length > this.max) {
                                        this.max = polygon[0].length;
                                        return this.index = index;
                                    }
                                }, trackMaxVertices);
                                array = path.coordinates[trackMaxVertices.index][0];
                            } else if (path.type === 'LineString') {
                                array = path.coordinates;
                            }
                            while (i < array.length) {
                                result.push(new google.maps.LatLng(array[i][1], array[i][0]));
                                i++;
                            }
                        }
                        return result;
                    },
                    getPath: function(object, key) {
                        var obj;
                        if ((key == null) || !_.isString(key)) {
                            return key;
                        }
                        obj = object;
                        _.each(key.split('.'), function(value) {
                            if (obj) {
                                return obj = obj[value];
                            }
                        });
                        return obj;
                    },
                    validateBoundPoints: function(bounds) {
                        if (angular.isUndefined(bounds.sw.latitude) || angular.isUndefined(bounds.sw.longitude) || angular.isUndefined(bounds.ne.latitude) || angular.isUndefined(bounds.ne.longitude)) {
                            return false;
                        }
                        return true;
                    },
                    convertBoundPoints: function(bounds) {
                        var result;
                        result = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.sw.latitude, bounds.sw.longitude), new google.maps.LatLng(bounds.ne.latitude, bounds.ne.longitude));
                        return result;
                    },
                    fitMapBounds: function(map, bounds) {
                        return map.fitBounds(bounds);
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapIsReady', [
            '$q', '$timeout', function($q, $timeout) {
                var _checkIfReady, _ctr, _promises, _proms;
                _ctr = 0;
                _proms = [];
                _promises = function() {
                    return $q.all(_proms);
                };
                _checkIfReady = function(deferred, expectedInstances, retriesLeft) {
                    return $timeout(function() {
                        if (retriesLeft <= 0) {
                            deferred.reject('Your maps are not found we have checked the maximum amount of times. :)');
                            return;
                        }
                        if (_ctr !== expectedInstances) {
                            _checkIfReady(deferred, expectedInstances, retriesLeft - 1);
                        } else {
                            deferred.resolve(_promises());
                        }
                    }, 100);
                };
                return {
                    spawn: function() {
                        var d;
                        d = $q.defer();
                        _proms.push(d.promise);
                        _ctr += 1;
                        return {
                            instance: _ctr,
                            deferred: d
                        };
                    },
                    promises: _promises,
                    instances: function() {
                        return _ctr;
                    },
                    promise: function(expectedInstances, numRetries) {
                        var d;
                        if (expectedInstances == null) {
                            expectedInstances = 1;
                        }
                        if (numRetries == null) {
                            numRetries = 50;
                        }
                        d = $q.defer();
                        _checkIfReady(d, expectedInstances, numRetries);
                        return d.promise;
                    },
                    reset: function() {
                        _ctr = 0;
                        _proms.length = 0;
                    },
                    decrement: function() {
                        if (_ctr > 0) {
                            _ctr -= 1;
                        }
                        if (_proms.length) {
                            _proms.length -= 1;
                        }
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapLinked", [
            "uiGmapBaseObject", function(BaseObject) {
                var Linked;
                Linked = (function(superClass) {
                    extend(Linked, superClass);

                    function Linked(scope, element, attrs, ctrls) {
                        this.scope = scope;
                        this.element = element;
                        this.attrs = attrs;
                        this.ctrls = ctrls;
                    }

                    return Linked;

                })(BaseObject);
                return Linked;
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapLogger', [
            'nemSimpleLogger', function(nemSimpleLogger) {
                return nemSimpleLogger.spawn();
            }
        ]);

    }).call(this);
    ;
    /*global _:true, angular:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapModelKey', [
            'uiGmapBaseObject', 'uiGmapGmapUtil', function(BaseObject, GmapUtil) {
                return (function(superClass) {
                    extend(_Class, superClass);

                    function _Class(scope1, _interface) {
                        this.scope = scope1;
                        this["interface"] = _interface != null ? _interface : {
                            scopeKeys: []
                        };
                        this.modelsLength = bind(this.modelsLength, this);
                        this.updateChild = bind(this.updateChild, this);
                        this.destroy = bind(this.destroy, this);
                        this.setChildScope = bind(this.setChildScope, this);
                        this.getChanges = bind(this.getChanges, this);
                        this.getProp = bind(this.getProp, this);
                        this.setIdKey = bind(this.setIdKey, this);
                        this.modelKeyComparison = bind(this.modelKeyComparison, this);
                        _Class.__super__.constructor.call(this);
                        this.defaultIdKey = 'id';
                        this.idKey = void 0;
                    }

                    _Class.prototype.evalModelHandle = function(model, modelKey) {
                        if ((model == null) || (modelKey == null)) {
                            return;
                        }
                        if (modelKey === 'self') {
                            return model;
                        } else {
                            if (_.isFunction(modelKey)) {
                                modelKey = modelKey();
                            }
                            return GmapUtil.getPath(model, modelKey);
                        }
                    };

                    _Class.prototype.modelKeyComparison = function(model1, model2) {
                        var coord1, coord2, hasCoords, isEqual, scope, without;
                        hasCoords = this["interface"].scopeKeys.indexOf('coords') >= 0;
                        if (hasCoords && (this.scope.coords != null) || !hasCoords) {
                            scope = this.scope;
                        }
                        if (scope == null) {
                            throw 'No scope set!';
                        }
                        if (hasCoords) {
                            coord1 = this.scopeOrModelVal('coords', scope, model1);
                            coord2 = this.scopeOrModelVal('coords', scope, model2);
                            isEqual = GmapUtil.equalCoords(coord1, coord2);
                            if (!isEqual) {
                                return isEqual;
                            }
                        }
                        without = _.without(this["interface"].scopeKeys, 'coords');
                        isEqual = _.every(without, (function(_this) {
                            return function(k) {
                                return _this.scopeOrModelVal(scope[k], scope, model1) === _this.scopeOrModelVal(scope[k], scope, model2);
                            };
                        })(this));
                        return isEqual;
                    };

                    _Class.prototype.setIdKey = function(scope) {
                        return this.idKey = scope.idKey != null ? scope.idKey : this.defaultIdKey;
                    };

                    _Class.prototype.setVal = function(model, key, newValue) {
                        this.modelOrKey(model, key = newValue);
                        return model;
                    };

                    _Class.prototype.modelOrKey = function(model, key) {
                        if (key == null) {
                            return;
                        }
                        if (key !== 'self') {
                            return GmapUtil.getPath(model, key);
                        }
                        return model;
                    };

                    _Class.prototype.getProp = function(propName, scope, model) {
                        return this.scopeOrModelVal(propName, scope, model);
                    };


                    /*
                     For the cases were watching a large object we only want to know the list of props
                     that actually changed.
                     Also we want to limit the amount of props we analyze to whitelisted props that are
                     actually tracked by scope. (should make things faster with whitelisted)
                     */

                    _Class.prototype.getChanges = function(now, prev, whitelistedProps) {
                        var c, changes, prop;
                        if (whitelistedProps) {
                            prev = _.pick(prev, whitelistedProps);
                            now = _.pick(now, whitelistedProps);
                        }
                        changes = {};
                        prop = {};
                        c = {};
                        for (prop in now) {
                            if (!prev || prev[prop] !== now[prop]) {
                                if (_.isArray(now[prop])) {
                                    changes[prop] = now[prop];
                                } else if (_.isObject(now[prop])) {
                                    c = this.getChanges(now[prop], (prev ? prev[prop] : null));
                                    if (!_.isEmpty(c)) {
                                        changes[prop] = c;
                                    }
                                } else {
                                    changes[prop] = now[prop];
                                }
                            }
                        }
                        return changes;
                    };

                    _Class.prototype.scopeOrModelVal = function(key, scope, model, doWrap) {
                        var maybeWrap, modelKey, modelProp, scopeProp;
                        if (doWrap == null) {
                            doWrap = false;
                        }
                        maybeWrap = function(isScope, ret, doWrap) {
                            if (doWrap == null) {
                                doWrap = false;
                            }
                            if (doWrap) {
                                return {
                                    isScope: isScope,
                                    value: ret
                                };
                            }
                            return ret;
                        };
                        scopeProp = _.get(scope, key);
                        if (_.isFunction(scopeProp)) {
                            return maybeWrap(true, scopeProp(model), doWrap);
                        }
                        if (_.isObject(scopeProp)) {
                            return maybeWrap(true, scopeProp, doWrap);
                        }
                        if (!_.isString(scopeProp)) {
                            return maybeWrap(true, scopeProp, doWrap);
                        }
                        modelKey = scopeProp;
                        if (!modelKey) {
                            modelProp = _.get(model, key);
                        } else {
                            modelProp = modelKey === 'self' ? model : _.get(model, modelKey);
                        }
                        if (_.isFunction(modelProp)) {
                            return maybeWrap(false, modelProp(), doWrap);
                        }
                        return maybeWrap(false, modelProp, doWrap);
                    };

                    _Class.prototype.setChildScope = function(keys, childScope, model) {
                        var isScopeObj, key, name, newValue;
                        for (key in keys) {
                            name = keys[key];
                            isScopeObj = this.scopeOrModelVal(name, childScope, model, true);
                            if ((isScopeObj != null ? isScopeObj.value : void 0) != null) {
                                newValue = isScopeObj.value;
                                if (newValue !== childScope[name]) {
                                    childScope[name] = newValue;
                                }
                            }
                        }
                        return childScope.model = model;
                    };

                    _Class.prototype.onDestroy = function(scope) {};

                    _Class.prototype.destroy = function(manualOverride) {
                        var ref;
                        if (manualOverride == null) {
                            manualOverride = false;
                        }
                        if ((this.scope != null) && !((ref = this.scope) != null ? ref.$$destroyed : void 0) && (this.needToManualDestroy || manualOverride)) {
                            return this.scope.$destroy();
                        } else {
                            return this.clean();
                        }
                    };

                    _Class.prototype.updateChild = function(child, model) {
                        if (model[this.idKey] == null) {
                            this.$log.error("Model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.");
                            return;
                        }
                        return child.updateModel(model);
                    };

                    _Class.prototype.modelsLength = function(arrayOrObjModels) {
                        var len, toCheck;
                        if (arrayOrObjModels == null) {
                            arrayOrObjModels = void 0;
                        }
                        len = 0;
                        toCheck = arrayOrObjModels ? arrayOrObjModels : this.scope.models;
                        if (toCheck == null) {
                            return len;
                        }
                        if (angular.isArray(toCheck) || (toCheck.length != null)) {
                            len = toCheck.length;
                        } else {
                            len = Object.keys(toCheck).length;
                        }
                        return len;
                    };

                    return _Class;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').factory('uiGmapModelsWatcher', [
            'uiGmapLogger', 'uiGmap_async', '$q', 'uiGmapPromise', function(Logger, _async, $q, uiGmapPromise) {
                return {
                    didQueueInitPromise: function(existingPiecesObj, scope) {
                        if (scope.models.length === 0) {
                            _async.promiseLock(existingPiecesObj, uiGmapPromise.promiseTypes.init, null, null, (function() {
                                return uiGmapPromise.resolve();
                            }));
                            return true;
                        }
                        return false;
                    },
                    figureOutState: function(idKey, scope, childObjects, comparison, callBack) {
                        var adds, children, mappedScopeModelIds, removals, updates;
                        adds = [];
                        mappedScopeModelIds = {};
                        removals = [];
                        updates = [];
                        scope.models.forEach(function(m) {
                            var child;
                            if (m[idKey] != null) {
                                mappedScopeModelIds[m[idKey]] = {};
                                if (childObjects.get(m[idKey]) == null) {
                                    return adds.push(m);
                                } else {
                                    child = childObjects.get(m[idKey]);
                                    if (!comparison(m, child.clonedModel, scope)) {
                                        return updates.push({
                                            model: m,
                                            child: child
                                        });
                                    }
                                }
                            } else {
                                return Logger.error(' id missing for model #{m.toString()},\ncan not use do comparison/insertion');
                            }
                        });
                        children = childObjects.values();
                        children.forEach(function(c) {
                            var id;
                            if (c == null) {
                                Logger.error('child undefined in ModelsWatcher.');
                                return;
                            }
                            if (c.model == null) {
                                Logger.error('child.model undefined in ModelsWatcher.');
                                return;
                            }
                            id = c.model[idKey];
                            if (mappedScopeModelIds[id] == null) {
                                return removals.push(c);
                            }
                        });
                        return {
                            adds: adds,
                            removals: removals,
                            updates: updates
                        };
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapPromise', [
            '$q', '$timeout', 'uiGmapLogger', function($q, $timeout, $log) {
                var ExposedPromise, SniffedPromise, defer, isInProgress, isResolved, promise, promiseStatus, promiseStatuses, promiseTypes, resolve, strPromiseStatuses;
                promiseTypes = {
                    create: 'create',
                    update: 'update',
                    "delete": 'delete',
                    init: 'init'
                };
                promiseStatuses = {
                    IN_PROGRESS: 0,
                    RESOLVED: 1,
                    REJECTED: 2
                };
                strPromiseStatuses = (function() {
                    var obj;
                    obj = {};
                    obj["" + promiseStatuses.IN_PROGRESS] = 'in-progress';
                    obj["" + promiseStatuses.RESOLVED] = 'resolved';
                    obj["" + promiseStatuses.REJECTED] = 'rejected';
                    return obj;
                })();
                isInProgress = function(promise) {
                    if (promise.$$state) {
                        return promise.$$state.status === promiseStatuses.IN_PROGRESS;
                    }
                    if (!promise.hasOwnProperty("$$v")) {
                        return true;
                    }
                };
                isResolved = function(promise) {
                    if (promise.$$state) {
                        return promise.$$state.status === promiseStatuses.RESOLVED;
                    }
                    if (promise.hasOwnProperty("$$v")) {
                        return true;
                    }
                };
                promiseStatus = function(status) {
                    return strPromiseStatuses[status] || 'done w error';
                };
                ExposedPromise = function(promise) {
                    var cancelDeferred, combined, wrapped;
                    cancelDeferred = $q.defer();
                    combined = $q.all([promise, cancelDeferred.promise]);
                    wrapped = $q.defer();
                    promise.then(cancelDeferred.resolve, (function() {}), function(notify) {
                        cancelDeferred.notify(notify);
                        return wrapped.notify(notify);
                    });
                    combined.then(function(successes) {
                        return wrapped.resolve(successes[0] || successes[1]);
                    }, function(error) {
                        return wrapped.reject(error);
                    });
                    wrapped.promise.cancel = function(reason) {
                        if (reason == null) {
                            reason = 'canceled';
                        }
                        return cancelDeferred.reject(reason);
                    };
                    wrapped.promise.notify = function(msg) {
                        if (msg == null) {
                            msg = 'cancel safe';
                        }
                        wrapped.notify(msg);
                        if (promise.hasOwnProperty('notify')) {
                            return promise.notify(msg);
                        }
                    };
                    if (promise.promiseType != null) {
                        wrapped.promise.promiseType = promise.promiseType;
                    }
                    return wrapped.promise;
                };
                SniffedPromise = function(fnPromise, promiseType) {
                    return {
                        promise: fnPromise,
                        promiseType: promiseType
                    };
                };
                defer = function() {
                    return $q.defer();
                };
                resolve = function() {
                    var d;
                    d = $q.defer();
                    d.resolve.apply(void 0, arguments);
                    return d.promise;
                };
                promise = function(fnToWrap) {
                    var d;
                    if (!_.isFunction(fnToWrap)) {
                        $log.error("uiGmapPromise.promise() only accepts functions");
                        return;
                    }
                    d = $q.defer();
                    $timeout(function() {
                        var result;
                        result = fnToWrap();
                        return d.resolve(result);
                    });
                    return d.promise;
                };
                return {
                    defer: defer,
                    promise: promise,
                    resolve: resolve,
                    promiseTypes: promiseTypes,
                    isInProgress: isInProgress,
                    isResolved: isResolved,
                    promiseStatus: promiseStatus,
                    ExposedPromise: ExposedPromise,
                    SniffedPromise: SniffedPromise
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapPropMap", function() {

            /*
             Simple Object Map with a length property to make it easy to track length/size
             */
            var PropMap;
            return PropMap = (function() {
                function PropMap() {
                    this.removeAll = bind(this.removeAll, this);
                    this.slice = bind(this.slice, this);
                    this.push = bind(this.push, this);
                    this.keys = bind(this.keys, this);
                    this.values = bind(this.values, this);
                    this.remove = bind(this.remove, this);
                    this.put = bind(this.put, this);
                    this.stateChanged = bind(this.stateChanged, this);
                    this.get = bind(this.get, this);
                    this.length = 0;
                    this.dict = {};
                    this.didValsStateChange = false;
                    this.didKeysStateChange = false;
                    this.allVals = [];
                    this.allKeys = [];
                }

                PropMap.prototype.get = function(key) {
                    return this.dict[key];
                };

                PropMap.prototype.stateChanged = function() {
                    this.didValsStateChange = true;
                    return this.didKeysStateChange = true;
                };

                PropMap.prototype.put = function(key, value) {
                    if (this.get(key) == null) {
                        this.length++;
                    }
                    this.stateChanged();
                    return this.dict[key] = value;
                };

                PropMap.prototype.remove = function(key, isSafe) {
                    var value;
                    if (isSafe == null) {
                        isSafe = false;
                    }
                    if (isSafe && !this.get(key)) {
                        return void 0;
                    }
                    value = this.dict[key];
                    delete this.dict[key];
                    this.length--;
                    this.stateChanged();
                    return value;
                };

                PropMap.prototype.valuesOrKeys = function(str) {
                    var keys, vals;
                    if (str == null) {
                        str = 'Keys';
                    }
                    if (!this["did" + str + "StateChange"]) {
                        return this['all' + str];
                    }
                    vals = [];
                    keys = [];
                    _.each(this.dict, function(v, k) {
                        vals.push(v);
                        return keys.push(k);
                    });
                    this.didKeysStateChange = false;
                    this.didValsStateChange = false;
                    this.allVals = vals;
                    this.allKeys = keys;
                    return this['all' + str];
                };

                PropMap.prototype.values = function() {
                    return this.valuesOrKeys('Vals');
                };

                PropMap.prototype.keys = function() {
                    return this.valuesOrKeys();
                };

                PropMap.prototype.push = function(obj, key) {
                    if (key == null) {
                        key = "key";
                    }
                    return this.put(obj[key], obj);
                };

                PropMap.prototype.slice = function() {
                    return this.keys().map((function(_this) {
                        return function(k) {
                            return _this.remove(k);
                        };
                    })(this));
                };

                PropMap.prototype.removeAll = function() {
                    return this.slice();
                };

                PropMap.prototype.each = function(cb) {
                    return _.each(this.dict, function(v, k) {
                        return cb(v);
                    });
                };

                PropMap.prototype.map = function(cb) {
                    return _.map(this.dict, function(v, k) {
                        return cb(v);
                    });
                };

                return PropMap;

            })();
        });

    }).call(this);
    ;
    /*globals angular,_ */

    (function() {
        angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapPropertyAction", [
            "uiGmapLogger", function(Logger) {
                var PropertyAction;
                PropertyAction = function(setterFn) {
                    this.setIfChange = function(callingKey) {
                        return function(newVal, oldVal) {
                            if (!_.isEqual(oldVal, newVal)) {
                                return setterFn(callingKey, newVal);
                            }
                        };
                    };
                    this.sic = this.setIfChange;
                    return this;
                };
                return PropertyAction;
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module('uiGmapgoogle-maps.directives.api.managers').factory('uiGmapClustererMarkerManager', [
            'uiGmapLogger', 'uiGmapFitHelper', 'uiGmapPropMap', 'uiGmapEventsHelper', function($log, FitHelper, PropMap, EventsHelper) {
                var ClustererMarkerManager;
                ClustererMarkerManager = (function() {
                    ClustererMarkerManager.type = 'ClustererMarkerManager';

                    function ClustererMarkerManager(gMap, opt_markers, opt_options, opt_events) {
                        if (opt_markers == null) {
                            opt_markers = {};
                        }
                        this.opt_options = opt_options != null ? opt_options : {};
                        this.opt_events = opt_events;
                        this.checkSync = bind(this.checkSync, this);
                        this.getGMarkers = bind(this.getGMarkers, this);
                        this.fit = bind(this.fit, this);
                        this.destroy = bind(this.destroy, this);
                        this.attachEvents = bind(this.attachEvents, this);
                        this.clear = bind(this.clear, this);
                        this.draw = bind(this.draw, this);
                        this.removeMany = bind(this.removeMany, this);
                        this.remove = bind(this.remove, this);
                        this.addMany = bind(this.addMany, this);
                        this.update = bind(this.update, this);
                        this.add = bind(this.add, this);
                        this.type = ClustererMarkerManager.type;
                        this.clusterer = new NgMapMarkerClusterer(gMap, opt_markers, this.opt_options);
                        this.propMapGMarkers = new PropMap();
                        this.attachEvents(this.opt_events, 'opt_events');
                        this.clusterer.setIgnoreHidden(true);
                        this.noDrawOnSingleAddRemoves = true;
                        $log.info(this);
                    }

                    ClustererMarkerManager.prototype.checkKey = function(gMarker) {
                        var msg;
                        if (gMarker.key == null) {
                            msg = 'gMarker.key undefined and it is REQUIRED!!';
                            return $log.error(msg);
                        }
                    };

                    ClustererMarkerManager.prototype.add = function(gMarker) {
                        this.checkKey(gMarker);
                        this.clusterer.addMarker(gMarker, this.noDrawOnSingleAddRemoves);
                        this.propMapGMarkers.put(gMarker.key, gMarker);
                        return this.checkSync();
                    };

                    ClustererMarkerManager.prototype.update = function(gMarker) {
                        this.remove(gMarker);
                        return this.add(gMarker);
                    };

                    ClustererMarkerManager.prototype.addMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(gMarker) {
                                return _this.add(gMarker);
                            };
                        })(this));
                    };

                    ClustererMarkerManager.prototype.remove = function(gMarker) {
                        var exists;
                        this.checkKey(gMarker);
                        exists = this.propMapGMarkers.get(gMarker.key);
                        if (exists) {
                            this.clusterer.removeMarker(gMarker, this.noDrawOnSingleAddRemoves);
                            this.propMapGMarkers.remove(gMarker.key);
                        }
                        return this.checkSync();
                    };

                    ClustererMarkerManager.prototype.removeMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(gMarker) {
                                return _this.remove(gMarker);
                            };
                        })(this));
                    };

                    ClustererMarkerManager.prototype.draw = function() {
                        return this.clusterer.repaint();
                    };

                    ClustererMarkerManager.prototype.clear = function() {
                        this.removeMany(this.getGMarkers());
                        return this.clusterer.repaint();
                    };

                    ClustererMarkerManager.prototype.attachEvents = function(options, optionsName) {
                        var eventHandler, eventName, results;
                        this.listeners = [];
                        if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
                            results = [];
                            for (eventName in options) {
                                eventHandler = options[eventName];
                                if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
                                    $log.info(optionsName + ": Attaching event: " + eventName + " to clusterer");
                                    results.push(this.listeners.push(google.maps.event.addListener(this.clusterer, eventName, options[eventName])));
                                } else {
                                    results.push(void 0);
                                }
                            }
                            return results;
                        }
                    };

                    ClustererMarkerManager.prototype.clearEvents = function() {
                        EventsHelper.removeEvents(this.listeners);
                        return this.listeners = [];
                    };

                    ClustererMarkerManager.prototype.destroy = function() {
                        this.clearEvents();
                        return this.clear();
                    };

                    ClustererMarkerManager.prototype.fit = function() {
                        return FitHelper.fit(this.getGMarkers(), this.clusterer.getMap());
                    };

                    ClustererMarkerManager.prototype.getGMarkers = function() {
                        return this.clusterer.getMarkers().values();
                    };

                    ClustererMarkerManager.prototype.checkSync = function() {};

                    return ClustererMarkerManager;

                })();
                return ClustererMarkerManager;
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.managers').service('uiGmapGoogleMapObjectManager', [
            function() {
                var _availableInstances, _usedInstances;
                _availableInstances = [];
                _usedInstances = [];
                return {
                    createMapInstance: function(parentElement, options) {
                        var instance;
                        instance = null;
                        if (_availableInstances.length === 0) {
                            instance = new google.maps.Map(parentElement, options);
                            _usedInstances.push(instance);
                        } else {
                            instance = _availableInstances.pop();
                            angular.element(parentElement).append(instance.getDiv());
                            instance.setOptions(options);
                            _usedInstances.push(instance);
                        }
                        return instance;
                    },
                    recycleMapInstance: function(instance) {
                        var index;
                        index = _usedInstances.indexOf(instance);
                        if (index < 0) {
                            throw new Error('Expected map instance to be a previously used instance');
                        }
                        _usedInstances.splice(index, 1);
                        return _availableInstances.push(instance);
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module("uiGmapgoogle-maps.directives.api.managers").factory("uiGmapMarkerManager", [
            "uiGmapLogger", "uiGmapFitHelper", "uiGmapPropMap", function(Logger, FitHelper, PropMap) {
                var MarkerManager;
                MarkerManager = (function() {
                    MarkerManager.type = 'MarkerManager';

                    function MarkerManager(gMap, opt_markers, opt_options) {
                        this.getGMarkers = bind(this.getGMarkers, this);
                        this.fit = bind(this.fit, this);
                        this.handleOptDraw = bind(this.handleOptDraw, this);
                        this.clear = bind(this.clear, this);
                        this.destroy = bind(this.destroy, this);
                        this.draw = bind(this.draw, this);
                        this.removeMany = bind(this.removeMany, this);
                        this.remove = bind(this.remove, this);
                        this.addMany = bind(this.addMany, this);
                        this.update = bind(this.update, this);
                        this.add = bind(this.add, this);
                        this.type = MarkerManager.type;
                        this.gMap = gMap;
                        this.gMarkers = new PropMap();
                        this.$log = Logger;
                        this.$log.info(this);
                    }

                    MarkerManager.prototype.add = function(gMarker, optDraw) {
                        var exists, msg;
                        if (optDraw == null) {
                            optDraw = true;
                        }
                        if (gMarker.key == null) {
                            msg = "gMarker.key undefined and it is REQUIRED!!";
                            Logger.error(msg);
                            throw msg;
                        }
                        exists = this.gMarkers.get(gMarker.key);
                        if (!exists) {
                            this.handleOptDraw(gMarker, optDraw, true);
                            return this.gMarkers.put(gMarker.key, gMarker);
                        }
                    };

                    MarkerManager.prototype.update = function(gMarker, optDraw) {
                        if (optDraw == null) {
                            optDraw = true;
                        }
                        this.remove(gMarker, optDraw);
                        return this.add(gMarker, optDraw);
                    };

                    MarkerManager.prototype.addMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(gMarker) {
                                return _this.add(gMarker);
                            };
                        })(this));
                    };

                    MarkerManager.prototype.remove = function(gMarker, optDraw) {
                        if (optDraw == null) {
                            optDraw = true;
                        }
                        this.handleOptDraw(gMarker, optDraw, false);
                        if (this.gMarkers.get(gMarker.key)) {
                            return this.gMarkers.remove(gMarker.key);
                        }
                    };

                    MarkerManager.prototype.removeMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(marker) {
                                return _this.remove(marker);
                            };
                        })(this));
                    };

                    MarkerManager.prototype.draw = function() {
                        var deletes;
                        deletes = [];
                        this.gMarkers.each((function(_this) {
                            return function(gMarker) {
                                if (!gMarker.isDrawn) {
                                    if (gMarker.doAdd) {
                                        gMarker.setMap(_this.gMap);
                                        return gMarker.isDrawn = true;
                                    } else {
                                        return deletes.push(gMarker);
                                    }
                                }
                            };
                        })(this));
                        return deletes.forEach((function(_this) {
                            return function(gMarker) {
                                gMarker.isDrawn = false;
                                return _this.remove(gMarker, true);
                            };
                        })(this));
                    };

                    MarkerManager.prototype.destroy = function() {
                        return this.clear();
                    };

                    MarkerManager.prototype.clear = function() {
                        this.gMarkers.each(function(gMarker) {
                            return gMarker.setMap(null);
                        });
                        delete this.gMarkers;
                        return this.gMarkers = new PropMap();
                    };

                    MarkerManager.prototype.handleOptDraw = function(gMarker, optDraw, doAdd) {
                        if (optDraw === true) {
                            if (doAdd) {
                                gMarker.setMap(this.gMap);
                            } else {
                                gMarker.setMap(null);
                            }
                            return gMarker.isDrawn = true;
                        } else {
                            gMarker.isDrawn = false;
                            return gMarker.doAdd = doAdd;
                        }
                    };

                    MarkerManager.prototype.fit = function() {
                        return FitHelper.fit(this.getGMarkers(), this.gMap);
                    };

                    MarkerManager.prototype.getGMarkers = function() {
                        return this.gMarkers.values();
                    };

                    return MarkerManager;

                })();
                return MarkerManager;
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module('uiGmapgoogle-maps.directives.api.managers').factory('uiGmapSpiderfierMarkerManager', [
            'uiGmapLogger', 'uiGmapFitHelper', 'uiGmapPropMap', 'uiGmapMarkerSpiderfier', function($log, FitHelper, PropMap, MarkerSpiderfier) {
                var SpiderfierMarkerManager;
                return SpiderfierMarkerManager = (function() {
                    SpiderfierMarkerManager.type = 'SpiderfierMarkerManager';

                    function SpiderfierMarkerManager(gMap, opt_markers, opt_options, opt_events, scope) {
                        if (opt_markers == null) {
                            opt_markers = {};
                        }
                        this.opt_options = opt_options != null ? opt_options : {};
                        this.opt_events = opt_events;
                        this.scope = scope;
                        this.checkSync = bind(this.checkSync, this);
                        this.isSpiderfied = bind(this.isSpiderfied, this);
                        this.getGMarkers = bind(this.getGMarkers, this);
                        this.fit = bind(this.fit, this);
                        this.destroy = bind(this.destroy, this);
                        this.attachEvents = bind(this.attachEvents, this);
                        this.clear = bind(this.clear, this);
                        this.draw = bind(this.draw, this);
                        this.removeMany = bind(this.removeMany, this);
                        this.remove = bind(this.remove, this);
                        this.addMany = bind(this.addMany, this);
                        this.update = bind(this.update, this);
                        this.add = bind(this.add, this);
                        this.type = SpiderfierMarkerManager.type;
                        this.markerSpiderfier = new MarkerSpiderfier(gMap, this.opt_options);
                        this.propMapGMarkers = new PropMap();
                        this.attachEvents(this.opt_events, 'opt_events');
                        this.noDrawOnSingleAddRemoves = true;
                        $log.info(this);
                    }

                    SpiderfierMarkerManager.prototype.checkKey = function(gMarker) {
                        var msg;
                        if (gMarker.key == null) {
                            msg = 'gMarker.key undefined and it is REQUIRED!!';
                            return $log.error(msg);
                        }
                    };

                    SpiderfierMarkerManager.prototype.add = function(gMarker) {
                        gMarker.setMap(this.markerSpiderfier.map);
                        this.checkKey(gMarker);
                        this.markerSpiderfier.addMarker(gMarker, this.noDrawOnSingleAddRemoves);
                        this.propMapGMarkers.put(gMarker.key, gMarker);
                        return this.checkSync();
                    };

                    SpiderfierMarkerManager.prototype.update = function(gMarker) {
                        this.remove(gMarker);
                        return this.add(gMarker);
                    };

                    SpiderfierMarkerManager.prototype.addMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(gMarker) {
                                return _this.add(gMarker);
                            };
                        })(this));
                    };

                    SpiderfierMarkerManager.prototype.remove = function(gMarker) {
                        var exists;
                        this.checkKey(gMarker);
                        exists = this.propMapGMarkers.get(gMarker.key);
                        if (exists) {
                            gMarker.setMap(null);
                            this.markerSpiderfier.removeMarker(gMarker, this.noDrawOnSingleAddRemoves);
                            this.propMapGMarkers.remove(gMarker.key);
                        }
                        return this.checkSync();
                    };

                    SpiderfierMarkerManager.prototype.removeMany = function(gMarkers) {
                        return gMarkers.forEach((function(_this) {
                            return function(gMarker) {
                                return _this.remove(gMarker);
                            };
                        })(this));
                    };

                    SpiderfierMarkerManager.prototype.draw = function() {};

                    SpiderfierMarkerManager.prototype.clear = function() {
                        return this.removeMany(this.getGMarkers());
                    };

                    SpiderfierMarkerManager.prototype.attachEvents = function(options, optionsName) {
                        if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
                            return _.each(options, (function(_this) {
                                return function(eventHandler, eventName) {
                                    if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
                                        $log.info(optionsName + ": Attaching event: " + eventName + " to markerSpiderfier");
                                        return _this.markerSpiderfier.addListener(eventName, function() {
                                            if (eventName === 'spiderfy' || eventName === 'unspiderfy') {
                                                return _this.scope.$evalAsync(options[eventName].apply(options, arguments));
                                            } else {
                                                return _this.scope.$evalAsync(options[eventName].apply(options, [arguments[0], eventName, arguments[0].model, arguments]));
                                            }
                                        });
                                    }
                                };
                            })(this));
                        }
                    };

                    SpiderfierMarkerManager.prototype.clearEvents = function(options, optionsName) {
                        var eventHandler, eventName;
                        if (angular.isDefined(options) && (options != null) && angular.isObject(options)) {
                            for (eventName in options) {
                                eventHandler = options[eventName];
                                if (options.hasOwnProperty(eventName) && angular.isFunction(options[eventName])) {
                                    $log.info(optionsName + ": Clearing event: " + eventName + " to markerSpiderfier");
                                    this.markerSpiderfier.clearListeners(eventName);
                                }
                            }
                        }
                    };

                    SpiderfierMarkerManager.prototype.destroy = function() {
                        this.clearEvents(this.opt_events, 'opt_events');
                        return this.clear();
                    };

                    SpiderfierMarkerManager.prototype.fit = function() {
                        return FitHelper.fit(this.getGMarkers(), this.markerSpiderfier.map);
                    };

                    SpiderfierMarkerManager.prototype.getGMarkers = function() {
                        return this.markerSpiderfier.getMarkers();
                    };

                    SpiderfierMarkerManager.prototype.isSpiderfied = function() {
                        return _.find(this.getGMarkers(), function(gMarker) {
                            return (gMarker != null ? gMarker._omsData : void 0) != null;
                        });
                    };

                    SpiderfierMarkerManager.prototype.checkSync = function() {};

                    return SpiderfierMarkerManager;

                })();
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps').factory('uiGmapadd-events', [
            '$timeout', function($timeout) {
                var addEvent, addEvents;
                addEvent = function(target, eventName, handler) {
                    return google.maps.event.addListener(target, eventName, function() {
                        handler.apply(this, arguments);
                        return $timeout((function() {}), true);
                    });
                };
                addEvents = function(target, eventName, handler) {
                    var remove;
                    if (handler) {
                        return addEvent(target, eventName, handler);
                    }
                    remove = [];
                    angular.forEach(eventName, function(_handler, key) {
                        return remove.push(addEvent(target, key, _handler));
                    });
                    return function() {
                        angular.forEach(remove, function(listener) {
                            return google.maps.event.removeListener(listener);
                        });
                        return remove = null;
                    };
                };
                return addEvents;
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps').factory('uiGmaparray-sync', [
            'uiGmapadd-events', function(mapEvents) {
                return function(mapArray, scope, pathEval, pathChangedFn) {
                    var geojsonArray, geojsonHandlers, geojsonWatcher, isSetFromScope, legacyHandlers, legacyWatcher, mapArrayListener, scopePath, watchListener;
                    isSetFromScope = false;
                    scopePath = scope.$eval(pathEval);
                    if (!scope["static"]) {
                        legacyHandlers = {
                            set_at: function(index) {
                                var value;
                                if (isSetFromScope) {
                                    return;
                                }
                                value = mapArray.getAt(index);
                                if (!value) {
                                    return;
                                }
                                if (!value.lng || !value.lat) {
                                    return scopePath[index] = value;
                                } else {
                                    scopePath[index].latitude = value.lat();
                                    return scopePath[index].longitude = value.lng();
                                }
                            },
                            insert_at: function(index) {
                                var value;
                                if (isSetFromScope) {
                                    return;
                                }
                                value = mapArray.getAt(index);
                                if (!value) {
                                    return;
                                }
                                if (!value.lng || !value.lat) {
                                    return scopePath.splice(index, 0, value);
                                } else {
                                    return scopePath.splice(index, 0, {
                                        latitude: value.lat(),
                                        longitude: value.lng()
                                    });
                                }
                            },
                            remove_at: function(index) {
                                if (isSetFromScope) {
                                    return;
                                }
                                return scopePath.splice(index, 1);
                            }
                        };
                        geojsonArray;
                        if (scopePath.type === 'Polygon') {
                            geojsonArray = scopePath.coordinates[0];
                        } else if (scopePath.type === 'LineString') {
                            geojsonArray = scopePath.coordinates;
                        }
                        geojsonHandlers = {
                            set_at: function(index) {
                                var value;
                                if (isSetFromScope) {
                                    return;
                                }
                                value = mapArray.getAt(index);
                                if (!(value && value.lng && value.lat)) {
                                    return;
                                }
                                geojsonArray[index][1] = value.lat();
                                return geojsonArray[index][0] = value.lng();
                            },
                            insert_at: function(index) {
                                var value;
                                if (isSetFromScope) {
                                    return;
                                }
                                value = mapArray.getAt(index);
                                if (!value) {
                                    return;
                                }
                                if (!value.lng || !value.lat) {
                                    return;
                                }
                                return geojsonArray.splice(index, 0, [value.lng(), value.lat()]);
                            },
                            remove_at: function(index) {
                                if (isSetFromScope) {
                                    return;
                                }
                                return geojsonArray.splice(index, 1);
                            }
                        };
                        mapArrayListener = mapEvents(mapArray, angular.isUndefined(scopePath.type) ? legacyHandlers : geojsonHandlers);
                    }
                    legacyWatcher = function(newPath) {
                        var changed, i, l, newLength, newValue, oldArray, oldLength, oldValue;
                        isSetFromScope = true;
                        oldArray = mapArray;
                        changed = false;
                        if (newPath) {
                            i = 0;
                            oldLength = oldArray.getLength();
                            newLength = newPath.length;
                            l = Math.min(oldLength, newLength);
                            newValue = void 0;
                            while (i < l) {
                                oldValue = oldArray.getAt(i);
                                newValue = newPath[i];
                                if (typeof newValue.equals === 'function') {
                                    if (!newValue.equals(oldValue)) {
                                        oldArray.setAt(i, newValue);
                                        changed = true;
                                    }
                                } else {
                                    if ((oldValue.lat() !== newValue.latitude) || (oldValue.lng() !== newValue.longitude)) {
                                        oldArray.setAt(i, new google.maps.LatLng(newValue.latitude, newValue.longitude));
                                        changed = true;
                                    }
                                }
                                i++;
                            }
                            while (i < newLength) {
                                newValue = newPath[i];
                                if (typeof newValue.lat === 'function' && typeof newValue.lng === 'function') {
                                    oldArray.push(newValue);
                                } else {
                                    oldArray.push(new google.maps.LatLng(newValue.latitude, newValue.longitude));
                                }
                                changed = true;
                                i++;
                            }
                            while (i < oldLength) {
                                oldArray.pop();
                                changed = true;
                                i++;
                            }
                        }
                        isSetFromScope = false;
                        if (changed) {
                            return pathChangedFn(oldArray);
                        }
                    };
                    geojsonWatcher = function(newPath) {
                        var array, changed, i, l, newLength, newValue, oldArray, oldLength, oldValue;
                        isSetFromScope = true;
                        oldArray = mapArray;
                        changed = false;
                        if (newPath) {
                            array;
                            if (scopePath.type === 'Polygon') {
                                array = newPath.coordinates[0];
                            } else if (scopePath.type === 'LineString') {
                                array = newPath.coordinates;
                            }
                            i = 0;
                            oldLength = oldArray.getLength();
                            newLength = array.length;
                            l = Math.min(oldLength, newLength);
                            newValue = void 0;
                            while (i < l) {
                                oldValue = oldArray.getAt(i);
                                newValue = array[i];
                                if ((oldValue.lat() !== newValue[1]) || (oldValue.lng() !== newValue[0])) {
                                    oldArray.setAt(i, new google.maps.LatLng(newValue[1], newValue[0]));
                                    changed = true;
                                }
                                i++;
                            }
                            while (i < newLength) {
                                newValue = array[i];
                                oldArray.push(new google.maps.LatLng(newValue[1], newValue[0]));
                                changed = true;
                                i++;
                            }
                            while (i < oldLength) {
                                oldArray.pop();
                                changed = true;
                                i++;
                            }
                        }
                        isSetFromScope = false;
                        if (changed) {
                            return pathChangedFn(oldArray);
                        }
                    };
                    watchListener;
                    if (!scope["static"]) {
                        if (angular.isUndefined(scopePath.type)) {
                            watchListener = scope.$watchCollection(pathEval, legacyWatcher);
                        } else {
                            watchListener = scope.$watch(pathEval, geojsonWatcher, true);
                        }
                    }
                    return function() {
                        if (mapArrayListener) {
                            mapArrayListener();
                            mapArrayListener = null;
                        }
                        if (watchListener) {
                            watchListener();
                            return watchListener = null;
                        }
                    };
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module("uiGmapgoogle-maps.directives.api.utils").factory("uiGmapChromeFixes", [
            '$timeout', function($timeout) {
                return {
                    maybeRepaint: function(el) {
                        if (el) {
                            el.style.opacity = 0.9;
                            return $timeout(function() {
                                return el.style.opacity = 1;
                            });
                        }
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps').service('uiGmapObjectIterators', function() {
            var _ignores, _iterators, _slapForEach, _slapMap;
            _ignores = ['length', 'forEach', 'map'];
            _iterators = [];
            _slapForEach = function(object) {
                object.forEach = function(cb) {
                    return _.each(_.omit(object, _ignores), function(val) {
                        if (!_.isFunction(val)) {
                            return cb(val);
                        }
                    });
                };
                return object;
            };
            _iterators.push(_slapForEach);
            _slapMap = function(object) {
                object.map = function(cb) {
                    return _.map(_.omit(object, _ignores), function(val) {
                        if (!_.isFunction(val)) {
                            return cb(val);
                        }
                    });
                };
                return object;
            };
            _iterators.push(_slapMap);
            return {
                slapMap: _slapMap,
                slapForEach: _slapForEach,
                slapAll: function(object) {
                    _iterators.forEach(function(it) {
                        return it(object);
                    });
                    return object;
                }
            };
        });

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.options.builders').service('uiGmapCommonOptionsBuilder', [
            'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapModelKey', function(BaseObject, $log, ModelKey) {
                var CommonOptionsBuilder;
                return CommonOptionsBuilder = (function(superClass) {
                    extend(CommonOptionsBuilder, superClass);

                    function CommonOptionsBuilder() {
                        this.watchProps = bind(this.watchProps, this);
                        this.buildOpts = bind(this.buildOpts, this);
                        return CommonOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    CommonOptionsBuilder.prototype.props = [
                        'clickable', 'draggable', 'editable', 'visible', {
                            prop: 'stroke',
                            isColl: true
                        }
                    ];

                    CommonOptionsBuilder.prototype.getCorrectModel = function(scope) {
                        if (angular.isDefined(scope != null ? scope.model : void 0)) {
                            return scope.model;
                        } else {
                            return scope;
                        }
                    };

                    CommonOptionsBuilder.prototype.buildOpts = function(customOpts, cachedEval, forEachOpts) {
                        var model, opts, stroke;
                        if (customOpts == null) {
                            customOpts = {};
                        }
                        if (forEachOpts == null) {
                            forEachOpts = {};
                        }
                        if (!this.scope) {
                            $log.error('this.scope not defined in CommonOptionsBuilder can not buildOpts');
                            return;
                        }
                        if (!this.gMap) {
                            $log.error('this.map not defined in CommonOptionsBuilder can not buildOpts');
                            return;
                        }
                        model = this.getCorrectModel(this.scope);
                        stroke = this.scopeOrModelVal('stroke', this.scope, model);
                        opts = angular.extend(customOpts, this.DEFAULTS, {
                            map: this.gMap,
                            strokeColor: stroke != null ? stroke.color : void 0,
                            strokeOpacity: stroke != null ? stroke.opacity : void 0,
                            strokeWeight: stroke != null ? stroke.weight : void 0
                        });
                        angular.forEach(angular.extend(forEachOpts, {
                            clickable: true,
                            draggable: false,
                            editable: false,
                            "static": false,
                            fit: false,
                            visible: true,
                            zIndex: 0,
                            icons: []
                        }), (function(_this) {
                            return function(defaultValue, key) {
                                var val;
                                val = cachedEval ? cachedEval[key] : _this.scopeOrModelVal(key, _this.scope, model);
                                if (angular.isUndefined(val)) {
                                    return opts[key] = defaultValue;
                                } else {
                                    return opts[key] = model[key];
                                }
                            };
                        })(this));
                        if (opts["static"]) {
                            opts.editable = false;
                        }
                        return opts;
                    };

                    CommonOptionsBuilder.prototype.watchProps = function(props) {
                        if (props == null) {
                            props = this.props;
                        }
                        return props.forEach((function(_this) {
                            return function(prop) {
                                if ((_this.attrs[prop] != null) || (_this.attrs[prop != null ? prop.prop : void 0] != null)) {
                                    if (prop != null ? prop.isColl : void 0) {
                                        return _this.scope.$watchCollection(prop.prop, _this.setMyOptions);
                                    } else {
                                        return _this.scope.$watch(prop, _this.setMyOptions);
                                    }
                                }
                            };
                        })(this));
                    };

                    return CommonOptionsBuilder;

                })(ModelKey);
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.options.builders').factory('uiGmapPolylineOptionsBuilder', [
            'uiGmapCommonOptionsBuilder', function(CommonOptionsBuilder) {
                var PolylineOptionsBuilder;
                return PolylineOptionsBuilder = (function(superClass) {
                    extend(PolylineOptionsBuilder, superClass);

                    function PolylineOptionsBuilder() {
                        return PolylineOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    PolylineOptionsBuilder.prototype.buildOpts = function(pathPoints, cachedEval) {
                        return PolylineOptionsBuilder.__super__.buildOpts.call(this, {
                            path: pathPoints
                        }, cachedEval, {
                            geodesic: false
                        });
                    };

                    return PolylineOptionsBuilder;

                })(CommonOptionsBuilder);
            }
        ]).factory('uiGmapShapeOptionsBuilder', [
            'uiGmapCommonOptionsBuilder', function(CommonOptionsBuilder) {
                var ShapeOptionsBuilder;
                return ShapeOptionsBuilder = (function(superClass) {
                    extend(ShapeOptionsBuilder, superClass);

                    function ShapeOptionsBuilder() {
                        return ShapeOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    ShapeOptionsBuilder.prototype.buildOpts = function(customOpts, cachedEval, forEachOpts) {
                        var fill, model;
                        model = this.getCorrectModel(this.scope);
                        fill = cachedEval ? cachedEval['fill'] : this.scopeOrModelVal('fill', this.scope, model);
                        customOpts = angular.extend(customOpts, {
                            fillColor: fill != null ? fill.color : void 0,
                            fillOpacity: fill != null ? fill.opacity : void 0
                        });
                        return ShapeOptionsBuilder.__super__.buildOpts.call(this, customOpts, cachedEval, forEachOpts);
                    };

                    return ShapeOptionsBuilder;

                })(CommonOptionsBuilder);
            }
        ]).factory('uiGmapPolygonOptionsBuilder', [
            'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
                var PolygonOptionsBuilder;
                return PolygonOptionsBuilder = (function(superClass) {
                    extend(PolygonOptionsBuilder, superClass);

                    function PolygonOptionsBuilder() {
                        return PolygonOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    PolygonOptionsBuilder.prototype.buildOpts = function(pathPoints, cachedEval) {
                        return PolygonOptionsBuilder.__super__.buildOpts.call(this, {
                            path: pathPoints
                        }, cachedEval, {
                            geodesic: false
                        });
                    };

                    return PolygonOptionsBuilder;

                })(ShapeOptionsBuilder);
            }
        ]).factory('uiGmapRectangleOptionsBuilder', [
            'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
                var RectangleOptionsBuilder;
                return RectangleOptionsBuilder = (function(superClass) {
                    extend(RectangleOptionsBuilder, superClass);

                    function RectangleOptionsBuilder() {
                        return RectangleOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    RectangleOptionsBuilder.prototype.buildOpts = function(bounds, cachedEval) {
                        return RectangleOptionsBuilder.__super__.buildOpts.call(this, {
                            bounds: bounds
                        }, cachedEval);
                    };

                    return RectangleOptionsBuilder;

                })(ShapeOptionsBuilder);
            }
        ]).factory('uiGmapCircleOptionsBuilder', [
            'uiGmapShapeOptionsBuilder', function(ShapeOptionsBuilder) {
                var CircleOptionsBuilder;
                return CircleOptionsBuilder = (function(superClass) {
                    extend(CircleOptionsBuilder, superClass);

                    function CircleOptionsBuilder() {
                        return CircleOptionsBuilder.__super__.constructor.apply(this, arguments);
                    }

                    CircleOptionsBuilder.prototype.buildOpts = function(center, radius, cachedEval) {
                        return CircleOptionsBuilder.__super__.buildOpts.call(this, {
                            center: center,
                            radius: radius
                        }, cachedEval);
                    };

                    return CircleOptionsBuilder;

                })(ShapeOptionsBuilder);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api.options').service('uiGmapMarkerOptions', [
            'uiGmapLogger', 'uiGmapGmapUtil', function($log, GmapUtil) {
                return _.extend(GmapUtil, {
                    createOptions: function(coords, icon, defaults, map) {
                        var opts;
                        if (defaults == null) {
                            defaults = {};
                        }
                        opts = angular.extend({}, defaults, {
                            position: defaults.position != null ? defaults.position : GmapUtil.getCoords(coords),
                            visible: defaults.visible != null ? defaults.visible : GmapUtil.validateCoords(coords)
                        });
                        if ((defaults.icon != null) || (icon != null)) {
                            opts = angular.extend(opts, {
                                icon: defaults.icon != null ? defaults.icon : icon
                            });
                        }
                        if (map != null) {
                            opts.map = map;
                        }
                        return opts;
                    },
                    isLabel: function(options) {
                        if (options == null) {
                            return false;
                        }
                        return (options.labelContent != null) || (options.labelAnchor != null) || (options.labelClass != null) || (options.labelStyle != null) || (options.labelVisible != null);
                    }
                });
            }
        ]);

    }).call(this);
    ;
    /*global _,angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapBasePolyChildModel', [
            'uiGmapLogger', '$timeout', 'uiGmaparray-sync', 'uiGmapGmapUtil', 'uiGmapEventsHelper', function($log, $timeout, arraySync, GmapUtil, EventsHelper) {
                return function(Builder, gFactory) {
                    var BasePolyChildModel;
                    return BasePolyChildModel = (function(superClass) {
                        extend(BasePolyChildModel, superClass);

                        BasePolyChildModel.include(GmapUtil);

                        function BasePolyChildModel(arg) {
                            var create, gObjectChangeCb, ref;
                            this.scope = arg.scope, this.attrs = arg.attrs, this.gMap = arg.gMap, this.defaults = arg.defaults, this.model = arg.model, gObjectChangeCb = arg.gObjectChangeCb, this.isScopeModel = (ref = arg.isScopeModel) != null ? ref : false;
                            this.clean = bind(this.clean, this);
                            if (this.isScopeModel) {
                                this.clonedModel = _.clone(this.model, true);
                            }
                            this.isDragging = false;
                            this.internalEvents = {
                                dragend: (function(_this) {
                                    return function() {
                                        return _.defer(function() {
                                            return _this.isDragging = false;
                                        });
                                    };
                                })(this),
                                dragstart: (function(_this) {
                                    return function() {
                                        return _this.isDragging = true;
                                    };
                                })(this)
                            };
                            create = (function(_this) {
                                return function() {
                                    var maybeCachedEval;
                                    if (_this.isDragging) {
                                        return;
                                    }
                                    _this.pathPoints = _this.convertPathPoints(_this.scope.path);
                                    if (_this.gObject != null) {
                                        _this.clean();
                                    }
                                    if (_this.scope.model != null) {
                                        maybeCachedEval = _this.scope;
                                    }
                                    if (_this.pathPoints.length > 0) {
                                        _this.gObject = gFactory(_this.buildOpts(_this.pathPoints, maybeCachedEval));
                                    }
                                    if (_this.gObject) {
                                        arraySync(_this.gObject.getPath(), _this.scope, 'path', function(pathPoints) {
                                            _this.pathPoints = pathPoints;
                                            if (gObjectChangeCb != null) {
                                                return gObjectChangeCb();
                                            }
                                        });
                                        if (angular.isDefined(_this.scope.events) && angular.isObject(_this.scope.events)) {
                                            _this.listeners = _this.model ? EventsHelper.setEvents(_this.gObject, _this.scope, _this.model) : EventsHelper.setEvents(_this.gObject, _this.scope, _this.scope);
                                        }
                                        return _this.internalListeners = _this.model ? EventsHelper.setEvents(_this.gObject, {
                                            events: _this.internalEvents
                                        }, _this.model) : EventsHelper.setEvents(_this.gObject, {
                                            events: _this.internalEvents
                                        }, _this.scope);
                                    }
                                };
                            })(this);
                            create();
                            this.scope.$watch('path', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (!_.isEqual(newValue, oldValue) || !_this.gObject) {
                                        return create();
                                    }
                                };
                            })(this), true);
                            if (!this.scope["static"] && angular.isDefined(this.scope.editable)) {
                                this.scope.$watch('editable', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            newValue = !_this.isFalse(newValue);
                                            return (ref1 = _this.gObject) != null ? ref1.setEditable(newValue) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.draggable)) {
                                this.scope.$watch('draggable', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            newValue = !_this.isFalse(newValue);
                                            return (ref1 = _this.gObject) != null ? ref1.setDraggable(newValue) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.visible)) {
                                this.scope.$watch('visible', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            newValue = !_this.isFalse(newValue);
                                        }
                                        return (ref1 = _this.gObject) != null ? ref1.setVisible(newValue) : void 0;
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.geodesic)) {
                                this.scope.$watch('geodesic', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            newValue = !_this.isFalse(newValue);
                                            return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.weight)) {
                                this.scope.$watch('stroke.weight', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.color)) {
                                this.scope.$watch('stroke.color', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.stroke) && angular.isDefined(this.scope.stroke.opacity)) {
                                this.scope.$watch('stroke.opacity', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            if (angular.isDefined(this.scope.icons)) {
                                this.scope.$watch('icons', (function(_this) {
                                    return function(newValue, oldValue) {
                                        var ref1;
                                        if (newValue !== oldValue) {
                                            return (ref1 = _this.gObject) != null ? ref1.setOptions(_this.buildOpts(_this.gObject.getPath())) : void 0;
                                        }
                                    };
                                })(this), true);
                            }
                            this.scope.$on('$destroy', (function(_this) {
                                return function() {
                                    _this.clean();
                                    return _this.scope = null;
                                };
                            })(this));
                            if (angular.isDefined(this.scope.fill) && angular.isDefined(this.scope.fill.color)) {
                                this.scope.$watch('fill.color', (function(_this) {
                                    return function(newValue, oldValue) {
                                        if (newValue !== oldValue) {
                                            return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
                                        }
                                    };
                                })(this));
                            }
                            if (angular.isDefined(this.scope.fill) && angular.isDefined(this.scope.fill.opacity)) {
                                this.scope.$watch('fill.opacity', (function(_this) {
                                    return function(newValue, oldValue) {
                                        if (newValue !== oldValue) {
                                            return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
                                        }
                                    };
                                })(this));
                            }
                            if (angular.isDefined(this.scope.zIndex)) {
                                this.scope.$watch('zIndex', (function(_this) {
                                    return function(newValue, oldValue) {
                                        if (newValue !== oldValue) {
                                            return _this.gObject.setOptions(_this.buildOpts(_this.gObject.getPath()));
                                        }
                                    };
                                })(this));
                            }
                        }

                        BasePolyChildModel.prototype.clean = function() {
                            var ref;
                            EventsHelper.removeEvents(this.listeners);
                            EventsHelper.removeEvents(this.internalListeners);
                            if ((ref = this.gObject) != null) {
                                ref.setMap(null);
                            }
                            return this.gObject = null;
                        };

                        return BasePolyChildModel;

                    })(Builder);
                };
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicholas McCready - https://twitter.com/nmccready
     Original idea from: http://stackoverflow.com/questions/22758950/google-map-drawing-freehand  , &
     http://jsfiddle.net/YsQdh/88/
     */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapDrawFreeHandChildModel', [
            'uiGmapLogger', '$q', function($log, $q) {
                var drawFreeHand, freeHandMgr;
                drawFreeHand = function(map, polys, done) {
                    var move, poly;
                    poly = new google.maps.Polyline({
                        map: map,
                        clickable: false
                    });
                    move = google.maps.event.addListener(map, 'mousemove', function(e) {
                        return poly.getPath().push(e.latLng);
                    });
                    google.maps.event.addListenerOnce(map, 'mouseup', function(e) {
                        var path;
                        google.maps.event.removeListener(move);
                        path = poly.getPath();
                        poly.setMap(null);
                        polys.push(new google.maps.Polygon({
                            map: map,
                            path: path
                        }));
                        poly = null;
                        google.maps.event.clearListeners(map.getDiv(), 'mousedown');
                        return done();
                    });
                    return void 0;
                };
                freeHandMgr = function(map1, scope) {
                    var disableMap, enableMap;
                    this.map = map1;
                    disableMap = (function(_this) {
                        return function() {
                            var mapOptions;
                            mapOptions = {
                                draggable: false,
                                disableDefaultUI: true,
                                scrollwheel: false,
                                disableDoubleClickZoom: false
                            };
                            $log.info('disabling map move');
                            return _this.map.setOptions(mapOptions);
                        };
                    })(this);
                    enableMap = (function(_this) {
                        return function() {
                            var mapOptions, ref;
                            mapOptions = {
                                draggable: true,
                                disableDefaultUI: false,
                                scrollwheel: true,
                                disableDoubleClickZoom: true
                            };
                            if ((ref = _this.deferred) != null) {
                                ref.resolve();
                            }
                            return _.defer(function() {
                                return _this.map.setOptions(_.extend(mapOptions, scope.options));
                            });
                        };
                    })(this);
                    this.engage = (function(_this) {
                        return function(polys1) {
                            _this.polys = polys1;
                            _this.deferred = $q.defer();
                            disableMap();
                            $log.info('DrawFreeHandChildModel is engaged (drawing).');
                            google.maps.event.addDomListener(_this.map.getDiv(), 'mousedown', function(e) {
                                return drawFreeHand(_this.map, _this.polys, enableMap);
                            });
                            return _this.deferred.promise;
                        };
                    })(this);
                    return this;
                };
                return freeHandMgr;
            }
        ]);

    }).call(this);
    ;
    /*global _:true,angular:true,google:true, RichMarker:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapMarkerChildModel', [
            'uiGmapModelKey', 'uiGmapGmapUtil', 'uiGmapLogger', 'uiGmapEventsHelper', 'uiGmapPropertyAction', 'uiGmapMarkerOptions', 'uiGmapIMarker', 'uiGmapMarkerManager', 'uiGmapPromise', function(ModelKey, GmapUtil, $log, EventsHelper, PropertyAction, MarkerOptions, IMarker, MarkerManager, uiGmapPromise) {
                var MarkerChildModel;
                MarkerChildModel = (function(superClass) {
                    var destroy;

                    extend(MarkerChildModel, superClass);

                    MarkerChildModel.include(GmapUtil);

                    MarkerChildModel.include(EventsHelper);

                    MarkerChildModel.include(MarkerOptions);

                    destroy = function(child) {
                        if ((child != null ? child.gObject : void 0) != null) {
                            child.removeEvents(child.externalListeners);
                            child.removeEvents(child.internalListeners);
                            if (child != null ? child.gObject : void 0) {
                                if (child.removeFromManager) {
                                    child.gManager.remove(child.gObject);
                                }
                                child.gObject.setMap(null);
                                return child.gObject = null;
                            }
                        }
                    };

                    function MarkerChildModel(opts) {
                        this.internalEvents = bind(this.internalEvents, this);
                        this.setLabelOptions = bind(this.setLabelOptions, this);
                        this.setOptions = bind(this.setOptions, this);
                        this.setIcon = bind(this.setIcon, this);
                        this.setCoords = bind(this.setCoords, this);
                        this.isNotValid = bind(this.isNotValid, this);
                        this.maybeSetScopeValue = bind(this.maybeSetScopeValue, this);
                        this.createMarker = bind(this.createMarker, this);
                        this.setMyScope = bind(this.setMyScope, this);
                        this.updateModel = bind(this.updateModel, this);
                        this.handleModelChanges = bind(this.handleModelChanges, this);
                        this.destroy = bind(this.destroy, this);
                        var action, ref, ref1, ref2, ref3, ref4, scope;
                        scope = opts.scope, this.model = opts.model, this.keys = opts.keys, this.gMap = opts.gMap, this.defaults = (ref = opts.defaults) != null ? ref : {}, this.doClick = opts.doClick, this.gManager = opts.gManager, this.doDrawSelf = (ref1 = opts.doDrawSelf) != null ? ref1 : true, this.trackModel = (ref2 = opts.trackModel) != null ? ref2 : true, this.needRedraw = (ref3 = opts.needRedraw) != null ? ref3 : false, this.isScopeModel = (ref4 = opts.isScopeModel) != null ? ref4 : false;
                        if (this.isScopeModel) {
                            this.clonedModel = _.clone(this.model, true);
                        }
                        this.deferred = uiGmapPromise.defer();
                        _.each(this.keys, (function(_this) {
                            return function(v, k) {
                                var keyValue;
                                keyValue = _this.keys[k];
                                if ((keyValue != null) && !_.isFunction(keyValue) && _.isString(keyValue)) {
                                    return _this[k + 'Key'] = keyValue;
                                }
                            };
                        })(this));
                        this.idKey = this.idKeyKey || 'id';
                        if (this.model[this.idKey] != null) {
                            this.id = this.model[this.idKey];
                        }
                        MarkerChildModel.__super__.constructor.call(this, scope);
                        this.scope.getGMarker = (function(_this) {
                            return function() {
                                return _this.gObject;
                            };
                        })(this);
                        this.firstTime = true;
                        if (this.trackModel) {
                            this.scope.model = this.model;
                            this.scope.$watch('model', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (newValue !== oldValue) {
                                        return _this.handleModelChanges(newValue, oldValue);
                                    }
                                };
                            })(this), true);
                        } else {
                            action = new PropertyAction((function(_this) {
                                return function(calledKey) {
                                    if (_.isFunction(calledKey)) {
                                        calledKey = 'all';
                                    }
                                    if (!_this.firstTime) {
                                        return _this.setMyScope(calledKey, scope);
                                    }
                                };
                            })(this), false);
                            _.each(this.keys, function(v, k) {
                                return scope.$watch(k, action.sic(k), true);
                            });
                        }
                        this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                return destroy(_this);
                            };
                        })(this));
                        this.createMarker(this.model);
                        $log.info(this);
                    }

                    MarkerChildModel.prototype.destroy = function(removeFromManager) {
                        if (removeFromManager == null) {
                            removeFromManager = true;
                        }
                        this.removeFromManager = removeFromManager;
                        return this.scope.$destroy();
                    };

                    MarkerChildModel.prototype.handleModelChanges = function(newValue, oldValue) {
                        var changes, ctr, len;
                        changes = this.getChanges(newValue, oldValue, IMarker.keys);
                        if (!this.firstTime) {
                            ctr = 0;
                            len = _.keys(changes).length;
                            return _.each(changes, (function(_this) {
                                return function(v, k) {
                                    var doDraw;
                                    ctr += 1;
                                    doDraw = len === ctr;
                                    _this.setMyScope(k, newValue, oldValue, false, true, doDraw);
                                    return _this.needRedraw = true;
                                };
                            })(this));
                        }
                    };

                    MarkerChildModel.prototype.updateModel = function(model) {
                        if (this.isScopeModel) {
                            this.clonedModel = _.clone(model, true);
                        }
                        return this.setMyScope('all', model, this.model);
                    };

                    MarkerChildModel.prototype.renderGMarker = function(doDraw, validCb) {
                        var coords, isSpiderfied, ref;
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        coords = this.getProp('coords', this.scope, this.model);
                        if (((ref = this.gManager) != null ? ref.isSpiderfied : void 0) != null) {
                            isSpiderfied = this.gManager.isSpiderfied();
                        }
                        if (coords != null) {
                            if (!this.validateCoords(coords)) {
                                $log.debug('MarkerChild does not have coords yet. They may be defined later.');
                                return;
                            }
                            if (validCb != null) {
                                validCb();
                            }
                            if (doDraw && this.gObject) {
                                this.gManager.add(this.gObject);
                            }
                            if (isSpiderfied) {
                                return this.gManager.markerSpiderfier.spiderListener(this.gObject, window.event);
                            }
                        } else {
                            if (doDraw && this.gObject) {
                                return this.gManager.remove(this.gObject);
                            }
                        }
                    };

                    MarkerChildModel.prototype.setMyScope = function(thingThatChanged, model, oldModel, isInit, doDraw) {
                        var justCreated;
                        if (oldModel == null) {
                            oldModel = void 0;
                        }
                        if (isInit == null) {
                            isInit = false;
                        }
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        if (model == null) {
                            model = this.model;
                        } else {
                            this.model = model;
                        }
                        if (!this.gObject) {
                            this.setOptions(this.scope, doDraw);
                            justCreated = true;
                        }
                        switch (thingThatChanged) {
                            case 'all':
                                return _.each(this.keys, (function(_this) {
                                    return function(v, k) {
                                        return _this.setMyScope(k, model, oldModel, isInit, doDraw);
                                    };
                                })(this));
                            case 'icon':
                                return this.maybeSetScopeValue({
                                    gSetter: this.setIcon,
                                    doDraw: doDraw
                                });
                            case 'coords':
                                return this.maybeSetScopeValue({
                                    gSetter: this.setCoords,
                                    doDraw: doDraw
                                });
                            case 'options':
                                if (!justCreated) {
                                    return this.createMarker(model, oldModel, isInit, doDraw);
                                }
                        }
                    };

                    MarkerChildModel.prototype.createMarker = function(model, oldModel, isInit, doDraw) {
                        if (oldModel == null) {
                            oldModel = void 0;
                        }
                        if (isInit == null) {
                            isInit = false;
                        }
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        this.maybeSetScopeValue({
                            gSetter: this.setOptions,
                            doDraw: doDraw
                        });
                        return this.firstTime = false;
                    };

                    MarkerChildModel.prototype.maybeSetScopeValue = function(arg) {
                        var doDraw, gSetter, ref;
                        gSetter = arg.gSetter, doDraw = (ref = arg.doDraw) != null ? ref : true;
                        if (gSetter != null) {
                            gSetter(this.scope, doDraw);
                        }
                        if (this.doDrawSelf && doDraw) {
                            return this.gManager.draw();
                        }
                    };

                    MarkerChildModel.prototype.isNotValid = function(scope, doCheckGmarker) {
                        var hasIdenticalScopes, hasNoGmarker;
                        if (doCheckGmarker == null) {
                            doCheckGmarker = true;
                        }
                        hasNoGmarker = !doCheckGmarker ? false : this.gObject === void 0;
                        hasIdenticalScopes = !this.trackModel ? scope.$id !== this.scope.$id : false;
                        return hasIdenticalScopes || hasNoGmarker;
                    };

                    MarkerChildModel.prototype.setCoords = function(scope, doDraw) {
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        if (this.isNotValid(scope) || (this.gObject == null)) {
                            return;
                        }
                        return this.renderGMarker(doDraw, (function(_this) {
                            return function() {
                                var newGValue, newModelVal, oldGValue;
                                newModelVal = _this.getProp('coords', scope, _this.model);
                                newGValue = _this.getCoords(newModelVal);
                                oldGValue = _this.gObject.getPosition();
                                if ((oldGValue != null) && (newGValue != null)) {
                                    if (newGValue.lng() === oldGValue.lng() && newGValue.lat() === oldGValue.lat()) {
                                        return;
                                    }
                                }
                                _this.gObject.setPosition(newGValue);
                                return _this.gObject.setVisible(_this.validateCoords(newModelVal));
                            };
                        })(this));
                    };

                    MarkerChildModel.prototype.setIcon = function(scope, doDraw) {
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        if (this.isNotValid(scope) || (this.gObject == null)) {
                            return;
                        }
                        return this.renderGMarker(doDraw, (function(_this) {
                            return function() {
                                var coords, newValue, oldValue;
                                oldValue = _this.gObject.getIcon();
                                newValue = _this.getProp('icon', scope, _this.model);
                                if (oldValue === newValue) {
                                    return;
                                }
                                _this.gObject.setIcon(newValue);
                                coords = _this.getProp('coords', scope, _this.model);
                                _this.gObject.setPosition(_this.getCoords(coords));
                                return _this.gObject.setVisible(_this.validateCoords(coords));
                            };
                        })(this));
                    };

                    MarkerChildModel.prototype.setOptions = function(scope, doDraw) {
                        var ref;
                        if (doDraw == null) {
                            doDraw = true;
                        }
                        if (this.isNotValid(scope, false)) {
                            return;
                        }
                        this.renderGMarker(doDraw, (function(_this) {
                            return function() {
                                var _options, coords, icon;
                                coords = _this.getProp('coords', scope, _this.model);
                                icon = _this.getProp('icon', scope, _this.model);
                                _options = _this.getProp('options', scope, _this.model);
                                _this.opts = _this.createOptions(coords, icon, _options);
                                if (_this.isLabel(_this.gObject) !== _this.isLabel(_this.opts) && (_this.gObject != null)) {
                                    _this.gManager.remove(_this.gObject);
                                    _this.gObject = void 0;
                                }
                                if (_this.gObject != null) {
                                    _this.gObject.setOptions(_this.setLabelOptions(_this.opts));
                                }
                                if (!_this.gObject) {
                                    if (_this.isLabel(_this.opts)) {
                                        _this.gObject = new MarkerWithLabel(_this.setLabelOptions(_this.opts));
                                    } else if (_this.opts.content) {
                                        _this.gObject = new RichMarker(_this.opts);
                                        _this.gObject.getIcon = _this.gObject.getContent;
                                        _this.gObject.setIcon = _this.gObject.setContent;
                                    } else {
                                        _this.gObject = new google.maps.Marker(_this.opts);
                                    }
                                    _.extend(_this.gObject, {
                                        model: _this.model
                                    });
                                }
                                if (_this.externalListeners) {
                                    _this.removeEvents(_this.externalListeners);
                                }
                                if (_this.internalListeners) {
                                    _this.removeEvents(_this.internalListeners);
                                }
                                _this.externalListeners = _this.setEvents(_this.gObject, _this.scope, _this.model, ['dragend']);
                                _this.internalListeners = _this.setEvents(_this.gObject, {
                                    events: _this.internalEvents(),
                                    $evalAsync: function() {}
                                }, _this.model);
                                if (_this.id != null) {
                                    return _this.gObject.key = _this.id;
                                }
                            };
                        })(this));
                        if (this.gObject && (this.gObject.getMap() || this.gManager.type !== MarkerManager.type)) {
                            this.deferred.resolve(this.gObject);
                        } else {
                            if (!this.gObject) {
                                return this.deferred.reject('gObject is null');
                            }
                            if (!(((ref = this.gObject) != null ? ref.getMap() : void 0) && this.gManager.type === MarkerManager.type)) {
                                $log.debug('gObject has no map yet');
                                this.deferred.resolve(this.gObject);
                            }
                        }
                        if (this.model[this.fitKey]) {
                            return this.gManager.fit();
                        }
                    };

                    MarkerChildModel.prototype.setLabelOptions = function(opts) {
                        if (opts.labelAnchor) {
                            opts.labelAnchor = this.getLabelPositionPoint(opts.labelAnchor);
                        }
                        return opts;
                    };

                    MarkerChildModel.prototype.internalEvents = function() {
                        return {
                            dragend: (function(_this) {
                                return function(marker, eventName, model, mousearg) {
                                    var events, modelToSet, newCoords;
                                    modelToSet = _this.trackModel ? _this.scope.model : _this.model;
                                    newCoords = _this.setCoordsFromEvent(_this.modelOrKey(modelToSet, _this.coordsKey), _this.gObject.getPosition());
                                    modelToSet = _this.setVal(model, _this.coordsKey, newCoords);
                                    events = _this.scope.events;
                                    if ((events != null ? events.dragend : void 0) != null) {
                                        events.dragend(marker, eventName, modelToSet, mousearg);
                                    }
                                    return _this.scope.$apply();
                                };
                            })(this),
                            click: (function(_this) {
                                return function(marker, eventName, model, mousearg) {
                                    var click;
                                    click = _this.getProp('click', _this.scope, _this.model);
                                    if (_this.doClick && angular.isFunction(click)) {
                                        return _this.scope.$evalAsync(click(marker, eventName, _this.model, mousearg));
                                    }
                                };
                            })(this)
                        };
                    };

                    return MarkerChildModel;

                })(ModelKey);
                return MarkerChildModel;
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygonChildModel', [
            'uiGmapBasePolyChildModel', 'uiGmapPolygonOptionsBuilder', function(BaseGen, Builder) {
                var PolygonChildModel, base, gFactory;
                gFactory = function(opts) {
                    return new google.maps.Polygon(opts);
                };
                base = new BaseGen(Builder, gFactory);
                return PolygonChildModel = (function(superClass) {
                    extend(PolygonChildModel, superClass);

                    function PolygonChildModel() {
                        return PolygonChildModel.__super__.constructor.apply(this, arguments);
                    }

                    return PolygonChildModel;

                })(base);
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolylineChildModel', [
            'uiGmapBasePolyChildModel', 'uiGmapPolylineOptionsBuilder', function(BaseGen, Builder) {
                var PolylineChildModel, base, gFactory;
                gFactory = function(opts) {
                    return new google.maps.Polyline(opts);
                };
                base = BaseGen(Builder, gFactory);
                return PolylineChildModel = (function(superClass) {
                    extend(PolylineChildModel, superClass);

                    function PolylineChildModel() {
                        return PolylineChildModel.__super__.constructor.apply(this, arguments);
                    }

                    return PolylineChildModel;

                })(base);
            }
        ]);

    }).call(this);
    ;
    /*global _:true,angular:true,google:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.child').factory('uiGmapWindowChildModel', [
            'uiGmapBaseObject', 'uiGmapGmapUtil', 'uiGmapLogger', '$compile', '$http', '$templateCache', 'uiGmapChromeFixes', 'uiGmapEventsHelper', function(BaseObject, GmapUtil, $log, $compile, $http, $templateCache, ChromeFixes, EventsHelper) {
                var WindowChildModel;
                WindowChildModel = (function(superClass) {
                    extend(WindowChildModel, superClass);

                    WindowChildModel.include(GmapUtil);

                    WindowChildModel.include(EventsHelper);

                    function WindowChildModel(opts) {
                        this.updateModel = bind(this.updateModel, this);
                        this.destroy = bind(this.destroy, this);
                        this.remove = bind(this.remove, this);
                        this.getLatestPosition = bind(this.getLatestPosition, this);
                        this.hideWindow = bind(this.hideWindow, this);
                        this.showWindow = bind(this.showWindow, this);
                        this.handleClick = bind(this.handleClick, this);
                        this.watchOptions = bind(this.watchOptions, this);
                        this.watchCoords = bind(this.watchCoords, this);
                        this.createGWin = bind(this.createGWin, this);
                        this.watchElement = bind(this.watchElement, this);
                        this.watchAndDoShow = bind(this.watchAndDoShow, this);
                        this.doShow = bind(this.doShow, this);
                        var maybeMarker, ref, ref1, ref2, ref3;
                        this.model = (ref = opts.model) != null ? ref : {}, this.scope = opts.scope, this.opts = opts.opts, this.isIconVisibleOnClick = opts.isIconVisibleOnClick, this.gMap = opts.gMap, this.markerScope = opts.markerScope, this.element = opts.element, this.needToManualDestroy = (ref1 = opts.needToManualDestroy) != null ? ref1 : false, this.markerIsVisibleAfterWindowClose = (ref2 = opts.markerIsVisibleAfterWindowClose) != null ? ref2 : true, this.isScopeModel = (ref3 = opts.isScopeModel) != null ? ref3 : false;
                        if (this.isScopeModel) {
                            this.clonedModel = _.clone(this.model, true);
                        }
                        this.getGmarker = function() {
                            var ref4, ref5;
                            if (((ref4 = this.markerScope) != null ? ref4['getGMarker'] : void 0) != null) {
                                return (ref5 = this.markerScope) != null ? ref5.getGMarker() : void 0;
                            }
                        };
                        this.listeners = [];
                        this.createGWin();
                        maybeMarker = this.getGmarker();
                        if (maybeMarker != null) {
                            maybeMarker.setClickable(true);
                        }
                        this.watchElement();
                        this.watchOptions();
                        this.watchCoords();
                        this.watchAndDoShow();
                        this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                return _this.destroy();
                            };
                        })(this));
                        $log.info(this);
                    }

                    WindowChildModel.prototype.doShow = function(wasOpen) {
                        if (this.scope.show === true || wasOpen) {
                            return this.showWindow();
                        } else {
                            return this.hideWindow();
                        }
                    };

                    WindowChildModel.prototype.watchAndDoShow = function() {
                        if (this.model.show != null) {
                            this.scope.show = this.model.show;
                        }
                        this.scope.$watch('show', this.doShow, true);
                        return this.doShow();
                    };

                    WindowChildModel.prototype.watchElement = function() {
                        return this.scope.$watch((function(_this) {
                            return function() {
                                var ref, wasOpen;
                                if (!(_this.element || _this.html)) {
                                    return;
                                }
                                if (_this.html !== _this.element.html() && _this.gObject) {
                                    if ((ref = _this.opts) != null) {
                                        ref.content = void 0;
                                    }
                                    wasOpen = _this.gObject.isOpen();
                                    _this.remove();
                                    return _this.createGWin(wasOpen);
                                }
                            };
                        })(this));
                    };

                    WindowChildModel.prototype.createGWin = function(isOpen) {
                        var _opts, defaults, maybeMarker, ref, ref1;
                        if (isOpen == null) {
                            isOpen = false;
                        }
                        maybeMarker = this.getGmarker();
                        defaults = {};
                        if (this.opts != null) {
                            if (this.scope.coords) {
                                this.opts.position = this.getCoords(this.scope.coords);
                            }
                            defaults = this.opts;
                        }
                        if (this.element) {
                            this.html = _.isObject(this.element) ? this.element.html() : this.element;
                        }
                        _opts = this.scope.options ? this.scope.options : defaults;
                        this.opts = this.createWindowOptions(maybeMarker, this.markerScope || this.scope, this.html, _opts);
                        if (this.opts != null) {
                            if (!this.gObject) {
                                if (this.opts.boxClass && (window.InfoBox && typeof window.InfoBox === 'function')) {
                                    this.gObject = new window.InfoBox(this.opts);
                                } else {
                                    this.gObject = new google.maps.InfoWindow(this.opts);
                                }
                                this.listeners.push(google.maps.event.addListener(this.gObject, 'domready', function() {
                                    return ChromeFixes.maybeRepaint(this.content);
                                }));
                                this.listeners.push(google.maps.event.addListener(this.gObject, 'closeclick', (function(_this) {
                                    return function() {
                                        if (maybeMarker) {
                                            maybeMarker.setAnimation(_this.oldMarkerAnimation);
                                            if (_this.markerIsVisibleAfterWindowClose) {
                                                _.delay(function() {
                                                    maybeMarker.setVisible(false);
                                                    return maybeMarker.setVisible(_this.markerIsVisibleAfterWindowClose);
                                                }, 250);
                                            }
                                        }
                                        _this.gObject.close();
                                        _this.model.show = false;
                                        if (_this.scope.closeClick != null) {
                                            return _this.scope.$evalAsync(_this.scope.closeClick());
                                        } else {
                                            return _this.scope.$evalAsync();
                                        }
                                    };
                                })(this)));
                            }
                            this.gObject.setContent(this.opts.content);
                            this.handleClick(((ref = this.scope) != null ? (ref1 = ref.options) != null ? ref1.forceClick : void 0 : void 0) || isOpen);
                            return this.doShow(this.gObject.isOpen());
                        }
                    };

                    WindowChildModel.prototype.watchCoords = function() {
                        var scope;
                        scope = this.markerScope != null ? this.markerScope : this.scope;
                        return scope.$watch('coords', (function(_this) {
                            return function(newValue, oldValue) {
                                var pos;
                                if (newValue !== oldValue) {
                                    if (newValue == null) {
                                        _this.hideWindow();
                                    } else if (!_this.validateCoords(newValue)) {
                                        $log.error("WindowChildMarker cannot render marker as scope.coords as no position on marker: " + (JSON.stringify(_this.model)));
                                        return;
                                    }
                                    pos = _this.getCoords(newValue);
                                    _this.doShow();
                                    _this.gObject.setPosition(pos);
                                    if (_this.opts) {
                                        return _this.opts.position = pos;
                                    }
                                }
                            };
                        })(this), true);
                    };

                    WindowChildModel.prototype.watchOptions = function() {
                        return this.scope.$watch('options', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    _this.opts = newValue;
                                    if (_this.gObject != null) {
                                        _this.gObject.setOptions(_this.opts);
                                        if ((_this.opts.visible != null) && _this.opts.visible) {
                                            return _this.showWindow();
                                        } else if (_this.opts.visible != null) {
                                            return _this.hideWindow();
                                        }
                                    }
                                }
                            };
                        })(this), true);
                    };

                    WindowChildModel.prototype.handleClick = function(forceClick) {
                        var click, maybeMarker;
                        if (this.gObject == null) {
                            return;
                        }
                        maybeMarker = this.getGmarker();
                        click = (function(_this) {
                            return function() {
                                if (_this.gObject == null) {
                                    _this.createGWin();
                                }
                                _this.showWindow();
                                if (maybeMarker != null) {
                                    _this.initialMarkerVisibility = maybeMarker.getVisible();
                                    _this.oldMarkerAnimation = maybeMarker.getAnimation();
                                    return maybeMarker.setVisible(_this.isIconVisibleOnClick);
                                }
                            };
                        })(this);
                        if (forceClick) {
                            click();
                        }
                        if (maybeMarker) {
                            return this.listeners = this.listeners.concat(this.setEvents(maybeMarker, {
                                events: {
                                    click: click
                                }
                            }, this.model));
                        }
                    };

                    WindowChildModel.prototype.showWindow = function() {
                        var compiled, show, templateScope;
                        if (this.gObject == null) {
                            return;
                        }
                        templateScope = null;
                        show = (function(_this) {
                            return function() {
                                var isOpen, maybeMarker, pos;
                                if (!_this.gObject.isOpen()) {
                                    maybeMarker = _this.getGmarker();
                                    if ((_this.gObject != null) && (_this.gObject.getPosition != null)) {
                                        pos = _this.gObject.getPosition();
                                    }
                                    if (maybeMarker) {
                                        pos = maybeMarker.getPosition();
                                    }
                                    if (!pos) {
                                        return;
                                    }
                                    _this.gObject.open(_this.gMap, maybeMarker);
                                    isOpen = _this.gObject.isOpen();
                                    if (_this.model.show !== isOpen) {
                                        return _this.model.show = isOpen;
                                    }
                                }
                            };
                        })(this);
                        if (this.scope.templateUrl) {
                            $http.get(this.scope.templateUrl, {
                                cache: $templateCache
                            }).then((function(_this) {
                                return function(content) {
                                    var compiled;
                                    templateScope = _this.scope.$new();
                                    if (angular.isDefined(_this.scope.templateParameter)) {
                                        templateScope.parameter = _this.scope.templateParameter;
                                    }
                                    compiled = $compile(content.data)(templateScope);
                                    _this.gObject.setContent(compiled[0]);
                                    return show();
                                };
                            })(this));
                        } else if (this.scope.template) {
                            templateScope = this.scope.$new();
                            if (angular.isDefined(this.scope.templateParameter)) {
                                templateScope.parameter = this.scope.templateParameter;
                            }
                            compiled = $compile(this.scope.template)(templateScope);
                            this.gObject.setContent(compiled[0]);
                            show();
                        } else {
                            show();
                        }
                        return this.scope.$on('destroy', function() {
                            return templateScope.$destroy();
                        });
                    };

                    WindowChildModel.prototype.hideWindow = function() {
                        if ((this.gObject != null) && this.gObject.isOpen()) {
                            return this.gObject.close();
                        }
                    };

                    WindowChildModel.prototype.getLatestPosition = function(overridePos) {
                        var maybeMarker;
                        maybeMarker = this.getGmarker();
                        if ((this.gObject != null) && (maybeMarker != null) && !overridePos) {
                            return this.gObject.setPosition(maybeMarker.getPosition());
                        } else {
                            if (overridePos) {
                                return this.gObject.setPosition(overridePos);
                            }
                        }
                    };

                    WindowChildModel.prototype.remove = function() {
                        this.hideWindow();
                        this.removeEvents(this.listeners);
                        this.listeners.length = 0;
                        delete this.gObject;
                        return delete this.opts;
                    };

                    WindowChildModel.prototype.destroy = function(manualOverride) {
                        var ref;
                        if (manualOverride == null) {
                            manualOverride = false;
                        }
                        this.remove();
                        if (((this.scope != null) && !((ref = this.scope) != null ? ref.$$destroyed : void 0)) && (this.needToManualDestroy || manualOverride)) {
                            return this.scope.$destroy();
                        }
                    };

                    WindowChildModel.prototype.updateModel = function(model) {
                        if (this.isScopeModel) {
                            this.clonedModel = _.clone(model, true);
                        }
                        return _.extend(this.model, this.clonedModel || model);
                    };

                    return WindowChildModel;

                })(BaseObject);
                return WindowChildModel;
            }
        ]);

    }).call(this);
    ;
    /*global _, angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapBasePolysParentModel', [
            '$timeout', 'uiGmapLogger', 'uiGmapModelKey', 'uiGmapModelsWatcher', 'uiGmapPropMap', 'uiGmap_async', 'uiGmapPromise', 'uiGmapFitHelper', function($timeout, $log, ModelKey, ModelsWatcher, PropMap, _async, uiGmapPromise, FitHelper) {
                return function(IPoly, PolyChildModel, gObjectName) {
                    var BasePolysParentModel;
                    return BasePolysParentModel = (function(superClass) {
                        extend(BasePolysParentModel, superClass);

                        BasePolysParentModel.include(ModelsWatcher);

                        function BasePolysParentModel(scope, element, attrs, gMap1, defaults) {
                            this.element = element;
                            this.attrs = attrs;
                            this.gMap = gMap1;
                            this.defaults = defaults;
                            this.maybeFit = bind(this.maybeFit, this);
                            this.createChild = bind(this.createChild, this);
                            this.pieceMeal = bind(this.pieceMeal, this);
                            this.createAllNew = bind(this.createAllNew, this);
                            this.watchIdKey = bind(this.watchIdKey, this);
                            this.createChildScopes = bind(this.createChildScopes, this);
                            this.watchDestroy = bind(this.watchDestroy, this);
                            this.onDestroy = bind(this.onDestroy, this);
                            this.rebuildAll = bind(this.rebuildAll, this);
                            this.doINeedToWipe = bind(this.doINeedToWipe, this);
                            this.watchModels = bind(this.watchModels, this);
                            BasePolysParentModel.__super__.constructor.call(this, scope);
                            this["interface"] = IPoly;
                            this.$log = $log;
                            this.plurals = new PropMap();
                            _.each(IPoly.scopeKeys, (function(_this) {
                                return function(name) {
                                    return _this[name + 'Key'] = void 0;
                                };
                            })(this));
                            this.models = void 0;
                            this.firstTime = true;
                            this.$log.info(this);
                            this.createChildScopes();
                        }

                        BasePolysParentModel.prototype.watchModels = function(scope) {

                            /*
                             This was watchCollection but not all model changes were being caught.
                             TODO: Make the directive flexible in overriding whether we watch models (and depth) via watch or watchColleciton.
                             */
                            return scope.$watch('models', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (newValue !== oldValue) {
                                        if (_this.doINeedToWipe(newValue) || scope.doRebuildAll) {
                                            return _this.rebuildAll(scope, true, true);
                                        } else {
                                            return _this.createChildScopes(false);
                                        }
                                    }
                                };
                            })(this), true);
                        };

                        BasePolysParentModel.prototype.doINeedToWipe = function(newValue) {
                            var newValueIsEmpty;
                            newValueIsEmpty = newValue != null ? newValue.length === 0 : true;
                            return this.plurals.length > 0 && newValueIsEmpty;
                        };

                        BasePolysParentModel.prototype.rebuildAll = function(scope, doCreate, doDelete) {
                            return this.onDestroy(doDelete).then((function(_this) {
                                return function() {
                                    if (doCreate) {
                                        return _this.createChildScopes();
                                    }
                                };
                            })(this));
                        };

                        BasePolysParentModel.prototype.onDestroy = function() {
                            BasePolysParentModel.__super__.onDestroy.call(this, this.scope);
                            return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
                                return function() {
                                    return _async.each(_this.plurals.values(), function(child) {
                                        return child.destroy(true);
                                    }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
                                        var ref;
                                        return (ref = _this.plurals) != null ? ref.removeAll() : void 0;
                                    });
                                };
                            })(this));
                        };

                        BasePolysParentModel.prototype.watchDestroy = function(scope) {
                            return scope.$on('$destroy', (function(_this) {
                                return function() {
                                    return _this.rebuildAll(scope, false, true);
                                };
                            })(this));
                        };

                        BasePolysParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
                            if (isCreatingFromScratch == null) {
                                isCreatingFromScratch = true;
                            }
                            if (angular.isUndefined(this.scope.models)) {
                                this.$log.error("No models to create " + gObjectName + "s from! I Need direct models!");
                                return;
                            }
                            if ((this.gMap == null) || (this.scope.models == null)) {
                                return;
                            }
                            this.watchIdKey(this.scope);
                            if (isCreatingFromScratch) {
                                return this.createAllNew(this.scope, false);
                            } else {
                                return this.pieceMeal(this.scope, false);
                            }
                        };

                        BasePolysParentModel.prototype.watchIdKey = function(scope) {
                            this.setIdKey(scope);
                            return scope.$watch('idKey', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (newValue !== oldValue && (newValue == null)) {
                                        _this.idKey = newValue;
                                        return _this.rebuildAll(scope, true, true);
                                    }
                                };
                            })(this));
                        };

                        BasePolysParentModel.prototype.createAllNew = function(scope, isArray) {
                            var maybeCanceled;
                            if (isArray == null) {
                                isArray = false;
                            }
                            this.models = scope.models;
                            if (this.firstTime) {
                                this.watchModels(scope);
                                this.watchDestroy(scope);
                            }
                            if (this.didQueueInitPromise(this, scope)) {
                                return;
                            }
                            maybeCanceled = null;
                            return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
                                return maybeCanceled = canceledMsg;
                            }), (function(_this) {
                                return function() {
                                    return _async.map(scope.models, function(model) {
                                        var child;
                                        child = _this.createChild(model, _this.gMap);
                                        if (maybeCanceled) {
                                            $log.debug('createNew should fall through safely');
                                            child.isEnabled = false;
                                        }
                                        maybeCanceled;
                                        return child.pathPoints.getArray();
                                    }, _async.chunkSizeFrom(scope.chunk)).then(function(pathPoints) {
                                        _this.maybeFit(pathPoints);
                                        return _this.firstTime = false;
                                    });
                                };
                            })(this));
                        };

                        BasePolysParentModel.prototype.pieceMeal = function(scope, isArray) {
                            var maybeCanceled, payload;
                            if (isArray == null) {
                                isArray = true;
                            }
                            if (scope.$$destroyed) {
                                return;
                            }
                            maybeCanceled = null;
                            payload = null;
                            this.models = scope.models;
                            if ((scope != null) && this.modelsLength() && this.plurals.length) {
                                return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
                                    return maybeCanceled = canceledMsg;
                                }), (function(_this) {
                                    return function() {
                                        return uiGmapPromise.promise(function() {
                                            return _this.figureOutState(_this.idKey, scope, _this.plurals, _this.modelKeyComparison);
                                        }).then(function(state) {
                                            payload = state;
                                            if (payload.updates.length) {
                                                _async.each(payload.updates, function(obj) {
                                                    _.extend(obj.child.scope, obj.model);
                                                    return obj.child.model = obj.model;
                                                });
                                            }
                                            return _async.each(payload.removals, function(child) {
                                                if (child != null) {
                                                    child.destroy();
                                                    _this.plurals.remove(child.model[_this.idKey]);
                                                    return maybeCanceled;
                                                }
                                            }, _async.chunkSizeFrom(scope.chunk));
                                        }).then(function() {
                                            return _async.each(payload.adds, function(modelToAdd) {
                                                if (maybeCanceled) {
                                                    $log.debug('pieceMeal should fall through safely');
                                                }
                                                _this.createChild(modelToAdd, _this.gMap);
                                                return maybeCanceled;
                                            }, _async.chunkSizeFrom(scope.chunk)).then(function() {
                                                return _this.maybeFit();
                                            });
                                        });
                                    };
                                })(this));
                            } else {
                                this.inProgress = false;
                                return this.rebuildAll(this.scope, true, true);
                            }
                        };

                        BasePolysParentModel.prototype.createChild = function(model, gMap) {
                            var child, childScope;
                            childScope = this.scope.$new(false);
                            this.setChildScope(IPoly.scopeKeys, childScope, model);
                            childScope.$watch('model', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (newValue !== oldValue) {
                                        return _this.setChildScope(childScope, newValue);
                                    }
                                };
                            })(this), true);
                            childScope["static"] = this.scope["static"];
                            child = new PolyChildModel({
                                isScopeModel: true,
                                scope: childScope,
                                attrs: this.attrs,
                                gMap: gMap,
                                defaults: this.defaults,
                                model: model,
                                gObjectChangeCb: (function(_this) {
                                    return function() {
                                        return _this.maybeFit();
                                    };
                                })(this)
                            });
                            if (model[this.idKey] == null) {
                                this.$log.error(gObjectName + " model has no id to assign a child to.\nThis is required for performance. Please assign id,\nor redirect id to a different key.");
                                return;
                            }
                            this.plurals.put(model[this.idKey], child);
                            return child;
                        };

                        BasePolysParentModel.prototype.maybeFit = function(pathPoints) {
                            if (pathPoints == null) {
                                pathPoints = this.plurals.map(function(p) {
                                    return p.pathPoints;
                                });
                            }
                            if (this.scope.fit) {
                                pathPoints = _.flatten(pathPoints);
                                return FitHelper.fit(pathPoints, this.gMap);
                            }
                        };

                        return BasePolysParentModel;

                    })(ModelKey);
                };
            }
        ]);

    }).call(this);
    ;
    /*globals angular, _, google */

    (function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapCircleParentModel', [
            'uiGmapLogger', '$timeout', 'uiGmapGmapUtil', 'uiGmapEventsHelper', 'uiGmapCircleOptionsBuilder', function($log, $timeout, GmapUtil, EventsHelper, Builder) {
                var CircleParentModel, _settingFromDirective;
                _settingFromDirective = function(scope, fn) {
                    scope.settingFromDirective = true;
                    fn();
                    return $timeout(function() {
                        return scope.settingFromDirective = false;
                    });
                };
                return CircleParentModel = (function(superClass) {
                    extend(CircleParentModel, superClass);

                    CircleParentModel.include(GmapUtil);

                    CircleParentModel.include(EventsHelper);

                    function CircleParentModel(scope, element, attrs, gMap, DEFAULTS) {
                        var clean, gObject, lastRadius;
                        this.attrs = attrs;
                        this.gMap = gMap;
                        this.DEFAULTS = DEFAULTS;
                        this.scope = scope;
                        lastRadius = null;
                        clean = (function(_this) {
                            return function() {
                                lastRadius = null;
                                if (_this.listeners != null) {
                                    _this.removeEvents(_this.listeners);
                                    return _this.listeners = void 0;
                                }
                            };
                        })(this);
                        gObject = new google.maps.Circle(this.buildOpts(GmapUtil.getCoords(scope.center), scope.radius));
                        this.setMyOptions = (function(_this) {
                            return function(newVals, oldVals) {
                                if (scope.settingFromDirective) {
                                    return;
                                }
                                if (!(_.isEqual(newVals, oldVals) && newVals === oldVals && ((newVals != null) && (oldVals != null) ? newVals.coordinates === oldVals.coordinates : true))) {
                                    return gObject.setOptions(_this.buildOpts(GmapUtil.getCoords(scope.center), scope.radius));
                                }
                            };
                        })(this);
                        this.props = this.props.concat([
                            {
                                prop: 'center',
                                isColl: true
                            }, {
                                prop: 'fill',
                                isColl: true
                            }, 'radius', 'zIndex'
                        ]);
                        this.watchProps();
                        if (this.scope.control != null) {
                            this.scope.control.getCircle = function() {
                                return gObject;
                            };
                        }
                        clean();
                        this.listeners = this.setEvents(gObject, scope, scope, ['radius_changed']) || [];
                        this.listeners.push(google.maps.event.addListener(gObject, 'radius_changed', function() {

                            /*
                             possible google bug, and or because a circle has two radii
                             radius_changed appears to fire twice (original and new) which is not too helpful
                             therefore we will check for radius changes manually and bail out if nothing has changed
                             */
                            var newRadius, work;
                            newRadius = gObject.getRadius();
                            if (newRadius === lastRadius) {
                                return;
                            }
                            lastRadius = newRadius;
                            work = function() {
                                return _settingFromDirective(scope, function() {
                                    var ref, ref1;
                                    if (newRadius !== scope.radius) {
                                        scope.radius = newRadius;
                                    }
                                    if (((ref = scope.events) != null ? ref.radius_changed : void 0) && _.isFunction((ref1 = scope.events) != null ? ref1.radius_changed : void 0)) {
                                        return scope.events.radius_changed(gObject, 'radius_changed', scope, arguments);
                                    }
                                });
                            };
                            if (!angular.mock) {
                                return scope.$evalAsync(function() {
                                    return work();
                                });
                            } else {
                                return work();
                            }
                        }));
                        this.listeners.push(google.maps.event.addListener(gObject, 'center_changed', function() {
                            return scope.$evalAsync(function() {
                                return _settingFromDirective(scope, function() {
                                    if (angular.isDefined(scope.center.type)) {
                                        scope.center.coordinates[1] = gObject.getCenter().lat();
                                        return scope.center.coordinates[0] = gObject.getCenter().lng();
                                    } else {
                                        scope.center.latitude = gObject.getCenter().lat();
                                        return scope.center.longitude = gObject.getCenter().lng();
                                    }
                                });
                            });
                        }));
                        scope.$on('$destroy', function() {
                            clean();
                            return gObject.setMap(null);
                        });
                        $log.info(this);
                    }

                    return CircleParentModel;

                })(Builder);
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapDrawingManagerParentModel', [
            'uiGmapLogger', '$timeout', 'uiGmapBaseObject', 'uiGmapEventsHelper', function($log, $timeout, BaseObject, EventsHelper) {
                var DrawingManagerParentModel;
                return DrawingManagerParentModel = (function(superClass) {
                    extend(DrawingManagerParentModel, superClass);

                    DrawingManagerParentModel.include(EventsHelper);

                    function DrawingManagerParentModel(scope, element, attrs, map) {
                        var gObject, listeners;
                        this.scope = scope;
                        this.attrs = attrs;
                        this.map = map;
                        gObject = new google.maps.drawing.DrawingManager(this.scope.options);
                        gObject.setMap(this.map);
                        listeners = void 0;
                        if (this.scope.control != null) {
                            this.scope.control.getDrawingManager = function() {
                                return gObject;
                            };
                        }
                        if (!this.scope["static"] && this.scope.options) {
                            this.scope.$watch('options', function(newValue) {
                                return gObject != null ? gObject.setOptions(newValue) : void 0;
                            }, true);
                        }
                        if (this.scope.events != null) {
                            listeners = this.setEvents(gObject, this.scope, this.scope);
                            this.scope.$watch('events', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (!_.isEqual(newValue, oldValue)) {
                                        if (listeners != null) {
                                            _this.removeEvents(listeners);
                                        }
                                        return listeners = _this.setEvents(gObject, _this.scope, _this.scope);
                                    }
                                };
                            })(this));
                        }
                        this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                if (listeners != null) {
                                    _this.removeEvents(listeners);
                                }
                                gObject.setMap(null);
                                return gObject = null;
                            };
                        })(this));
                    }

                    return DrawingManagerParentModel;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;
    /*
     - interface for all markers to derrive from
     - to enforce a minimum set of requirements
     - attributes
     - coords
     - icon
     - implementation needed on watches
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapIMarkerParentModel", [
            "uiGmapModelKey", "uiGmapLogger", function(ModelKey, Logger) {
                var IMarkerParentModel;
                IMarkerParentModel = (function(superClass) {
                    extend(IMarkerParentModel, superClass);

                    IMarkerParentModel.prototype.DEFAULTS = {};

                    function IMarkerParentModel(scope1, element, attrs, map) {
                        this.scope = scope1;
                        this.element = element;
                        this.attrs = attrs;
                        this.map = map;
                        this.onWatch = bind(this.onWatch, this);
                        this.watch = bind(this.watch, this);
                        this.validateScope = bind(this.validateScope, this);
                        IMarkerParentModel.__super__.constructor.call(this, this.scope);
                        this.$log = Logger;
                        if (!this.validateScope(this.scope)) {
                            throw new String("Unable to construct IMarkerParentModel due to invalid scope");
                        }
                        this.doClick = angular.isDefined(this.attrs.click);
                        if (this.scope.options != null) {
                            this.DEFAULTS = this.scope.options;
                        }
                        this.watch('coords', this.scope);
                        this.watch('icon', this.scope);
                        this.watch('options', this.scope);
                        this.scope.$on("$destroy", (function(_this) {
                            return function() {
                                return _this.onDestroy(_this.scope);
                            };
                        })(this));
                    }

                    IMarkerParentModel.prototype.validateScope = function(scope) {
                        var ret;
                        if (scope == null) {
                            this.$log.error(this.constructor.name + ": invalid scope used");
                            return false;
                        }
                        ret = scope.coords != null;
                        if (!ret) {
                            this.$log.error(this.constructor.name + ": no valid coords attribute found");
                            return false;
                        }
                        return ret;
                    };

                    IMarkerParentModel.prototype.watch = function(propNameToWatch, scope, equalityCheck) {
                        if (equalityCheck == null) {
                            equalityCheck = true;
                        }
                        return scope.$watch(propNameToWatch, (function(_this) {
                            return function(newValue, oldValue) {
                                if (!_.isEqual(newValue, oldValue)) {
                                    return _this.onWatch(propNameToWatch, scope, newValue, oldValue);
                                }
                            };
                        })(this), equalityCheck);
                    };

                    IMarkerParentModel.prototype.onWatch = function(propNameToWatch, scope, newValue, oldValue) {};

                    return IMarkerParentModel;

                })(ModelKey);
                return IMarkerParentModel;
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapIWindowParentModel", [
            "uiGmapModelKey", "uiGmapGmapUtil", "uiGmapLogger", function(ModelKey, GmapUtil, Logger) {
                var IWindowParentModel;
                return IWindowParentModel = (function(superClass) {
                    extend(IWindowParentModel, superClass);

                    IWindowParentModel.include(GmapUtil);

                    function IWindowParentModel(scope, element, attrs, ctrls, $timeout, $compile, $http, $templateCache) {
                        IWindowParentModel.__super__.constructor.call(this, scope);
                        this.$log = Logger;
                        this.$timeout = $timeout;
                        this.$compile = $compile;
                        this.$http = $http;
                        this.$templateCache = $templateCache;
                        this.DEFAULTS = {};
                        if (scope.options != null) {
                            this.DEFAULTS = scope.options;
                        }
                    }

                    IWindowParentModel.prototype.getItem = function(scope, modelsPropToIterate, index) {
                        if (modelsPropToIterate === 'models') {
                            return scope[modelsPropToIterate][index];
                        }
                        return scope[modelsPropToIterate].get(index);
                    };

                    return IWindowParentModel;

                })(ModelKey);
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapLayerParentModel', [
            'uiGmapBaseObject', 'uiGmapLogger', '$timeout', function(BaseObject, Logger, $timeout) {
                var LayerParentModel;
                LayerParentModel = (function(superClass) {
                    extend(LayerParentModel, superClass);

                    function LayerParentModel(scope, element, attrs, gMap, onLayerCreated, $log) {
                        this.scope = scope;
                        this.element = element;
                        this.attrs = attrs;
                        this.gMap = gMap;
                        this.onLayerCreated = onLayerCreated != null ? onLayerCreated : void 0;
                        this.$log = $log != null ? $log : Logger;
                        this.createGoogleLayer = bind(this.createGoogleLayer, this);
                        if (this.attrs.type == null) {
                            this.$log.info('type attribute for the layer directive is mandatory. Layer creation aborted!!');
                            return;
                        }
                        this.createGoogleLayer();
                        this.doShow = true;
                        if (angular.isDefined(this.attrs.show)) {
                            this.doShow = this.scope.show;
                        }
                        if (this.doShow && (this.gMap != null)) {
                            this.gObject.setMap(this.gMap);
                        }
                        this.scope.$watch('show', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    _this.doShow = newValue;
                                    if (newValue) {
                                        return _this.gObject.setMap(_this.gMap);
                                    } else {
                                        return _this.gObject.setMap(null);
                                    }
                                }
                            };
                        })(this), true);
                        this.scope.$watch('options', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue && _this.doShow) {
                                    return _this.gObject.setOptions(newValue);
                                }
                            };
                        })(this), true);
                        this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                return _this.gObject.setMap(null);
                            };
                        })(this));
                    }

                    LayerParentModel.prototype.createGoogleLayer = function() {
                        var base;
                        if (this.attrs.options == null) {
                            this.gObject = this.attrs.namespace === void 0 ? new google.maps[this.attrs.type]() : new google.maps[this.attrs.namespace][this.attrs.type]();
                        } else {
                            this.gObject = this.attrs.namespace === void 0 ? new google.maps[this.attrs.type](this.scope.options) : new google.maps[this.attrs.namespace][this.attrs.type](this.scope.options);
                        }
                        if ((this.gObject != null) && this.doShow) {
                            this.gObject.setMap(this.gMap);
                        }
                        if ((this.gObject != null) && (this.onLayerCreated != null)) {
                            return typeof (base = this.onLayerCreated(this.scope, this.gObject)) === "function" ? base(this.gObject) : void 0;
                        }
                    };

                    return LayerParentModel;

                })(BaseObject);
                return LayerParentModel;
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapMapTypeParentModel', [
            'uiGmapBaseObject', 'uiGmapLogger', function(BaseObject, Logger) {
                var MapTypeParentModel;
                MapTypeParentModel = (function(superClass) {
                    extend(MapTypeParentModel, superClass);

                    function MapTypeParentModel(scope, element, attrs, gMap, $log) {
                        this.scope = scope;
                        this.element = element;
                        this.attrs = attrs;
                        this.gMap = gMap;
                        this.$log = $log != null ? $log : Logger;
                        this.hideOverlay = bind(this.hideOverlay, this);
                        this.showOverlay = bind(this.showOverlay, this);
                        this.refreshMapType = bind(this.refreshMapType, this);
                        this.createMapType = bind(this.createMapType, this);
                        if (this.attrs.options == null) {
                            this.$log.info('options attribute for the map-type directive is mandatory. Map type creation aborted!!');
                            return;
                        }
                        this.id = this.gMap.overlayMapTypesCount = this.gMap.overlayMapTypesCount + 1 || 0;
                        this.doShow = true;
                        this.createMapType();
                        if (angular.isDefined(this.attrs.show)) {
                            this.doShow = this.scope.show;
                        }
                        if (this.doShow && (this.gMap != null)) {
                            this.showOverlay();
                        }
                        this.scope.$watch('show', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    _this.doShow = newValue;
                                    if (newValue) {
                                        return _this.showOverlay();
                                    } else {
                                        return _this.hideOverlay();
                                    }
                                }
                            };
                        })(this), true);
                        this.scope.$watchCollection('options', (function(_this) {
                            return function(newValue, oldValue) {
                                var different, mapTypeProps;
                                if (!_.isEqual(newValue, oldValue)) {
                                    mapTypeProps = ['tileSize', 'maxZoom', 'minZoom', 'name', 'alt'];
                                    different = _.some(mapTypeProps, function(prop) {
                                        return !oldValue || !newValue || !_.isEqual(newValue[prop], oldValue[prop]);
                                    });
                                    if (different) {
                                        return _this.refreshMapType();
                                    }
                                }
                            };
                        })(this));
                        if (angular.isDefined(this.attrs.refresh)) {
                            this.scope.$watch('refresh', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (!_.isEqual(newValue, oldValue)) {
                                        return _this.refreshMapType();
                                    }
                                };
                            })(this), true);
                        }
                        this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                _this.hideOverlay();
                                return _this.mapType = null;
                            };
                        })(this));
                    }

                    MapTypeParentModel.prototype.createMapType = function() {
                        if (this.scope.options.getTile != null) {
                            this.mapType = this.scope.options;
                        } else if (this.scope.options.getTileUrl != null) {
                            this.mapType = new google.maps.ImageMapType(this.scope.options);
                        } else {
                            this.$log.info('options should provide either getTile or getTileUrl methods. Map type creation aborted!!');
                            return;
                        }
                        if (this.attrs.id && this.scope.id) {
                            this.gMap.mapTypes.set(this.scope.id, this.mapType);
                            if (!angular.isDefined(this.attrs.show)) {
                                this.doShow = false;
                            }
                        }
                        return this.mapType.layerId = this.id;
                    };

                    MapTypeParentModel.prototype.refreshMapType = function() {
                        this.hideOverlay();
                        this.mapType = null;
                        this.createMapType();
                        if (this.doShow && (this.gMap != null)) {
                            return this.showOverlay();
                        }
                    };

                    MapTypeParentModel.prototype.showOverlay = function() {
                        return this.gMap.overlayMapTypes.push(this.mapType);
                    };

                    MapTypeParentModel.prototype.hideOverlay = function() {
                        var found;
                        found = false;
                        return this.gMap.overlayMapTypes.forEach((function(_this) {
                            return function(mapType, index) {
                                if (!found && mapType.layerId === _this.id) {
                                    found = true;
                                    _this.gMap.overlayMapTypes.removeAt(index);
                                }
                            };
                        })(this));
                    };

                    return MapTypeParentModel;

                })(BaseObject);
                return MapTypeParentModel;
            }
        ]);

    }).call(this);
    ;
    /*global _:true,angular:true, */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api.models.parent").factory("uiGmapMarkersParentModel", [
            "uiGmapIMarkerParentModel", "uiGmapModelsWatcher", "uiGmapPropMap", "uiGmapMarkerChildModel", "uiGmap_async", "uiGmapClustererMarkerManager", "uiGmapMarkerManager", "$timeout", "uiGmapIMarker", "uiGmapPromise", "uiGmapGmapUtil", "uiGmapLogger", "uiGmapSpiderfierMarkerManager", function(IMarkerParentModel, ModelsWatcher, PropMap, MarkerChildModel, _async, ClustererMarkerManager, MarkerManager, $timeout, IMarker, uiGmapPromise, GmapUtil, $log, SpiderfierMarkerManager) {
                var MarkersParentModel, _setPlurals;
                _setPlurals = function(val, objToSet) {
                    objToSet.plurals = new PropMap();
                    objToSet.scope.plurals = objToSet.plurals;
                    return objToSet;
                };
                MarkersParentModel = (function(superClass) {
                    extend(MarkersParentModel, superClass);

                    MarkersParentModel.include(GmapUtil);

                    MarkersParentModel.include(ModelsWatcher);

                    function MarkersParentModel(scope, element, attrs, map) {
                        this.maybeExecMappedEvent = bind(this.maybeExecMappedEvent, this);
                        this.onDestroy = bind(this.onDestroy, this);
                        this.newChildMarker = bind(this.newChildMarker, this);
                        this.pieceMeal = bind(this.pieceMeal, this);
                        this.rebuildAll = bind(this.rebuildAll, this);
                        this.createAllNew = bind(this.createAllNew, this);
                        this.bindToTypeEvents = bind(this.bindToTypeEvents, this);
                        this.createChildScopes = bind(this.createChildScopes, this);
                        this.validateScope = bind(this.validateScope, this);
                        this.onWatch = bind(this.onWatch, this);
                        MarkersParentModel.__super__.constructor.call(this, scope, element, attrs, map);
                        this["interface"] = IMarker;
                        _setPlurals(new PropMap(), this);
                        this.scope.pluralsUpdate = {
                            updateCtr: 0
                        };
                        this.$log.info(this);
                        this.doRebuildAll = this.scope.doRebuildAll != null ? this.scope.doRebuildAll : false;
                        this.setIdKey(this.scope);
                        this.scope.$watch('doRebuildAll', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    return _this.doRebuildAll = newValue;
                                }
                            };
                        })(this));
                        if (!this.modelsLength()) {
                            this.modelsRendered = false;
                        }
                        this.scope.$watch('models', (function(_this) {
                            return function(newValue, oldValue) {
                                if (!_.isEqual(newValue, oldValue) || !_this.modelsRendered) {
                                    if (newValue.length === 0 && oldValue.length === 0) {
                                        return;
                                    }
                                    _this.modelsRendered = true;
                                    return _this.onWatch('models', _this.scope, newValue, oldValue);
                                }
                            };
                        })(this), !this.isTrue(attrs.modelsbyref));
                        this.watch('doCluster', this.scope);
                        this.watch('type', this.scope);
                        this.watch('clusterOptions', this.scope);
                        this.watch('clusterEvents', this.scope);
                        this.watch('typeOptions', this.scope);
                        this.watch('typeEvents', this.scope);
                        this.watch('fit', this.scope);
                        this.watch('idKey', this.scope);
                        this.gManager = void 0;
                        this.createAllNew(this.scope);
                    }

                    MarkersParentModel.prototype.onWatch = function(propNameToWatch, scope, newValue, oldValue) {
                        if (propNameToWatch === "idKey" && newValue !== oldValue) {
                            this.idKey = newValue;
                        }
                        if (this.doRebuildAll || (propNameToWatch === 'doCluster' || propNameToWatch === 'type')) {
                            return this.rebuildAll(scope);
                        } else {
                            return this.pieceMeal(scope);
                        }
                    };

                    MarkersParentModel.prototype.validateScope = function(scope) {
                        var modelsNotDefined;
                        modelsNotDefined = angular.isUndefined(scope.models) || scope.models === void 0;
                        if (modelsNotDefined) {
                            this.$log.error(this.constructor.name + ": no valid models attribute found");
                        }
                        return MarkersParentModel.__super__.validateScope.call(this, scope) || modelsNotDefined;
                    };


                    /*
                     Not used internally by this parent
                     created for consistency for external control in the API
                     */

                    MarkersParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
                        if ((this.gMap == null) || (this.scope.models == null)) {
                            return;
                        }
                        if (isCreatingFromScratch) {
                            return this.createAllNew(this.scope, false);
                        } else {
                            return this.pieceMeal(this.scope, false);
                        }
                    };

                    MarkersParentModel.prototype.bindToTypeEvents = function(typeEvents, events) {
                        var internalHandles, self;
                        if (events == null) {
                            events = ['click', 'mouseout', 'mouseover'];
                        }

                        /*
                         You should only be binding to events that produce groups/clusters of somthing.
                         Otherwise use the orginal event handle.
                         For Example: Click on a cluster pushes a cluster/group obj through which has getMarkers
                         However Spiderfy's click is for a single marker so this is not ideal for that.
                         */
                        self = this;
                        if (!this.origTypeEvents) {
                            this.origTypeEvents = {};
                            _.each(events, (function(_this) {
                                return function(eventName) {
                                    return _this.origTypeEvents[eventName] = typeEvents != null ? typeEvents[eventName] : void 0;
                                };
                            })(this));
                        } else {
                            angular.extend(typeEvents, this.origTypeEvents);
                        }
                        internalHandles = {};
                        _.each(events, function(eventName) {
                            return internalHandles[eventName] = function(group) {
                                return self.maybeExecMappedEvent(group, eventName);
                            };
                        });
                        return angular.extend(typeEvents, internalHandles);
                    };

                    MarkersParentModel.prototype.createAllNew = function(scope) {
                        var isSpiderfied, maybeCanceled, typeEvents, typeOptions;
                        if (this.gManager != null) {
                            if (this.gManager instanceof SpiderfierMarkerManager) {
                                isSpiderfied = this.gManager.isSpiderfied();
                            }
                            this.gManager.clear();
                            delete this.gManager;
                        }
                        typeEvents = scope.typeEvents || scope.clusterEvents;
                        typeOptions = scope.typeOptions || scope.clusterOptions;
                        if (scope.doCluster || scope.type === 'cluster') {
                            if (typeEvents != null) {
                                this.bindToTypeEvents(typeEvents);
                            }
                            this.gManager = new ClustererMarkerManager(this.map, void 0, typeOptions, typeEvents);
                        } else if (scope.type === 'spider') {
                            if (typeEvents != null) {
                                this.bindToTypeEvents(typeEvents, ['spiderfy', 'unspiderfy']);
                            }
                            this.gManager = new SpiderfierMarkerManager(this.map, void 0, typeOptions, typeEvents, this.scope);
                            if (isSpiderfied) {
                                this.gManager.spiderfy();
                            }
                        } else {
                            this.gManager = new MarkerManager(this.map);
                        }
                        if (this.didQueueInitPromise(this, scope)) {
                            return;
                        }
                        maybeCanceled = null;
                        return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
                            return maybeCanceled = canceledMsg;
                        }), (function(_this) {
                            return function() {
                                return _async.each(scope.models, function(model) {
                                    _this.newChildMarker(model, scope);
                                    return maybeCanceled;
                                }, _async.chunkSizeFrom(scope.chunk)).then(function() {
                                    _this.modelsRendered = true;
                                    if (scope.fit) {
                                        _this.gManager.fit();
                                    }
                                    _this.gManager.draw();
                                    return _this.scope.pluralsUpdate.updateCtr += 1;
                                }, _async.chunkSizeFrom(scope.chunk));
                            };
                        })(this));
                    };

                    MarkersParentModel.prototype.rebuildAll = function(scope) {
                        var ref;
                        if (!scope.doRebuild && scope.doRebuild !== void 0) {
                            return;
                        }
                        if ((ref = this.scope.plurals) != null ? ref.length : void 0) {
                            return this.onDestroy(scope).then((function(_this) {
                                return function() {
                                    return _this.createAllNew(scope);
                                };
                            })(this));
                        } else {
                            return this.createAllNew(scope);
                        }
                    };

                    MarkersParentModel.prototype.pieceMeal = function(scope) {
                        var maybeCanceled, payload;
                        if (scope.$$destroyed) {
                            return;
                        }
                        maybeCanceled = null;
                        payload = null;
                        if (this.modelsLength() && this.scope.plurals.length) {
                            return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
                                return maybeCanceled = canceledMsg;
                            }), (function(_this) {
                                return function() {
                                    return uiGmapPromise.promise((function() {
                                        return _this.figureOutState(_this.idKey, scope, _this.scope.plurals, _this.modelKeyComparison);
                                    })).then(function(state) {
                                        payload = state;
                                        return _async.each(payload.removals, function(child) {
                                            if (child != null) {
                                                if (child.destroy != null) {
                                                    child.destroy();
                                                }
                                                _this.scope.plurals.remove(child.id);
                                                return maybeCanceled;
                                            }
                                        }, _async.chunkSizeFrom(scope.chunk));
                                    }).then(function() {
                                        return _async.each(payload.adds, function(modelToAdd) {
                                            _this.newChildMarker(modelToAdd, scope);
                                            return maybeCanceled;
                                        }, _async.chunkSizeFrom(scope.chunk));
                                    }).then(function() {
                                        return _async.each(payload.updates, function(update) {
                                            _this.updateChild(update.child, update.model);
                                            return maybeCanceled;
                                        }, _async.chunkSizeFrom(scope.chunk));
                                    }).then(function() {
                                        if (payload.adds.length > 0 || payload.removals.length > 0 || payload.updates.length > 0) {
                                            scope.plurals = _this.scope.plurals;
                                            if (scope.fit) {
                                                _this.gManager.fit();
                                            }
                                            _this.gManager.draw();
                                        }
                                        return _this.scope.pluralsUpdate.updateCtr += 1;
                                    });
                                };
                            })(this));
                        } else {
                            this.inProgress = false;
                            return this.rebuildAll(scope);
                        }
                    };

                    MarkersParentModel.prototype.newChildMarker = function(model, scope) {
                        var child, childScope, keys;
                        if (!model) {
                            throw 'model undefined';
                        }
                        if (model[this.idKey] == null) {
                            this.$log.error("Marker model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.");
                            return;
                        }
                        this.$log.info('child', child, 'markers', this.scope.markerModels);
                        childScope = scope.$new(false);
                        childScope.events = scope.events;
                        keys = {};
                        IMarker.scopeKeys.forEach(function(k) {
                            return keys[k] = scope[k];
                        });
                        child = new MarkerChildModel({
                            scope: childScope,
                            model: model,
                            keys: keys,
                            gMap: this.map,
                            defaults: this.DEFAULTS,
                            doClick: this.doClick,
                            gManager: this.gManager,
                            doDrawSelf: false,
                            isScopeModel: true
                        });
                        this.scope.plurals.put(model[this.idKey], child);
                        return child;
                    };

                    MarkersParentModel.prototype.onDestroy = function(scope) {
                        MarkersParentModel.__super__.onDestroy.call(this, scope);
                        return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
                            return function() {
                                return _async.each(_this.scope.plurals.values(), function(model) {
                                    if (model != null) {
                                        return model.destroy(false);
                                    }
                                }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
                                    if (_this.gManager != null) {
                                        _this.gManager.destroy();
                                    }
                                    _this.plurals.removeAll();
                                    if (_this.plurals !== _this.scope.plurals) {
                                        console.error('plurals out of sync for MarkersParentModel');
                                    }
                                    return _this.scope.pluralsUpdate.updateCtr += 1;
                                });
                            };
                        })(this));
                    };

                    MarkersParentModel.prototype.maybeExecMappedEvent = function(group, fnName) {
                        var pair, typeEvents;
                        if (this.scope.$$destroyed) {
                            return;
                        }
                        typeEvents = this.scope.typeEvents || this.scope.clusterEvents;
                        if (_.isFunction(typeEvents != null ? typeEvents[fnName] : void 0)) {
                            pair = this.mapTypeToPlurals(group);
                            if (this.origTypeEvents[fnName]) {
                                return this.origTypeEvents[fnName](pair.group, pair.mapped);
                            }
                        }
                    };

                    MarkersParentModel.prototype.mapTypeToPlurals = function(group) {
                        var arrayToMap, mapped, ref;
                        if (_.isArray(group)) {
                            arrayToMap = group;
                        } else if (_.isFunction(group.getMarkers)) {
                            arrayToMap = group.getMarkers();
                        }
                        if (arrayToMap == null) {
                            $log.error("Unable to map event as we cannot find the array group to map");
                            return;
                        }
                        if ((ref = this.scope.plurals.values()) != null ? ref.length : void 0) {
                            mapped = arrayToMap.map((function(_this) {
                                return function(g) {
                                    return _this.scope.plurals.get(g.key).model;
                                };
                            })(this));
                        } else {
                            mapped = [];
                        }
                        return {
                            cluster: group,
                            mapped: mapped,
                            group: group
                        };
                    };

                    MarkersParentModel.prototype.getItem = function(scope, modelsPropToIterate, index) {
                        if (modelsPropToIterate === 'models') {
                            return scope[modelsPropToIterate][index];
                        }
                        return scope[modelsPropToIterate].get(index);
                    };

                    return MarkersParentModel;

                })(IMarkerParentModel);
                return MarkersParentModel;
            }
        ]);

    }).call(this);
    ;(function() {
        ['Polygon', 'Polyline'].forEach(function(name) {
            return angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory("uiGmap" + name + "sParentModel", [
                'uiGmapBasePolysParentModel', "uiGmap" + name + "ChildModel", "uiGmapI" + name, function(BasePolysParentModel, ChildModel, IPoly) {
                    return BasePolysParentModel(IPoly, ChildModel, name);
                }
            ]);
        });

    }).call(this);
    ;
    /*globals angular, _, google */

    (function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapRectangleParentModel', [
            'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapEventsHelper', 'uiGmapRectangleOptionsBuilder', function($log, GmapUtil, EventsHelper, Builder) {
                var RectangleParentModel;
                return RectangleParentModel = (function(superClass) {
                    extend(RectangleParentModel, superClass);

                    RectangleParentModel.include(GmapUtil);

                    RectangleParentModel.include(EventsHelper);

                    function RectangleParentModel(scope, element, attrs, gMap, DEFAULTS) {
                        var bounds, clear, createBounds, dragging, fit, gObject, init, listeners, myListeners, settingBoundsFromScope, updateBounds;
                        this.scope = scope;
                        this.attrs = attrs;
                        this.gMap = gMap;
                        this.DEFAULTS = DEFAULTS;
                        bounds = void 0;
                        dragging = false;
                        myListeners = [];
                        listeners = void 0;
                        fit = (function(_this) {
                            return function() {
                                if (_this.isTrue(_this.attrs.fit)) {
                                    return _this.fitMapBounds(_this.gMap, bounds);
                                }
                            };
                        })(this);
                        createBounds = (function(_this) {
                            return function() {
                                var ref, ref1, ref2;
                                if ((_this.scope.bounds != null) && (((ref = _this.scope.bounds) != null ? ref.sw : void 0) != null) && (((ref1 = _this.scope.bounds) != null ? ref1.ne : void 0) != null) && _this.validateBoundPoints(_this.scope.bounds)) {
                                    bounds = _this.convertBoundPoints(_this.scope.bounds);
                                    return $log.info("new new bounds created: " + (JSON.stringify(bounds)));
                                } else if ((_this.scope.bounds.getNorthEast != null) && (_this.scope.bounds.getSouthWest != null)) {
                                    return bounds = _this.scope.bounds;
                                } else {
                                    if (_this.scope.bounds != null) {
                                        return $log.error("Invalid bounds for newValue: " + (JSON.stringify((ref2 = _this.scope) != null ? ref2.bounds : void 0)));
                                    }
                                }
                            };
                        })(this);
                        createBounds();
                        gObject = new google.maps.Rectangle(this.buildOpts(bounds));
                        $log.info("gObject (rectangle) created: " + gObject);
                        settingBoundsFromScope = false;
                        updateBounds = (function(_this) {
                            return function() {
                                var b, ne, sw;
                                b = gObject.getBounds();
                                ne = b.getNorthEast();
                                sw = b.getSouthWest();
                                if (settingBoundsFromScope) {
                                    return;
                                }
                                return _this.scope.$evalAsync(function(s) {
                                    if ((s.bounds != null) && (s.bounds.sw != null) && (s.bounds.ne != null)) {
                                        s.bounds.ne = {
                                            latitude: ne.lat(),
                                            longitude: ne.lng()
                                        };
                                        s.bounds.sw = {
                                            latitude: sw.lat(),
                                            longitude: sw.lng()
                                        };
                                    }
                                    if ((s.bounds.getNorthEast != null) && (s.bounds.getSouthWest != null)) {
                                        return s.bounds = b;
                                    }
                                });
                            };
                        })(this);
                        init = (function(_this) {
                            return function() {
                                fit();
                                _this.removeEvents(myListeners);
                                myListeners.push(google.maps.event.addListener(gObject, 'dragstart', function() {
                                    return dragging = true;
                                }));
                                myListeners.push(google.maps.event.addListener(gObject, 'dragend', function() {
                                    dragging = false;
                                    return updateBounds();
                                }));
                                return myListeners.push(google.maps.event.addListener(gObject, 'bounds_changed', function() {
                                    if (dragging) {
                                        return;
                                    }
                                    return updateBounds();
                                }));
                            };
                        })(this);
                        clear = (function(_this) {
                            return function() {
                                _this.removeEvents(myListeners);
                                if (listeners != null) {
                                    _this.removeEvents(listeners);
                                }
                                return gObject.setMap(null);
                            };
                        })(this);
                        if (bounds != null) {
                            init();
                        }
                        this.scope.$watch('bounds', (function(newValue, oldValue) {
                            var isNew;
                            if (_.isEqual(newValue, oldValue) && (bounds != null) || dragging) {
                                return;
                            }
                            settingBoundsFromScope = true;
                            if (newValue == null) {
                                clear();
                                return;
                            }
                            if (bounds == null) {
                                isNew = true;
                            } else {
                                fit();
                            }
                            createBounds();
                            gObject.setBounds(bounds);
                            settingBoundsFromScope = false;
                            if (isNew && (bounds != null)) {
                                return init();
                            }
                        }), true);
                        this.setMyOptions = (function(_this) {
                            return function(newVals, oldVals) {
                                if (!_.isEqual(newVals, oldVals)) {
                                    if ((bounds != null) && (newVals != null)) {
                                        return gObject.setOptions(_this.buildOpts(bounds));
                                    }
                                }
                            };
                        })(this);
                        this.props.push('bounds');
                        this.watchProps(this.props);
                        if (this.attrs.events != null) {
                            listeners = this.setEvents(gObject, this.scope, this.scope);
                            this.scope.$watch('events', (function(_this) {
                                return function(newValue, oldValue) {
                                    if (!_.isEqual(newValue, oldValue)) {
                                        if (listeners != null) {
                                            _this.removeEvents(listeners);
                                        }
                                        return listeners = _this.setEvents(gObject, _this.scope, _this.scope);
                                    }
                                };
                            })(this));
                        }
                        this.scope.$on('$destroy', function() {
                            return clear();
                        });
                        $log.info(this);
                    }

                    return RectangleParentModel;

                })(Builder);
            }
        ]);

    }).call(this);
    ;
    /*global angular:true, google:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapSearchBoxParentModel', [
            'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapEventsHelper', function(BaseObject, Logger, EventsHelper) {
                var SearchBoxParentModel;
                SearchBoxParentModel = (function(superClass) {
                    extend(SearchBoxParentModel, superClass);

                    SearchBoxParentModel.include(EventsHelper);

                    function SearchBoxParentModel(scope, element, attrs, gMap, ctrlPosition, template, $log) {
                        var controlDiv;
                        this.scope = scope;
                        this.element = element;
                        this.attrs = attrs;
                        this.gMap = gMap;
                        this.ctrlPosition = ctrlPosition;
                        this.template = template;
                        this.$log = $log != null ? $log : Logger;
                        this.setVisibility = bind(this.setVisibility, this);
                        this.getBounds = bind(this.getBounds, this);
                        this.setBounds = bind(this.setBounds, this);
                        this.createSearchBox = bind(this.createSearchBox, this);
                        this.addToParentDiv = bind(this.addToParentDiv, this);
                        this.addAsMapControl = bind(this.addAsMapControl, this);
                        this.init = bind(this.init, this);
                        if (this.attrs.template == null) {
                            this.$log.error('template attribute for the search-box directive is mandatory. Places Search Box creation aborted!!');
                            return;
                        }
                        if (angular.isUndefined(this.scope.options)) {
                            this.scope.options = {};
                            this.scope.options.visible = true;
                        }
                        if (angular.isUndefined(this.scope.options.visible)) {
                            this.scope.options.visible = true;
                        }
                        if (angular.isUndefined(this.scope.options.autocomplete)) {
                            this.scope.options.autocomplete = false;
                        }
                        this.visible = this.scope.options.visible;
                        this.autocomplete = this.scope.options.autocomplete;
                        controlDiv = angular.element('<div></div>');
                        controlDiv.append(this.template);
                        this.input = controlDiv.find('input')[0];
                        this.init();
                    }

                    SearchBoxParentModel.prototype.init = function() {
                        this.createSearchBox();
                        this.scope.$watch('options', (function(_this) {
                            return function(newValue, oldValue) {
                                if (angular.isObject(newValue)) {
                                    if (newValue.bounds != null) {
                                        _this.setBounds(newValue.bounds);
                                    }
                                    if (newValue.visible != null) {
                                        if (_this.visible !== newValue.visible) {
                                            return _this.setVisibility(newValue.visible);
                                        }
                                    }
                                }
                            };
                        })(this), true);
                        if (this.attrs.parentdiv != null) {
                            this.addToParentDiv();
                        } else {
                            this.addAsMapControl();
                        }
                        if (!this.visible) {
                            this.setVisibility(this.visible);
                        }
                        if (this.autocomplete) {
                            this.listener = google.maps.event.addListener(this.gObject, 'place_changed', (function(_this) {
                                return function() {
                                    return _this.places = _this.gObject.getPlace();
                                };
                            })(this));
                        } else {
                            this.listener = google.maps.event.addListener(this.gObject, 'places_changed', (function(_this) {
                                return function() {
                                    return _this.places = _this.gObject.getPlaces();
                                };
                            })(this));
                        }
                        this.listeners = this.setEvents(this.gObject, this.scope, this.scope);
                        this.$log.info(this);
                        this.scope.$on('$stateChangeSuccess', (function(_this) {
                            return function() {
                                if (_this.attrs.parentdiv != null) {
                                    return _this.addToParentDiv();
                                }
                            };
                        })(this));
                        return this.scope.$on('$destroy', (function(_this) {
                            return function() {
                                return _this.gObject = null;
                            };
                        })(this));
                    };

                    SearchBoxParentModel.prototype.addAsMapControl = function() {
                        return this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].push(this.input);
                    };

                    SearchBoxParentModel.prototype.addToParentDiv = function() {
                        var ref;
                        this.parentDiv = angular.element(document.getElementById(this.scope.parentdiv));
                        if ((ref = this.parentDiv) != null ? ref.length : void 0) {
                            return this.parentDiv.append(this.input);
                        }
                    };

                    SearchBoxParentModel.prototype.createSearchBox = function() {
                        if (this.autocomplete) {
                            return this.gObject = new google.maps.places.Autocomplete(this.input, this.scope.options);
                        } else {
                            return this.gObject = new google.maps.places.SearchBox(this.input, this.scope.options);
                        }
                    };

                    SearchBoxParentModel.prototype.setBounds = function(bounds) {
                        if (angular.isUndefined(bounds.isEmpty)) {
                            this.$log.error('Error: SearchBoxParentModel setBounds. Bounds not an instance of LatLngBounds.');
                        } else {
                            if (bounds.isEmpty() === false) {
                                if (this.gObject != null) {
                                    return this.gObject.setBounds(bounds);
                                }
                            }
                        }
                    };

                    SearchBoxParentModel.prototype.getBounds = function() {
                        return this.gObject.getBounds();
                    };

                    SearchBoxParentModel.prototype.setVisibility = function(val) {
                        if (this.attrs.parentdiv != null) {
                            if (val === false) {
                                this.parentDiv.addClass("ng-hide");
                            } else {
                                this.parentDiv.removeClass("ng-hide");
                            }
                        } else {
                            if (val === false) {
                                this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].clear();
                            } else {
                                this.gMap.controls[google.maps.ControlPosition[this.ctrlPosition]].push(this.input);
                            }
                        }
                        return this.visible = val;
                    };

                    return SearchBoxParentModel;

                })(BaseObject);
                return SearchBoxParentModel;
            }
        ]);

    }).call(this);
    ;
    /*global _,angular */


    /*
     WindowsChildModel generator where there are many ChildModels to a parent.
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api.models.parent').factory('uiGmapWindowsParentModel', [
            'uiGmapIWindowParentModel', 'uiGmapModelsWatcher', 'uiGmapPropMap', 'uiGmapWindowChildModel', 'uiGmapLinked', 'uiGmap_async', 'uiGmapLogger', '$timeout', '$compile', '$http', '$templateCache', '$interpolate', 'uiGmapPromise', 'uiGmapIWindow', 'uiGmapGmapUtil', function(IWindowParentModel, ModelsWatcher, PropMap, WindowChildModel, Linked, _async, $log, $timeout, $compile, $http, $templateCache, $interpolate, uiGmapPromise, IWindow, GmapUtil) {
                var WindowsParentModel;
                WindowsParentModel = (function(superClass) {
                    extend(WindowsParentModel, superClass);

                    WindowsParentModel.include(ModelsWatcher);

                    function WindowsParentModel(scope, element, attrs, ctrls, gMap1, markersScope) {
                        this.gMap = gMap1;
                        this.markersScope = markersScope;
                        this.modelKeyComparison = bind(this.modelKeyComparison, this);
                        this.interpolateContent = bind(this.interpolateContent, this);
                        this.setChildScope = bind(this.setChildScope, this);
                        this.createWindow = bind(this.createWindow, this);
                        this.setContentKeys = bind(this.setContentKeys, this);
                        this.pieceMeal = bind(this.pieceMeal, this);
                        this.createAllNew = bind(this.createAllNew, this);
                        this.watchIdKey = bind(this.watchIdKey, this);
                        this.createChildScopes = bind(this.createChildScopes, this);
                        this.watchOurScope = bind(this.watchOurScope, this);
                        this.watchDestroy = bind(this.watchDestroy, this);
                        this.onDestroy = bind(this.onDestroy, this);
                        this.rebuildAll = bind(this.rebuildAll, this);
                        this.doINeedToWipe = bind(this.doINeedToWipe, this);
                        this.watchModels = bind(this.watchModels, this);
                        this.go = bind(this.go, this);
                        WindowsParentModel.__super__.constructor.call(this, scope, element, attrs, ctrls, $timeout, $compile, $http, $templateCache);
                        this["interface"] = IWindow;
                        this.plurals = new PropMap();
                        _.each(IWindow.scopeKeys, (function(_this) {
                            return function(name) {
                                return _this[name + 'Key'] = void 0;
                            };
                        })(this));
                        this.linked = new Linked(scope, element, attrs, ctrls);
                        this.contentKeys = void 0;
                        this.isIconVisibleOnClick = void 0;
                        this.firstTime = true;
                        this.firstWatchModels = true;
                        this.$log.info(self);
                        this.parentScope = void 0;
                        this.go(scope);
                    }

                    WindowsParentModel.prototype.go = function(scope) {
                        this.watchOurScope(scope);
                        this.doRebuildAll = this.scope.doRebuildAll != null ? this.scope.doRebuildAll : false;
                        scope.$watch('doRebuildAll', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    return _this.doRebuildAll = newValue;
                                }
                            };
                        })(this));
                        return this.createChildScopes();
                    };

                    WindowsParentModel.prototype.watchModels = function(scope) {
                        var itemToWatch;
                        itemToWatch = this.markersScope != null ? 'pluralsUpdate' : 'models';
                        return scope.$watch(itemToWatch, (function(_this) {
                            return function(newValue, oldValue) {
                                var doScratch;
                                if (!_.isEqual(newValue, oldValue) || _this.firstWatchModels) {
                                    _this.firstWatchModels = false;
                                    if (_this.doRebuildAll || _this.doINeedToWipe(scope.models)) {
                                        return _this.rebuildAll(scope, true, true);
                                    } else {
                                        doScratch = _this.plurals.length === 0;
                                        if (_this.existingPieces != null) {
                                            return _.last(_this.existingPieces._content).then(function() {
                                                return _this.createChildScopes(doScratch);
                                            });
                                        } else {
                                            return _this.createChildScopes(doScratch);
                                        }
                                    }
                                }
                            };
                        })(this), true);
                    };

                    WindowsParentModel.prototype.doINeedToWipe = function(newValue) {
                        var newValueIsEmpty;
                        newValueIsEmpty = newValue != null ? newValue.length === 0 : true;
                        return this.plurals.length > 0 && newValueIsEmpty;
                    };

                    WindowsParentModel.prototype.rebuildAll = function(scope, doCreate, doDelete) {
                        return this.onDestroy(doDelete).then((function(_this) {
                            return function() {
                                if (doCreate) {
                                    return _this.createChildScopes();
                                }
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.onDestroy = function(scope) {
                        WindowsParentModel.__super__.onDestroy.call(this, this.scope);
                        return _async.promiseLock(this, uiGmapPromise.promiseTypes["delete"], void 0, void 0, (function(_this) {
                            return function() {
                                return _async.each(_this.plurals.values(), function(child) {
                                    return child.destroy(true);
                                }, _async.chunkSizeFrom(_this.scope.cleanchunk, false)).then(function() {
                                    var ref;
                                    return (ref = _this.plurals) != null ? ref.removeAll() : void 0;
                                });
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.watchDestroy = function(scope) {
                        return scope.$on('$destroy', (function(_this) {
                            return function() {
                                _this.firstWatchModels = true;
                                _this.firstTime = true;
                                return _this.rebuildAll(scope, false, true);
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.watchOurScope = function(scope) {
                        return _.each(IWindow.scopeKeys, (function(_this) {
                            return function(name) {
                                var nameKey;
                                nameKey = name + 'Key';
                                return _this[nameKey] = typeof scope[name] === 'function' ? scope[name]() : scope[name];
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.createChildScopes = function(isCreatingFromScratch) {
                        var modelsNotDefined, ref, ref1;
                        if (isCreatingFromScratch == null) {
                            isCreatingFromScratch = true;
                        }

                        /*
                         being that we cannot tell the difference in Key String vs. a normal value string (TemplateUrl)
                         we will assume that all scope values are string expressions either pointing to a key (propName) or using
                         'self' to point the model as container/object of interest.

                         This may force redundant information into the model, but this appears to be the most flexible approach.
                         */
                        this.isIconVisibleOnClick = true;
                        if (angular.isDefined(this.linked.attrs.isiconvisibleonclick)) {
                            this.isIconVisibleOnClick = this.linked.scope.isIconVisibleOnClick;
                        }
                        modelsNotDefined = angular.isUndefined(this.linked.scope.models);
                        if (modelsNotDefined && (this.markersScope === void 0 || (((ref = this.markersScope) != null ? ref.plurals : void 0) === void 0 || ((ref1 = this.markersScope) != null ? ref1.models : void 0) === void 0))) {
                            this.$log.error('No models to create windows from! Need direct models or models derived from markers!');
                            return;
                        }
                        if (this.gMap != null) {
                            if (this.linked.scope.models != null) {
                                this.watchIdKey(this.linked.scope);
                                if (isCreatingFromScratch) {
                                    return this.createAllNew(this.linked.scope, false);
                                } else {
                                    return this.pieceMeal(this.linked.scope, false);
                                }
                            } else {
                                this.parentScope = this.markersScope;
                                this.watchIdKey(this.parentScope);
                                if (isCreatingFromScratch) {
                                    return this.createAllNew(this.markersScope, true, 'plurals', false);
                                } else {
                                    return this.pieceMeal(this.markersScope, true, 'plurals', false);
                                }
                            }
                        }
                    };

                    WindowsParentModel.prototype.watchIdKey = function(scope) {
                        this.setIdKey(scope);
                        return scope.$watch('idKey', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue && (newValue == null)) {
                                    _this.idKey = newValue;
                                    return _this.rebuildAll(scope, true, true);
                                }
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.createAllNew = function(scope, hasGMarker, modelsPropToIterate, isArray) {
                        var maybeCanceled;
                        if (modelsPropToIterate == null) {
                            modelsPropToIterate = 'models';
                        }
                        if (isArray == null) {
                            isArray = false;
                        }
                        if (this.firstTime) {
                            this.watchModels(scope);
                            this.watchDestroy(scope);
                        }
                        this.setContentKeys(scope.models);
                        if (this.didQueueInitPromise(this, scope)) {
                            return;
                        }
                        maybeCanceled = null;
                        return _async.promiseLock(this, uiGmapPromise.promiseTypes.create, 'createAllNew', (function(canceledMsg) {
                            return maybeCanceled = canceledMsg;
                        }), (function(_this) {
                            return function() {
                                return _async.each(scope.models, function(model) {
                                    var gMarker, ref;
                                    gMarker = hasGMarker ? (ref = _this.getItem(scope, modelsPropToIterate, model[_this.idKey])) != null ? ref.gObject : void 0 : void 0;
                                    if (!maybeCanceled) {
                                        if (!gMarker && _this.markersScope) {
                                            $log.error('Unable to get gMarker from markersScope!');
                                        }
                                        _this.createWindow(model, gMarker, _this.gMap);
                                    }
                                    return maybeCanceled;
                                }, _async.chunkSizeFrom(scope.chunk)).then(function() {
                                    return _this.firstTime = false;
                                });
                            };
                        })(this));
                    };

                    WindowsParentModel.prototype.pieceMeal = function(scope, hasGMarker, modelsPropToIterate, isArray) {
                        var maybeCanceled, payload;
                        if (modelsPropToIterate == null) {
                            modelsPropToIterate = 'models';
                        }
                        if (isArray == null) {
                            isArray = true;
                        }
                        if (scope.$$destroyed) {
                            return;
                        }
                        maybeCanceled = null;
                        payload = null;
                        if ((scope != null) && this.modelsLength() && this.plurals.length) {
                            return _async.promiseLock(this, uiGmapPromise.promiseTypes.update, 'pieceMeal', (function(canceledMsg) {
                                return maybeCanceled = canceledMsg;
                            }), (function(_this) {
                                return function() {
                                    return uiGmapPromise.promise((function() {
                                        return _this.figureOutState(_this.idKey, scope, _this.plurals, _this.modelKeyComparison);
                                    })).then(function(state) {
                                        payload = state;
                                        return _async.each(payload.removals, function(child) {
                                            if (child != null) {
                                                _this.plurals.remove(child.id);
                                                if (child.destroy != null) {
                                                    child.destroy(true);
                                                }
                                                return maybeCanceled;
                                            }
                                        }, _async.chunkSizeFrom(scope.chunk));
                                    }).then(function() {
                                        return _async.each(payload.adds, function(modelToAdd) {
                                            var gMarker, ref;
                                            gMarker = (ref = _this.getItem(scope, modelsPropToIterate, modelToAdd[_this.idKey])) != null ? ref.gObject : void 0;
                                            if (!gMarker) {
                                                throw 'Gmarker undefined';
                                            }
                                            _this.createWindow(modelToAdd, gMarker, _this.gMap);
                                            return maybeCanceled;
                                        });
                                    }).then(function() {
                                        return _async.each(payload.updates, function(update) {
                                            _this.updateChild(update.child, update.model);
                                            return maybeCanceled;
                                        }, _async.chunkSizeFrom(scope.chunk));
                                    });
                                };
                            })(this));
                        } else {
                            $log.debug('pieceMeal: rebuildAll');
                            return this.rebuildAll(this.scope, true, true);
                        }
                    };

                    WindowsParentModel.prototype.setContentKeys = function(models) {
                        if (this.modelsLength(models)) {
                            return this.contentKeys = Object.keys(models[0]);
                        }
                    };

                    WindowsParentModel.prototype.createWindow = function(model, gMarker, gMap) {
                        var child, childScope, fakeElement, opts, ref, ref1;
                        childScope = this.linked.scope.$new(false);
                        this.setChildScope(childScope, model);
                        childScope.$watch('model', (function(_this) {
                            return function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    return _this.setChildScope(childScope, newValue);
                                }
                            };
                        })(this), true);
                        fakeElement = {
                            html: (function(_this) {
                                return function() {
                                    return _this.interpolateContent(_this.linked.element.html(), model);
                                };
                            })(this)
                        };
                        this.DEFAULTS = this.scopeOrModelVal(this.optionsKey, this.scope, model) || {};
                        opts = this.createWindowOptions(gMarker, childScope, fakeElement.html(), this.DEFAULTS);
                        child = new WindowChildModel({
                            model: model,
                            scope: childScope,
                            opts: opts,
                            isIconVisibleOnClick: this.isIconVisibleOnClick,
                            gMap: gMap,
                            markerScope: (ref = this.markersScope) != null ? (ref1 = ref.plurals.get(model[this.idKey])) != null ? ref1.scope : void 0 : void 0,
                            element: fakeElement,
                            needToManualDestroy: false,
                            markerIsVisibleAfterWindowClose: true,
                            isScopeModel: true
                        });
                        if (model[this.idKey] == null) {
                            this.$log.error('Window model has no id to assign a child to. This is required for performance. Please assign id, or redirect id to a different key.');
                            return;
                        }
                        this.plurals.put(model[this.idKey], child);
                        return child;
                    };

                    WindowsParentModel.prototype.setChildScope = function(childScope, model) {
                        _.each(IWindow.scopeKeys, (function(_this) {
                            return function(name) {
                                var nameKey, newValue;
                                nameKey = name + 'Key';
                                newValue = _this[nameKey] === 'self' ? model : model[_this[nameKey]];
                                if (newValue !== childScope[name]) {
                                    return childScope[name] = newValue;
                                }
                            };
                        })(this));
                        return childScope.model = model;
                    };

                    WindowsParentModel.prototype.interpolateContent = function(content, model) {
                        var exp, i, interpModel, key, len, ref;
                        if (this.contentKeys === void 0 || this.contentKeys.length === 0) {
                            return;
                        }
                        exp = $interpolate(content);
                        interpModel = {};
                        ref = this.contentKeys;
                        for (i = 0, len = ref.length; i < len; i++) {
                            key = ref[i];
                            interpModel[key] = model[key];
                        }
                        return exp(interpModel);
                    };

                    WindowsParentModel.prototype.modelKeyComparison = function(model1, model2) {
                        var isEqual, scope;
                        scope = this.scope.coords != null ? this.scope : this.parentScope;
                        if (scope == null) {
                            throw 'No scope or parentScope set!';
                        }
                        isEqual = GmapUtil.equalCoords(this.evalModelHandle(model1, scope.coords), this.evalModelHandle(model2, scope.coords));
                        if (!isEqual) {
                            return isEqual;
                        }
                        isEqual = _.every(_.without(this["interface"].scopeKeys, 'coords'), (function(_this) {
                            return function(k) {
                                return _this.evalModelHandle(model1, scope[k]) === _this.evalModelHandle(model2, scope[k]);
                            };
                        })(this));
                        return isEqual;
                    };

                    return WindowsParentModel;

                })(IWindowParentModel);
                return WindowsParentModel;
            }
        ]);

    }).call(this);
    ;
    /*global angular, _ */

    (function() {
        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapCircle", [
            "uiGmapICircle", "uiGmapCircleParentModel", function(ICircle, CircleParentModel) {
                return _.extend(ICircle, {
                    link: function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then(function(gMap) {
                            return new CircleParentModel(scope, element, attrs, gMap);
                        });
                    }
                });
            }
        ]);

    }).call(this);
    ;(function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapControl", [
            "uiGmapIControl", "$http", "$templateCache", "$compile", "$controller", 'uiGmapGoogleMapApi', function(IControl, $http, $templateCache, $compile, $controller, GoogleMapApi) {
                var Control;
                return Control = (function(superClass) {
                    extend(Control, superClass);

                    function Control() {
                        this.link = bind(this.link, this);
                        Control.__super__.constructor.call(this);
                    }

                    Control.prototype.transclude = true;

                    Control.prototype.link = function(scope, element, attrs, ctrl, transclude) {
                        return GoogleMapApi.then((function(_this) {
                            return function(maps) {
                                var hasTranscludedContent, index, position, transcludedContent;
                                transcludedContent = transclude();
                                hasTranscludedContent = transclude().length > 0;
                                if (!hasTranscludedContent && angular.isUndefined(scope.template)) {
                                    _this.$log.error('mapControl: could not find a valid template property or elements for transclusion');
                                    return;
                                }
                                index = angular.isDefined(scope.index && !isNaN(parseInt(scope.index))) ? parseInt(scope.index) : void 0;
                                position = angular.isDefined(scope.position) ? scope.position.toUpperCase().replace(/-/g, '_') : 'TOP_CENTER';
                                if (!maps.ControlPosition[position]) {
                                    _this.$log.error('mapControl: invalid position property');
                                    return;
                                }
                                return IControl.mapPromise(scope, ctrl).then(function(map) {
                                    var control, controlDiv, pushControl;
                                    control = void 0;
                                    controlDiv = angular.element('<div></div>');
                                    pushControl = function(map, control, index) {
                                        if (index) {
                                            control[0].index = index;
                                        }
                                        return map.controls[google.maps.ControlPosition[position]].push(control[0]);
                                    };
                                    if (hasTranscludedContent) {
                                        return transclude(function(transcludeEl) {
                                            controlDiv.append(transcludeEl);
                                            return pushControl(map, controlDiv, index);
                                        });
                                    } else {
                                        return $http.get(scope.template, {
                                            cache: $templateCache
                                        }).success(function(template) {
                                            var templateCtrl, templateScope;
                                            templateScope = scope.$new();
                                            controlDiv.append(template);
                                            if (angular.isDefined(scope.controller)) {
                                                templateCtrl = $controller(scope.controller, {
                                                    $scope: templateScope
                                                });
                                                controlDiv.children().data('$ngControllerController', templateCtrl);
                                            }
                                            return control = $compile(controlDiv.children())(templateScope);
                                        }).error(function(error) {
                                            return _this.$log.error('mapControl: template could not be found');
                                        }).then(function() {
                                            return pushControl(map, control, index);
                                        });
                                    }
                                });
                            };
                        })(this));
                    };

                    return Control;

                })(IControl);
            }
        ]);

    }).call(this);
    ;
    /*globals angular, _ */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapDragZoom', [
            'uiGmapCtrlHandle', 'uiGmapPropertyAction', function(CtrlHandle, PropertyAction) {
                return {
                    restrict: 'EMA',
                    transclude: true,
                    template: '<div class="angular-google-map-dragzoom" ng-transclude style="display: none"></div>',
                    require: '^' + 'uiGmapGoogleMap',
                    scope: {
                        keyboardkey: '=',
                        options: '=',
                        spec: '='
                    },
                    controller: [
                        '$scope', '$element', function($scope, $element) {
                            $scope.ctrlType = 'uiGmapDragZoom';
                            return _.extend(this, CtrlHandle.handle($scope, $element));
                        }
                    ],
                    link: function(scope, element, attrs, ctrl) {
                        return CtrlHandle.mapPromise(scope, ctrl).then(function(map) {
                            var enableKeyDragZoom, setKeyAction, setOptionsAction;
                            enableKeyDragZoom = function(opts) {
                                return map.enableKeyDragZoom(opts);
                            };
                            setKeyAction = new PropertyAction(function(key, newVal) {
                                if (newVal) {
                                    return enableKeyDragZoom({
                                        key: newVal
                                    });
                                } else {
                                    return enableKeyDragZoom();
                                }
                            });
                            setOptionsAction = new PropertyAction(function(key, newVal) {
                                if (newVal) {
                                    return enableKeyDragZoom(newVal);
                                }
                            });
                            scope.$watch('keyboardkey', setKeyAction.sic('keyboardkey'));
                            setKeyAction.sic(scope.keyboardkey);
                            scope.$watch('options', setOptionsAction.sic('options'));
                            return setOptionsAction.sic(scope.options);
                        });
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapDrawingManager", [
            "uiGmapIDrawingManager", "uiGmapDrawingManagerParentModel", function(IDrawingManager, DrawingManagerParentModel) {
                return _.extend(IDrawingManager, {
                    link: function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then(function(map) {
                            return new DrawingManagerParentModel(scope, element, attrs, map);
                        });
                    }
                });
            }
        ]);

    }).call(this);
    ;
    /*
     - Link up Polygons to be sent back to a controller
     - inject the draw function into a controllers scope so that controller can call the directive to draw on demand
     - draw function creates the DrawFreeHandChildModel which manages itself
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapApiFreeDrawPolygons', [
            'uiGmapLogger', 'uiGmapBaseObject', 'uiGmapCtrlHandle', 'uiGmapDrawFreeHandChildModel', 'uiGmapLodash', function($log, BaseObject, CtrlHandle, DrawFreeHandChildModel, uiGmapLodash) {
                var FreeDrawPolygons;
                return FreeDrawPolygons = (function(superClass) {
                    extend(FreeDrawPolygons, superClass);

                    function FreeDrawPolygons() {
                        this.link = bind(this.link, this);
                        return FreeDrawPolygons.__super__.constructor.apply(this, arguments);
                    }

                    FreeDrawPolygons.include(CtrlHandle);

                    FreeDrawPolygons.prototype.restrict = 'EMA';

                    FreeDrawPolygons.prototype.replace = true;

                    FreeDrawPolygons.prototype.require = '^' + 'uiGmapGoogleMap';

                    FreeDrawPolygons.prototype.scope = {
                        polygons: '=',
                        draw: '='
                    };

                    FreeDrawPolygons.prototype.link = function(scope, element, attrs, ctrl) {
                        return this.mapPromise(scope, ctrl).then((function(_this) {
                            return function(map) {
                                var freeHand, listener;
                                if (!scope.polygons) {
                                    return $log.error('No polygons to bind to!');
                                }
                                if (!_.isArray(scope.polygons)) {
                                    return $log.error('Free Draw Polygons must be of type Array!');
                                }
                                freeHand = new DrawFreeHandChildModel(map, ctrl.getScope());
                                listener = void 0;
                                return scope.draw = function() {
                                    if (typeof listener === "function") {
                                        listener();
                                    }
                                    return freeHand.engage(scope.polygons).then(function() {
                                        var firstTime;
                                        firstTime = true;
                                        return listener = scope.$watchCollection('polygons', function(newValue, oldValue) {
                                            var removals;
                                            if (firstTime || newValue === oldValue) {
                                                firstTime = false;
                                                return;
                                            }
                                            removals = uiGmapLodash.differenceObjects(oldValue, newValue);
                                            return removals.forEach(function(p) {
                                                return p.setMap(null);
                                            });
                                        });
                                    });
                                };
                            };
                        })(this));
                    };

                    return FreeDrawPolygons;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module("uiGmapgoogle-maps.directives.api").service("uiGmapICircle", [
            function() {
                var DEFAULTS;
                DEFAULTS = {};
                return {
                    restrict: "EA",
                    replace: true,
                    require: '^' + 'uiGmapGoogleMap',
                    scope: {
                        center: "=center",
                        radius: "=radius",
                        stroke: "=stroke",
                        fill: "=fill",
                        clickable: "=",
                        draggable: "=",
                        editable: "=",
                        geodesic: "=",
                        icons: "=icons",
                        visible: "=",
                        events: "=",
                        control: "=",
                        zIndex: "=zindex"
                    }
                };
            }
        ]);

    }).call(this);
    ;
    /*
     - interface for all controls to derive from
     - to enforce a minimum set of requirements
     - attributes
     - template
     - position
     - controller
     - index
     */

    (function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapIControl", [
            "uiGmapBaseObject", "uiGmapLogger", "uiGmapCtrlHandle", function(BaseObject, Logger, CtrlHandle) {
                var IControl;
                return IControl = (function(superClass) {
                    extend(IControl, superClass);

                    IControl.extend(CtrlHandle);

                    function IControl() {
                        this.restrict = 'EA';
                        this.replace = true;
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.scope = {
                            template: '@template',
                            position: '@position',
                            controller: '@controller',
                            index: '@index'
                        };
                        this.$log = Logger;
                    }

                    IControl.prototype.link = function(scope, element, attrs, ctrl) {
                        throw new Exception("Not implemented!!");
                    };

                    return IControl;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapIDrawingManager', [
            function() {
                return {
                    restrict: 'EA',
                    replace: true,
                    require: '^' + 'uiGmapGoogleMap',
                    scope: {
                        "static": '@',
                        control: '=',
                        options: '=',
                        events: '='
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIMarker', [
            'uiGmapBaseObject', 'uiGmapCtrlHandle', function(BaseObject, CtrlHandle) {
                var IMarker;
                return IMarker = (function(superClass) {
                    extend(IMarker, superClass);

                    IMarker.scope = {
                        coords: '=coords',
                        icon: '=icon',
                        click: '&click',
                        options: '=options',
                        events: '=events',
                        fit: '=fit',
                        idKey: '=idkey',
                        control: '=control'
                    };

                    IMarker.scopeKeys = _.keys(IMarker.scope);

                    IMarker.keys = IMarker.scopeKeys;

                    IMarker.extend(CtrlHandle);

                    function IMarker() {
                        this.restrict = 'EMA';
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.priority = -1;
                        this.transclude = true;
                        this.replace = true;
                        this.scope = _.extend(this.scope || {}, IMarker.scope);
                    }

                    return IMarker;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIPolygon', [
            'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapCtrlHandle', function(GmapUtil, BaseObject, Logger, CtrlHandle) {
                var IPolygon;
                return IPolygon = (function(superClass) {
                    extend(IPolygon, superClass);

                    IPolygon.scope = {
                        path: '=path',
                        stroke: '=stroke',
                        clickable: '=',
                        draggable: '=',
                        editable: '=',
                        geodesic: '=',
                        fill: '=',
                        icons: '=icons',
                        visible: '=',
                        "static": '=',
                        events: '=',
                        zIndex: '=zindex',
                        fit: '=',
                        control: '=control'
                    };

                    IPolygon.scopeKeys = _.keys(IPolygon.scope);

                    IPolygon.include(GmapUtil);

                    IPolygon.extend(CtrlHandle);

                    function IPolygon() {}

                    IPolygon.prototype.restrict = 'EMA';

                    IPolygon.prototype.replace = true;

                    IPolygon.prototype.require = '^' + 'uiGmapGoogleMap';

                    IPolygon.prototype.scope = IPolygon.scope;

                    IPolygon.prototype.DEFAULTS = {};

                    IPolygon.prototype.$log = Logger;

                    return IPolygon;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIPolyline', [
            'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapLogger', 'uiGmapCtrlHandle', function(GmapUtil, BaseObject, Logger, CtrlHandle) {
                var IPolyline;
                return IPolyline = (function(superClass) {
                    extend(IPolyline, superClass);

                    IPolyline.scope = {
                        path: '=',
                        stroke: '=',
                        clickable: '=',
                        draggable: '=',
                        editable: '=',
                        geodesic: '=',
                        icons: '=',
                        visible: '=',
                        "static": '=',
                        fit: '=',
                        events: '=',
                        zIndex: '=zindex'
                    };

                    IPolyline.scopeKeys = _.keys(IPolyline.scope);

                    IPolyline.include(GmapUtil);

                    IPolyline.extend(CtrlHandle);

                    function IPolyline() {}

                    IPolyline.prototype.restrict = 'EMA';

                    IPolyline.prototype.replace = true;

                    IPolyline.prototype.require = '^' + 'uiGmapGoogleMap';

                    IPolyline.prototype.scope = IPolyline.scope;

                    IPolyline.prototype.DEFAULTS = {};

                    IPolyline.prototype.$log = Logger;

                    return IPolyline;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapIRectangle', [
            function() {
                'use strict';
                var DEFAULTS;
                DEFAULTS = {};
                return {
                    restrict: 'EMA',
                    require: '^' + 'uiGmapGoogleMap',
                    replace: true,
                    scope: {
                        bounds: '=',
                        stroke: '=',
                        clickable: '=',
                        draggable: '=',
                        editable: '=',
                        fill: '=',
                        visible: '=',
                        events: '='
                    }
                };
            }
        ]);

    }).call(this);
    ;(function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapIWindow', [
            'uiGmapBaseObject', 'uiGmapChildEvents', 'uiGmapCtrlHandle', function(BaseObject, ChildEvents, CtrlHandle) {
                var IWindow;
                return IWindow = (function(superClass) {
                    extend(IWindow, superClass);

                    IWindow.scope = {
                        coords: '=coords',
                        template: '=template',
                        templateUrl: '=templateurl',
                        templateParameter: '=templateparameter',
                        isIconVisibleOnClick: '=isiconvisibleonclick',
                        closeClick: '&closeclick',
                        options: '=options',
                        control: '=control',
                        show: '=show'
                    };

                    IWindow.scopeKeys = _.keys(IWindow.scope);

                    IWindow.include(ChildEvents);

                    IWindow.extend(CtrlHandle);

                    function IWindow() {
                        this.restrict = 'EMA';
                        this.template = void 0;
                        this.transclude = true;
                        this.priority = -100;
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.replace = true;
                        this.scope = _.extend(this.scope || {}, IWindow.scope);
                    }

                    return IWindow;

                })(BaseObject);
            }
        ]);

    }).call(this);
    ;
    /*globals angular,_,google */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapMap', ['$timeout', '$q', '$log', 'uiGmapGmapUtil', 'uiGmapBaseObject', 'uiGmapCtrlHandle', 'uiGmapIsReady', 'uiGmapuuid', 'uiGmapExtendGWin', 'uiGmapExtendMarkerClusterer', 'uiGmapGoogleMapsUtilV3', 'uiGmapGoogleMapApi', 'uiGmapEventsHelper', 'uiGmapGoogleMapObjectManager', function($timeout, $q, $log, uiGmapGmapUtil, uiGmapBaseObject, uiGmapCtrlHandle, uiGmapIsReady, uiGmapuuid, uiGmapExtendGWin, uiGmapExtendMarkerClusterer, uiGmapGoogleMapsUtilV3, uiGmapGoogleMapApi, uiGmapEventsHelper, uiGmapGoogleMapObjectManager) {
            var DEFAULTS, Map, initializeItems;
            DEFAULTS = void 0;
            initializeItems = [uiGmapGoogleMapsUtilV3, uiGmapExtendGWin, uiGmapExtendMarkerClusterer];
            return Map = (function(superClass) {
                extend(Map, superClass);

                Map.include(uiGmapGmapUtil);

                function Map() {
                    this.link = bind(this.link, this);
                    var ctrlFn;
                    ctrlFn = function($scope) {
                        var ctrlObj, retCtrl;
                        retCtrl = void 0;
                        $scope.$on('$destroy', function() {
                            return uiGmapIsReady.decrement();
                        });
                        ctrlObj = uiGmapCtrlHandle.handle($scope);
                        $scope.ctrlType = 'Map';
                        $scope.deferred.promise.then(function() {
                            return initializeItems.forEach(function(i) {
                                return i.init();
                            });
                        });
                        ctrlObj.getMap = function() {
                            return $scope.map;
                        };
                        retCtrl = _.extend(this, ctrlObj);
                        return retCtrl;
                    };
                    this.controller = ['$scope', ctrlFn];
                }

                Map.prototype.restrict = 'EMA';

                Map.prototype.transclude = true;

                Map.prototype.replace = false;

                Map.prototype.template = "<div class=\"angular-google-map\"><div class=\"angular-google-map-container\">\n</div><div ng-transclude style=\"display: none\"></div></div>";

                Map.prototype.scope = {
                    center: '=',
                    zoom: '=',
                    dragging: '=',
                    control: '=',
                    options: '=',
                    events: '=',
                    eventOpts: '=',
                    styles: '=',
                    bounds: '=',
                    update: '='
                };

                Map.prototype.link = function(scope, element, attrs) {
                    var listeners;
                    listeners = [];
                    scope.$on('$destroy', function() {
                        uiGmapEventsHelper.removeEvents(listeners);
                        if (attrs.recycleMapInstance === 'true' && scope.map) {
                            uiGmapGoogleMapObjectManager.recycleMapInstance(scope.map);
                            return scope.map = null;
                        }
                    });
                    scope.idleAndZoomChanged = false;
                    return uiGmapGoogleMapApi.then((function(_this) {
                        return function(maps) {
                            var _gMap, customListeners, disabledEvents, dragging, el, eventName, getEventHandler, mapOptions, maybeHookToEvent, opts, ref, resolveSpawned, settingFromDirective, spawned, type, updateCenter, zoomPromise;
                            DEFAULTS = {
                                mapTypeId: maps.MapTypeId.ROADMAP
                            };
                            spawned = uiGmapIsReady.spawn();
                            resolveSpawned = function() {
                                return spawned.deferred.resolve({
                                    instance: spawned.instance,
                                    map: _gMap
                                });
                            };
                            if (!angular.isDefined(scope.center) && !angular.isDefined(scope.bounds)) {
                                $log.error('angular-google-maps: a center or bounds property is required');
                                return;
                            }
                            if (!angular.isDefined(scope.center)) {
                                scope.center = new google.maps.LatLngBounds(_this.getCoords(scope.bounds.southwest), _this.getCoords(scope.bounds.northeast)).getCenter();
                            }
                            if (!angular.isDefined(scope.zoom)) {
                                scope.zoom = 10;
                            }
                            el = angular.element(element);
                            el.addClass('angular-google-map');
                            opts = {
                                options: {}
                            };
                            if (attrs.options) {
                                opts.options = scope.options;
                            }
                            if (attrs.styles) {
                                opts.styles = scope.styles;
                            }
                            if (attrs.type) {
                                type = attrs.type.toUpperCase();
                                if (google.maps.MapTypeId.hasOwnProperty(type)) {
                                    opts.mapTypeId = google.maps.MapTypeId[attrs.type.toUpperCase()];
                                } else {
                                    $log.error("angular-google-maps: invalid map type '" + attrs.type + "'");
                                }
                            }
                            mapOptions = angular.extend({}, DEFAULTS, opts, {
                                center: _this.getCoords(scope.center),
                                zoom: scope.zoom,
                                bounds: scope.bounds
                            });
                            if (attrs.recycleMapInstance === 'true') {
                                _gMap = uiGmapGoogleMapObjectManager.createMapInstance(el.find('div')[1], mapOptions);
                            } else {
                                _gMap = new google.maps.Map(el.find('div')[1], mapOptions);
                            }
                            _gMap['uiGmap_id'] = uiGmapuuid.generate();
                            dragging = false;
                            listeners.push(google.maps.event.addListenerOnce(_gMap, 'idle', function() {
                                scope.deferred.resolve(_gMap);
                                return resolveSpawned();
                            }));
                            disabledEvents = attrs.events && (((ref = scope.events) != null ? ref.blacklist : void 0) != null) ? scope.events.blacklist : [];
                            if (_.isString(disabledEvents)) {
                                disabledEvents = [disabledEvents];
                            }
                            maybeHookToEvent = function(eventName, fn, prefn) {
                                if (!_.includes(disabledEvents, eventName)) {
                                    if (prefn) {
                                        prefn();
                                    }
                                    return listeners.push(google.maps.event.addListener(_gMap, eventName, function() {
                                        var ref1;
                                        if (!((ref1 = scope.update) != null ? ref1.lazy : void 0)) {
                                            return fn();
                                        }
                                    }));
                                }
                            };
                            if (!_.includes(disabledEvents, 'all')) {
                                maybeHookToEvent('dragstart', function() {
                                    dragging = true;
                                    return scope.$evalAsync(function(s) {
                                        if (s.dragging != null) {
                                            return s.dragging = dragging;
                                        }
                                    });
                                });
                                maybeHookToEvent('dragend', function() {
                                    dragging = false;
                                    return scope.$evalAsync(function(s) {
                                        if (s.dragging != null) {
                                            return s.dragging = dragging;
                                        }
                                    });
                                });
                                updateCenter = function(c, s) {
                                    if (c == null) {
                                        c = _gMap.center;
                                    }
                                    if (s == null) {
                                        s = scope;
                                    }
                                    if (_.includes(disabledEvents, 'center')) {
                                        if (s.center.latitude !== c.lat()) {
                                            s.center.latitude = c.lat();
                                        }
                                        if (s.center.longitude !== c.lng()) {
                                            return s.center.longitude = c.lng();
                                        }
                                    }
                                };
                                settingFromDirective = false;
                                maybeHookToEvent('idle', function() {
                                    var b, ne, sw;
                                    b = _gMap.getBounds();
                                    ne = b.getNorthEast();
                                    sw = b.getSouthWest();
                                    settingFromDirective = true;
                                    return scope.$evalAsync(function(s) {
                                        updateCenter();
                                        if (!_.isUndefined(s.bounds) && !_.includes(disabledEvents, 'bounds')) {
                                            s.bounds.northeast = {
                                                latitude: ne.lat(),
                                                longitude: ne.lng()
                                            };
                                            s.bounds.southwest = {
                                                latitude: sw.lat(),
                                                longitude: sw.lng()
                                            };
                                        }
                                        if (!_.includes(disabledEvents, 'zoom')) {
                                            s.zoom = _gMap.zoom;
                                            scope.idleAndZoomChanged = !scope.idleAndZoomChanged;
                                        }
                                        return settingFromDirective = false;
                                    });
                                });
                            }
                            if (angular.isDefined(scope.events) && scope.events !== null && angular.isObject(scope.events)) {
                                getEventHandler = function(eventName) {
                                    return function() {
                                        return scope.events[eventName].apply(scope, [_gMap, eventName, arguments]);
                                    };
                                };
                                customListeners = [];
                                for (eventName in scope.events) {
                                    if (scope.events.hasOwnProperty(eventName) && angular.isFunction(scope.events[eventName])) {
                                        customListeners.push(google.maps.event.addListener(_gMap, eventName, getEventHandler(eventName)));
                                    }
                                }
                                listeners.concat(customListeners);
                            }
                            _gMap.getOptions = function() {
                                return mapOptions;
                            };
                            scope.map = _gMap;
                            if ((attrs.control != null) && (scope.control != null)) {
                                scope.control.refresh = function(maybeCoords) {
                                    var coords, ref1, ref2;
                                    if (_gMap == null) {
                                        return;
                                    }
                                    if (((typeof google !== "undefined" && google !== null ? (ref1 = google.maps) != null ? (ref2 = ref1.event) != null ? ref2.trigger : void 0 : void 0 : void 0) != null) && (_gMap != null)) {
                                        google.maps.event.trigger(_gMap, 'resize');
                                    }
                                    if (((maybeCoords != null ? maybeCoords.latitude : void 0) != null) && ((maybeCoords != null ? maybeCoords.longitude : void 0) != null)) {
                                        coords = _this.getCoords(maybeCoords);
                                        if (_this.isTrue(attrs.pan)) {
                                            return _gMap.panTo(coords);
                                        } else {
                                            return _gMap.setCenter(coords);
                                        }
                                    }
                                };
                                scope.control.getGMap = function() {
                                    return _gMap;
                                };
                                scope.control.getMapOptions = function() {
                                    return mapOptions;
                                };
                                scope.control.getCustomEventListeners = function() {
                                    return customListeners;
                                };
                                scope.control.removeEvents = function(yourListeners) {
                                    return uiGmapEventsHelper.removeEvents(yourListeners);
                                };
                            }
                            scope.$watch('center', function(newValue, oldValue) {
                                var coords;
                                if (newValue === oldValue || settingFromDirective) {
                                    return;
                                }
                                coords = _this.getCoords(scope.center);
                                if (coords.lat() === _gMap.center.lat() && coords.lng() === _gMap.center.lng()) {
                                    return;
                                }
                                if (!dragging) {
                                    if (!_this.validateCoords(newValue)) {
                                        $log.error("Invalid center for newValue: " + (JSON.stringify(newValue)));
                                    }
                                    if (_this.isTrue(attrs.pan) && scope.zoom === _gMap.zoom) {
                                        return _gMap.panTo(coords);
                                    } else {
                                        return _gMap.setCenter(coords);
                                    }
                                }
                            }, true);
                            zoomPromise = null;
                            scope.$watch('zoom', function(newValue, oldValue) {
                                var ref1, ref2;
                                if (newValue == null) {
                                    return;
                                }
                                if (_.isEqual(newValue, oldValue) || (_gMap != null ? _gMap.getZoom() : void 0) === (scope != null ? scope.zoom : void 0) || settingFromDirective) {
                                    return;
                                }
                                if (zoomPromise != null) {
                                    $timeout.cancel(zoomPromise);
                                }
                                return zoomPromise = $timeout(function() {
                                    return _gMap.setZoom(newValue);
                                }, ((ref1 = scope.eventOpts) != null ? (ref2 = ref1.debounce) != null ? ref2.zoomMs : void 0 : void 0) + 20, false);
                            });
                            scope.$watch('bounds', function(newValue, oldValue) {
                                var bounds, ne, ref1, ref2, ref3, ref4, sw;
                                if (newValue === oldValue) {
                                    return;
                                }
                                if (((newValue != null ? (ref1 = newValue.northeast) != null ? ref1.latitude : void 0 : void 0) == null) || ((newValue != null ? (ref2 = newValue.northeast) != null ? ref2.longitude : void 0 : void 0) == null) || ((newValue != null ? (ref3 = newValue.southwest) != null ? ref3.latitude : void 0 : void 0) == null) || ((newValue != null ? (ref4 = newValue.southwest) != null ? ref4.longitude : void 0 : void 0) == null)) {
                                    $log.error("Invalid map bounds for new value: " + (JSON.stringify(newValue)));
                                    return;
                                }
                                ne = new google.maps.LatLng(newValue.northeast.latitude, newValue.northeast.longitude);
                                sw = new google.maps.LatLng(newValue.southwest.latitude, newValue.southwest.longitude);
                                bounds = new google.maps.LatLngBounds(sw, ne);
                                return _gMap.fitBounds(bounds);
                            });
                            return ['options', 'styles'].forEach(function(toWatch) {
                                return scope.$watch(toWatch, function(newValue, oldValue) {
                                    if (_.isEqual(newValue, oldValue)) {
                                        return;
                                    }
                                    if (toWatch === 'options') {
                                        opts.options = newValue;
                                    } else {
                                        opts.options[toWatch] = newValue;
                                    }
                                    if (_gMap != null) {
                                        return _gMap.setOptions(opts);
                                    }
                                }, true);
                            });
                        };
                    })(this));
                };

                return Map;

            })(uiGmapBaseObject);
        }]);

    }).call(this);
    ;
    /*global _:true,angular:true */

    (function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapMarker", [
            "uiGmapIMarker", "uiGmapMarkerChildModel", "uiGmapMarkerManager", "uiGmapLogger", function(IMarker, MarkerChildModel, MarkerManager, $log) {
                var Marker;
                return Marker = (function(superClass) {
                    extend(Marker, superClass);

                    function Marker() {
                        Marker.__super__.constructor.call(this);
                        this.template = '<span class="angular-google-map-marker" ng-transclude></span>';
                        $log.info(this);
                    }

                    Marker.prototype.controller = [
                        '$scope', '$element', function($scope, $element) {
                            $scope.ctrlType = 'Marker';
                            return _.extend(this, IMarker.handle($scope, $element));
                        }
                    ];

                    Marker.prototype.link = function(scope, element, attrs, ctrl) {
                        var mapPromise;
                        mapPromise = IMarker.mapPromise(scope, ctrl);
                        mapPromise.then(function(gMap) {
                            var gManager, keys, m;
                            gManager = new MarkerManager(gMap);
                            keys = _.object(IMarker.keys, IMarker.keys);
                            m = new MarkerChildModel({
                                scope: scope,
                                model: scope,
                                keys: keys,
                                gMap: gMap,
                                doClick: true,
                                gManager: gManager,
                                doDrawSelf: false,
                                trackModel: false
                            });
                            m.deferred.promise.then(function(gMarker) {
                                return scope.deferred.resolve(gMarker);
                            });
                            if (scope.control != null) {
                                return scope.control.getGMarkers = gManager.getGMarkers;
                            }
                        });
                        return scope.$on('$destroy', function() {
                            var gManager;
                            if (typeof gManager !== "undefined" && gManager !== null) {
                                gManager.clear();
                            }
                            return gManager = null;
                        });
                    };

                    return Marker;

                })(IMarker);
            }
        ]);

    }).call(this);
    ;
    /*global _:true,angular:true */

    (function() {
        var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module("uiGmapgoogle-maps.directives.api").factory("uiGmapMarkers", [
            "uiGmapIMarker", "uiGmapPlural", "uiGmapMarkersParentModel", "uiGmap_sync", "uiGmapLogger", function(IMarker, Plural, MarkersParentModel, _sync, $log) {
                var Markers;
                return Markers = (function(superClass) {
                    extend(Markers, superClass);

                    function Markers() {
                        Markers.__super__.constructor.call(this);
                        this.template = '<span class="angular-google-map-markers" ng-transclude></span>';
                        Plural.extend(this, {
                            doCluster: '=?docluster',
                            clusterOptions: '=clusteroptions',
                            clusterEvents: '=clusterevents',
                            modelsByRef: '=modelsbyref',
                            type: '=?type',
                            typeOptions: '=?typeoptions',
                            typeEvents: '=?typeevents'
                        });
                        $log.info(this);
                    }

                    Markers.prototype.controller = [
                        '$scope', '$element', function($scope, $element) {
                            $scope.ctrlType = 'Markers';
                            return _.extend(this, IMarker.handle($scope, $element));
                        }
                    ];

                    Markers.prototype.link = function(scope, element, attrs, ctrl) {
                        var parentModel, ready;
                        parentModel = void 0;
                        ready = function() {
                            return scope.deferred.resolve();
                        };
                        return IMarker.mapPromise(scope, ctrl).then(function(map) {
                            var mapScope;
                            mapScope = ctrl.getScope();
                            mapScope.$watch('idleAndZoomChanged', function() {
                                return _.defer(parentModel.gManager.draw);
                            });
                            parentModel = new MarkersParentModel(scope, element, attrs, map);
                            Plural.link(scope, parentModel);
                            if (scope.control != null) {
                                scope.control.getGMarkers = function() {
                                    var ref;
                                    return (ref = parentModel.gManager) != null ? ref.getGMarkers() : void 0;
                                };
                                scope.control.getChildMarkers = function() {
                                    return parentModel.plurals;
                                };
                            }
                            return _.last(parentModel.existingPieces._content).then(function() {
                                return ready();
                            });
                        });
                    };

                    return Markers;

                })(IMarker);
            }
        ]);

    }).call(this);
    ;
    /*global angular */

    (function() {
        angular.module('uiGmapgoogle-maps.directives.api').service('uiGmapPlural', [
            function() {
                var _initControl;
                _initControl = function(scope, parent) {
                    if (scope.control == null) {
                        return;
                    }
                    scope.control.updateModels = function(models) {
                        scope.models = models;
                        return parent.createChildScopes(false);
                    };
                    scope.control.newModels = function(models) {
                        scope.models = models;
                        return parent.rebuildAll(scope, true, true);
                    };
                    scope.control.clean = function() {
                        return parent.rebuildAll(scope, false, true);
                    };
                    scope.control.getPlurals = function() {
                        return parent.plurals;
                    };
                    scope.control.getManager = function() {
                        return parent.gManager;
                    };
                    scope.control.hasManager = function() {
                        return (parent.gManager != null) === true;
                    };
                    return scope.control.managerDraw = function() {
                        var ref;
                        if (scope.control.hasManager()) {
                            return (ref = scope.control.getManager()) != null ? ref.draw() : void 0;
                        }
                    };
                };
                return {
                    extend: function(obj, obj2) {
                        return _.extend(obj.scope || {}, obj2 || {}, {
                            idKey: '=idkey',
                            doRebuildAll: '=dorebuildall',
                            models: '=models',
                            chunk: '=chunk',
                            cleanchunk: '=cleanchunk',
                            control: '=control'
                        });
                    },
                    link: function(scope, parent) {
                        return _initControl(scope, parent);
                    }
                };
            }
        ]);

    }).call(this);
    ;
    /*global angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygon', [
            'uiGmapIPolygon', '$timeout', 'uiGmapPolygonChildModel', function(IPolygon, $timeout, PolygonChild) {
                var Polygon;
                return Polygon = (function(superClass) {
                    extend(Polygon, superClass);

                    function Polygon() {
                        this.link = bind(this.link, this);
                        return Polygon.__super__.constructor.apply(this, arguments);
                    }

                    Polygon.prototype.link = function(scope, element, attrs, mapCtrl) {
                        var children, promise;
                        children = [];
                        promise = IPolygon.mapPromise(scope, mapCtrl);
                        if (scope.control != null) {
                            scope.control.getInstance = this;
                            scope.control.polygons = children;
                            scope.control.promise = promise;
                        }
                        return promise.then((function(_this) {
                            return function(gMap) {
                                return children.push(new PolygonChild({
                                    scope: scope,
                                    attrs: attrs,
                                    gMap: gMap,
                                    defaults: _this.DEFAULTS
                                }));
                            };
                        })(this));
                    };

                    return Polygon;

                })(IPolygon);
            }
        ]);

    }).call(this);
    ;
    /*global angular:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolygons', [
            'uiGmapIPolygon', '$timeout', 'uiGmapPolygonsParentModel', 'uiGmapPlural', function(Interface, $timeout, ParentModel, Plural) {
                var Polygons;
                return Polygons = (function(superClass) {
                    extend(Polygons, superClass);

                    function Polygons() {
                        this.link = bind(this.link, this);
                        Polygons.__super__.constructor.call(this);
                        Plural.extend(this);
                        this.$log.info(this);
                    }

                    Polygons.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then((function(_this) {
                            return function(map) {
                                if (angular.isUndefined(scope.path) || scope.path === null) {
                                    _this.$log.warn('polygons: no valid path attribute found');
                                }
                                if (!scope.models) {
                                    _this.$log.warn('polygons: no models found to create from');
                                }
                                return Plural.link(scope, new ParentModel(scope, element, attrs, map, _this.DEFAULTS));
                            };
                        })(this));
                    };

                    return Polygons;

                })(Interface);
            }
        ]);

    }).call(this);
    ;
    /*global angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolyline', [
            'uiGmapIPolyline', '$timeout', 'uiGmapPolylineChildModel', function(IPolyline, $timeout, PolylineChildModel) {
                var Polyline;
                return Polyline = (function(superClass) {
                    extend(Polyline, superClass);

                    function Polyline() {
                        this.link = bind(this.link, this);
                        return Polyline.__super__.constructor.apply(this, arguments);
                    }

                    Polyline.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return IPolyline.mapPromise(scope, mapCtrl).then((function(_this) {
                            return function(gMap) {
                                if (angular.isUndefined(scope.path) || scope.path === null || !_this.validatePath(scope.path)) {
                                    _this.$log.warn('polyline: no valid path attribute found');
                                }
                                return new PolylineChildModel({
                                    scope: scope,
                                    attrs: attrs,
                                    gMap: gMap,
                                    defaults: _this.DEFAULTS
                                });
                            };
                        })(this));
                    };

                    return Polyline;

                })(IPolyline);
            }
        ]);

    }).call(this);
    ;
    /*global angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapPolylines', [
            'uiGmapIPolyline', '$timeout', 'uiGmapPolylinesParentModel', 'uiGmapPlural', function(IPolyline, $timeout, PolylinesParentModel, Plural) {
                var Polylines;
                return Polylines = (function(superClass) {
                    extend(Polylines, superClass);

                    function Polylines() {
                        this.link = bind(this.link, this);
                        Polylines.__super__.constructor.call(this);
                        Plural.extend(this);
                        this.$log.info(this);
                    }

                    Polylines.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then((function(_this) {
                            return function(gMap) {
                                if (angular.isUndefined(scope.path) || scope.path === null) {
                                    _this.$log.warn('polylines: no valid path attribute found');
                                }
                                if (!scope.models) {
                                    _this.$log.warn('polylines: no models found to create from');
                                }
                                return Plural.link(scope, new PolylinesParentModel(scope, element, attrs, gMap, _this.DEFAULTS));
                            };
                        })(this));
                    };

                    return Polylines;

                })(IPolyline);
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapRectangle', [
            'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapIRectangle', 'uiGmapRectangleParentModel', function($log, GmapUtil, IRectangle, RectangleParentModel) {
                return _.extend(IRectangle, {
                    link: function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then(function(gMap) {
                            return new RectangleParentModel(scope, element, attrs, gMap);
                        });
                    }
                });
            }
        ]);

    }).call(this);
    ;
    /*global angular:true */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapWindow', [
            'uiGmapIWindow', 'uiGmapGmapUtil', 'uiGmapWindowChildModel', 'uiGmapLodash', 'uiGmapLogger', function(IWindow, GmapUtil, WindowChildModel, uiGmapLodash, $log) {
                var Window;
                return Window = (function(superClass) {
                    extend(Window, superClass);

                    Window.include(GmapUtil);

                    function Window() {
                        this.link = bind(this.link, this);
                        Window.__super__.constructor.call(this);
                        this.require = ['^' + 'uiGmapGoogleMap', '^?' + 'uiGmapMarker'];
                        this.template = '<span class="angular-google-maps-window" ng-transclude></span>';
                        $log.debug(this);
                        this.childWindows = [];
                    }

                    Window.prototype.link = function(scope, element, attrs, ctrls) {
                        var markerCtrl, markerScope;
                        markerCtrl = ctrls.length > 1 && (ctrls[1] != null) ? ctrls[1] : void 0;
                        markerScope = markerCtrl != null ? markerCtrl.getScope() : void 0;
                        this.mapPromise = IWindow.mapPromise(scope, ctrls[0]);
                        return this.mapPromise.then((function(_this) {
                            return function(gMap) {
                                var isIconVisibleOnClick;
                                isIconVisibleOnClick = true;
                                if (angular.isDefined(attrs.isiconvisibleonclick)) {
                                    isIconVisibleOnClick = scope.isIconVisibleOnClick;
                                }
                                if (!markerCtrl) {
                                    _this.init(scope, element, isIconVisibleOnClick, gMap);
                                    return;
                                }
                                return markerScope.deferred.promise.then(function(gMarker) {
                                    return _this.init(scope, element, isIconVisibleOnClick, gMap, markerScope);
                                });
                            };
                        })(this));
                    };

                    Window.prototype.init = function(scope, element, isIconVisibleOnClick, gMap, markerScope) {
                        var childWindow, defaults, gMarker, hasScopeCoords, opts;
                        defaults = scope.options != null ? scope.options : {};
                        hasScopeCoords = (scope != null) && this.validateCoords(scope.coords);
                        if ((markerScope != null ? markerScope['getGMarker'] : void 0) != null) {
                            gMarker = markerScope.getGMarker();
                        }
                        opts = hasScopeCoords ? this.createWindowOptions(gMarker, scope, element.html(), defaults) : defaults;
                        if (gMap != null) {
                            childWindow = new WindowChildModel({
                                scope: scope,
                                opts: opts,
                                isIconVisibleOnClick: isIconVisibleOnClick,
                                gMap: gMap,
                                markerScope: markerScope,
                                element: element
                            });
                            this.childWindows.push(childWindow);
                            scope.$on('$destroy', (function(_this) {
                                return function() {
                                    _this.childWindows = uiGmapLodash.withoutObjects(_this.childWindows, [childWindow], function(child1, child2) {
                                        return child1.scope.$id === child2.scope.$id;
                                    });
                                    return _this.childWindows.length = 0;
                                };
                            })(this));
                        }
                        if (scope.control != null) {
                            scope.control.getGWindows = (function(_this) {
                                return function() {
                                    return _this.childWindows.map(function(child) {
                                        return child.gObject;
                                    });
                                };
                            })(this);
                            scope.control.getChildWindows = (function(_this) {
                                return function() {
                                    return _this.childWindows;
                                };
                            })(this);
                            scope.control.getPlurals = scope.control.getChildWindows;
                            scope.control.showWindow = (function(_this) {
                                return function() {
                                    return _this.childWindows.map(function(child) {
                                        return child.showWindow();
                                    });
                                };
                            })(this);
                            scope.control.hideWindow = (function(_this) {
                                return function() {
                                    return _this.childWindows.map(function(child) {
                                        return child.hideWindow();
                                    });
                                };
                            })(this);
                        }
                        if ((this.onChildCreation != null) && (childWindow != null)) {
                            return this.onChildCreation(childWindow);
                        }
                    };

                    return Window;

                })(IWindow);
            }
        ]);

    }).call(this);
    ;
    /*global angular */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
            extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
            hasProp = {}.hasOwnProperty;

        angular.module('uiGmapgoogle-maps.directives.api').factory('uiGmapWindows', [
            'uiGmapIWindow', 'uiGmapPlural', 'uiGmapWindowsParentModel', 'uiGmapPromise', 'uiGmapLogger', function(IWindow, Plural, WindowsParentModel, uiGmapPromise, $log) {

                /*
                 Windows directive where many windows map to the models property
                 */
                var Windows;
                return Windows = (function(superClass) {
                    extend(Windows, superClass);

                    function Windows() {
                        this.link = bind(this.link, this);
                        Windows.__super__.constructor.call(this);
                        this.require = ['^' + 'uiGmapGoogleMap', '^?' + 'uiGmapMarkers'];
                        this.template = '<span class="angular-google-maps-windows" ng-transclude></span>';
                        Plural.extend(this);
                        $log.debug(this);
                    }

                    Windows.prototype.link = function(scope, element, attrs, ctrls) {
                        var mapScope, markerCtrl, markerScope;
                        mapScope = ctrls[0].getScope();
                        markerCtrl = ctrls.length > 1 && (ctrls[1] != null) ? ctrls[1] : void 0;
                        markerScope = markerCtrl != null ? markerCtrl.getScope() : void 0;
                        return mapScope.deferred.promise.then((function(_this) {
                            return function(map) {
                                var promise, ref;
                                promise = (markerScope != null ? (ref = markerScope.deferred) != null ? ref.promise : void 0 : void 0) || uiGmapPromise.resolve();
                                return promise.then(function() {
                                    var pieces, ref1;
                                    pieces = (ref1 = _this.parentModel) != null ? ref1.existingPieces : void 0;
                                    if (pieces) {
                                        return pieces.then(function() {
                                            return _this.init(scope, element, attrs, ctrls, map, markerScope);
                                        });
                                    } else {
                                        return _this.init(scope, element, attrs, ctrls, map, markerScope);
                                    }
                                });
                            };
                        })(this));
                    };

                    Windows.prototype.init = function(scope, element, attrs, ctrls, map, additionalScope) {
                        var parentModel;
                        parentModel = new WindowsParentModel(scope, element, attrs, ctrls, map, additionalScope);
                        Plural.link(scope, parentModel);
                        if (scope.control != null) {
                            scope.control.getGWindows = function() {
                                return parentModel.plurals.map(function(child) {
                                    return child.gObject;
                                });
                            };
                            return scope.control.getChildWindows = function() {
                                return parentModel.plurals;
                            };
                        }
                    };

                    return Windows;

                })(IWindow);
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     Nick Baugh - https://github.com/niftylettuce
     */


    /*globals angular */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapGoogleMap", ['uiGmapMap', function(uiGmapMap) {
            return new uiGmapMap();
        }]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     Map marker directive

     This directive is used to create a marker on an existing map.
     This directive creates a new scope.

     {attribute coords required}  object containing latitude and longitude properties
     {attribute icon optional}    string url to image used for marker icon
     {attribute animate optional} if set to false, the marker won't be animated (on by default)
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapMarker', [
            '$timeout', 'uiGmapMarker', function($timeout, Marker) {
                return new Marker($timeout);
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     Map marker directive

     This directive is used to create a marker on an existing map.
     This directive creates a new scope.

     {attribute coords required}  object containing latitude and longitude properties
     {attribute icon optional}    string url to image used for marker icon
     {attribute animate optional} if set to false, the marker won't be animated (on by default)
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapMarkers', [
            '$timeout', 'uiGmapMarkers', function($timeout, Markers) {
                return new Markers($timeout);
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     Rick Huizinga - https://plus.google.com/+RickHuizinga
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapPolygon', [
            'uiGmapPolygon', function(Polygon) {
                return new Polygon();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Julian Popescu - https://github.com/jpopesculian
     Rick Huizinga - https://plus.google.com/+RickHuizinga
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive("uiGmapCircle", [
            "uiGmapCircle", function(Circle) {
                return Circle;
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapPolyline", [
            "uiGmapPolyline", function(Polyline) {
                return new Polyline();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapPolylines', [
            'uiGmapPolylines', function(Polylines) {
                return new Polylines();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     Chentsu Lin - https://github.com/ChenTsuLin
     */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapRectangle", [
            "uiGmapLogger", "uiGmapRectangle", function($log, Rectangle) {
                return Rectangle;
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     Map info window directive

     This directive is used to create an info window on an existing map.
     This directive creates a new scope.

     {attribute coords required}  object containing latitude and longitude properties
     {attribute show optional}    map will show when this expression returns true
     */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapWindow", [
            "$timeout", "$compile", "$http", "$templateCache", "uiGmapWindow", function($timeout, $compile, $http, $templateCache, Window) {
                return new Window($timeout, $compile, $http, $templateCache);
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     Map info window directive

     This directive is used to create an info window on an existing map.
     This directive creates a new scope.

     {attribute coords required}  object containing latitude and longitude properties
     {attribute show optional}    map will show when this expression returns true
     */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapWindows", [
            "$timeout", "$compile", "$http", "$templateCache", "$interpolate", "uiGmapWindows", function($timeout, $compile, $http, $templateCache, $interpolate, Windows) {
                return new Windows($timeout, $compile, $http, $templateCache, $interpolate);
            }
        ]);

    }).call(this);
    ;
    /*
     @authors:
     - Nicolas Laplante https://plus.google.com/108189012221374960701
     - Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     Map Layer directive

     This directive is used to create any type of Layer from the google maps sdk.
     This directive creates a new scope.

     {attribute show optional}  true (default) shows the trafficlayer otherwise it is hidden
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module('uiGmapgoogle-maps').directive('uiGmapLayer', [
            '$timeout', 'uiGmapLogger', 'uiGmapLayerParentModel', function($timeout, Logger, LayerParentModel) {
                var Layer;
                Layer = (function() {
                    function Layer() {
                        this.link = bind(this.link, this);
                        this.$log = Logger;
                        this.restrict = 'EMA';
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.priority = -1;
                        this.transclude = true;
                        this.template = '<span class=\'angular-google-map-layer\' ng-transclude></span>';
                        this.replace = true;
                        this.scope = {
                            show: '=show',
                            type: '=type',
                            namespace: '=namespace',
                            options: '=options',
                            onCreated: '&oncreated'
                        };
                    }

                    Layer.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then((function(_this) {
                            return function(map) {
                                if (scope.onCreated != null) {
                                    return new LayerParentModel(scope, element, attrs, map, scope.onCreated);
                                } else {
                                    return new LayerParentModel(scope, element, attrs, map);
                                }
                            };
                        })(this));
                    };

                    return Layer;

                })();
                return new Layer();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Adam Kreitals, kreitals@hotmail.com
     */


    /*
     mapControl directive

     This directive is used to create a custom control element on an existing map.
     This directive creates a new scope.

     {attribute template required}  	string url of the template to be used for the control
     {attribute position optional}  	string position of the control of the form top-left or TOP_LEFT defaults to TOP_CENTER
     {attribute controller optional}	string controller to be applied to the template
     {attribute index optional}		number index for controlling the order of similarly positioned mapControl elements
     */

    (function() {
        angular.module("uiGmapgoogle-maps").directive("uiGmapMapControl", [
            "uiGmapControl", function(Control) {
                return new Control();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicholas McCready - https://twitter.com/nmccready
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapDragZoom', [
            'uiGmapDragZoom', function(DragZoom) {
                return DragZoom;
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps').directive("uiGmapDrawingManager", [
            "uiGmapDrawingManager", function(DrawingManager) {
                return DrawingManager;
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicholas McCready - https://twitter.com/nmccready
     * Brunt of the work is in DrawFreeHandChildModel
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapFreeDrawPolygons', [
            'uiGmapApiFreeDrawPolygons', function(FreeDrawPolygons) {
                return new FreeDrawPolygons();
            }
        ]);

    }).call(this);
    ;
    /*
     Map Layer directive

     This directive is used to create any type of Layer from the google maps sdk.
     This directive creates a new scope.

     {attribute show optional}  true (default) shows the trafficlayer otherwise it is hidden
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module("uiGmapgoogle-maps").directive("uiGmapMapType", [
            "$timeout", "uiGmapLogger", "uiGmapMapTypeParentModel", function($timeout, Logger, MapTypeParentModel) {
                var MapType;
                MapType = (function() {
                    function MapType() {
                        this.link = bind(this.link, this);
                        this.$log = Logger;
                        this.restrict = "EMA";
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.priority = -1;
                        this.transclude = true;
                        this.template = '<span class=\"angular-google-map-layer\" ng-transclude></span>';
                        this.replace = true;
                        this.scope = {
                            show: "=show",
                            options: '=options',
                            refresh: '=refresh',
                            id: '@'
                        };
                    }

                    MapType.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return mapCtrl.getScope().deferred.promise.then((function(_this) {
                            return function(map) {
                                return new MapTypeParentModel(scope, element, attrs, map);
                            };
                        })(this));
                    };

                    return MapType;

                })();
                return new MapType();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors
     Nicolas Laplante - https://plus.google.com/108189012221374960701
     Nicholas McCready - https://twitter.com/nmccready
     Rick Huizinga - https://plus.google.com/+RickHuizinga
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapPolygons', [
            'uiGmapPolygons', function(Polygons) {
                return new Polygons();
            }
        ]);

    }).call(this);
    ;
    /*
     @authors:
     - Nicolas Laplante https://plus.google.com/108189012221374960701
     - Nicholas McCready - https://twitter.com/nmccready
     - Carrie Kengle - http://about.me/carrie
     */


    /*
     Places Search Box directive

     This directive is used to create a Places Search Box.
     This directive creates a new scope.

     {attribute input required}  HTMLInputElement
     {attribute options optional} The options that can be set on a SearchBox object (google.maps.places.SearchBoxOptions object specification)
     */

    (function() {
        var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

        angular.module('uiGmapgoogle-maps').directive('uiGmapSearchBox', [
            'uiGmapGoogleMapApi', 'uiGmapLogger', 'uiGmapSearchBoxParentModel', '$http', '$templateCache', '$compile', function(GoogleMapApi, Logger, SearchBoxParentModel, $http, $templateCache, $compile) {
                var SearchBox;
                SearchBox = (function() {
                    SearchBox.prototype.require = 'ngModel';

                    function SearchBox() {
                        this.link = bind(this.link, this);
                        this.$log = Logger;
                        this.restrict = 'EMA';
                        this.require = '^' + 'uiGmapGoogleMap';
                        this.priority = -1;
                        this.transclude = true;
                        this.template = '<span class=\'angular-google-map-search\' ng-transclude></span>';
                        this.replace = true;
                        this.scope = {
                            template: '=template',
                            events: '=events',
                            position: '=?position',
                            options: '=?options',
                            parentdiv: '=?parentdiv',
                            ngModel: "=?"
                        };
                    }

                    SearchBox.prototype.link = function(scope, element, attrs, mapCtrl) {
                        return GoogleMapApi.then((function(_this) {
                            return function(maps) {
                                if (scope.template == null) {
                                    $templateCache.put('uigmap-searchbox-default.tpl.html', '<input type="text">');
                                    scope.template = 'uigmap-searchbox-default.tpl.html';
                                }
                                return $http.get(scope.template, {
                                    cache: $templateCache
                                }).success(function(template) {
                                    if (angular.isUndefined(scope.events)) {
                                        _this.$log.error('searchBox: the events property is required');
                                        return;
                                    }
                                    return mapCtrl.getScope().deferred.promise.then(function(map) {
                                        var ctrlPosition;
                                        ctrlPosition = angular.isDefined(scope.position) ? scope.position.toUpperCase().replace(/-/g, '_') : 'TOP_LEFT';
                                        if (!maps.ControlPosition[ctrlPosition]) {
                                            _this.$log.error('searchBox: invalid position property');
                                            return;
                                        }
                                        return new SearchBoxParentModel(scope, element, attrs, map, ctrlPosition, $compile(template)(scope));
                                    });
                                });
                            };
                        })(this));
                    };

                    return SearchBox;

                })();
                return new SearchBox();
            }
        ]);

    }).call(this);
    ;(function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapShow', [
            '$animate', 'uiGmapLogger', function($animate, $log) {
                return {
                    scope: {
                        'uiGmapShow': '=',
                        'uiGmapAfterShow': '&',
                        'uiGmapAfterHide': '&'
                    },
                    link: function(scope, element) {
                        var angular_post_1_3_handle, angular_pre_1_3_handle, handle;
                        angular_post_1_3_handle = function(animateAction, cb) {
                            return $animate[animateAction](element, 'ng-hide').then(function() {
                                return cb();
                            });
                        };
                        angular_pre_1_3_handle = function(animateAction, cb) {
                            return $animate[animateAction](element, 'ng-hide', cb);
                        };
                        handle = function(animateAction, cb) {
                            if (angular.version.major > 1) {
                                return $log.error("uiGmapShow is not supported for Angular Major greater than 1.\nYour Major is " + angular.version.major + "\"");
                            }
                            if (angular.version.major === 1 && angular.version.minor < 3) {
                                return angular_pre_1_3_handle(animateAction, cb);
                            }
                            return angular_post_1_3_handle(animateAction, cb);
                        };
                        return scope.$watch('uiGmapShow', function(show) {
                            if (show) {
                                handle('removeClass', scope.uiGmapAfterShow);
                            }
                            if (!show) {
                                return handle('addClass', scope.uiGmapAfterHide);
                            }
                        });
                    }
                };
            }
        ]);

    }).call(this);
    ;
    /*
     @authors:
     - Nicholas McCready - https://twitter.com/nmccready
     */


    /*
     StreetViewPanorama Directive to care of basic initialization of StreetViewPanorama
     */

    (function() {
        angular.module('uiGmapgoogle-maps').directive('uiGmapStreetViewPanorama', [
            'uiGmapGoogleMapApi', 'uiGmapLogger', 'uiGmapGmapUtil', 'uiGmapEventsHelper', function(GoogleMapApi, $log, GmapUtil, EventsHelper) {
                var name;
                name = 'uiGmapStreetViewPanorama';
                return {
                    restrict: 'EMA',
                    template: '<div class="angular-google-map-street-view-panorama"></div>',
                    replace: true,
                    scope: {
                        focalcoord: '=',
                        radius: '=?',
                        events: '=?',
                        options: '=?',
                        control: '=?',
                        povoptions: '=?',
                        imagestatus: '='
                    },
                    link: function(scope, element, attrs) {
                        return GoogleMapApi.then((function(_this) {
                            return function(maps) {
                                var clean, create, didCreateOptionsFromDirective, firstTime, handleSettings, listeners, opts, pano, povOpts, sv;
                                pano = void 0;
                                sv = void 0;
                                didCreateOptionsFromDirective = false;
                                listeners = void 0;
                                opts = null;
                                povOpts = null;
                                clean = function() {
                                    EventsHelper.removeEvents(listeners);
                                    if (pano != null) {
                                        pano.unbind('position');
                                        pano.setVisible(false);
                                    }
                                    if (sv != null) {
                                        if ((sv != null ? sv.setVisible : void 0) != null) {
                                            sv.setVisible(false);
                                        }
                                        return sv = void 0;
                                    }
                                };
                                handleSettings = function(perspectivePoint, focalPoint) {
                                    var heading;
                                    heading = google.maps.geometry.spherical.computeHeading(perspectivePoint, focalPoint);
                                    didCreateOptionsFromDirective = true;
                                    scope.radius = scope.radius || 50;
                                    povOpts = angular.extend({
                                        heading: heading,
                                        zoom: 1,
                                        pitch: 0
                                    }, scope.povoptions || {});
                                    opts = opts = angular.extend({
                                        navigationControl: false,
                                        addressControl: false,
                                        linksControl: false,
                                        position: perspectivePoint,
                                        pov: povOpts,
                                        visible: true
                                    }, scope.options || {});
                                    return didCreateOptionsFromDirective = false;
                                };
                                create = function() {
                                    var focalPoint;
                                    if (!scope.focalcoord) {
                                        $log.error(name + ": focalCoord needs to be defined");
                                        return;
                                    }
                                    if (!scope.radius) {
                                        $log.error(name + ": needs a radius to set the camera view from its focal target.");
                                        return;
                                    }
                                    clean();
                                    if (sv == null) {
                                        sv = new google.maps.StreetViewService();
                                    }
                                    if (scope.events) {
                                        listeners = EventsHelper.setEvents(sv, scope, scope);
                                    }
                                    focalPoint = GmapUtil.getCoords(scope.focalcoord);
                                    return sv.getPanoramaByLocation(focalPoint, scope.radius, function(streetViewPanoramaData, status) {
                                        var ele, perspectivePoint, ref;
                                        if (scope.imagestatus != null) {
                                            scope.imagestatus = status;
                                        }
                                        if (((ref = scope.events) != null ? ref.image_status_changed : void 0) != null) {
                                            scope.events.image_status_changed(sv, 'image_status_changed', scope, status);
                                        }
                                        if (status === "OK") {
                                            perspectivePoint = streetViewPanoramaData.location.latLng;
                                            handleSettings(perspectivePoint, focalPoint);
                                            ele = element[0];
                                            return pano = new google.maps.StreetViewPanorama(ele, opts);
                                        }
                                    });
                                };
                                if (scope.control != null) {
                                    scope.control.getOptions = function() {
                                        return opts;
                                    };
                                    scope.control.getPovOptions = function() {
                                        return povOpts;
                                    };
                                    scope.control.getGObject = function() {
                                        return sv;
                                    };
                                    scope.control.getGPano = function() {
                                        return pano;
                                    };
                                }
                                scope.$watch('options', function(newValue, oldValue) {
                                    if (newValue === oldValue || newValue === opts || didCreateOptionsFromDirective) {
                                        return;
                                    }
                                    return create();
                                });
                                firstTime = true;
                                scope.$watch('focalcoord', function(newValue, oldValue) {
                                    if (newValue === oldValue && !firstTime) {
                                        return;
                                    }
                                    if (newValue == null) {
                                        return;
                                    }
                                    firstTime = false;
                                    return create();
                                });
                                return scope.$on('$destroy', function() {
                                    return clean();
                                });
                            };
                        })(this));
                    }
                };
            }
        ]);

    }).call(this);
    ;angular.module('uiGmapgoogle-maps.wrapped')
        .service('uiGmapuuid', function() {
            //BEGIN REPLACE
            /* istanbul ignore next */
            /*
             Version: core-1.0
             The MIT License: Copyright (c) 2012 LiosK.
             */
            function UUID(){}UUID.generate=function(){var a=UUID._gri,b=UUID._ha;return b(a(32),8)+"-"+b(a(16),4)+"-"+b(16384|a(12),4)+"-"+b(32768|a(14),4)+"-"+b(a(48),12)};UUID._gri=function(a){return 0>a?NaN:30>=a?0|Math.random()*(1<<a):53>=a?(0|1073741824*Math.random())+1073741824*(0|Math.random()*(1<<a-30)):NaN};UUID._ha=function(a,b){for(var c=a.toString(16),d=b-c.length,e="0";0<d;d>>>=1,e+=e)d&1&&(c=e+c);return c};

            //END REPLACE
            return UUID;
        });
    ;// wrap the utility libraries needed in ./lib
// http://google-maps-utility-library-v3.googlecode.com/svn/
    angular.module('uiGmapgoogle-maps.wrapped')
        .service('uiGmapGoogleMapsUtilV3', function () {
            return {
                init: _.once(function () {
                    //BEGIN REPLACE
                    /* istanbul ignore next */
                    +function(){
                        function ClusterIcon(cluster,styles){cluster.getMarkerClusterer().extend(ClusterIcon,google.maps.OverlayView),this.cluster_=cluster,this.className_=cluster.getMarkerClusterer().getClusterClass(),this.styles_=styles,this.center_=null,this.div_=null,this.sums_=null,this.visible_=!1,this.setMap(cluster.getMap())}function Cluster(mc){this.markerClusterer_=mc,this.map_=mc.getMap(),this.gridSize_=mc.getGridSize(),this.minClusterSize_=mc.getMinimumClusterSize(),this.averageCenter_=mc.getAverageCenter(),this.hideLabel_=mc.getHideLabel(),this.markers_=[],this.center_=null,this.bounds_=null,this.clusterIcon_=new ClusterIcon(this,mc.getStyles())}function MarkerClusterer(map,opt_markers,opt_options){this.extend(MarkerClusterer,google.maps.OverlayView),opt_markers=opt_markers||[],opt_options=opt_options||{},this.markers_=[],this.clusters_=[],this.listeners_=[],this.activeMap_=null,this.ready_=!1,this.gridSize_=opt_options.gridSize||60,this.minClusterSize_=opt_options.minimumClusterSize||2,this.maxZoom_=opt_options.maxZoom||null,this.styles_=opt_options.styles||[],this.title_=opt_options.title||"",this.zoomOnClick_=!0,void 0!==opt_options.zoomOnClick&&(this.zoomOnClick_=opt_options.zoomOnClick),this.averageCenter_=!1,void 0!==opt_options.averageCenter&&(this.averageCenter_=opt_options.averageCenter),this.ignoreHidden_=!1,void 0!==opt_options.ignoreHidden&&(this.ignoreHidden_=opt_options.ignoreHidden),this.enableRetinaIcons_=!1,void 0!==opt_options.enableRetinaIcons&&(this.enableRetinaIcons_=opt_options.enableRetinaIcons),this.hideLabel_=!1,void 0!==opt_options.hideLabel&&(this.hideLabel_=opt_options.hideLabel),this.imagePath_=opt_options.imagePath||MarkerClusterer.IMAGE_PATH,this.imageExtension_=opt_options.imageExtension||MarkerClusterer.IMAGE_EXTENSION,this.imageSizes_=opt_options.imageSizes||MarkerClusterer.IMAGE_SIZES,this.calculator_=opt_options.calculator||MarkerClusterer.CALCULATOR,this.batchSize_=opt_options.batchSize||MarkerClusterer.BATCH_SIZE,this.batchSizeIE_=opt_options.batchSizeIE||MarkerClusterer.BATCH_SIZE_IE,this.clusterClass_=opt_options.clusterClass||"cluster",-1!==navigator.userAgent.toLowerCase().indexOf("msie")&&(this.batchSize_=this.batchSizeIE_),this.setupStyles_(),this.addMarkers(opt_markers,!0),this.setMap(map)}ClusterIcon.prototype.onAdd=function(){var cMouseDownInCluster,cDraggingMapByCluster,cClusterIcon=this;this.div_=document.createElement("div"),this.div_.className=this.className_,this.visible_&&this.show(),this.getPanes().overlayMouseTarget.appendChild(this.div_),this.boundsChangedListener_=google.maps.event.addListener(this.getMap(),"bounds_changed",function(){cDraggingMapByCluster=cMouseDownInCluster}),google.maps.event.addDomListener(this.div_,"mousedown",function(){cMouseDownInCluster=!0,cDraggingMapByCluster=!1}),google.maps.event.addDomListener(this.div_,"click",function(e){if(cMouseDownInCluster=!1,!cDraggingMapByCluster){var theBounds,mz,mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"click",cClusterIcon.cluster_),google.maps.event.trigger(mc,"clusterclick",cClusterIcon.cluster_),mc.getZoomOnClick()&&(mz=mc.getMaxZoom(),theBounds=cClusterIcon.cluster_.getBounds(),mc.getMap().fitBounds(theBounds),setTimeout(function(){mc.getMap().fitBounds(theBounds),null!==mz&&mc.getMap().getZoom()>mz&&mc.getMap().setZoom(mz+1)},100)),e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation()}}),google.maps.event.addDomListener(this.div_,"mouseover",function(){var mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"mouseover",cClusterIcon.cluster_)}),google.maps.event.addDomListener(this.div_,"mouseout",function(){var mc=cClusterIcon.cluster_.getMarkerClusterer();google.maps.event.trigger(mc,"mouseout",cClusterIcon.cluster_)})},ClusterIcon.prototype.onRemove=function(){this.div_&&this.div_.parentNode&&(this.hide(),google.maps.event.removeListener(this.boundsChangedListener_),google.maps.event.clearInstanceListeners(this.div_),this.div_.parentNode.removeChild(this.div_),this.div_=null)},ClusterIcon.prototype.draw=function(){if(this.visible_){var pos=this.getPosFromLatLng_(this.center_);this.div_.style.top=pos.y+"px",this.div_.style.left=pos.x+"px"}},ClusterIcon.prototype.hide=function(){this.div_&&(this.div_.style.display="none"),this.visible_=!1},ClusterIcon.prototype.show=function(){if(this.div_){var img="",bp=this.backgroundPosition_.split(" "),spriteH=parseInt(bp[0].trim(),10),spriteV=parseInt(bp[1].trim(),10),pos=this.getPosFromLatLng_(this.center_);this.div_.style.cssText=this.createCss(pos),img="<img src='"+this.url_+"' style='position: absolute; top: "+spriteV+"px; left: "+spriteH+"px; ",img+=this.cluster_.getMarkerClusterer().enableRetinaIcons_?"width: "+this.width_+"px;height: "+this.height_+"px;":"clip: rect("+-1*spriteV+"px, "+(-1*spriteH+this.width_)+"px, "+(-1*spriteV+this.height_)+"px, "+-1*spriteH+"px);",img+="'>",this.div_.innerHTML=img+"<div style='position: absolute;top: "+this.anchorText_[0]+"px;left: "+this.anchorText_[1]+"px;color: "+this.textColor_+";font-size: "+this.textSize_+"px;font-family: "+this.fontFamily_+";font-weight: "+this.fontWeight_+";font-style: "+this.fontStyle_+";text-decoration: "+this.textDecoration_+";text-align: center;width: "+this.width_+"px;line-height:"+this.height_+"px;'>"+(this.cluster_.hideLabel_?" ":this.sums_.text)+"</div>",this.div_.title="undefined"==typeof this.sums_.title||""===this.sums_.title?this.cluster_.getMarkerClusterer().getTitle():this.sums_.title,this.div_.style.display=""}this.visible_=!0},ClusterIcon.prototype.useStyle=function(sums){this.sums_=sums;var index=Math.max(0,sums.index-1);index=Math.min(this.styles_.length-1,index);var style=this.styles_[index];this.url_=style.url,this.height_=style.height,this.width_=style.width,this.anchorText_=style.anchorText||[0,0],this.anchorIcon_=style.anchorIcon||[parseInt(this.height_/2,10),parseInt(this.width_/2,10)],this.textColor_=style.textColor||"black",this.textSize_=style.textSize||11,this.textDecoration_=style.textDecoration||"none",this.fontWeight_=style.fontWeight||"bold",this.fontStyle_=style.fontStyle||"normal",this.fontFamily_=style.fontFamily||"Arial,sans-serif",this.backgroundPosition_=style.backgroundPosition||"0 0"},ClusterIcon.prototype.setCenter=function(center){this.center_=center},ClusterIcon.prototype.createCss=function(pos){var style=[];return style.push("cursor: pointer;"),style.push("position: absolute; top: "+pos.y+"px; left: "+pos.x+"px;"),style.push("width: "+this.width_+"px; height: "+this.height_+"px;"),style.join("")},ClusterIcon.prototype.getPosFromLatLng_=function(latlng){var pos=this.getProjection().fromLatLngToDivPixel(latlng);return pos.x-=this.anchorIcon_[1],pos.y-=this.anchorIcon_[0],pos.x=parseInt(pos.x,10),pos.y=parseInt(pos.y,10),pos},Cluster.prototype.getSize=function(){return this.markers_.length},Cluster.prototype.getMarkers=function(){return this.markers_},Cluster.prototype.getCenter=function(){return this.center_},Cluster.prototype.getMap=function(){return this.map_},Cluster.prototype.getMarkerClusterer=function(){return this.markerClusterer_},Cluster.prototype.getBounds=function(){var i,bounds=new google.maps.LatLngBounds(this.center_,this.center_),markers=this.getMarkers();for(i=0;i<markers.length;i++)bounds.extend(markers[i].getPosition());return bounds},Cluster.prototype.remove=function(){this.clusterIcon_.setMap(null),this.markers_=[],delete this.markers_},Cluster.prototype.addMarker=function(marker){var i,mCount,mz;if(this.isMarkerAlreadyAdded_(marker))return!1;if(this.center_){if(this.averageCenter_){var l=this.markers_.length+1,lat=(this.center_.lat()*(l-1)+marker.getPosition().lat())/l,lng=(this.center_.lng()*(l-1)+marker.getPosition().lng())/l;this.center_=new google.maps.LatLng(lat,lng),this.calculateBounds_()}}else this.center_=marker.getPosition(),this.calculateBounds_();if(marker.isAdded=!0,this.markers_.push(marker),mCount=this.markers_.length,mz=this.markerClusterer_.getMaxZoom(),null!==mz&&this.map_.getZoom()>mz)marker.getMap()!==this.map_&&marker.setMap(this.map_);else if(mCount<this.minClusterSize_)marker.getMap()!==this.map_&&marker.setMap(this.map_);else if(mCount===this.minClusterSize_)for(i=0;mCount>i;i++)this.markers_[i].setMap(null);else marker.setMap(null);return!0},Cluster.prototype.isMarkerInClusterBounds=function(marker){return this.bounds_.contains(marker.getPosition())},Cluster.prototype.calculateBounds_=function(){var bounds=new google.maps.LatLngBounds(this.center_,this.center_);this.bounds_=this.markerClusterer_.getExtendedBounds(bounds)},Cluster.prototype.updateIcon_=function(){var mCount=this.markers_.length,mz=this.markerClusterer_.getMaxZoom();if(null!==mz&&this.map_.getZoom()>mz)return void this.clusterIcon_.hide();if(mCount<this.minClusterSize_)return void this.clusterIcon_.hide();var numStyles=this.markerClusterer_.getStyles().length,sums=this.markerClusterer_.getCalculator()(this.markers_,numStyles);this.clusterIcon_.setCenter(this.center_),this.clusterIcon_.useStyle(sums),this.clusterIcon_.show()},Cluster.prototype.isMarkerAlreadyAdded_=function(marker){for(var i=0,n=this.markers_.length;n>i;i++)if(marker===this.markers_[i])return!0;return!1},MarkerClusterer.prototype.onAdd=function(){var cMarkerClusterer=this;this.activeMap_=this.getMap(),this.ready_=!0,this.repaint(),this.listeners_=[google.maps.event.addListener(this.getMap(),"zoom_changed",function(){cMarkerClusterer.resetViewport_(!1),(this.getZoom()===(this.get("minZoom")||0)||this.getZoom()===this.get("maxZoom"))&&google.maps.event.trigger(this,"idle")}),google.maps.event.addListener(this.getMap(),"idle",function(){cMarkerClusterer.redraw_()})]},MarkerClusterer.prototype.onRemove=function(){var i;for(i=0;i<this.markers_.length;i++)this.markers_[i].getMap()!==this.activeMap_&&this.markers_[i].setMap(this.activeMap_);for(i=0;i<this.clusters_.length;i++)this.clusters_[i].remove();for(this.clusters_=[],i=0;i<this.listeners_.length;i++)google.maps.event.removeListener(this.listeners_[i]);this.listeners_=[],this.activeMap_=null,this.ready_=!1},MarkerClusterer.prototype.draw=function(){},MarkerClusterer.prototype.setupStyles_=function(){var i,size;if(!(this.styles_.length>0))for(i=0;i<this.imageSizes_.length;i++)size=this.imageSizes_[i],this.styles_.push({url:this.imagePath_+(i+1)+"."+this.imageExtension_,height:size,width:size})},MarkerClusterer.prototype.fitMapToMarkers=function(){var i,markers=this.getMarkers(),bounds=new google.maps.LatLngBounds;for(i=0;i<markers.length;i++)bounds.extend(markers[i].getPosition());this.getMap().fitBounds(bounds)},MarkerClusterer.prototype.getGridSize=function(){return this.gridSize_},MarkerClusterer.prototype.setGridSize=function(gridSize){this.gridSize_=gridSize},MarkerClusterer.prototype.getMinimumClusterSize=function(){return this.minClusterSize_},MarkerClusterer.prototype.setMinimumClusterSize=function(minimumClusterSize){this.minClusterSize_=minimumClusterSize},MarkerClusterer.prototype.getMaxZoom=function(){return this.maxZoom_},MarkerClusterer.prototype.setMaxZoom=function(maxZoom){this.maxZoom_=maxZoom},MarkerClusterer.prototype.getStyles=function(){return this.styles_},MarkerClusterer.prototype.setStyles=function(styles){this.styles_=styles},MarkerClusterer.prototype.getTitle=function(){return this.title_},MarkerClusterer.prototype.setTitle=function(title){this.title_=title},MarkerClusterer.prototype.getZoomOnClick=function(){return this.zoomOnClick_},MarkerClusterer.prototype.setZoomOnClick=function(zoomOnClick){this.zoomOnClick_=zoomOnClick},MarkerClusterer.prototype.getAverageCenter=function(){return this.averageCenter_},MarkerClusterer.prototype.setAverageCenter=function(averageCenter){this.averageCenter_=averageCenter},MarkerClusterer.prototype.getIgnoreHidden=function(){return this.ignoreHidden_},MarkerClusterer.prototype.setIgnoreHidden=function(ignoreHidden){this.ignoreHidden_=ignoreHidden},MarkerClusterer.prototype.getEnableRetinaIcons=function(){return this.enableRetinaIcons_},MarkerClusterer.prototype.setEnableRetinaIcons=function(enableRetinaIcons){this.enableRetinaIcons_=enableRetinaIcons},MarkerClusterer.prototype.getImageExtension=function(){return this.imageExtension_},MarkerClusterer.prototype.setImageExtension=function(imageExtension){this.imageExtension_=imageExtension},MarkerClusterer.prototype.getImagePath=function(){return this.imagePath_},MarkerClusterer.prototype.setImagePath=function(imagePath){this.imagePath_=imagePath},MarkerClusterer.prototype.getImageSizes=function(){return this.imageSizes_},MarkerClusterer.prototype.setImageSizes=function(imageSizes){this.imageSizes_=imageSizes},MarkerClusterer.prototype.getCalculator=function(){return this.calculator_},MarkerClusterer.prototype.setCalculator=function(calculator){this.calculator_=calculator},MarkerClusterer.prototype.setHideLabel=function(hideLabel){this.hideLabel_=hideLabel},MarkerClusterer.prototype.getHideLabel=function(){return this.hideLabel_},MarkerClusterer.prototype.getBatchSizeIE=function(){return this.batchSizeIE_},MarkerClusterer.prototype.setBatchSizeIE=function(batchSizeIE){this.batchSizeIE_=batchSizeIE},MarkerClusterer.prototype.getClusterClass=function(){return this.clusterClass_},MarkerClusterer.prototype.setClusterClass=function(clusterClass){this.clusterClass_=clusterClass},MarkerClusterer.prototype.getMarkers=function(){return this.markers_},MarkerClusterer.prototype.getTotalMarkers=function(){return this.markers_.length},MarkerClusterer.prototype.getClusters=function(){return this.clusters_},MarkerClusterer.prototype.getTotalClusters=function(){return this.clusters_.length},MarkerClusterer.prototype.addMarker=function(marker,opt_nodraw){this.pushMarkerTo_(marker),opt_nodraw||this.redraw_()},MarkerClusterer.prototype.addMarkers=function(markers,opt_nodraw){var key;for(key in markers)markers.hasOwnProperty(key)&&this.pushMarkerTo_(markers[key]);opt_nodraw||this.redraw_()},MarkerClusterer.prototype.pushMarkerTo_=function(marker){if(marker.getDraggable()){var cMarkerClusterer=this;google.maps.event.addListener(marker,"dragend",function(){cMarkerClusterer.ready_&&(this.isAdded=!1,cMarkerClusterer.repaint())})}marker.isAdded=!1,this.markers_.push(marker)},MarkerClusterer.prototype.removeMarker=function(marker,opt_nodraw,opt_noMapRemove){var removeFromMap=!0&&!opt_noMapRemove,removed=this.removeMarker_(marker,removeFromMap);return!opt_nodraw&&removed&&this.repaint(),removed},MarkerClusterer.prototype.removeMarkers=function(markers,opt_nodraw,opt_noMapRemove){var i,r,removed=!1,removeFromMap=!0&&!opt_noMapRemove;for(i=0;i<markers.length;i++)r=this.removeMarker_(markers[i],removeFromMap),removed=removed||r;return!opt_nodraw&&removed&&this.repaint(),removed},MarkerClusterer.prototype.removeMarker_=function(marker,removeFromMap){var i,index=-1;if(this.markers_.indexOf)index=this.markers_.indexOf(marker);else for(i=0;i<this.markers_.length;i++)if(marker===this.markers_[i]){index=i;break}return-1===index?!1:(removeFromMap&&marker.setMap(null),this.markers_.splice(index,1),!0)},MarkerClusterer.prototype.clearMarkers=function(){this.resetViewport_(!0),this.markers_=[]},MarkerClusterer.prototype.repaint=function(){var oldClusters=this.clusters_.slice();this.clusters_=[],this.resetViewport_(!1),this.redraw_(),setTimeout(function(){var i;for(i=0;i<oldClusters.length;i++)oldClusters[i].remove()},0)},MarkerClusterer.prototype.getExtendedBounds=function(bounds){var projection=this.getProjection(),tr=new google.maps.LatLng(bounds.getNorthEast().lat(),bounds.getNorthEast().lng()),bl=new google.maps.LatLng(bounds.getSouthWest().lat(),bounds.getSouthWest().lng()),trPix=projection.fromLatLngToDivPixel(tr);trPix.x+=this.gridSize_,trPix.y-=this.gridSize_;var blPix=projection.fromLatLngToDivPixel(bl);blPix.x-=this.gridSize_,blPix.y+=this.gridSize_;var ne=projection.fromDivPixelToLatLng(trPix),sw=projection.fromDivPixelToLatLng(blPix);return bounds.extend(ne),bounds.extend(sw),bounds},MarkerClusterer.prototype.redraw_=function(){this.createClusters_(0)},MarkerClusterer.prototype.resetViewport_=function(opt_hide){var i,marker;for(i=0;i<this.clusters_.length;i++)this.clusters_[i].remove();for(this.clusters_=[],i=0;i<this.markers_.length;i++)marker=this.markers_[i],marker.isAdded=!1,opt_hide&&marker.setMap(null)},MarkerClusterer.prototype.distanceBetweenPoints_=function(p1,p2){var R=6371,dLat=(p2.lat()-p1.lat())*Math.PI/180,dLon=(p2.lng()-p1.lng())*Math.PI/180,a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(p1.lat()*Math.PI/180)*Math.cos(p2.lat()*Math.PI/180)*Math.sin(dLon/2)*Math.sin(dLon/2),c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)),d=R*c;return d},MarkerClusterer.prototype.isMarkerInBounds_=function(marker,bounds){return bounds.contains(marker.getPosition())},MarkerClusterer.prototype.addToClosestCluster_=function(marker){var i,d,cluster,center,distance=4e4,clusterToAddTo=null;for(i=0;i<this.clusters_.length;i++)cluster=this.clusters_[i],center=cluster.getCenter(),center&&(d=this.distanceBetweenPoints_(center,marker.getPosition()),distance>d&&(distance=d,clusterToAddTo=cluster));clusterToAddTo&&clusterToAddTo.isMarkerInClusterBounds(marker)?clusterToAddTo.addMarker(marker):(cluster=new Cluster(this),cluster.addMarker(marker),this.clusters_.push(cluster))},MarkerClusterer.prototype.createClusters_=function(iFirst){var i,marker,mapBounds,cMarkerClusterer=this;if(this.ready_){0===iFirst&&(google.maps.event.trigger(this,"clusteringbegin",this),"undefined"!=typeof this.timerRefStatic&&(clearTimeout(this.timerRefStatic),delete this.timerRefStatic)),mapBounds=this.getMap().getZoom()>3?new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),this.getMap().getBounds().getNorthEast()):new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472,-178.48388434375),new google.maps.LatLng(-85.08136444384544,178.00048865625));var bounds=this.getExtendedBounds(mapBounds),iLast=Math.min(iFirst+this.batchSize_,this.markers_.length);for(i=iFirst;iLast>i;i++)marker=this.markers_[i],!marker.isAdded&&this.isMarkerInBounds_(marker,bounds)&&(!this.ignoreHidden_||this.ignoreHidden_&&marker.getVisible())&&this.addToClosestCluster_(marker);if(iLast<this.markers_.length)this.timerRefStatic=setTimeout(function(){cMarkerClusterer.createClusters_(iLast)},0);else for(delete this.timerRefStatic,google.maps.event.trigger(this,"clusteringend",this),i=0;i<this.clusters_.length;i++)this.clusters_[i].updateIcon_()}},MarkerClusterer.prototype.extend=function(obj1,obj2){return function(object){var property;for(property in object.prototype)this.prototype[property]=object.prototype[property];return this}.apply(obj1,[obj2])},MarkerClusterer.CALCULATOR=function(markers,numStyles){for(var index=0,title="",count=markers.length.toString(),dv=count;0!==dv;)dv=parseInt(dv/10,10),index++;return index=Math.min(index,numStyles),{text:count,index:index,title:title}},MarkerClusterer.BATCH_SIZE=2e3,MarkerClusterer.BATCH_SIZE_IE=500,MarkerClusterer.IMAGE_PATH="//cdn.rawgit.com/mahnunchik/markerclustererplus/master/images/m",MarkerClusterer.IMAGE_EXTENSION="png",MarkerClusterer.IMAGE_SIZES=[53,56,66,78,90],"function"!=typeof String.prototype.trim&&(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")});
                        /**
                         *  google-maps-utility-library-v3-infobox
                         *
                         * @version: 1.1.14
                         * @author: Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
                         * @contributors: Nicholas McCready
                         * @date: Fri May 13 2016 16:35:27 GMT-0400 (EDT)
                         * @license: Apache License 2.0
                         */
                        /**
                         * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
                         *  <p>
                         *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
                         *  additional properties for advanced styling. An InfoBox can also be used as a map label.
                         *  <p>
                         *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
                         */

                        /*jslint browser:true */
                        /*global google */

                        /**
                         * @name InfoBoxOptions
                         * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
                         * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
                         * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
                         * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
                         * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
                         *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
                         *  to the map pixel corresponding to <tt>position</tt>.
                         * @property {LatLng} position The geographic location at which to display the InfoBox.
                         * @property {number} zIndex The CSS z-index style value for the InfoBox.
                         *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
                         * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
                         * @property {Object} [boxStyle] An object literal whose properties define specific CSS
                         *  style values to be applied to the InfoBox. Style values defined here override those that may
                         *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
                         *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
                         *  are removed from the InfoBox before the new style values are applied.
                         * @property {string} closeBoxMargin The CSS margin style value for the close box.
                         *  The default is "2px" (a 2-pixel margin on all sides).
                         * @property {string} closeBoxURL The URL of the image representing the close box.
                         *  Note: The default is the URL for Google's standard close box.
                         *  Set this property to "" if no close box is required.
                         * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
                         *  map edge after an auto-pan.
                         * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
                         *  [Deprecated in favor of the <tt>visible</tt> property.]
                         * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
                         * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
                         *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
                         * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
                         *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
                         *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
                         * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
                         *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
                         *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
                         *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
                         */

                        /**
                         * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
                         *  Call <tt>InfoBox.open</tt> to add the box to the map.
                         * @constructor
                         * @param {InfoBoxOptions} [opt_opts]
                         */
                        function InfoBox(opt_opts) {

                            opt_opts = opt_opts || {};

                            google.maps.OverlayView.apply(this, arguments);

                            // Standard options (in common with google.maps.InfoWindow):
                            //
                            this.content_ = opt_opts.content || "";
                            this.disableAutoPan_ = opt_opts.disableAutoPan || false;
                            this.maxWidth_ = opt_opts.maxWidth || 0;
                            this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
                            this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
                            this.zIndex_ = opt_opts.zIndex || null;

                            // Additional options (unique to InfoBox):
                            //
                            this.boxClass_ = opt_opts.boxClass || "infoBox";
                            this.boxStyle_ = opt_opts.boxStyle || {};
                            this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
                            this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
                            if (opt_opts.closeBoxURL === "") {
                                this.closeBoxURL_ = "";
                            }
                            this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);

                            if (typeof opt_opts.visible === "undefined") {
                                if (typeof opt_opts.isHidden === "undefined") {
                                    opt_opts.visible = true;
                                } else {
                                    opt_opts.visible = !opt_opts.isHidden;
                                }
                            }
                            this.isHidden_ = !opt_opts.visible;

                            this.alignBottom_ = opt_opts.alignBottom || false;
                            this.pane_ = opt_opts.pane || "floatPane";
                            this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

                            this.div_ = null;
                            this.closeListener_ = null;
                            this.moveListener_ = null;
                            this.contextListener_ = null;
                            this.eventListeners_ = null;
                            this.fixedWidthSet_ = null;
                        }

                        /* InfoBox extends OverlayView in the Google Maps API v3.
                         */
                        InfoBox.prototype = new google.maps.OverlayView();

                        /**
                         * Creates the DIV representing the InfoBox.
                         * @private
                         */
                        InfoBox.prototype.createInfoBoxDiv_ = function () {

                            var i;
                            var events;
                            var bw;
                            var me = this;

                            // This handler prevents an event in the InfoBox from being passed on to the map.
                            //
                            var cancelHandler = function (e) {
                                e.cancelBubble = true;
                                if (e.stopPropagation) {
                                    e.stopPropagation();
                                }
                            };

                            // This handler ignores the current event in the InfoBox and conditionally prevents
                            // the event from being passed on to the map. It is used for the contextmenu event.
                            //
                            var ignoreHandler = function (e) {

                                e.returnValue = false;

                                if (e.preventDefault) {

                                    e.preventDefault();
                                }

                                if (!me.enableEventPropagation_) {

                                    cancelHandler(e);
                                }
                            };

                            if (!this.div_) {

                                this.div_ = document.createElement("div");

                                this.setBoxStyle_();

                                if (typeof this.content_.nodeType === "undefined") {
                                    this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
                                } else {
                                    this.div_.innerHTML = this.getCloseBoxImg_();
                                    this.div_.appendChild(this.content_);
                                }

                                // Add the InfoBox DIV to the DOM
                                this.getPanes()[this.pane_].appendChild(this.div_);

                                this.addClickHandler_();

                                if (this.div_.style.width) {

                                    this.fixedWidthSet_ = true;

                                } else {

                                    if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

                                        this.div_.style.width = this.maxWidth_;
                                        this.div_.style.overflow = "auto";
                                        this.fixedWidthSet_ = true;

                                    } else { // The following code is needed to overcome problems with MSIE

                                        bw = this.getBoxWidths_();

                                        this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
                                        this.fixedWidthSet_ = false;
                                    }
                                }

                                this.panBox_(this.disableAutoPan_);

                                if (!this.enableEventPropagation_) {

                                    this.eventListeners_ = [];

                                    // Cancel event propagation.
                                    //
                                    // Note: mousemove not included (to resolve Issue 152)
                                    events = ["mousedown", "mouseover", "mouseout", "mouseup",
                                        "click", "dblclick", "touchstart", "touchend", "touchmove"];

                                    for (i = 0; i < events.length; i++) {

                                        this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
                                    }

                                    // Workaround for Google bug that causes the cursor to change to a pointer
                                    // when the mouse moves over a marker underneath InfoBox.
                                    this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function (e) {
                                        this.style.cursor = "default";
                                    }));
                                }

                                this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

                                /**
                                 * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
                                 * @name InfoBox#domready
                                 * @event
                                 */
                                google.maps.event.trigger(this, "domready");
                            }
                        };

                        /**
                         * Returns the HTML <IMG> tag for the close box.
                         * @private
                         */
                        InfoBox.prototype.getCloseBoxImg_ = function () {

                            var img = "";

                            if (this.closeBoxURL_ !== "") {

                                img  = "<img";
                                img += " src='" + this.closeBoxURL_ + "'";
                                img += " align=right"; // Do this because Opera chokes on style='float: right;'
                                img += " style='";
                                img += " position: relative;"; // Required by MSIE
                                img += " cursor: pointer;";
                                img += " margin: " + this.closeBoxMargin_ + ";";
                                img += "'>";
                            }

                            return img;
                        };

                        /**
                         * Adds the click handler to the InfoBox close box.
                         * @private
                         */
                        InfoBox.prototype.addClickHandler_ = function () {

                            var closeBox;

                            if (this.closeBoxURL_ !== "") {

                                closeBox = this.div_.firstChild;
                                this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());

                            } else {

                                this.closeListener_ = null;
                            }
                        };

                        /**
                         * Returns the function to call when the user clicks the close box of an InfoBox.
                         * @private
                         */
                        InfoBox.prototype.getCloseClickHandler_ = function () {

                            var me = this;

                            return function (e) {

                                // 1.0.3 fix: Always prevent propagation of a close box click to the map:
                                e.cancelBubble = true;

                                if (e.stopPropagation) {

                                    e.stopPropagation();
                                }

                                /**
                                 * This event is fired when the InfoBox's close box is clicked.
                                 * @name InfoBox#closeclick
                                 * @event
                                 */
                                google.maps.event.trigger(me, "closeclick");

                                me.close();
                            };
                        };

                        /**
                         * Pans the map so that the InfoBox appears entirely within the map's visible area.
                         * @private
                         */
                        InfoBox.prototype.panBox_ = function (disablePan) {

                            var map;
                            var bounds;
                            var xOffset = 0, yOffset = 0;

                            if (!disablePan) {

                                map = this.getMap();

                                if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama

                                    if (!map.getBounds().contains(this.position_)) {
                                        // Marker not in visible area of map, so set center
                                        // of map to the marker position first.
                                        map.setCenter(this.position_);
                                    }

                                    bounds = map.getBounds();

                                    var mapDiv = map.getDiv();
                                    var mapWidth = mapDiv.offsetWidth;
                                    var mapHeight = mapDiv.offsetHeight;
                                    var iwOffsetX = this.pixelOffset_.width;
                                    var iwOffsetY = this.pixelOffset_.height;
                                    var iwWidth = this.div_.offsetWidth;
                                    var iwHeight = this.div_.offsetHeight;
                                    var padX = this.infoBoxClearance_.width;
                                    var padY = this.infoBoxClearance_.height;
                                    var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

                                    if (pixPosition.x < (-iwOffsetX + padX)) {
                                        xOffset = pixPosition.x + iwOffsetX - padX;
                                    } else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
                                        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
                                    }
                                    if (this.alignBottom_) {
                                        if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
                                            yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
                                        } else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
                                            yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
                                        }
                                    } else {
                                        if (pixPosition.y < (-iwOffsetY + padY)) {
                                            yOffset = pixPosition.y + iwOffsetY - padY;
                                        } else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
                                            yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
                                        }
                                    }

                                    if (!(xOffset === 0 && yOffset === 0)) {

                                        // Move the map to the shifted center.
                                        //
                                        var c = map.getCenter();
                                        map.panBy(xOffset, yOffset);
                                    }
                                }
                            }
                        };

                        /**
                         * Sets the style of the InfoBox by setting the style sheet and applying
                         * other specific styles requested.
                         * @private
                         */
                        InfoBox.prototype.setBoxStyle_ = function () {

                            var i, boxStyle;

                            if (this.div_) {

                                // Apply style values from the style sheet defined in the boxClass parameter:
                                this.div_.className = this.boxClass_;

                                // Clear existing inline style values:
                                this.div_.style.cssText = "";

                                // Apply style values defined in the boxStyle parameter:
                                boxStyle = this.boxStyle_;
                                for (i in boxStyle) {

                                    if (boxStyle.hasOwnProperty(i)) {

                                        this.div_.style[i] = boxStyle[i];
                                    }
                                }

                                // Fix for iOS disappearing InfoBox problem.
                                // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
                                this.div_.style.WebkitTransform = "translateZ(0)";

                                // Fix up opacity style for benefit of MSIE:
                                //
                                if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
                                    // See http://www.quirksmode.org/css/opacity.html
                                    this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + (this.div_.style.opacity * 100) + ")\"";
                                    this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
                                }

                                // Apply required styles:
                                //
                                this.div_.style.position = "absolute";
                                this.div_.style.visibility = 'hidden';
                                if (this.zIndex_ !== null) {

                                    this.div_.style.zIndex = this.zIndex_;
                                }
                            }
                        };

                        /**
                         * Get the widths of the borders of the InfoBox.
                         * @private
                         * @return {Object} widths object (top, bottom left, right)
                         */
                        InfoBox.prototype.getBoxWidths_ = function () {

                            var computedStyle;
                            var bw = {top: 0, bottom: 0, left: 0, right: 0};
                            var box = this.div_;

                            if (document.defaultView && document.defaultView.getComputedStyle) {

                                computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

                                if (computedStyle) {

                                    // The computed styles are always in pixel units (good!)
                                    bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
                                    bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
                                    bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
                                    bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
                                }

                            } else if (document.documentElement.currentStyle) { // MSIE

                                if (box.currentStyle) {

                                    // The current styles may not be in pixel units, but assume they are (bad!)
                                    bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
                                    bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
                                    bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
                                    bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
                                }
                            }

                            return bw;
                        };

                        /**
                         * Invoked when <tt>close</tt> is called. Do not call it directly.
                         */
                        InfoBox.prototype.onRemove = function () {

                            if (this.div_) {

                                this.div_.parentNode.removeChild(this.div_);
                                this.div_ = null;
                            }
                        };

                        /**
                         * Draws the InfoBox based on the current map projection and zoom level.
                         */
                        InfoBox.prototype.draw = function () {

                            this.createInfoBoxDiv_();

                            var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

                            this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";

                            if (this.alignBottom_) {
                                this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
                            } else {
                                this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
                            }

                            if (this.isHidden_) {

                                this.div_.style.visibility = "hidden";

                            } else {

                                this.div_.style.visibility = "visible";
                            }
                        };

                        /**
                         * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
                         *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
                         *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
                         *  is <tt>open</tt>ed.
                         * @param {InfoBoxOptions} opt_opts
                         */
                        InfoBox.prototype.setOptions = function (opt_opts) {
                            if (typeof opt_opts.boxClass !== "undefined") { // Must be first

                                this.boxClass_ = opt_opts.boxClass;
                                this.setBoxStyle_();
                            }
                            if (typeof opt_opts.boxStyle !== "undefined") { // Must be second

                                this.boxStyle_ = opt_opts.boxStyle;
                                this.setBoxStyle_();
                            }
                            if (typeof opt_opts.content !== "undefined") {

                                this.setContent(opt_opts.content);
                            }
                            if (typeof opt_opts.disableAutoPan !== "undefined") {

                                this.disableAutoPan_ = opt_opts.disableAutoPan;
                            }
                            if (typeof opt_opts.maxWidth !== "undefined") {

                                this.maxWidth_ = opt_opts.maxWidth;
                            }
                            if (typeof opt_opts.pixelOffset !== "undefined") {

                                this.pixelOffset_ = opt_opts.pixelOffset;
                            }
                            if (typeof opt_opts.alignBottom !== "undefined") {

                                this.alignBottom_ = opt_opts.alignBottom;
                            }
                            if (typeof opt_opts.position !== "undefined") {

                                this.setPosition(opt_opts.position);
                            }
                            if (typeof opt_opts.zIndex !== "undefined") {

                                this.setZIndex(opt_opts.zIndex);
                            }
                            if (typeof opt_opts.closeBoxMargin !== "undefined") {

                                this.closeBoxMargin_ = opt_opts.closeBoxMargin;
                            }
                            if (typeof opt_opts.closeBoxURL !== "undefined") {

                                this.closeBoxURL_ = opt_opts.closeBoxURL;
                            }
                            if (typeof opt_opts.infoBoxClearance !== "undefined") {

                                this.infoBoxClearance_ = opt_opts.infoBoxClearance;
                            }
                            if (typeof opt_opts.isHidden !== "undefined") {

                                this.isHidden_ = opt_opts.isHidden;
                            }
                            if (typeof opt_opts.visible !== "undefined") {

                                this.isHidden_ = !opt_opts.visible;
                            }
                            if (typeof opt_opts.enableEventPropagation !== "undefined") {

                                this.enableEventPropagation_ = opt_opts.enableEventPropagation;
                            }

                            if (this.div_) {

                                this.draw();
                            }
                        };

                        /**
                         * Sets the content of the InfoBox.
                         *  The content can be plain text or an HTML DOM node.
                         * @param {string|Node} content
                         */
                        InfoBox.prototype.setContent = function (content) {
                            this.content_ = content;

                            if (this.div_) {

                                if (this.closeListener_) {

                                    google.maps.event.removeListener(this.closeListener_);
                                    this.closeListener_ = null;
                                }

                                // Odd code required to make things work with MSIE.
                                //
                                if (!this.fixedWidthSet_) {

                                    this.div_.style.width = "";
                                }

                                if (typeof content.nodeType === "undefined") {
                                    this.div_.innerHTML = this.getCloseBoxImg_() + content;
                                } else {
                                    this.div_.innerHTML = this.getCloseBoxImg_();
                                    this.div_.appendChild(content);
                                }

                                // Perverse code required to make things work with MSIE.
                                // (Ensures the close box does, in fact, float to the right.)
                                //
                                if (!this.fixedWidthSet_) {
                                    this.div_.style.width = this.div_.offsetWidth + "px";
                                    if (typeof content.nodeType === "undefined") {
                                        this.div_.innerHTML = this.getCloseBoxImg_() + content;
                                    } else {
                                        this.div_.innerHTML = this.getCloseBoxImg_();
                                        this.div_.appendChild(content);
                                    }
                                }

                                this.addClickHandler_();
                            }

                            /**
                             * This event is fired when the content of the InfoBox changes.
                             * @name InfoBox#content_changed
                             * @event
                             */
                            google.maps.event.trigger(this, "content_changed");
                        };

                        /**
                         * Sets the geographic location of the InfoBox.
                         * @param {LatLng} latlng
                         */
                        InfoBox.prototype.setPosition = function (latlng) {

                            this.position_ = latlng;

                            if (this.div_) {

                                this.draw();
                            }

                            /**
                             * This event is fired when the position of the InfoBox changes.
                             * @name InfoBox#position_changed
                             * @event
                             */
                            google.maps.event.trigger(this, "position_changed");
                        };

                        /**
                         * Sets the zIndex style for the InfoBox.
                         * @param {number} index
                         */
                        InfoBox.prototype.setZIndex = function (index) {

                            this.zIndex_ = index;

                            if (this.div_) {

                                this.div_.style.zIndex = index;
                            }

                            /**
                             * This event is fired when the zIndex of the InfoBox changes.
                             * @name InfoBox#zindex_changed
                             * @event
                             */
                            google.maps.event.trigger(this, "zindex_changed");
                        };

                        /**
                         * Sets the visibility of the InfoBox.
                         * @param {boolean} isVisible
                         */
                        InfoBox.prototype.setVisible = function (isVisible) {

                            this.isHidden_ = !isVisible;
                            if (this.div_) {
                                this.div_.style.visibility = (this.isHidden_ ? "hidden" : "visible");
                            }
                        };

                        /**
                         * Returns the content of the InfoBox.
                         * @returns {string}
                         */
                        InfoBox.prototype.getContent = function () {

                            return this.content_;
                        };

                        /**
                         * Returns the geographic location of the InfoBox.
                         * @returns {LatLng}
                         */
                        InfoBox.prototype.getPosition = function () {

                            return this.position_;
                        };

                        /**
                         * Returns the zIndex for the InfoBox.
                         * @returns {number}
                         */
                        InfoBox.prototype.getZIndex = function () {

                            return this.zIndex_;
                        };

                        /**
                         * Returns a flag indicating whether the InfoBox is visible.
                         * @returns {boolean}
                         */
                        InfoBox.prototype.getVisible = function () {

                            var isVisible;

                            if ((typeof this.getMap() === "undefined") || (this.getMap() === null)) {
                                isVisible = false;
                            } else {
                                isVisible = !this.isHidden_;
                            }
                            return isVisible;
                        };

                        /**
                         * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
                         */
                        InfoBox.prototype.show = function () {

                            this.isHidden_ = false;
                            if (this.div_) {
                                this.div_.style.visibility = "visible";
                            }
                        };

                        /**
                         * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
                         */
                        InfoBox.prototype.hide = function () {

                            this.isHidden_ = true;
                            if (this.div_) {
                                this.div_.style.visibility = "hidden";
                            }
                        };

                        /**
                         * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
                         *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
                         *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
                         *  anchor is dragged to a new location, the InfoBox moves as well.
                         * @param {Map|StreetViewPanorama} map
                         * @param {MVCObject} [anchor]
                         */
                        InfoBox.prototype.open = function (map, anchor) {

                            var me = this;

                            if (anchor) {

                                this.position_ = anchor.getPosition();
                                this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
                                    me.setPosition(this.getPosition());
                                });
                            }

                            this.setMap(map);

                            if (this.div_) {

                                this.panBox_();
                            }
                        };

                        /**
                         * Removes the InfoBox from the map.
                         */
                        InfoBox.prototype.close = function () {

                            var i;

                            if (this.closeListener_) {

                                google.maps.event.removeListener(this.closeListener_);
                                this.closeListener_ = null;
                            }

                            if (this.eventListeners_) {

                                for (i = 0; i < this.eventListeners_.length; i++) {

                                    google.maps.event.removeListener(this.eventListeners_[i]);
                                }
                                this.eventListeners_ = null;
                            }

                            if (this.moveListener_) {

                                google.maps.event.removeListener(this.moveListener_);
                                this.moveListener_ = null;
                            }

                            if (this.contextListener_) {

                                google.maps.event.removeListener(this.contextListener_);
                                this.contextListener_ = null;
                            }

                            this.setMap(null);
                        };

                        /**
                         *  google-maps-utility-library-v3-keydragzoom
                         *
                         * @version: 2.0.9
                         * @author: Nianwei Liu [nianwei at gmail dot com] & Gary Little [gary at luxcentral dot com]
                         * @contributors: undefined
                         * @date: Fri May 13 2016 13:45:18 GMT-0400 (EDT)
                         * @license: Apache License 2.0
                         */
                        /**
                         * @fileoverview This library adds a drag zoom capability to a V3 Google map.
                         *  When drag zoom is enabled, holding down a designated hot key <code>(shift | ctrl | alt)</code>
                         *  while dragging a box around an area of interest will zoom the map in to that area when
                         *  the mouse button is released. Optionally, a visual control can also be supplied for turning
                         *  a drag zoom operation on and off.
                         *  Only one line of code is needed: <code>google.maps.Map.enableKeyDragZoom();</code>
                         *  <p>
                         *  NOTE: Do not use Ctrl as the hot key with Google Maps JavaScript API V3 since, unlike with V2,
                         *  it causes a context menu to appear when running on the Macintosh.
                         *  <p>
                         *  Note that if the map's container has a border around it, the border widths must be specified
                         *  in pixel units (or as thin, medium, or thick). This is required because of an MSIE limitation.
                         *   <p>NL: 2009-05-28: initial port to core API V3.
                         *  <br>NL: 2009-11-02: added a temp fix for -moz-transform for FF3.5.x using code from Paul Kulchenko (http://notebook.kulchenko.com/maps/gridmove).
                         *  <br>NL: 2010-02-02: added a fix for IE flickering on divs onmousemove, caused by scroll value when get mouse position.
                         *  <br>GL: 2010-06-15: added a visual control option.
                         */
                        (function () {
                            /*jslint browser:true */
                            /*global window,google */
                            /* Utility functions use "var funName=function()" syntax to allow use of the */
                            /* Dean Edwards Packer compression tool (with Shrink variables, without Base62 encode). */

                            /**
                             * Converts "thin", "medium", and "thick" to pixel widths
                             * in an MSIE environment. Not called for other browsers
                             * because getComputedStyle() returns pixel widths automatically.
                             * @param {string} widthValue The value of the border width parameter.
                             */
                            var toPixels = function (widthValue) {
                                var px;
                                switch (widthValue) {
                                    case "thin":
                                        px = "2px";
                                        break;
                                    case "medium":
                                        px = "4px";
                                        break;
                                    case "thick":
                                        px = "6px";
                                        break;
                                    default:
                                        px = widthValue;
                                }
                                return px;
                            };
                            /**
                             * Get the widths of the borders of an HTML element.
                             *
                             * @param {Node} h  The HTML element.
                             * @return {Object} The width object {top, bottom left, right}.
                             */
                            var getBorderWidths = function (h) {
                                var computedStyle;
                                var bw = {};
                                if (document.defaultView && document.defaultView.getComputedStyle) {
                                    computedStyle = h.ownerDocument.defaultView.getComputedStyle(h, "");
                                    if (computedStyle) {
                                        // The computed styles are always in pixel units (good!)
                                        bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
                                        bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
                                        bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
                                        bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
                                        return bw;
                                    }
                                } else if (document.documentElement.currentStyle) { // MSIE
                                    if (h.currentStyle) {
                                        // The current styles may not be in pixel units so try to convert (bad!)
                                        bw.top = parseInt(toPixels(h.currentStyle.borderTopWidth), 10) || 0;
                                        bw.bottom = parseInt(toPixels(h.currentStyle.borderBottomWidth), 10) || 0;
                                        bw.left = parseInt(toPixels(h.currentStyle.borderLeftWidth), 10) || 0;
                                        bw.right = parseInt(toPixels(h.currentStyle.borderRightWidth), 10) || 0;
                                        return bw;
                                    }
                                }
                                // Shouldn't get this far for any modern browser
                                bw.top = parseInt(h.style["border-top-width"], 10) || 0;
                                bw.bottom = parseInt(h.style["border-bottom-width"], 10) || 0;
                                bw.left = parseInt(h.style["border-left-width"], 10) || 0;
                                bw.right = parseInt(h.style["border-right-width"], 10) || 0;
                                return bw;
                            };

                            // Page scroll values for use by getMousePosition. To prevent flickering on MSIE
                            // they are calculated only when the document actually scrolls, not every time the
                            // mouse moves (as they would be if they were calculated inside getMousePosition).
                            var scroll = {
                                x: 0,
                                y: 0
                            };
                            var getScrollValue = function (e) {
                                scroll.x = (typeof document.documentElement.scrollLeft !== "undefined" ? document.documentElement.scrollLeft : document.body.scrollLeft);
                                scroll.y = (typeof document.documentElement.scrollTop !== "undefined" ? document.documentElement.scrollTop : document.body.scrollTop);
                            };
                            getScrollValue();

                            /**
                             * Get the position of the mouse relative to the document.
                             * @param {Event} e  The mouse event.
                             * @return {Object} The position object {left, top}.
                             */
                            var getMousePosition = function (e) {
                                var posX = 0, posY = 0;
                                e = e || window.event;
                                if (typeof e.pageX !== "undefined") {
                                    posX = e.pageX;
                                    posY = e.pageY;
                                } else if (typeof e.clientX !== "undefined") { // MSIE
                                    posX = e.clientX + scroll.x;
                                    posY = e.clientY + scroll.y;
                                }
                                return {
                                    left: posX,
                                    top: posY
                                };
                            };
                            /**
                             * Get the position of an HTML element relative to the document.
                             * @param {Node} h  The HTML element.
                             * @return {Object} The position object {left, top}.
                             */
                            var getElementPosition = function (h) {
                                var posX = h.offsetLeft;
                                var posY = h.offsetTop;
                                var parent = h.offsetParent;
                                // Add offsets for all ancestors in the hierarchy
                                while (parent !== null) {
                                    // Adjust for scrolling elements which may affect the map position.
                                    //
                                    // See http://www.howtocreate.co.uk/tutorials/javascript/browserspecific
                                    //
                                    // "...make sure that every element [on a Web page] with an overflow
                                    // of anything other than visible also has a position style set to
                                    // something other than the default static..."
                                    if (parent !== document.body && parent !== document.documentElement) {
                                        posX -= parent.scrollLeft;
                                        posY -= parent.scrollTop;
                                    }
                                    // See http://groups.google.com/group/google-maps-js-api-v3/browse_thread/thread/4cb86c0c1037a5e5
                                    // Example: http://notebook.kulchenko.com/maps/gridmove
                                    var m = parent;
                                    // This is the "normal" way to get offset information:
                                    var moffx = m.offsetLeft;
                                    var moffy = m.offsetTop;
                                    // This covers those cases where a transform is used:
                                    if (!moffx && !moffy && window.getComputedStyle) {
                                        var matrix = document.defaultView.getComputedStyle(m, null).MozTransform ||
                                            document.defaultView.getComputedStyle(m, null).WebkitTransform;
                                        if (matrix) {
                                            if (typeof matrix === "string") {
                                                var parms = matrix.split(",");
                                                moffx += parseInt(parms[4], 10) || 0;
                                                moffy += parseInt(parms[5], 10) || 0;
                                            }
                                        }
                                    }
                                    posX += moffx;
                                    posY += moffy;
                                    parent = parent.offsetParent;
                                }
                                return {
                                    left: posX,
                                    top: posY
                                };
                            };
                            /**
                             * Set the properties of an object to those from another object.
                             * @param {Object} obj The target object.
                             * @param {Object} vals The source object.
                             */
                            var setVals = function (obj, vals) {
                                if (obj && vals) {
                                    for (var x in vals) {
                                        if (vals.hasOwnProperty(x)) {
                                            obj[x] = vals[x];
                                        }
                                    }
                                }
                                return obj;
                            };
                            /**
                             * Set the opacity. If op is not passed in, this function just performs an MSIE fix.
                             * @param {Node} h The HTML element.
                             * @param {number} op The opacity value (0-1).
                             */
                            var setOpacity = function (h, op) {
                                if (typeof op !== "undefined") {
                                    h.style.opacity = op;
                                }
                                if (typeof h.style.opacity !== "undefined" && h.style.opacity !== "") {
                                    h.style.filter = "alpha(opacity=" + (h.style.opacity * 100) + ")";
                                }
                            };
                            /**
                             * @name KeyDragZoomOptions
                             * @class This class represents the optional parameter passed into <code>google.maps.Map.enableKeyDragZoom</code>.
                             * @property {string} [key="shift"] The hot key to hold down to activate a drag zoom, <code>shift | ctrl | alt</code>.
                             *  NOTE: Do not use Ctrl as the hot key with Google Maps JavaScript API V3 since, unlike with V2,
                             *  it causes a context menu to appear when running on the Macintosh. Also note that the
                             *  <code>alt</code> hot key refers to the Option key on a Macintosh.
                             * @property {Object} [boxStyle={border: "4px solid #736AFF"}]
                             *  An object literal defining the CSS styles of the zoom box.
                             *  Border widths must be specified in pixel units (or as thin, medium, or thick).
                             * @property {Object} [veilStyle={backgroundColor: "gray", opacity: 0.25, cursor: "crosshair"}]
                             *  An object literal defining the CSS styles of the veil pane which covers the map when a drag
                             *  zoom is activated. The previous name for this property was <code>paneStyle</code> but the use
                             *  of this name is now deprecated.
                             * @property {boolean} [noZoom=false] A flag indicating whether to disable zooming after an area is
                             *  selected. Set this to <code>true</code> to allow KeyDragZoom to be used as a simple area
                             *  selection tool.
                             * @property {boolean} [visualEnabled=false] A flag indicating whether a visual control is to be used.
                             * @property {string} [visualClass=""] The name of the CSS class defining the styles for the visual
                             *  control. To prevent the visual control from being printed, set this property to the name of
                             *  a class, defined inside a <code>@media print</code> rule, which sets the CSS
                             *  <code>display</code> style to <code>none</code>.
                             * @property {ControlPosition} [visualPosition=google.maps.ControlPosition.LEFT_TOP]
                             *  The position of the visual control.
                             * @property {Size} [visualPositionOffset=google.maps.Size(35, 0)] The width and height values
                             *  provided by this property are the offsets (in pixels) from the location at which the control
                             *  would normally be drawn to the desired drawing location.
                             * @property {number} [visualPositionIndex=null] The index of the visual control.
                             *  The index is for controlling the placement of the control relative to other controls at the
                             *  position given by <code>visualPosition</code>; controls with a lower index are placed first.
                             *  Use a negative value to place the control <i>before</i> any default controls. No index is
                             *  generally required.
                             * @property {String} [visualSprite="http://maps.gstatic.com/mapfiles/ftr/controls/dragzoom_btn.png"]
                             *  The URL of the sprite image used for showing the visual control in the on, off, and hot
                             *  (i.e., when the mouse is over the control) states. The three images within the sprite must
                             *  be the same size and arranged in on-hot-off order in a single row with no spaces between images.
                             * @property {Size} [visualSize=google.maps.Size(20, 20)] The width and height values provided by
                             *  this property are the size (in pixels) of each of the images within <code>visualSprite</code>.
                             * @property {Object} [visualTips={off: "Turn on drag zoom mode", on: "Turn off drag zoom mode"}]
                             *  An object literal defining the help tips that appear when
                             *  the mouse moves over the visual control. The <code>off</code> property is the tip to be shown
                             *  when the control is off and the <code>on</code> property is the tip to be shown when the
                             *  control is on.
                             */
                            /**
                             * @name DragZoom
                             * @class This class represents a drag zoom object for a map. The object is activated by holding down the hot key
                             * or by turning on the visual control.
                             * This object is created when <code>google.maps.Map.enableKeyDragZoom</code> is called; it cannot be created directly.
                             * Use <code>google.maps.Map.getDragZoomObject</code> to gain access to this object in order to attach event listeners.
                             * @param {Map} map The map to which the DragZoom object is to be attached.
                             * @param {KeyDragZoomOptions} [opt_zoomOpts] The optional parameters.
                             */
                            function DragZoom(map, opt_zoomOpts) {
                                var me = this;
                                var ov = new google.maps.OverlayView();
                                ov.onAdd = function () {
                                    me.init_(map, opt_zoomOpts);
                                };
                                ov.draw = function () {
                                };
                                ov.onRemove = function () {
                                };
                                ov.setMap(map);
                                this.prjov_ = ov;
                            }
                            /**
                             * Initialize the tool.
                             * @param {Map} map The map to which the DragZoom object is to be attached.
                             * @param {KeyDragZoomOptions} [opt_zoomOpts] The optional parameters.
                             */
                            DragZoom.prototype.init_ = function (map, opt_zoomOpts) {
                                var i;
                                var me = this;
                                this.map_ = map;
                                opt_zoomOpts = opt_zoomOpts || {};
                                this.key_ = opt_zoomOpts.key || "shift";
                                this.key_ = this.key_.toLowerCase();
                                this.borderWidths_ = getBorderWidths(this.map_.getDiv());
                                this.veilDiv_ = [];
                                for (i = 0; i < 4; i++) {
                                    this.veilDiv_[i] = document.createElement("div");
                                    // Prevents selection of other elements on the webpage
                                    // when a drag zoom operation is in progress:
                                    this.veilDiv_[i].onselectstart = function () {
                                        return false;
                                    };
                                    // Apply default style values for the veil:
                                    setVals(this.veilDiv_[i].style, {
                                        backgroundColor: "gray",
                                        opacity: 0.25,
                                        cursor: "crosshair"
                                    });
                                    // Apply style values specified in veilStyle parameter:
                                    setVals(this.veilDiv_[i].style, opt_zoomOpts.paneStyle); // Old option name was "paneStyle"
                                    setVals(this.veilDiv_[i].style, opt_zoomOpts.veilStyle); // New name is "veilStyle"
                                    // Apply mandatory style values:
                                    setVals(this.veilDiv_[i].style, {
                                        position: "absolute",
                                        overflow: "hidden",
                                        display: "none"
                                    });
                                    // Workaround for Firefox Shift-Click problem:
                                    if (this.key_ === "shift") {
                                        this.veilDiv_[i].style.MozUserSelect = "none";
                                    }
                                    setOpacity(this.veilDiv_[i]);
                                    // An IE fix: If the background is transparent it cannot capture mousedown
                                    // events, so if it is, change the background to white with 0 opacity.
                                    if (this.veilDiv_[i].style.backgroundColor === "transparent") {
                                        this.veilDiv_[i].style.backgroundColor = "white";
                                        setOpacity(this.veilDiv_[i], 0);
                                    }
                                    this.map_.getDiv().appendChild(this.veilDiv_[i]);
                                }

                                this.noZoom_ = opt_zoomOpts.noZoom || false;
                                this.visualEnabled_ = opt_zoomOpts.visualEnabled || false;
                                this.visualClass_ = opt_zoomOpts.visualClass || "";
                                this.visualPosition_ = opt_zoomOpts.visualPosition || google.maps.ControlPosition.LEFT_TOP;
                                this.visualPositionOffset_ = opt_zoomOpts.visualPositionOffset || new google.maps.Size(35, 0);
                                this.visualPositionIndex_ = opt_zoomOpts.visualPositionIndex || null;
                                this.visualSprite_ = opt_zoomOpts.visualSprite || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/mapfiles/ftr/controls/dragzoom_btn.png";
                                this.visualSize_ = opt_zoomOpts.visualSize || new google.maps.Size(20, 20);
                                this.visualTips_ = opt_zoomOpts.visualTips || {};
                                this.visualTips_.off =  this.visualTips_.off || "Turn on drag zoom mode";
                                this.visualTips_.on =  this.visualTips_.on || "Turn off drag zoom mode";

                                this.boxDiv_ = document.createElement("div");
                                // Apply default style values for the zoom box:
                                setVals(this.boxDiv_.style, {
                                    border: "4px solid #736AFF"
                                });
                                // Apply style values specified in boxStyle parameter:
                                setVals(this.boxDiv_.style, opt_zoomOpts.boxStyle);
                                // Apply mandatory style values:
                                setVals(this.boxDiv_.style, {
                                    position: "absolute",
                                    display: "none"
                                });
                                setOpacity(this.boxDiv_);
                                this.map_.getDiv().appendChild(this.boxDiv_);
                                this.boxBorderWidths_ = getBorderWidths(this.boxDiv_);

                                this.listeners_ = [
                                    google.maps.event.addDomListener(document, "keydown", function (e) {
                                        me.onKeyDown_(e);
                                    }),
                                    google.maps.event.addDomListener(document, "keyup", function (e) {
                                        me.onKeyUp_(e);
                                    }),
                                    google.maps.event.addDomListener(this.veilDiv_[0], "mousedown", function (e) {
                                        me.onMouseDown_(e);
                                    }),
                                    google.maps.event.addDomListener(this.veilDiv_[1], "mousedown", function (e) {
                                        me.onMouseDown_(e);
                                    }),
                                    google.maps.event.addDomListener(this.veilDiv_[2], "mousedown", function (e) {
                                        me.onMouseDown_(e);
                                    }),
                                    google.maps.event.addDomListener(this.veilDiv_[3], "mousedown", function (e) {
                                        me.onMouseDown_(e);
                                    }),
                                    google.maps.event.addDomListener(document, "mousedown", function (e) {
                                        me.onMouseDownDocument_(e);
                                    }),
                                    google.maps.event.addDomListener(document, "mousemove", function (e) {
                                        me.onMouseMove_(e);
                                    }),
                                    google.maps.event.addDomListener(document, "mouseup", function (e) {
                                        me.onMouseUp_(e);
                                    }),
                                    google.maps.event.addDomListener(window, "scroll", getScrollValue)
                                ];

                                this.hotKeyDown_ = false;
                                this.mouseDown_ = false;
                                this.dragging_ = false;
                                this.startPt_ = null;
                                this.endPt_ = null;
                                this.mapWidth_ = null;
                                this.mapHeight_ = null;
                                this.mousePosn_ = null;
                                this.mapPosn_ = null;

                                if (this.visualEnabled_) {
                                    this.buttonDiv_ = this.initControl_(this.visualPositionOffset_);
                                    if (this.visualPositionIndex_ !== null) {
                                        this.buttonDiv_.index = this.visualPositionIndex_;
                                    }
                                    this.map_.controls[this.visualPosition_].push(this.buttonDiv_);
                                    this.controlIndex_ = this.map_.controls[this.visualPosition_].length - 1;
                                }
                            };
                            /**
                             * Initializes the visual control and returns its DOM element.
                             * @param {Size} offset The offset of the control from its normal position.
                             * @return {Node} The DOM element containing the visual control.
                             */
                            DragZoom.prototype.initControl_ = function (offset) {
                                var control;
                                var image;
                                var me = this;

                                control = document.createElement("div");
                                control.className = this.visualClass_;
                                control.style.position = "relative";
                                control.style.overflow = "hidden";
                                control.style.height = this.visualSize_.height + "px";
                                control.style.width = this.visualSize_.width + "px";
                                control.title = this.visualTips_.off;
                                image = document.createElement("img");
                                image.src = this.visualSprite_;
                                image.style.position = "absolute";
                                image.style.left = -(this.visualSize_.width * 2) + "px";
                                image.style.top = 0 + "px";
                                control.appendChild(image);
                                control.onclick = function (e) {
                                    me.hotKeyDown_ = !me.hotKeyDown_;
                                    if (me.hotKeyDown_) {
                                        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 0) + "px";
                                        me.buttonDiv_.title = me.visualTips_.on;
                                        me.activatedByControl_ = true;
                                        google.maps.event.trigger(me, "activate");
                                    } else {
                                        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 2) + "px";
                                        me.buttonDiv_.title = me.visualTips_.off;
                                        google.maps.event.trigger(me, "deactivate");
                                    }
                                    me.onMouseMove_(e); // Updates the veil
                                };
                                control.onmouseover = function () {
                                    me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 1) + "px";
                                };
                                control.onmouseout = function () {
                                    if (me.hotKeyDown_) {
                                        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 0) + "px";
                                        me.buttonDiv_.title = me.visualTips_.on;
                                    } else {
                                        me.buttonDiv_.firstChild.style.left = -(me.visualSize_.width * 2) + "px";
                                        me.buttonDiv_.title = me.visualTips_.off;
                                    }
                                };
                                control.ondragstart = function () {
                                    return false;
                                };
                                setVals(control.style, {
                                    cursor: "pointer",
                                    marginTop: offset.height + "px",
                                    marginLeft: offset.width + "px"
                                });
                                return control;
                            };
                            /**
                             * Returns <code>true</code> if the hot key is being pressed when an event occurs.
                             * @param {Event} e The keyboard event.
                             * @return {boolean} Flag indicating whether the hot key is down.
                             */
                            DragZoom.prototype.isHotKeyDown_ = function (e) {
                                var isHot;
                                e = e || window.event;
                                isHot = (e.shiftKey && this.key_ === "shift") || (e.altKey && this.key_ === "alt") || (e.ctrlKey && this.key_ === "ctrl");
                                if (!isHot) {
                                    // Need to look at keyCode for Opera because it
                                    // doesn't set the shiftKey, altKey, ctrlKey properties
                                    // unless a non-modifier event is being reported.
                                    //
                                    // See http://cross-browser.com/x/examples/shift_mode.php
                                    // Also see http://unixpapa.com/js/key.html
                                    switch (e.keyCode) {
                                        case 16:
                                            if (this.key_ === "shift") {
                                                isHot = true;
                                            }
                                            break;
                                        case 17:
                                            if (this.key_ === "ctrl") {
                                                isHot = true;
                                            }
                                            break;
                                        case 18:
                                            if (this.key_ === "alt") {
                                                isHot = true;
                                            }
                                            break;
                                    }
                                }
                                return isHot;
                            };
                            /**
                             * Returns <code>true</code> if the mouse is on top of the map div.
                             * The position is captured in onMouseMove_.
                             * @return {boolean}
                             */
                            DragZoom.prototype.isMouseOnMap_ = function () {
                                var mousePosn = this.mousePosn_;
                                if (mousePosn) {
                                    var mapPosn = this.mapPosn_;
                                    var mapDiv = this.map_.getDiv();
                                    return mousePosn.left > mapPosn.left && mousePosn.left < (mapPosn.left + mapDiv.offsetWidth) &&
                                        mousePosn.top > mapPosn.top && mousePosn.top < (mapPosn.top + mapDiv.offsetHeight);
                                } else {
                                    // if user never moved mouse
                                    return false;
                                }
                            };
                            /**
                             * Show the veil if the hot key is down and the mouse is over the map,
                             * otherwise hide the veil.
                             */
                            DragZoom.prototype.setVeilVisibility_ = function () {
                                var i;
                                if (this.map_ && this.hotKeyDown_ && this.isMouseOnMap_()) {
                                    var mapDiv = this.map_.getDiv();
                                    this.mapWidth_ = mapDiv.offsetWidth - (this.borderWidths_.left + this.borderWidths_.right);
                                    this.mapHeight_ = mapDiv.offsetHeight - (this.borderWidths_.top + this.borderWidths_.bottom);
                                    if (this.activatedByControl_) { // Veil covers entire map (except control)
                                        var left = parseInt(this.buttonDiv_.style.left, 10) + this.visualPositionOffset_.width;
                                        var top = parseInt(this.buttonDiv_.style.top, 10) + this.visualPositionOffset_.height;
                                        var width = this.visualSize_.width;
                                        var height = this.visualSize_.height;
                                        // Left veil rectangle:
                                        this.veilDiv_[0].style.top = "0px";
                                        this.veilDiv_[0].style.left = "0px";
                                        this.veilDiv_[0].style.width = left + "px";
                                        this.veilDiv_[0].style.height = this.mapHeight_ + "px";
                                        // Right veil rectangle:
                                        this.veilDiv_[1].style.top = "0px";
                                        this.veilDiv_[1].style.left = (left + width) + "px";
                                        this.veilDiv_[1].style.width = (this.mapWidth_ - (left + width)) + "px";
                                        this.veilDiv_[1].style.height = this.mapHeight_ + "px";
                                        // Top veil rectangle:
                                        this.veilDiv_[2].style.top = "0px";
                                        this.veilDiv_[2].style.left = left + "px";
                                        this.veilDiv_[2].style.width = width + "px";
                                        this.veilDiv_[2].style.height = top + "px";
                                        // Bottom veil rectangle:
                                        this.veilDiv_[3].style.top = (top + height) + "px";
                                        this.veilDiv_[3].style.left = left + "px";
                                        this.veilDiv_[3].style.width = width + "px";
                                        this.veilDiv_[3].style.height = (this.mapHeight_ - (top + height)) + "px";
                                        for (i = 0; i < this.veilDiv_.length; i++) {
                                            this.veilDiv_[i].style.display = "block";
                                        }
                                    } else {
                                        this.veilDiv_[0].style.left = "0px";
                                        this.veilDiv_[0].style.top = "0px";
                                        this.veilDiv_[0].style.width = this.mapWidth_ + "px";
                                        this.veilDiv_[0].style.height = this.mapHeight_ + "px";
                                        for (i = 1; i < this.veilDiv_.length; i++) {
                                            this.veilDiv_[i].style.width = "0px";
                                            this.veilDiv_[i].style.height = "0px";
                                        }
                                        for (i = 0; i < this.veilDiv_.length; i++) {
                                            this.veilDiv_[i].style.display = "block";
                                        }
                                    }
                                } else {
                                    for (i = 0; i < this.veilDiv_.length; i++) {
                                        this.veilDiv_[i].style.display = "none";
                                    }
                                }
                            };
                            /**
                             * Handle key down. Show the veil if the hot key has been pressed.
                             * @param {Event} e The keyboard event.
                             */
                            DragZoom.prototype.onKeyDown_ = function (e) {
                                if (this.map_ && !this.hotKeyDown_ && this.isHotKeyDown_(e)) {
                                    this.mapPosn_ = getElementPosition(this.map_.getDiv());
                                    this.hotKeyDown_ = true;
                                    this.activatedByControl_ = false;
                                    this.setVeilVisibility_();
                                    /**
                                     * This event is fired when the hot key is pressed.
                                     * @name DragZoom#activate
                                     * @event
                                     */
                                    google.maps.event.trigger(this, "activate");
                                }
                            };
                            /**
                             * Get the <code>google.maps.Point</code> of the mouse position.
                             * @param {Event} e The mouse event.
                             * @return {Point} The mouse position.
                             */
                            DragZoom.prototype.getMousePoint_ = function (e) {
                                var mousePosn = getMousePosition(e);
                                var p = new google.maps.Point();
                                p.x = mousePosn.left - this.mapPosn_.left - this.borderWidths_.left;
                                p.y = mousePosn.top - this.mapPosn_.top - this.borderWidths_.top;
                                p.x = Math.min(p.x, this.mapWidth_);
                                p.y = Math.min(p.y, this.mapHeight_);
                                p.x = Math.max(p.x, 0);
                                p.y = Math.max(p.y, 0);
                                return p;
                            };
                            /**
                             * Handle mouse down.
                             * @param {Event} e The mouse event.
                             */
                            DragZoom.prototype.onMouseDown_ = function (e) {
                                if (this.map_ && this.hotKeyDown_) {
                                    this.mapPosn_ = getElementPosition(this.map_.getDiv());
                                    this.dragging_ = true;
                                    this.startPt_ = this.endPt_ = this.getMousePoint_(e);
                                    this.boxDiv_.style.width = this.boxDiv_.style.height = "0px";
                                    var prj = this.prjov_.getProjection();
                                    var latlng = prj.fromContainerPixelToLatLng(this.startPt_);
                                    /**
                                     * This event is fired when the drag operation begins.
                                     * The parameter passed is the geographic position of the starting point.
                                     * @name DragZoom#dragstart
                                     * @param {LatLng} latlng The geographic position of the starting point.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, "dragstart", latlng);
                                }
                            };
                            /**
                             * Handle mouse down at the document level.
                             * @param {Event} e The mouse event.
                             */
                            DragZoom.prototype.onMouseDownDocument_ = function (e) {
                                this.mouseDown_ = true;
                            };
                            /**
                             * Handle mouse move.
                             * @param {Event} e The mouse event.
                             */
                            DragZoom.prototype.onMouseMove_ = function (e) {
                                this.mousePosn_ = getMousePosition(e);
                                if (this.dragging_) {
                                    this.endPt_ = this.getMousePoint_(e);
                                    var left = Math.min(this.startPt_.x, this.endPt_.x);
                                    var top = Math.min(this.startPt_.y, this.endPt_.y);
                                    var width = Math.abs(this.startPt_.x - this.endPt_.x);
                                    var height = Math.abs(this.startPt_.y - this.endPt_.y);
                                    // For benefit of MSIE 7/8 ensure following values are not negative:
                                    var boxWidth = Math.max(0, width - (this.boxBorderWidths_.left + this.boxBorderWidths_.right));
                                    var boxHeight = Math.max(0, height - (this.boxBorderWidths_.top + this.boxBorderWidths_.bottom));
                                    // Left veil rectangle:
                                    this.veilDiv_[0].style.top = "0px";
                                    this.veilDiv_[0].style.left = "0px";
                                    this.veilDiv_[0].style.width = left + "px";
                                    this.veilDiv_[0].style.height = this.mapHeight_ + "px";
                                    // Right veil rectangle:
                                    this.veilDiv_[1].style.top = "0px";
                                    this.veilDiv_[1].style.left = (left + width) + "px";
                                    this.veilDiv_[1].style.width = (this.mapWidth_ - (left + width)) + "px";
                                    this.veilDiv_[1].style.height = this.mapHeight_ + "px";
                                    // Top veil rectangle:
                                    this.veilDiv_[2].style.top = "0px";
                                    this.veilDiv_[2].style.left = left + "px";
                                    this.veilDiv_[2].style.width = width + "px";
                                    this.veilDiv_[2].style.height = top + "px";
                                    // Bottom veil rectangle:
                                    this.veilDiv_[3].style.top = (top + height) + "px";
                                    this.veilDiv_[3].style.left = left + "px";
                                    this.veilDiv_[3].style.width = width + "px";
                                    this.veilDiv_[3].style.height = (this.mapHeight_ - (top + height)) + "px";
                                    // Selection rectangle:
                                    this.boxDiv_.style.top = top + "px";
                                    this.boxDiv_.style.left = left + "px";
                                    this.boxDiv_.style.width = boxWidth + "px";
                                    this.boxDiv_.style.height = boxHeight + "px";
                                    this.boxDiv_.style.display = "block";
                                    /**
                                     * This event is fired repeatedly while the user drags a box across the area of interest.
                                     * The southwest and northeast point are passed as parameters of type <code>google.maps.Point</code>
                                     * (for performance reasons), relative to the map container. Also passed is the projection object
                                     * so that the event listener, if necessary, can convert the pixel positions to geographic
                                     * coordinates using <code>google.maps.MapCanvasProjection.fromContainerPixelToLatLng</code>.
                                     * @name DragZoom#drag
                                     * @param {Point} southwestPixel The southwest point of the selection area.
                                     * @param {Point} northeastPixel The northeast point of the selection area.
                                     * @param {MapCanvasProjection} prj The projection object.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, "drag", new google.maps.Point(left, top + height), new google.maps.Point(left + width, top), this.prjov_.getProjection());
                                } else if (!this.mouseDown_) {
                                    this.mapPosn_ = getElementPosition(this.map_.getDiv());
                                    this.setVeilVisibility_();
                                }
                            };
                            /**
                             * Handle mouse up.
                             * @param {Event} e The mouse event.
                             */
                            DragZoom.prototype.onMouseUp_ = function (e) {
                                var z;
                                var me = this;
                                this.mouseDown_ = false;
                                if (this.dragging_) {
                                    if ((this.getMousePoint_(e).x === this.startPt_.x) && (this.getMousePoint_(e).y === this.startPt_.y)) {
                                        this.onKeyUp_(e); // Cancel event
                                        return;
                                    }
                                    var left = Math.min(this.startPt_.x, this.endPt_.x);
                                    var top = Math.min(this.startPt_.y, this.endPt_.y);
                                    var width = Math.abs(this.startPt_.x - this.endPt_.x);
                                    var height = Math.abs(this.startPt_.y - this.endPt_.y);
                                    // Google Maps API bug: setCenter() doesn't work as expected if the map has a
                                    // border on the left or top. The code here includes a workaround for this problem.
                                    var kGoogleCenteringBug = true;
                                    if (kGoogleCenteringBug) {
                                        left += this.borderWidths_.left;
                                        top += this.borderWidths_.top;
                                    }

                                    var prj = this.prjov_.getProjection();
                                    var sw = prj.fromContainerPixelToLatLng(new google.maps.Point(left, top + height));
                                    var ne = prj.fromContainerPixelToLatLng(new google.maps.Point(left + width, top));
                                    var bnds = new google.maps.LatLngBounds(sw, ne);

                                    if (this.noZoom_) {
                                        this.boxDiv_.style.display = "none";
                                    } else {
                                        // Sometimes fitBounds causes a zoom OUT, so restore original zoom level if this happens.
                                        z = this.map_.getZoom();
                                        this.map_.fitBounds(bnds);
                                        if (this.map_.getZoom() < z) {
                                            this.map_.setZoom(z);
                                        }

                                        // Redraw box after zoom:
                                        var swPt = prj.fromLatLngToContainerPixel(sw);
                                        var nePt = prj.fromLatLngToContainerPixel(ne);
                                        if (kGoogleCenteringBug) {
                                            swPt.x -= this.borderWidths_.left;
                                            swPt.y -= this.borderWidths_.top;
                                            nePt.x -= this.borderWidths_.left;
                                            nePt.y -= this.borderWidths_.top;
                                        }
                                        this.boxDiv_.style.left = swPt.x + "px";
                                        this.boxDiv_.style.top = nePt.y + "px";
                                        this.boxDiv_.style.width = (Math.abs(nePt.x - swPt.x) - (this.boxBorderWidths_.left + this.boxBorderWidths_.right)) + "px";
                                        this.boxDiv_.style.height = (Math.abs(nePt.y - swPt.y) - (this.boxBorderWidths_.top + this.boxBorderWidths_.bottom)) + "px";
                                        // Hide box asynchronously after 1 second:
                                        setTimeout(function () {
                                            me.boxDiv_.style.display = "none";
                                        }, 1000);
                                    }
                                    this.dragging_ = false;
                                    this.onMouseMove_(e); // Updates the veil
                                    /**
                                     * This event is fired when the drag operation ends.
                                     * The parameter passed is the geographic bounds of the selected area.
                                     * Note that this event is <i>not</i> fired if the hot key is released before the drag operation ends.
                                     * @name DragZoom#dragend
                                     * @param {LatLngBounds} bnds The geographic bounds of the selected area.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, "dragend", bnds);
                                    // if the hot key isn't down, the drag zoom must have been activated by turning
                                    // on the visual control. In this case, finish up by simulating a key up event.
                                    if (!this.isHotKeyDown_(e)) {
                                        this.onKeyUp_(e);
                                    }
                                }
                            };
                            /**
                             * Handle key up.
                             * @param {Event} e The keyboard event.
                             */
                            DragZoom.prototype.onKeyUp_ = function (e) {
                                var i;
                                var left, top, width, height, prj, sw, ne;
                                var bnds = null;
                                if (this.map_ && this.hotKeyDown_) {
                                    this.hotKeyDown_ = false;
                                    if (this.dragging_) {
                                        this.boxDiv_.style.display = "none";
                                        this.dragging_ = false;
                                        // Calculate the bounds when drag zoom was cancelled
                                        left = Math.min(this.startPt_.x, this.endPt_.x);
                                        top = Math.min(this.startPt_.y, this.endPt_.y);
                                        width = Math.abs(this.startPt_.x - this.endPt_.x);
                                        height = Math.abs(this.startPt_.y - this.endPt_.y);
                                        prj = this.prjov_.getProjection();
                                        sw = prj.fromContainerPixelToLatLng(new google.maps.Point(left, top + height));
                                        ne = prj.fromContainerPixelToLatLng(new google.maps.Point(left + width, top));
                                        bnds = new google.maps.LatLngBounds(sw, ne);
                                    }
                                    for (i = 0; i < this.veilDiv_.length; i++) {
                                        this.veilDiv_[i].style.display = "none";
                                    }
                                    if (this.visualEnabled_) {
                                        this.buttonDiv_.firstChild.style.left = -(this.visualSize_.width * 2) + "px";
                                        this.buttonDiv_.title = this.visualTips_.off;
                                        this.buttonDiv_.style.display = "";
                                    }
                                    /**
                                     * This event is fired when the hot key is released.
                                     * The parameter passed is the geographic bounds of the selected area immediately
                                     * before the hot key was released.
                                     * @name DragZoom#deactivate
                                     * @param {LatLngBounds} bnds The geographic bounds of the selected area immediately
                                     *  before the hot key was released.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, "deactivate", bnds);
                                }
                            };
                            /**
                             * @name google.maps.Map
                             * @class These are new methods added to the Google Maps JavaScript API V3's
                             * <a href="http://code.google.com/apis/maps/documentation/javascript/reference.html#Map">Map</a>
                             * class.
                             */
                            /**
                             * Enables drag zoom. The user can zoom to an area of interest by holding down the hot key
                             * <code>(shift | ctrl | alt )</code> while dragging a box around the area or by turning
                             * on the visual control then dragging a box around the area.
                             * @param {KeyDragZoomOptions} opt_zoomOpts The optional parameters.
                             */
                            google.maps.Map.prototype.enableKeyDragZoom = function (opt_zoomOpts) {
                                this.dragZoom_ = new DragZoom(this, opt_zoomOpts);
                            };
                            /**
                             * Disables drag zoom.
                             */
                            google.maps.Map.prototype.disableKeyDragZoom = function () {
                                var i;
                                var d = this.dragZoom_;
                                if (d) {
                                    for (i = 0; i < d.listeners_.length; ++i) {
                                        google.maps.event.removeListener(d.listeners_[i]);
                                    }
                                    this.getDiv().removeChild(d.boxDiv_);
                                    for (i = 0; i < d.veilDiv_.length; i++) {
                                        this.getDiv().removeChild(d.veilDiv_[i]);
                                    }
                                    if (d.visualEnabled_) {
                                        // Remove the custom control:
                                        this.controls[d.visualPosition_].removeAt(d.controlIndex_);
                                    }
                                    d.prjov_.setMap(null);
                                    this.dragZoom_ = null;
                                }
                            };
                            /**
                             * Returns <code>true</code> if the drag zoom feature has been enabled.
                             * @return {boolean}
                             */
                            google.maps.Map.prototype.keyDragZoomEnabled = function () {
                                return this.dragZoom_ !== null;
                            };
                            /**
                             * Returns the DragZoom object which is created when <code>google.maps.Map.enableKeyDragZoom</code> is called.
                             * With this object you can use <code>google.maps.event.addListener</code> to attach event listeners
                             * for the "activate", "deactivate", "dragstart", "drag", and "dragend" events.
                             * @return {DragZoom}
                             */
                            google.maps.Map.prototype.getDragZoomObject = function () {
                                return this.dragZoom_;
                            };
                        })();

                        /**
                         *  google-maps-utility-library-v3-markerwithlabel
                         *
                         * @version: 1.1.10
                         * @author: Gary Little (inspired by code from Marc Ridey of Google).
                         * @contributors: Nicholas McCready
                         * @date: Fri May 13 2016 16:29:58 GMT-0400 (EDT)
                         * @license: Apache License 2.0
                         */
                        /**
                         *  MarkerWithLabel allows you to define markers with associated labels. As you would expect,
                         *  if the marker is draggable, so too will be the label. In addition, a marker with a label
                         *  responds to all mouse events in the same manner as a regular marker. It also fires mouse
                         *  events and "property changed" events just as a regular marker would. Version 1.1 adds
                         *  support for the raiseOnDrag feature introduced in API V3.3.
                         *  <p>
                         *  If you drag a marker by its label, you can cancel the drag and return the marker to its
                         *  original position by pressing the <code>Esc</code> key. This doesn't work if you drag the marker
                         *  itself because this feature is not (yet) supported in the <code>google.maps.Marker</code> class.
                         */

                        /*jslint browser:true */
                        /*global document,google */

                        /**
                         * @param {Function} childCtor Child class.
                         * @param {Function} parentCtor Parent class.
                         * @private
                         */
                        function inherits(childCtor, parentCtor) {
                            /* @constructor */
                            function tempCtor() {}
                            tempCtor.prototype = parentCtor.prototype;
                            childCtor.superClass_ = parentCtor.prototype;
                            childCtor.prototype = new tempCtor();
                            /* @override */
                            childCtor.prototype.constructor = childCtor;
                        }

                        /**
                         * This constructor creates a label and associates it with a marker.
                         * It is for the private use of the MarkerWithLabel class.
                         * @constructor
                         * @param {Marker} marker The marker with which the label is to be associated.
                         * @param {string} crossURL The URL of the cross image =.
                         * @param {string} handCursor The URL of the hand cursor.
                         * @private
                         */
                        function MarkerLabel_(marker, crossURL, handCursorURL) {
                            this.marker_ = marker;
                            this.handCursorURL_ = marker.handCursorURL;

                            this.labelDiv_ = document.createElement("div");
                            this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";

                            // Set up the DIV for handling mouse events in the label. This DIV forms a transparent veil
                            // in the "overlayMouseTarget" pane, a veil that covers just the label. This is done so that
                            // events can be captured even if the label is in the shadow of a google.maps.InfoWindow.
                            // Code is included here to ensure the veil is always exactly the same size as the label.
                            this.eventDiv_ = document.createElement("div");
                            this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;

                            // This is needed for proper behavior on MSIE:
                            this.eventDiv_.setAttribute("onselectstart", "return false;");
                            this.eventDiv_.setAttribute("ondragstart", "return false;");

                            // Get the DIV for the "X" to be displayed when the marker is raised.
                            this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
                        }

                        inherits(MarkerLabel_, google.maps.OverlayView);

                        /**
                         * Returns the DIV for the cross used when dragging a marker when the
                         * raiseOnDrag parameter set to true. One cross is shared with all markers.
                         * @param {string} crossURL The URL of the cross image =.
                         * @private
                         */
                        MarkerLabel_.getSharedCross = function (crossURL) {
                            var div;
                            if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
                                div = document.createElement("img");
                                div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
                                // Hopefully Google never changes the standard "X" attributes:
                                div.style.marginLeft = "-8px";
                                div.style.marginTop = "-9px";
                                div.src = crossURL;
                                MarkerLabel_.getSharedCross.crossDiv = div;
                            }
                            return MarkerLabel_.getSharedCross.crossDiv;
                        };

                        /**
                         * Adds the DIV representing the label to the DOM. This method is called
                         * automatically when the marker's <code>setMap</code> method is called.
                         * @private
                         */
                        MarkerLabel_.prototype.onAdd = function () {
                            var me = this;
                            var cMouseIsDown = false;
                            var cDraggingLabel = false;
                            var cSavedZIndex;
                            var cLatOffset, cLngOffset;
                            var cIgnoreClick;
                            var cRaiseEnabled;
                            var cStartPosition;
                            var cStartCenter;
                            // Constants:
                            var cRaiseOffset = 20;
                            var cDraggingCursor = "url(" + this.handCursorURL_ + ")";

                            // Stops all processing of an event.
                            //
                            var cAbortEvent = function (e) {
                                if (e.preventDefault) {
                                    e.preventDefault();
                                }
                                e.cancelBubble = true;
                                if (e.stopPropagation) {
                                    e.stopPropagation();
                                }
                            };

                            var cStopBounce = function () {
                                me.marker_.setAnimation(null);
                            };

                            this.getPanes().overlayImage.appendChild(this.labelDiv_);
                            this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
                            // One cross is shared with all markers, so only add it once:
                            if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
                                this.getPanes().overlayImage.appendChild(this.crossDiv_);
                                MarkerLabel_.getSharedCross.processed = true;
                            }

                            this.listeners_ = [
                                google.maps.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
                                    if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                                        this.style.cursor = "pointer";
                                        google.maps.event.trigger(me.marker_, "mouseover", e);
                                    }
                                }),
                                google.maps.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
                                    if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
                                        this.style.cursor = me.marker_.getCursor();
                                        google.maps.event.trigger(me.marker_, "mouseout", e);
                                    }
                                }),
                                google.maps.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
                                    cDraggingLabel = false;
                                    if (me.marker_.getDraggable()) {
                                        cMouseIsDown = true;
                                        this.style.cursor = cDraggingCursor;
                                    }
                                    if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                                        google.maps.event.trigger(me.marker_, "mousedown", e);
                                        cAbortEvent(e); // Prevent map pan when starting a drag on a label
                                    }
                                }),
                                google.maps.event.addDomListener(document, "mouseup", function (mEvent) {
                                    var position;
                                    if (cMouseIsDown) {
                                        cMouseIsDown = false;
                                        me.eventDiv_.style.cursor = "pointer";
                                        google.maps.event.trigger(me.marker_, "mouseup", mEvent);
                                    }
                                    if (cDraggingLabel) {
                                        if (cRaiseEnabled) { // Lower the marker & label
                                            position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
                                            position.y += cRaiseOffset;
                                            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
                                            // This is not the same bouncing style as when the marker portion is dragged,
                                            // but it will have to do:
                                            try { // Will fail if running Google Maps API earlier than V3.3
                                                me.marker_.setAnimation(google.maps.Animation.BOUNCE);
                                                setTimeout(cStopBounce, 1406);
                                            } catch (e) {}
                                        }
                                        me.crossDiv_.style.display = "none";
                                        me.marker_.setZIndex(cSavedZIndex);
                                        cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
                                        cDraggingLabel = false;
                                        mEvent.latLng = me.marker_.getPosition();
                                        google.maps.event.trigger(me.marker_, "dragend", mEvent);
                                    }
                                }),
                                google.maps.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
                                    var position;
                                    if (cMouseIsDown) {
                                        if (cDraggingLabel) {
                                            // Change the reported location from the mouse position to the marker position:
                                            mEvent.latLng = new google.maps.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
                                            position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
                                            if (cRaiseEnabled) {
                                                me.crossDiv_.style.left = position.x + "px";
                                                me.crossDiv_.style.top = position.y + "px";
                                                me.crossDiv_.style.display = "";
                                                position.y -= cRaiseOffset;
                                            }
                                            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
                                            if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
                                                me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
                                            }
                                            google.maps.event.trigger(me.marker_, "drag", mEvent);
                                        } else {
                                            // Calculate offsets from the click point to the marker position:
                                            cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
                                            cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
                                            cSavedZIndex = me.marker_.getZIndex();
                                            cStartPosition = me.marker_.getPosition();
                                            cStartCenter = me.marker_.getMap().getCenter();
                                            cRaiseEnabled = me.marker_.get("raiseOnDrag");
                                            cDraggingLabel = true;
                                            me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
                                            mEvent.latLng = me.marker_.getPosition();
                                            google.maps.event.trigger(me.marker_, "dragstart", mEvent);
                                        }
                                    }
                                }),
                                google.maps.event.addDomListener(document, "keydown", function (e) {
                                    if (cDraggingLabel) {
                                        if (e.keyCode === 27) { // Esc key
                                            cRaiseEnabled = false;
                                            me.marker_.setPosition(cStartPosition);
                                            me.marker_.getMap().setCenter(cStartCenter);
                                            google.maps.event.trigger(document, "mouseup", e);
                                        }
                                    }
                                }),
                                google.maps.event.addDomListener(this.eventDiv_, "click", function (e) {
                                    if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                                        if (cIgnoreClick) { // Ignore the click reported when a label drag ends
                                            cIgnoreClick = false;
                                        } else {
                                            google.maps.event.trigger(me.marker_, "click", e);
                                            cAbortEvent(e); // Prevent click from being passed on to map
                                        }
                                    }
                                }),
                                google.maps.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
                                    if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                                        google.maps.event.trigger(me.marker_, "dblclick", e);
                                        cAbortEvent(e); // Prevent map zoom when double-clicking on a label
                                    }
                                }),
                                google.maps.event.addListener(this.marker_, "dragstart", function (mEvent) {
                                    if (!cDraggingLabel) {
                                        cRaiseEnabled = this.get("raiseOnDrag");
                                    }
                                }),
                                google.maps.event.addListener(this.marker_, "drag", function (mEvent) {
                                    if (!cDraggingLabel) {
                                        if (cRaiseEnabled) {
                                            me.setPosition(cRaiseOffset);
                                            // During a drag, the marker's z-index is temporarily set to 1000000 to
                                            // ensure it appears above all other markers. Also set the label's z-index
                                            // to 1000000 (plus or minus 1 depending on whether the label is supposed
                                            // to be above or below the marker).
                                            me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
                                        }
                                    }
                                }),
                                google.maps.event.addListener(this.marker_, "dragend", function (mEvent) {
                                    if (!cDraggingLabel) {
                                        if (cRaiseEnabled) {
                                            me.setPosition(0); // Also restores z-index of label
                                        }
                                    }
                                }),
                                google.maps.event.addListener(this.marker_, "position_changed", function () {
                                    me.setPosition();
                                }),
                                google.maps.event.addListener(this.marker_, "zindex_changed", function () {
                                    me.setZIndex();
                                }),
                                google.maps.event.addListener(this.marker_, "visible_changed", function () {
                                    me.setVisible();
                                }),
                                google.maps.event.addListener(this.marker_, "labelvisible_changed", function () {
                                    me.setVisible();
                                }),
                                google.maps.event.addListener(this.marker_, "title_changed", function () {
                                    me.setTitle();
                                }),
                                google.maps.event.addListener(this.marker_, "labelcontent_changed", function () {
                                    me.setContent();
                                }),
                                google.maps.event.addListener(this.marker_, "labelanchor_changed", function () {
                                    me.setAnchor();
                                }),
                                google.maps.event.addListener(this.marker_, "labelclass_changed", function () {
                                    me.setStyles();
                                }),
                                google.maps.event.addListener(this.marker_, "labelstyle_changed", function () {
                                    me.setStyles();
                                })
                            ];
                        };

                        /**
                         * Removes the DIV for the label from the DOM. It also removes all event handlers.
                         * This method is called automatically when the marker's <code>setMap(null)</code>
                         * method is called.
                         * @private
                         */
                        MarkerLabel_.prototype.onRemove = function () {
                            var i;
                            this.labelDiv_.parentNode.removeChild(this.labelDiv_);
                            this.eventDiv_.parentNode.removeChild(this.eventDiv_);

                            // Remove event listeners:
                            for (i = 0; i < this.listeners_.length; i++) {
                                google.maps.event.removeListener(this.listeners_[i]);
                            }
                        };

                        /**
                         * Draws the label on the map.
                         * @private
                         */
                        MarkerLabel_.prototype.draw = function () {
                            this.setContent();
                            this.setTitle();
                            this.setStyles();
                        };

                        /**
                         * Sets the content of the label.
                         * The content can be plain text or an HTML DOM node.
                         * @private
                         */
                        MarkerLabel_.prototype.setContent = function () {
                            var content = this.marker_.get("labelContent");
                            if (typeof content.nodeType === "undefined") {
                                this.labelDiv_.innerHTML = content;
                                this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
                            } else {
                                this.labelDiv_.innerHTML = ""; // Remove current content
                                this.labelDiv_.appendChild(content);
                                content = content.cloneNode(true);
                                this.eventDiv_.innerHTML = ""; // Remove current content
                                this.eventDiv_.appendChild(content);
                            }
                        };

                        /**
                         * Sets the content of the tool tip for the label. It is
                         * always set to be the same as for the marker itself.
                         * @private
                         */
                        MarkerLabel_.prototype.setTitle = function () {
                            this.eventDiv_.title = this.marker_.getTitle() || "";
                        };

                        /**
                         * Sets the style of the label by setting the style sheet and applying
                         * other specific styles requested.
                         * @private
                         */
                        MarkerLabel_.prototype.setStyles = function () {
                            var i, labelStyle;

                            // Apply style values from the style sheet defined in the labelClass parameter:
                            this.labelDiv_.className = this.marker_.get("labelClass");
                            this.eventDiv_.className = this.labelDiv_.className;

                            // Clear existing inline style values:
                            this.labelDiv_.style.cssText = "";
                            this.eventDiv_.style.cssText = "";
                            // Apply style values defined in the labelStyle parameter:
                            labelStyle = this.marker_.get("labelStyle");
                            for (i in labelStyle) {
                                if (labelStyle.hasOwnProperty(i)) {
                                    this.labelDiv_.style[i] = labelStyle[i];
                                    this.eventDiv_.style[i] = labelStyle[i];
                                }
                            }
                            this.setMandatoryStyles();
                        };

                        /**
                         * Sets the mandatory styles to the DIV representing the label as well as to the
                         * associated event DIV. This includes setting the DIV position, z-index, and visibility.
                         * @private
                         */
                        MarkerLabel_.prototype.setMandatoryStyles = function () {
                            this.labelDiv_.style.position = "absolute";
                            this.labelDiv_.style.overflow = "hidden";
                            // Make sure the opacity setting causes the desired effect on MSIE:
                            if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
                                this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
                                this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
                            }

                            this.eventDiv_.style.position = this.labelDiv_.style.position;
                            this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
                            this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
                            this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
                            this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE

                            this.setAnchor();
                            this.setPosition(); // This also updates z-index, if necessary.
                            this.setVisible();
                        };

                        /**
                         * Sets the anchor point of the label.
                         * @private
                         */
                        MarkerLabel_.prototype.setAnchor = function () {
                            var anchor = this.marker_.get("labelAnchor");
                            this.labelDiv_.style.marginLeft = -anchor.x + "px";
                            this.labelDiv_.style.marginTop = -anchor.y + "px";
                            this.eventDiv_.style.marginLeft = -anchor.x + "px";
                            this.eventDiv_.style.marginTop = -anchor.y + "px";
                        };

                        /**
                         * Sets the position of the label. The z-index is also updated, if necessary.
                         * @private
                         */
                        MarkerLabel_.prototype.setPosition = function (yOffset) {
                            var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
                            if (typeof yOffset === "undefined") {
                                yOffset = 0;
                            }
                            this.labelDiv_.style.left = Math.round(position.x) + "px";
                            this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
                            this.eventDiv_.style.left = this.labelDiv_.style.left;
                            this.eventDiv_.style.top = this.labelDiv_.style.top;

                            this.setZIndex();
                        };

                        /**
                         * Sets the z-index of the label. If the marker's z-index property has not been defined, the z-index
                         * of the label is set to the vertical coordinate of the label. This is in keeping with the default
                         * stacking order for Google Maps: markers to the south are in front of markers to the north.
                         * @private
                         */
                        MarkerLabel_.prototype.setZIndex = function () {
                            var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
                            if (typeof this.marker_.getZIndex() === "undefined") {
                                this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
                                this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
                            } else {
                                this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
                                this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
                            }
                        };

                        /**
                         * Sets the visibility of the label. The label is visible only if the marker itself is
                         * visible (i.e., its visible property is true) and the labelVisible property is true.
                         * @private
                         */
                        MarkerLabel_.prototype.setVisible = function () {
                            if (this.marker_.get("labelVisible")) {
                                this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
                            } else {
                                this.labelDiv_.style.display = "none";
                            }
                            this.eventDiv_.style.display = this.labelDiv_.style.display;
                        };

                        /**
                         * @name MarkerWithLabelOptions
                         * @class This class represents the optional parameter passed to the {@link MarkerWithLabel} constructor.
                         *  The properties available are the same as for <code>google.maps.Marker</code> with the addition
                         *  of the properties listed below. To change any of these additional properties after the labeled
                         *  marker has been created, call <code>google.maps.Marker.set(propertyName, propertyValue)</code>.
                         *  <p>
                         *  When any of these properties changes, a property changed event is fired. The names of these
                         *  events are derived from the name of the property and are of the form <code>propertyname_changed</code>.
                         *  For example, if the content of the label changes, a <code>labelcontent_changed</code> event
                         *  is fired.
                         *  <p>
                         * @property {string|Node} [labelContent] The content of the label (plain text or an HTML DOM node).
                         * @property {Point} [labelAnchor] By default, a label is drawn with its anchor point at (0,0) so
                         *  that its top left corner is positioned at the anchor point of the associated marker. Use this
                         *  property to change the anchor point of the label. For example, to center a 50px-wide label
                         *  beneath a marker, specify a <code>labelAnchor</code> of <code>google.maps.Point(25, 0)</code>.
                         *  (Note: x-values increase to the right and y-values increase to the top.)
                         * @property {string} [labelClass] The name of the CSS class defining the styles for the label.
                         *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
                         *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
                         *  <code>marginTop</code> are ignored; these styles are for internal use only.
                         * @property {Object} [labelStyle] An object literal whose properties define specific CSS
                         *  style values to be applied to the label. Style values defined here override those that may
                         *  be defined in the <code>labelClass</code> style sheet. If this property is changed after the
                         *  label has been created, all previously set styles (except those defined in the style sheet)
                         *  are removed from the label before the new style values are applied.
                         *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
                         *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
                         *  <code>marginTop</code> are ignored; these styles are for internal use only.
                         * @property {boolean} [labelInBackground] A flag indicating whether a label that overlaps its
                         *  associated marker should appear in the background (i.e., in a plane below the marker).
                         *  The default is <code>false</code>, which causes the label to appear in the foreground.
                         * @property {boolean} [labelVisible] A flag indicating whether the label is to be visible.
                         *  The default is <code>true</code>. Note that even if <code>labelVisible</code> is
                         *  <code>true</code>, the label will <i>not</i> be visible unless the associated marker is also
                         *  visible (i.e., unless the marker's <code>visible</code> property is <code>true</code>).
                         * @property {boolean} [raiseOnDrag] A flag indicating whether the label and marker are to be
                         *  raised when the marker is dragged. The default is <code>true</code>. If a draggable marker is
                         *  being created and a version of Google Maps API earlier than V3.3 is being used, this property
                         *  must be set to <code>false</code>.
                         * @property {boolean} [optimized] A flag indicating whether rendering is to be optimized for the
                         *  marker. <b>Important: The optimized rendering technique is not supported by MarkerWithLabel,
                         *  so the value of this parameter is always forced to <code>false</code>.
                         * @property {string} [crossImage="http://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png"]
                         *  The URL of the cross image to be displayed while dragging a marker.
                         * @property {string} [handCursor="http://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur"]
                         *  The URL of the cursor to be displayed while dragging a marker.
                         */
                        /**
                         * Creates a MarkerWithLabel with the options specified in {@link MarkerWithLabelOptions}.
                         * @constructor
                         * @param {MarkerWithLabelOptions} [opt_options] The optional parameters.
                         */
                        function MarkerWithLabel(opt_options) {
                            opt_options = opt_options || {};
                            opt_options.labelContent = opt_options.labelContent || "";
                            opt_options.labelAnchor = opt_options.labelAnchor || new google.maps.Point(0, 0);
                            opt_options.labelClass = opt_options.labelClass || "markerLabels";
                            opt_options.labelStyle = opt_options.labelStyle || {};
                            opt_options.labelInBackground = opt_options.labelInBackground || false;
                            if (typeof opt_options.labelVisible === "undefined") {
                                opt_options.labelVisible = true;
                            }
                            if (typeof opt_options.raiseOnDrag === "undefined") {
                                opt_options.raiseOnDrag = true;
                            }
                            if (typeof opt_options.clickable === "undefined") {
                                opt_options.clickable = true;
                            }
                            if (typeof opt_options.draggable === "undefined") {
                                opt_options.draggable = false;
                            }
                            if (typeof opt_options.optimized === "undefined") {
                                opt_options.optimized = false;
                            }
                            opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
                            opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
                            opt_options.optimized = false; // Optimized rendering is not supported

                            this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker

                            // Call the parent constructor. It calls Marker.setValues to initialize, so all
                            // the new parameters are conveniently saved and can be accessed with get/set.
                            // Marker.set triggers a property changed event (called "propertyname_changed")
                            // that the marker label listens for in order to react to state changes.
                            google.maps.Marker.apply(this, arguments);
                        }

                        inherits(MarkerWithLabel, google.maps.Marker);

                        /**
                         * Overrides the standard Marker setMap function.
                         * @param {Map} theMap The map to which the marker is to be added.
                         * @private
                         */
                        MarkerWithLabel.prototype.setMap = function (theMap) {

                            // Call the inherited function...
                            google.maps.Marker.prototype.setMap.apply(this, arguments);

                            // ... then deal with the label:
                            this.label.setMap(theMap);
                        };

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3.js
// @output_wrapper (function() {%output%})();
// ==/ClosureCompiler==

                        /**
                         * @license
                         * Copyright 2013 Google Inc. All Rights Reserved.
                         *
                         * Licensed under the Apache License, Version 2.0 (the "License");
                         * you may not use this file except in compliance with the License.
                         * You may obtain a copy of the License at
                         *
                         *     http://www.apache.org/licenses/LICENSE-2.0
                         *
                         * Unless required by applicable law or agreed to in writing, software
                         * distributed under the License is distributed on an "AS IS" BASIS,
                         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                         * See the License for the specific language governing permissions and
                         * limitations under the License.
                         */

                        /**
                         * A RichMarker that allows any HTML/DOM to be added to a map and be draggable.
                         *
                         * @param {Object.<string, *>=} opt_options Optional properties to set.
                         * @extends {google.maps.OverlayView}
                         * @constructor
                         */
                        function RichMarker(opt_options) {
                            var options = opt_options || {};

                            /**
                             * @type {boolean}
                             * @private
                             */
                            this.ready_ = false;

                            /**
                             * @type {boolean}
                             * @private
                             */
                            this.dragging_ = false;

                            if (opt_options['visible'] == undefined) {
                                opt_options['visible'] = true;
                            }

                            if (opt_options['shadow'] == undefined) {
                                opt_options['shadow'] = '7px -3px 5px rgba(88,88,88,0.7)';
                            }

                            if (opt_options['anchor'] == undefined) {
                                opt_options['anchor'] = RichMarkerPosition['BOTTOM'];
                            }

                            this.setValues(options);
                        }
                        RichMarker.prototype = new google.maps.OverlayView();
                        window['RichMarker'] = RichMarker;


                        /**
                         * Returns the current visibility state of the marker.
                         *
                         * @return {boolean} The visiblity of the marker.
                         */
                        RichMarker.prototype.getVisible = function() {
                            return /** @type {boolean} */ (this.get('visible'));
                        };
                        RichMarker.prototype['getVisible'] = RichMarker.prototype.getVisible;


                        /**
                         * Sets the visiblility state of the marker.
                         *
                         * @param {boolean} visible The visiblilty of the marker.
                         */
                        RichMarker.prototype.setVisible = function(visible) {
                            this.set('visible', visible);
                        };
                        RichMarker.prototype['setVisible'] = RichMarker.prototype.setVisible;


                        /**
                         *  The visible changed event.
                         */
                        RichMarker.prototype.visible_changed = function() {
                            if (this.ready_) {
                                this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
                                this.draw();
                            }
                        };
                        RichMarker.prototype['visible_changed'] = RichMarker.prototype.visible_changed;


                        /**
                         * Sets the marker to be flat.
                         *
                         * @param {boolean} flat If the marker is to be flat or not.
                         */
                        RichMarker.prototype.setFlat = function(flat) {
                            this.set('flat', !!flat);
                        };
                        RichMarker.prototype['setFlat'] = RichMarker.prototype.setFlat;


                        /**
                         * If the makrer is flat or not.
                         *
                         * @return {boolean} True the marker is flat.
                         */
                        RichMarker.prototype.getFlat = function() {
                            return /** @type {boolean} */ (this.get('flat'));
                        };
                        RichMarker.prototype['getFlat'] = RichMarker.prototype.getFlat;


                        /**
                         * Get the width of the marker.
                         *
                         * @return {Number} The width of the marker.
                         */
                        RichMarker.prototype.getWidth = function() {
                            return /** @type {Number} */ (this.get('width'));
                        };
                        RichMarker.prototype['getWidth'] = RichMarker.prototype.getWidth;


                        /**
                         * Get the height of the marker.
                         *
                         * @return {Number} The height of the marker.
                         */
                        RichMarker.prototype.getHeight = function() {
                            return /** @type {Number} */ (this.get('height'));
                        };
                        RichMarker.prototype['getHeight'] = RichMarker.prototype.getHeight;


                        /**
                         * Sets the marker's box shadow.
                         *
                         * @param {string} shadow The box shadow to set.
                         */
                        RichMarker.prototype.setShadow = function(shadow) {
                            this.set('shadow', shadow);
                            this.flat_changed();
                        };
                        RichMarker.prototype['setShadow'] = RichMarker.prototype.setShadow;


                        /**
                         * Gets the marker's box shadow.
                         *
                         * @return {string} The box shadow.
                         */
                        RichMarker.prototype.getShadow = function() {
                            return /** @type {string} */ (this.get('shadow'));
                        };
                        RichMarker.prototype['getShadow'] = RichMarker.prototype.getShadow;


                        /**
                         * Flat changed event.
                         */
                        RichMarker.prototype.flat_changed = function() {
                            if (!this.ready_) {
                                return;
                            }

                            this.markerWrapper_.style['boxShadow'] =
                                this.markerWrapper_.style['webkitBoxShadow'] =
                                    this.markerWrapper_.style['MozBoxShadow'] =
                                        this.getFlat() ? '' : this.getShadow();
                        };
                        RichMarker.prototype['flat_changed'] = RichMarker.prototype.flat_changed;


                        /**
                         * Sets the zIndex of the marker.
                         *
                         * @param {Number} index The index to set.
                         */
                        RichMarker.prototype.setZIndex = function(index) {
                            this.set('zIndex', index);
                        };
                        RichMarker.prototype['setZIndex'] = RichMarker.prototype.setZIndex;


                        /**
                         * Gets the zIndex of the marker.
                         *
                         * @return {Number} The zIndex of the marker.
                         */
                        RichMarker.prototype.getZIndex = function() {
                            return /** @type {Number} */ (this.get('zIndex'));
                        };
                        RichMarker.prototype['getZIndex'] = RichMarker.prototype.getZIndex;


                        /**
                         * zIndex changed event.
                         */
                        RichMarker.prototype.zIndex_changed = function() {
                            if (this.getZIndex() && this.ready_) {
                                this.markerWrapper_.style.zIndex = this.getZIndex();
                            }
                        };
                        RichMarker.prototype['zIndex_changed'] = RichMarker.prototype.zIndex_changed;

                        /**
                         * Whether the marker is draggable or not.
                         *
                         * @return {boolean} True if the marker is draggable.
                         */
                        RichMarker.prototype.getDraggable = function() {
                            return /** @type {boolean} */ (this.get('draggable'));
                        };
                        RichMarker.prototype['getDraggable'] = RichMarker.prototype.getDraggable;


                        /**
                         * Sets the marker to be draggable or not.
                         *
                         * @param {boolean} draggable If the marker is draggable or not.
                         */
                        RichMarker.prototype.setDraggable = function(draggable) {
                            this.set('draggable', !!draggable);
                        };
                        RichMarker.prototype['setDraggable'] = RichMarker.prototype.setDraggable;


                        /**
                         * Draggable property changed callback.
                         */
                        RichMarker.prototype.draggable_changed = function() {
                            if (this.ready_) {
                                if (this.getDraggable()) {
                                    this.addDragging_(this.markerWrapper_);
                                } else {
                                    this.removeDragListeners_();
                                }
                            }
                        };
                        RichMarker.prototype['draggable_changed'] =
                            RichMarker.prototype.draggable_changed;


                        /**
                         * Gets the postiton of the marker.
                         *
                         * @return {google.maps.LatLng} The position of the marker.
                         */
                        RichMarker.prototype.getPosition = function() {
                            return /** @type {google.maps.LatLng} */ (this.get('position'));
                        };
                        RichMarker.prototype['getPosition'] = RichMarker.prototype.getPosition;


                        /**
                         * Sets the position of the marker.
                         *
                         * @param {google.maps.LatLng} position The position to set.
                         */
                        RichMarker.prototype.setPosition = function(position) {
                            this.set('position', position);
                        };
                        RichMarker.prototype['setPosition'] = RichMarker.prototype.setPosition;


                        /**
                         * Position changed event.
                         */
                        RichMarker.prototype.position_changed = function() {
                            this.draw();
                        };
                        RichMarker.prototype['position_changed'] =
                            RichMarker.prototype.position_changed;


                        /**
                         * Gets the anchor.
                         *
                         * @return {google.maps.Size} The position of the anchor.
                         */
                        RichMarker.prototype.getAnchor = function() {
                            return /** @type {google.maps.Size} */ (this.get('anchor'));
                        };
                        RichMarker.prototype['getAnchor'] = RichMarker.prototype.getAnchor;


                        /**
                         * Sets the anchor.
                         *
                         * @param {RichMarkerPosition|google.maps.Size} anchor The anchor to set.
                         */
                        RichMarker.prototype.setAnchor = function(anchor) {
                            this.set('anchor', anchor);
                        };
                        RichMarker.prototype['setAnchor'] = RichMarker.prototype.setAnchor;


                        /**
                         * Anchor changed event.
                         */
                        RichMarker.prototype.anchor_changed = function() {
                            this.draw();
                        };
                        RichMarker.prototype['anchor_changed'] = RichMarker.prototype.anchor_changed;


                        /**
                         * Converts a HTML string to a document fragment.
                         *
                         * @param {string} htmlString The HTML string to convert.
                         * @return {Node} A HTML document fragment.
                         * @private
                         */
                        RichMarker.prototype.htmlToDocumentFragment_ = function(htmlString) {
                            var tempDiv = document.createElement('DIV');
                            tempDiv.innerHTML = htmlString;
                            if (tempDiv.childNodes.length == 1) {
                                return /** @type {!Node} */ (tempDiv.removeChild(tempDiv.firstChild));
                            } else {
                                var fragment = document.createDocumentFragment();
                                while (tempDiv.firstChild) {
                                    fragment.appendChild(tempDiv.firstChild);
                                }
                                return fragment;
                            }
                        };


                        /**
                         * Removes all children from the node.
                         *
                         * @param {Node} node The node to remove all children from.
                         * @private
                         */
                        RichMarker.prototype.removeChildren_ = function(node) {
                            if (!node) {
                                return;
                            }

                            var child;
                            while (child = node.firstChild) {
                                node.removeChild(child);
                            }
                        };


                        /**
                         * Sets the content of the marker.
                         *
                         * @param {string|Node} content The content to set.
                         */
                        RichMarker.prototype.setContent = function(content) {
                            this.set('content', content);
                        };
                        RichMarker.prototype['setContent'] = RichMarker.prototype.setContent;


                        /**
                         * Get the content of the marker.
                         *
                         * @return {string|Node} The marker content.
                         */
                        RichMarker.prototype.getContent = function() {
                            return /** @type {Node|string} */ (this.get('content'));
                        };
                        RichMarker.prototype['getContent'] = RichMarker.prototype.getContent;


                        /**
                         * Sets the marker content and adds loading events to images
                         */
                        RichMarker.prototype.content_changed = function() {
                            if (!this.markerContent_) {
                                // Marker content area doesnt exist.
                                return;
                            }

                            this.removeChildren_(this.markerContent_);
                            var content = this.getContent();
                            if (content) {
                                if (typeof content == 'string') {
                                    content = content.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
                                    content = this.htmlToDocumentFragment_(content);
                                }
                                this.markerContent_.appendChild(content);

                                var that = this;
                                var images = this.markerContent_.getElementsByTagName('IMG');
                                for (var i = 0, image; image = images[i]; i++) {
                                    // By default, a browser lets a image be dragged outside of the browser,
                                    // so by calling preventDefault we stop this behaviour and allow the image
                                    // to be dragged around the map and now out of the browser and onto the
                                    // desktop.
                                    google.maps.event.addDomListener(image, 'mousedown', function(e) {
                                        if (that.getDraggable()) {
                                            if (e.preventDefault) {
                                                e.preventDefault();
                                            }
                                            e.returnValue = false;
                                        }
                                    });

                                    // Because we don't know the size of an image till it loads, add a
                                    // listener to the image load so the marker can resize and reposition
                                    // itself to be the correct height.
                                    google.maps.event.addDomListener(image, 'load', function() {
                                        that.draw();
                                    });
                                }

                                google.maps.event.trigger(this, 'domready');
                            }

                            if (this.ready_) {
                                this.draw();
                            }
                        };
                        RichMarker.prototype['content_changed'] = RichMarker.prototype.content_changed;

                        /**
                         * Sets the cursor.
                         *
                         * @param {string} whichCursor What cursor to show.
                         * @private
                         */
                        RichMarker.prototype.setCursor_ = function(whichCursor) {
                            if (!this.ready_) {
                                return;
                            }

                            var cursor = '';
                            if (navigator.userAgent.indexOf('Gecko/') !== -1) {
                                // Moz has some nice cursors :)
                                if (whichCursor == 'dragging') {
                                    cursor = '-moz-grabbing';
                                }

                                if (whichCursor == 'dragready') {
                                    cursor = '-moz-grab';
                                }

                                if (whichCursor == 'draggable') {
                                    cursor = 'pointer';
                                }
                            } else {
                                if (whichCursor == 'dragging' || whichCursor == 'dragready') {
                                    cursor = 'move';
                                }

                                if (whichCursor == 'draggable') {
                                    cursor = 'pointer';
                                }
                            }

                            if (this.markerWrapper_.style.cursor != cursor) {
                                this.markerWrapper_.style.cursor = cursor;
                            }
                        };

                        /**
                         * Start dragging.
                         *
                         * @param {Event} e The event.
                         */
                        RichMarker.prototype.startDrag = function(e) {
                            if (!this.getDraggable()) {
                                return;
                            }

                            if (!this.dragging_) {
                                this.dragging_ = true;
                                var map = this.getMap();
                                this.mapDraggable_ = map.get('draggable');
                                map.set('draggable', false);

                                // Store the current mouse position
                                this.mouseX_ = e.clientX;
                                this.mouseY_ = e.clientY;

                                this.setCursor_('dragready');

                                // Stop the text from being selectable while being dragged
                                this.markerWrapper_.style['MozUserSelect'] = 'none';
                                this.markerWrapper_.style['KhtmlUserSelect'] = 'none';
                                this.markerWrapper_.style['WebkitUserSelect'] = 'none';

                                this.markerWrapper_['unselectable'] = 'on';
                                this.markerWrapper_['onselectstart'] = function() {
                                    return false;
                                };

                                this.addDraggingListeners_();

                                google.maps.event.trigger(this, 'dragstart');
                            }
                        };


                        /**
                         * Stop dragging.
                         */
                        RichMarker.prototype.stopDrag = function() {
                            if (!this.getDraggable()) {
                                return;
                            }

                            if (this.dragging_) {
                                this.dragging_ = false;
                                this.getMap().set('draggable', this.mapDraggable_);
                                this.mouseX_ = this.mouseY_ = this.mapDraggable_ = null;

                                // Allow the text to be selectable again
                                this.markerWrapper_.style['MozUserSelect'] = '';
                                this.markerWrapper_.style['KhtmlUserSelect'] = '';
                                this.markerWrapper_.style['WebkitUserSelect'] = '';
                                this.markerWrapper_['unselectable'] = 'off';
                                this.markerWrapper_['onselectstart'] = function() {};

                                this.removeDraggingListeners_();

                                this.setCursor_('draggable');
                                google.maps.event.trigger(this, 'dragend');

                                this.draw();
                            }
                        };


                        /**
                         * Handles the drag event.
                         *
                         * @param {Event} e The event.
                         */
                        RichMarker.prototype.drag = function(e) {
                            if (!this.getDraggable() || !this.dragging_) {
                                // This object isn't draggable or we have stopped dragging
                                this.stopDrag();
                                return;
                            }

                            var dx = this.mouseX_ - e.clientX;
                            var dy = this.mouseY_ - e.clientY;

                            this.mouseX_ = e.clientX;
                            this.mouseY_ = e.clientY;

                            var left = parseInt(this.markerWrapper_.style['left'], 10) - dx;
                            var top = parseInt(this.markerWrapper_.style['top'], 10) - dy;

                            this.markerWrapper_.style['left'] = left + 'px';
                            this.markerWrapper_.style['top'] = top + 'px';

                            var offset = this.getOffset_();

                            // Set the position property and adjust for the anchor offset
                            var point = new google.maps.Point(left - offset.width, top - offset.height);
                            var projection = this.getProjection();
                            this.setPosition(projection.fromDivPixelToLatLng(point));

                            this.setCursor_('dragging');
                            google.maps.event.trigger(this, 'drag');
                        };


                        /**
                         * Removes the drag listeners associated with the marker.
                         *
                         * @private
                         */
                        RichMarker.prototype.removeDragListeners_ = function() {
                            if (this.draggableListener_) {
                                google.maps.event.removeListener(this.draggableListener_);
                                delete this.draggableListener_;
                            }
                            this.setCursor_('');
                        };


                        /**
                         * Add dragability events to the marker.
                         *
                         * @param {Node} node The node to apply dragging to.
                         * @private
                         */
                        RichMarker.prototype.addDragging_ = function(node) {
                            if (!node) {
                                return;
                            }

                            var that = this;
                            this.draggableListener_ =
                                google.maps.event.addDomListener(node, 'mousedown', function(e) {
                                    that.startDrag(e);
                                });

                            this.setCursor_('draggable');
                        };


                        /**
                         * Add dragging listeners.
                         *
                         * @private
                         */
                        RichMarker.prototype.addDraggingListeners_ = function() {
                            var that = this;
                            if (this.markerWrapper_.setCapture) {
                                this.markerWrapper_.setCapture(true);
                                this.draggingListeners_ = [
                                    google.maps.event.addDomListener(this.markerWrapper_, 'mousemove', function(e) {
                                        that.drag(e);
                                    }, true),
                                    google.maps.event.addDomListener(this.markerWrapper_, 'mouseup', function() {
                                        that.stopDrag();
                                        that.markerWrapper_.releaseCapture();
                                    }, true)
                                ];
                            } else {
                                this.draggingListeners_ = [
                                    google.maps.event.addDomListener(window, 'mousemove', function(e) {
                                        that.drag(e);
                                    }, true),
                                    google.maps.event.addDomListener(window, 'mouseup', function() {
                                        that.stopDrag();
                                    }, true)
                                ];
                            }
                        };


                        /**
                         * Remove dragging listeners.
                         *
                         * @private
                         */
                        RichMarker.prototype.removeDraggingListeners_ = function() {
                            if (this.draggingListeners_) {
                                for (var i = 0, listener; listener = this.draggingListeners_[i]; i++) {
                                    google.maps.event.removeListener(listener);
                                }
                                this.draggingListeners_.length = 0;
                            }
                        };


                        /**
                         * Get the anchor offset.
                         *
                         * @return {google.maps.Size} The size offset.
                         * @private
                         */
                        RichMarker.prototype.getOffset_ = function() {
                            var anchor = this.getAnchor();
                            if (typeof anchor == 'object') {
                                return /** @type {google.maps.Size} */ (anchor);
                            }

                            var offset = new google.maps.Size(0, 0);
                            if (!this.markerContent_) {
                                return offset;
                            }

                            var width = this.markerContent_.offsetWidth;
                            var height = this.markerContent_.offsetHeight;

                            switch (anchor) {
                                case RichMarkerPosition['TOP_LEFT']:
                                    break;
                                case RichMarkerPosition['TOP']:
                                    offset.width = -width / 2;
                                    break;
                                case RichMarkerPosition['TOP_RIGHT']:
                                    offset.width = -width;
                                    break;
                                case RichMarkerPosition['LEFT']:
                                    offset.height = -height / 2;
                                    break;
                                case RichMarkerPosition['MIDDLE']:
                                    offset.width = -width / 2;
                                    offset.height = -height / 2;
                                    break;
                                case RichMarkerPosition['RIGHT']:
                                    offset.width = -width;
                                    offset.height = -height / 2;
                                    break;
                                case RichMarkerPosition['BOTTOM_LEFT']:
                                    offset.height = -height;
                                    break;
                                case RichMarkerPosition['BOTTOM']:
                                    offset.width = -width / 2;
                                    offset.height = -height;
                                    break;
                                case RichMarkerPosition['BOTTOM_RIGHT']:
                                    offset.width = -width;
                                    offset.height = -height;
                                    break;
                            }

                            return offset;
                        };


                        /**
                         * Adding the marker to a map.
                         * Implementing the interface.
                         */
                        RichMarker.prototype.onAdd = function() {
                            if (!this.markerWrapper_) {
                                this.markerWrapper_ = document.createElement('DIV');
                                this.markerWrapper_.style['position'] = 'absolute';
                            }

                            if (this.getZIndex()) {
                                this.markerWrapper_.style['zIndex'] = this.getZIndex();
                            }

                            this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';

                            if (!this.markerContent_) {
                                this.markerContent_ = document.createElement('DIV');
                                this.markerWrapper_.appendChild(this.markerContent_);

                                var that = this;
                                google.maps.event.addDomListener(this.markerContent_, 'click', function(e) {
                                    google.maps.event.trigger(that, 'click');
                                });
                                google.maps.event.addDomListener(this.markerContent_, 'mouseover', function(e) {
                                    google.maps.event.trigger(that, 'mouseover');
                                });
                                google.maps.event.addDomListener(this.markerContent_, 'mouseout', function(e) {
                                    google.maps.event.trigger(that, 'mouseout');
                                });
                            }

                            this.ready_ = true;
                            this.content_changed();
                            this.flat_changed();
                            this.draggable_changed();

                            var panes = this.getPanes();
                            if (panes) {
                                panes.overlayMouseTarget.appendChild(this.markerWrapper_);
                            }

                            google.maps.event.trigger(this, 'ready');
                        };
                        RichMarker.prototype['onAdd'] = RichMarker.prototype.onAdd;


                        /**
                         * Impelementing the interface.
                         */
                        RichMarker.prototype.draw = function() {
                            if (!this.ready_ || this.dragging_) {
                                return;
                            }

                            var projection = this.getProjection();

                            if (!projection) {
                                // The map projection is not ready yet so do nothing
                                return;
                            }

                            var latLng = /** @type {google.maps.LatLng} */ (this.get('position'));
                            var pos = projection.fromLatLngToDivPixel(latLng);

                            var offset = this.getOffset_();
                            this.markerWrapper_.style['top'] = (pos.y + offset.height) + 'px';
                            this.markerWrapper_.style['left'] = (pos.x + offset.width) + 'px';

                            var height = this.markerContent_.offsetHeight;
                            var width = this.markerContent_.offsetWidth;

                            if (width != this.get('width')) {
                                this.set('width', width);
                            }

                            if (height != this.get('height')) {
                                this.set('height', height);
                            }
                        };
                        RichMarker.prototype['draw'] = RichMarker.prototype.draw;


                        /**
                         * Removing a marker from the map.
                         * Implementing the interface.
                         */
                        RichMarker.prototype.onRemove = function() {
                            if (this.markerWrapper_ && this.markerWrapper_.parentNode) {
                                this.markerWrapper_.parentNode.removeChild(this.markerWrapper_);
                            }
                            this.removeDragListeners_();
                        };
                        RichMarker.prototype['onRemove'] = RichMarker.prototype.onRemove;


                        /**
                         * RichMarker Anchor positions
                         * @enum {number}
                         */
                        var RichMarkerPosition = {
                            'TOP_LEFT': 1,
                            'TOP': 2,
                            'TOP_RIGHT': 3,
                            'LEFT': 4,
                            'MIDDLE': 5,
                            'RIGHT': 6,
                            'BOTTOM_LEFT': 7,
                            'BOTTOM': 8,
                            'BOTTOM_RIGHT': 9
                        };
                        window['RichMarkerPosition'] = RichMarkerPosition;


                        //TODO: export / passthese on in the service instead of window
                        window.InfoBox = InfoBox;
                        window.Cluster = Cluster;
                        window.ClusterIcon = ClusterIcon;
                        window.MarkerClusterer = MarkerClusterer;
                        window.MarkerLabel_ = MarkerLabel_;
                        window.MarkerWithLabel = MarkerWithLabel;
                        window.RichMarker = RichMarker;
                    }();
                    //END REPLACE
                })
            };
        });
    ;/******/ (function(modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};

        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {

            /******/ 		// Check if module is in cache
            /******/ 		if(installedModules[moduleId])
            /******/ 			return installedModules[moduleId].exports;

            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			exports: {},
                /******/ 			id: moduleId,
                /******/ 			loaded: false
                /******/ 		};

            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

            /******/ 		// Flag the module as loaded
            /******/ 		module.loaded = true;

            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/ 	}


        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;

        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;

        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";

        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(0);
        /******/ })
    /************************************************************************/
    /******/ ([
        /* 0 */
        /***/ function(module, exports, __webpack_require__) {

            /* istanbul ignore next */
            angular.module('uiGmapgoogle-maps.wrapped')
                .service('uiGmapDataStructures', function() {
                    return {
                        Graph: __webpack_require__(1).Graph,
                        Queue: __webpack_require__(1).Queue
                    };
                });


            /***/ },
        /* 1 */
        /***/ function(module, exports, __webpack_require__) {

            (function() {
                module.exports = {
                    Graph: __webpack_require__(2),
                    Heap: __webpack_require__(3),
                    LinkedList: __webpack_require__(4),
                    Map: __webpack_require__(5),
                    Queue: __webpack_require__(6),
                    RedBlackTree: __webpack_require__(7),
                    Trie: __webpack_require__(8)
                };

            }).call(this);


            /***/ },
        /* 2 */
        /***/ function(module, exports) {

            /*
             Graph implemented as a modified incidence list. O(1) for every typical
             operation except `removeNode()` at O(E) where E is the number of edges.

             ## Overview example:

             ```js
             var graph = new Graph;
             graph.addNode('A'); // => a node object. For more info, log the output or check
             // the documentation for addNode
             graph.addNode('B');
             graph.addNode('C');
             graph.addEdge('A', 'C'); // => an edge object
             graph.addEdge('A', 'B');
             graph.getEdge('B', 'A'); // => undefined. Directed edge!
             graph.getEdge('A', 'B'); // => the edge object previously added
             graph.getEdge('A', 'B').weight = 2 // weight is the only built-in handy property
             // of an edge object. Feel free to attach
             // other properties
             graph.getInEdgesOf('B'); // => array of edge objects, in this case only one;
             // connecting A to B
             graph.getOutEdgesOf('A'); // => array of edge objects, one to B and one to C
             graph.getAllEdgesOf('A'); // => all the in and out edges. Edge directed toward
             // the node itself are only counted once
             forEachNode(function(nodeObject) {
             console.log(node);
             });
             forEachEdge(function(edgeObject) {
             console.log(edgeObject);
             });
             graph.removeNode('C'); // => 'C'. The edge between A and C also removed
             graph.removeEdge('A', 'B'); // => the edge object removed
             ```

             ## Properties:

             - nodeSize: total number of nodes.
             - edgeSize: total number of edges.
             */


            (function() {
                var Graph,
                    __hasProp = {}.hasOwnProperty;

                Graph = (function() {
                    function Graph() {
                        this._nodes = {};
                        this.nodeSize = 0;
                        this.edgeSize = 0;
                    }

                    Graph.prototype.addNode = function(id) {
                        /*
                         The `id` is a unique identifier for the node, and should **not** change
                         after it's added. It will be used for adding, retrieving and deleting
                         related edges too.

                         **Note** that, internally, the ids are kept in an object. JavaScript's
                         object hashes the id `'2'` and `2` to the same key, so please stick to a
                         simple id data type such as number or string.

                         _Returns:_ the node object. Feel free to attach additional custom properties
                         on it for graph algorithms' needs. **Undefined if node id already exists**,
                         as to avoid accidental overrides.
                         */

                        if (!this._nodes[id]) {
                            this.nodeSize++;
                            return this._nodes[id] = {
                                _outEdges: {},
                                _inEdges: {}
                            };
                        }
                    };

                    Graph.prototype.getNode = function(id) {
                        /*
                         _Returns:_ the node object. Feel free to attach additional custom properties
                         on it for graph algorithms' needs.
                         */

                        return this._nodes[id];
                    };

                    Graph.prototype.removeNode = function(id) {
                        /*
                         _Returns:_ the node object removed, or undefined if it didn't exist in the
                         first place.
                         */

                        var inEdgeId, nodeToRemove, outEdgeId, _ref, _ref1;
                        nodeToRemove = this._nodes[id];
                        if (!nodeToRemove) {
                            return;
                        } else {
                            _ref = nodeToRemove._outEdges;
                            for (outEdgeId in _ref) {
                                if (!__hasProp.call(_ref, outEdgeId)) continue;
                                this.removeEdge(id, outEdgeId);
                            }
                            _ref1 = nodeToRemove._inEdges;
                            for (inEdgeId in _ref1) {
                                if (!__hasProp.call(_ref1, inEdgeId)) continue;
                                this.removeEdge(inEdgeId, id);
                            }
                            this.nodeSize--;
                            delete this._nodes[id];
                        }
                        return nodeToRemove;
                    };

                    Graph.prototype.addEdge = function(fromId, toId, weight) {
                        var edgeToAdd, fromNode, toNode;
                        if (weight == null) {
                            weight = 1;
                        }
                        /*
                         `fromId` and `toId` are the node id specified when it was created using
                         `addNode()`. `weight` is optional and defaults to 1. Ignoring it effectively
                         makes this an unweighted graph. Under the hood, `weight` is just a normal
                         property of the edge object.

                         _Returns:_ the edge object created. Feel free to attach additional custom
                         properties on it for graph algorithms' needs. **Or undefined** if the nodes
                         of id `fromId` or `toId` aren't found, or if an edge already exists between
                         the two nodes.
                         */

                        if (this.getEdge(fromId, toId)) {
                            return;
                        }
                        fromNode = this._nodes[fromId];
                        toNode = this._nodes[toId];
                        if (!fromNode || !toNode) {
                            return;
                        }
                        edgeToAdd = {
                            weight: weight
                        };
                        fromNode._outEdges[toId] = edgeToAdd;
                        toNode._inEdges[fromId] = edgeToAdd;
                        this.edgeSize++;
                        return edgeToAdd;
                    };

                    Graph.prototype.getEdge = function(fromId, toId) {
                        /*
                         _Returns:_ the edge object, or undefined if the nodes of id `fromId` or
                         `toId` aren't found.
                         */

                        var fromNode, toNode;
                        fromNode = this._nodes[fromId];
                        toNode = this._nodes[toId];
                        if (!fromNode || !toNode) {

                        } else {
                            return fromNode._outEdges[toId];
                        }
                    };

                    Graph.prototype.removeEdge = function(fromId, toId) {
                        /*
                         _Returns:_ the edge object removed, or undefined of edge wasn't found.
                         */

                        var edgeToDelete, fromNode, toNode;
                        fromNode = this._nodes[fromId];
                        toNode = this._nodes[toId];
                        edgeToDelete = this.getEdge(fromId, toId);
                        if (!edgeToDelete) {
                            return;
                        }
                        delete fromNode._outEdges[toId];
                        delete toNode._inEdges[fromId];
                        this.edgeSize--;
                        return edgeToDelete;
                    };

                    Graph.prototype.getInEdgesOf = function(nodeId) {
                        /*
                         _Returns:_ an array of edge objects that are directed toward the node, or
                         empty array if no such edge or node exists.
                         */

                        var fromId, inEdges, toNode, _ref;
                        toNode = this._nodes[nodeId];
                        inEdges = [];
                        _ref = toNode != null ? toNode._inEdges : void 0;
                        for (fromId in _ref) {
                            if (!__hasProp.call(_ref, fromId)) continue;
                            inEdges.push(this.getEdge(fromId, nodeId));
                        }
                        return inEdges;
                    };

                    Graph.prototype.getOutEdgesOf = function(nodeId) {
                        /*
                         _Returns:_ an array of edge objects that go out of the node, or empty array
                         if no such edge or node exists.
                         */

                        var fromNode, outEdges, toId, _ref;
                        fromNode = this._nodes[nodeId];
                        outEdges = [];
                        _ref = fromNode != null ? fromNode._outEdges : void 0;
                        for (toId in _ref) {
                            if (!__hasProp.call(_ref, toId)) continue;
                            outEdges.push(this.getEdge(nodeId, toId));
                        }
                        return outEdges;
                    };

                    Graph.prototype.getAllEdgesOf = function(nodeId) {
                        /*
                         **Note:** not the same as concatenating `getInEdgesOf()` and
                         `getOutEdgesOf()`. Some nodes might have an edge pointing toward itself.
                         This method solves that duplication.

                         _Returns:_ an array of edge objects linked to the node, no matter if they're
                         outgoing or coming. Duplicate edge created by self-pointing nodes are
                         removed. Only one copy stays. Empty array if node has no edge.
                         */

                        var i, inEdges, outEdges, selfEdge, _i, _ref, _ref1;
                        inEdges = this.getInEdgesOf(nodeId);
                        outEdges = this.getOutEdgesOf(nodeId);
                        if (inEdges.length === 0) {
                            return outEdges;
                        }
                        selfEdge = this.getEdge(nodeId, nodeId);
                        for (i = _i = 0, _ref = inEdges.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
                            if (inEdges[i] === selfEdge) {
                                _ref1 = [inEdges[inEdges.length - 1], inEdges[i]], inEdges[i] = _ref1[0], inEdges[inEdges.length - 1] = _ref1[1];
                                inEdges.pop();
                                break;
                            }
                        }
                        return inEdges.concat(outEdges);
                    };

                    Graph.prototype.forEachNode = function(operation) {
                        /*
                         Traverse through the graph in an arbitrary manner, visiting each node once.
                         Pass a function of the form `fn(nodeObject, nodeId)`.

                         _Returns:_ undefined.
                         */

                        var nodeId, nodeObject, _ref;
                        _ref = this._nodes;
                        for (nodeId in _ref) {
                            if (!__hasProp.call(_ref, nodeId)) continue;
                            nodeObject = _ref[nodeId];
                            operation(nodeObject, nodeId);
                        }
                    };

                    Graph.prototype.forEachEdge = function(operation) {
                        /*
                         Traverse through the graph in an arbitrary manner, visiting each edge once.
                         Pass a function of the form `fn(edgeObject)`.

                         _Returns:_ undefined.
                         */

                        var edgeObject, nodeId, nodeObject, toId, _ref, _ref1;
                        _ref = this._nodes;
                        for (nodeId in _ref) {
                            if (!__hasProp.call(_ref, nodeId)) continue;
                            nodeObject = _ref[nodeId];
                            _ref1 = nodeObject._outEdges;
                            for (toId in _ref1) {
                                if (!__hasProp.call(_ref1, toId)) continue;
                                edgeObject = _ref1[toId];
                                operation(edgeObject);
                            }
                        }
                    };

                    return Graph;

                })();

                module.exports = Graph;

            }).call(this);


            /***/ },
        /* 3 */
        /***/ function(module, exports) {

            /*
             Minimum heap, i.e. smallest node at root.

             **Note:** does not accept null or undefined. This is by design. Those values
             cause comparison problems and might report false negative during extraction.

             ## Overview example:

             ```js
             var heap = new Heap([5, 6, 3, 4]);
             heap.add(10); // => 10
             heap.removeMin(); // => 3
             heap.peekMin(); // => 4
             ```

             ## Properties:

             - size: total number of items.
             */


            (function() {
                var Heap, _leftChild, _parent, _rightChild;

                Heap = (function() {
                    function Heap(dataToHeapify) {
                        var i, item, _i, _j, _len, _ref;
                        if (dataToHeapify == null) {
                            dataToHeapify = [];
                        }
                        /*
                         Pass an optional array to be heapified. Takes only O(n) time.
                         */

                        this._data = [void 0];
                        for (_i = 0, _len = dataToHeapify.length; _i < _len; _i++) {
                            item = dataToHeapify[_i];
                            if (item != null) {
                                this._data.push(item);
                            }
                        }
                        if (this._data.length > 1) {
                            for (i = _j = 2, _ref = this._data.length; 2 <= _ref ? _j < _ref : _j > _ref; i = 2 <= _ref ? ++_j : --_j) {
                                this._upHeap(i);
                            }
                        }
                        this.size = this._data.length - 1;
                    }

                    Heap.prototype.add = function(value) {
                        /*
                         **Remember:** rejects null and undefined for mentioned reasons.

                         _Returns:_ the value added.
                         */

                        if (value == null) {
                            return;
                        }
                        this._data.push(value);
                        this._upHeap(this._data.length - 1);
                        this.size++;
                        return value;
                    };

                    Heap.prototype.removeMin = function() {
                        /*
                         _Returns:_ the smallest item (the root).
                         */

                        var min;
                        if (this._data.length === 1) {
                            return;
                        }
                        this.size--;
                        if (this._data.length === 2) {
                            return this._data.pop();
                        }
                        min = this._data[1];
                        this._data[1] = this._data.pop();
                        this._downHeap();
                        return min;
                    };

                    Heap.prototype.peekMin = function() {
                        /*
                         Check the smallest item without removing it.

                         _Returns:_ the smallest item (the root).
                         */

                        return this._data[1];
                    };

                    Heap.prototype._upHeap = function(index) {
                        var valueHolder, _ref;
                        valueHolder = this._data[index];
                        while (this._data[index] < this._data[_parent(index)] && index > 1) {
                            _ref = [this._data[_parent(index)], this._data[index]], this._data[index] = _ref[0], this._data[_parent(index)] = _ref[1];
                            index = _parent(index);
                        }
                    };

                    Heap.prototype._downHeap = function() {
                        var currentIndex, smallerChildIndex, _ref;
                        currentIndex = 1;
                        while (_leftChild(currentIndex < this._data.length)) {
                            smallerChildIndex = _leftChild(currentIndex);
                            if (smallerChildIndex < this._data.length - 1) {
                                if (this._data[_rightChild(currentIndex)] < this._data[smallerChildIndex]) {
                                    smallerChildIndex = _rightChild(currentIndex);
                                }
                            }
                            if (this._data[smallerChildIndex] < this._data[currentIndex]) {
                                _ref = [this._data[currentIndex], this._data[smallerChildIndex]], this._data[smallerChildIndex] = _ref[0], this._data[currentIndex] = _ref[1];
                                currentIndex = smallerChildIndex;
                            } else {
                                break;
                            }
                        }
                    };

                    return Heap;

                })();

                _parent = function(index) {
                    return index >> 1;
                };

                _leftChild = function(index) {
                    return index << 1;
                };

                _rightChild = function(index) {
                    return (index << 1) + 1;
                };

                module.exports = Heap;

            }).call(this);


            /***/ },
        /* 4 */
        /***/ function(module, exports) {

            /*
             Doubly Linked.

             ## Overview example:

             ```js
             var list = new LinkedList([5, 4, 9]);
             list.add(12); // => 12
             list.head.next.value; // => 4
             list.tail.value; // => 12
             list.at(-1); // => 12
             list.removeAt(2); // => 9
             list.remove(4); // => 4
             list.indexOf(5); // => 0
             list.add(5, 1); // => 5. Second 5 at position 1.
             list.indexOf(5, 1); // => 1
             ```

             ## Properties:

             - head: first item.
             - tail: last item.
             - size: total number of items.
             - item.value: value passed to the item when calling `add()`.
             - item.prev: previous item.
             - item.next: next item.
             */


            (function() {
                var LinkedList;

                LinkedList = (function() {
                    function LinkedList(valuesToAdd) {
                        var value, _i, _len;
                        if (valuesToAdd == null) {
                            valuesToAdd = [];
                        }
                        /*
                         Can pass an array of elements to link together during `new LinkedList()`
                         initiation.
                         */

                        this.head = {
                            prev: void 0,
                            value: void 0,
                            next: void 0
                        };
                        this.tail = {
                            prev: void 0,
                            value: void 0,
                            next: void 0
                        };
                        this.size = 0;
                        for (_i = 0, _len = valuesToAdd.length; _i < _len; _i++) {
                            value = valuesToAdd[_i];
                            this.add(value);
                        }
                    }

                    LinkedList.prototype.at = function(position) {
                        /*
                         Get the item at `position` (optional). Accepts negative index:

                         ```js
                         myList.at(-1); // Returns the last element.
                         ```
                         However, passing a negative index that surpasses the boundary will return
                         undefined:

                         ```js
                         myList = new LinkedList([2, 6, 8, 3])
                         myList.at(-5); // Undefined.
                         myList.at(-4); // 2.
                         ```
                         _Returns:_ item gotten, or undefined if not found.
                         */

                        var currentNode, i, _i, _j, _ref;
                        if (!((-this.size <= position && position < this.size))) {
                            return;
                        }
                        position = this._adjust(position);
                        if (position * 2 < this.size) {
                            currentNode = this.head;
                            for (i = _i = 1; _i <= position; i = _i += 1) {
                                currentNode = currentNode.next;
                            }
                        } else {
                            currentNode = this.tail;
                            for (i = _j = 1, _ref = this.size - position - 1; _j <= _ref; i = _j += 1) {
                                currentNode = currentNode.prev;
                            }
                        }
                        return currentNode;
                    };

                    LinkedList.prototype.add = function(value, position) {
                        var currentNode, nodeToAdd, _ref, _ref1, _ref2;
                        if (position == null) {
                            position = this.size;
                        }
                        /*
                         Add a new item at `position` (optional). Defaults to adding at the end.
                         `position`, just like in `at()`, can be negative (within the negative
                         boundary). Position specifies the place the value's going to be, and the old
                         node will be pushed higher. `add(-2)` on list of size 7 is the same as
                         `add(5)`.

                         _Returns:_ item added.
                         */

                        if (!((-this.size <= position && position <= this.size))) {
                            return;
                        }
                        nodeToAdd = {
                            value: value
                        };
                        position = this._adjust(position);
                        if (this.size === 0) {
                            this.head = nodeToAdd;
                        } else {
                            if (position === 0) {
                                _ref = [nodeToAdd, this.head, nodeToAdd], this.head.prev = _ref[0], nodeToAdd.next = _ref[1], this.head = _ref[2];
                            } else {
                                currentNode = this.at(position - 1);
                                _ref1 = [currentNode.next, nodeToAdd, nodeToAdd, currentNode], nodeToAdd.next = _ref1[0], (_ref2 = currentNode.next) != null ? _ref2.prev = _ref1[1] : void 0, currentNode.next = _ref1[2], nodeToAdd.prev = _ref1[3];
                            }
                        }
                        if (position === this.size) {
                            this.tail = nodeToAdd;
                        }
                        this.size++;
                        return value;
                    };

                    LinkedList.prototype.removeAt = function(position) {
                        var currentNode, valueToReturn, _ref;
                        if (position == null) {
                            position = this.size - 1;
                        }
                        /*
                         Remove an item at index `position` (optional). Defaults to the last item.
                         Index can be negative (within the boundary).

                         _Returns:_ item removed.
                         */

                        if (!((-this.size <= position && position < this.size))) {
                            return;
                        }
                        if (this.size === 0) {
                            return;
                        }
                        position = this._adjust(position);
                        if (this.size === 1) {
                            valueToReturn = this.head.value;
                            this.head.value = this.tail.value = void 0;
                        } else {
                            if (position === 0) {
                                valueToReturn = this.head.value;
                                this.head = this.head.next;
                                this.head.prev = void 0;
                            } else {
                                currentNode = this.at(position);
                                valueToReturn = currentNode.value;
                                currentNode.prev.next = currentNode.next;
                                if ((_ref = currentNode.next) != null) {
                                    _ref.prev = currentNode.prev;
                                }
                                if (position === this.size - 1) {
                                    this.tail = currentNode.prev;
                                }
                            }
                        }
                        this.size--;
                        return valueToReturn;
                    };

                    LinkedList.prototype.remove = function(value) {
                        /*
                         Remove the item using its value instead of position. **Will remove the fist
                         occurrence of `value`.**

                         _Returns:_ the value, or undefined if value's not found.
                         */

                        var currentNode;
                        if (value == null) {
                            return;
                        }
                        currentNode = this.head;
                        while (currentNode && currentNode.value !== value) {
                            currentNode = currentNode.next;
                        }
                        if (!currentNode) {
                            return;
                        }
                        if (this.size === 1) {
                            this.head.value = this.tail.value = void 0;
                        } else if (currentNode === this.head) {
                            this.head = this.head.next;
                            this.head.prev = void 0;
                        } else if (currentNode === this.tail) {
                            this.tail = this.tail.prev;
                            this.tail.next = void 0;
                        } else {
                            currentNode.prev.next = currentNode.next;
                            currentNode.next.prev = currentNode.prev;
                        }
                        this.size--;
                        return value;
                    };

                    LinkedList.prototype.indexOf = function(value, startingPosition) {
                        var currentNode, position;
                        if (startingPosition == null) {
                            startingPosition = 0;
                        }
                        /*
                         Find the index of an item, similarly to `array.indexOf()`. Defaults to start
                         searching from the beginning, by can start at another position by passing
                         `startingPosition`. This parameter can also be negative; but unlike the
                         other methods of this class, `startingPosition` (optional) can be as small
                         as desired; a value of -999 for a list of size 5 will start searching
                         normally, at the beginning.

                         **Note:** searches forwardly, **not** backwardly, i.e:

                         ```js
                         var myList = new LinkedList([2, 3, 1, 4, 3, 5])
                         myList.indexOf(3, -3); // Returns 4, not 1
                         ```
                         _Returns:_ index of item found, or -1 if not found.
                         */

                        if (((this.head.value == null) && !this.head.next) || startingPosition >= this.size) {
                            return -1;
                        }
                        startingPosition = Math.max(0, this._adjust(startingPosition));
                        currentNode = this.at(startingPosition);
                        position = startingPosition;
                        while (currentNode) {
                            if (currentNode.value === value) {
                                break;
                            }
                            currentNode = currentNode.next;
                            position++;
                        }
                        if (position === this.size) {
                            return -1;
                        } else {
                            return position;
                        }
                    };

                    LinkedList.prototype._adjust = function(position) {
                        if (position < 0) {
                            return this.size + position;
                        } else {
                            return position;
                        }
                    };

                    return LinkedList;

                })();

                module.exports = LinkedList;

            }).call(this);


            /***/ },
        /* 5 */
        /***/ function(module, exports) {

            /*
             Kind of a stopgap measure for the upcoming [JavaScript
             Map](http://wiki.ecmascript.org/doku.php?id=harmony:simple_maps_and_sets)

             **Note:** due to JavaScript's limitations, hashing something other than Boolean,
             Number, String, Undefined, Null, RegExp, Function requires a hack that inserts a
             hidden unique property into the object. This means `set`, `get`, `has` and
             `delete` must employ the same object, and not a mere identical copy as in the
             case of, say, a string.

             ## Overview example:

             ```js
             var map = new Map({'alice': 'wonderland', 20: 'ok'});
             map.set('20', 5); // => 5
             map.get('20'); // => 5
             map.has('alice'); // => true
             map.delete(20) // => true
             var arr = [1, 2];
             map.add(arr, 'goody'); // => 'goody'
             map.has(arr); // => true
             map.has([1, 2]); // => false. Needs to compare by reference
             map.forEach(function(key, value) {
             console.log(key, value);
             });
             ```

             ## Properties:

             - size: The total number of `(key, value)` pairs.
             */


            (function() {
                var Map, SPECIAL_TYPE_KEY_PREFIX, _extractDataType, _isSpecialType,
                    __hasProp = {}.hasOwnProperty;

                SPECIAL_TYPE_KEY_PREFIX = '_mapId_';

                Map = (function() {
                    Map._mapIdTracker = 0;

                    Map._newMapId = function() {
                        return this._mapIdTracker++;
                    };

                    function Map(objectToMap) {
                        /*
                         Pass an optional object whose (key, value) pair will be hashed. **Careful**
                         not to pass something like {5: 'hi', '5': 'hello'}, since JavaScript's
                         native object behavior will crush the first 5 property before it gets to
                         constructor.
                         */

                        var key, value;
                        this._content = {};
                        this._itemId = 0;
                        this._id = Map._newMapId();
                        this.size = 0;
                        for (key in objectToMap) {
                            if (!__hasProp.call(objectToMap, key)) continue;
                            value = objectToMap[key];
                            this.set(key, value);
                        }
                    }

                    Map.prototype.hash = function(key, makeHash) {
                        var propertyForMap, type;
                        if (makeHash == null) {
                            makeHash = false;
                        }
                        /*
                         The hash function for hashing keys is public. Feel free to replace it with
                         your own. The `makeHash` parameter is optional and accepts a boolean
                         (defaults to `false`) indicating whether or not to produce a new hash (for
                         the first use, naturally).

                         _Returns:_ the hash.
                         */

                        type = _extractDataType(key);
                        if (_isSpecialType(key)) {
                            propertyForMap = SPECIAL_TYPE_KEY_PREFIX + this._id;
                            if (makeHash && !key[propertyForMap]) {
                                key[propertyForMap] = this._itemId++;
                            }
                            return propertyForMap + '_' + key[propertyForMap];
                        } else {
                            return type + '_' + key;
                        }
                    };

                    Map.prototype.set = function(key, value) {
                        /*
                         _Returns:_ value.
                         */

                        if (!this.has(key)) {
                            this.size++;
                        }
                        this._content[this.hash(key, true)] = [value, key];
                        return value;
                    };

                    Map.prototype.get = function(key) {
                        /*
                         _Returns:_ value corresponding to the key, or undefined if not found.
                         */

                        var _ref;
                        return (_ref = this._content[this.hash(key)]) != null ? _ref[0] : void 0;
                    };

                    Map.prototype.has = function(key) {
                        /*
                         Check whether a value exists for the key.

                         _Returns:_ true or false.
                         */

                        return this.hash(key) in this._content;
                    };

                    Map.prototype["delete"] = function(key) {
                        /*
                         Remove the (key, value) pair.

                         _Returns:_ **true or false**. Unlike most of this library, this method
                         doesn't return the deleted value. This is so that it conforms to the future
                         JavaScript `map.delete()`'s behavior.
                         */

                        var hashedKey;
                        hashedKey = this.hash(key);
                        if (hashedKey in this._content) {
                            delete this._content[hashedKey];
                            if (_isSpecialType(key)) {
                                delete key[SPECIAL_TYPE_KEY_PREFIX + this._id];
                            }
                            this.size--;
                            return true;
                        }
                        return false;
                    };

                    Map.prototype.forEach = function(operation) {
                        /*
                         Traverse through the map. Pass a function of the form `fn(key, value)`.

                         _Returns:_ undefined.
                         */

                        var key, value, _ref;
                        _ref = this._content;
                        for (key in _ref) {
                            if (!__hasProp.call(_ref, key)) continue;
                            value = _ref[key];
                            operation(value[1], value[0]);
                        }
                    };

                    return Map;

                })();

                _isSpecialType = function(key) {
                    var simpleHashableTypes, simpleType, type, _i, _len;
                    simpleHashableTypes = ['Boolean', 'Number', 'String', 'Undefined', 'Null', 'RegExp', 'Function'];
                    type = _extractDataType(key);
                    for (_i = 0, _len = simpleHashableTypes.length; _i < _len; _i++) {
                        simpleType = simpleHashableTypes[_i];
                        if (type === simpleType) {
                            return false;
                        }
                    }
                    return true;
                };

                _extractDataType = function(type) {
                    return Object.prototype.toString.apply(type).match(/\[object (.+)\]/)[1];
                };

                module.exports = Map;

            }).call(this);


            /***/ },
        /* 6 */
        /***/ function(module, exports) {

            /*
             Amortized O(1) dequeue!

             ## Overview example:

             ```js
             var queue = new Queue([1, 6, 4]);
             queue.enqueue(10); // => 10
             queue.dequeue(); // => 1
             queue.dequeue(); // => 6
             queue.dequeue(); // => 4
             queue.peek(); // => 10
             queue.dequeue(); // => 10
             queue.peek(); // => undefined
             ```

             ## Properties:

             - size: The total number of items.
             */


            (function() {
                var Queue;

                Queue = (function() {
                    function Queue(initialArray) {
                        if (initialArray == null) {
                            initialArray = [];
                        }
                        /*
                         Pass an optional array to be transformed into a queue. The item at index 0
                         is the first to be dequeued.
                         */

                        this._content = initialArray;
                        this._dequeueIndex = 0;
                        this.size = this._content.length;
                    }

                    Queue.prototype.enqueue = function(item) {
                        /*
                         _Returns:_ the item.
                         */

                        this.size++;
                        this._content.push(item);
                        return item;
                    };

                    Queue.prototype.dequeue = function() {
                        /*
                         _Returns:_ the dequeued item.
                         */

                        var itemToDequeue;
                        if (this.size === 0) {
                            return;
                        }
                        this.size--;
                        itemToDequeue = this._content[this._dequeueIndex];
                        this._dequeueIndex++;
                        if (this._dequeueIndex * 2 > this._content.length) {
                            this._content = this._content.slice(this._dequeueIndex);
                            this._dequeueIndex = 0;
                        }
                        return itemToDequeue;
                    };

                    Queue.prototype.peek = function() {
                        /*
                         Check the next item to be dequeued, without removing it.

                         _Returns:_ the item.
                         */

                        return this._content[this._dequeueIndex];
                    };

                    return Queue;

                })();

                module.exports = Queue;

            }).call(this);


            /***/ },
        /* 7 */
        /***/ function(module, exports) {

            /*
             Credit to Wikipedia's article on [Red-black
             tree](http://en.wikipedia.org/wiki/Red–black_tree)

             **Note:** doesn't handle duplicate entries, undefined and null. This is by
             design.

             ## Overview example:

             ```js
             var rbt = new RedBlackTree([7, 5, 1, 8]);
             rbt.add(2); // => 2
             rbt.add(10); // => 10
             rbt.has(5); // => true
             rbt.peekMin(); // => 1
             rbt.peekMax(); // => 10
             rbt.removeMin(); // => 1
             rbt.removeMax(); // => 10
             rbt.remove(8); // => 8
             ```

             ## Properties:

             - size: The total number of items.
             */


            (function() {
                var BLACK, NODE_FOUND, NODE_TOO_BIG, NODE_TOO_SMALL, RED, RedBlackTree, STOP_SEARCHING, _findNode, _grandParentOf, _isLeft, _leftOrRight, _peekMaxNode, _peekMinNode, _siblingOf, _uncleOf;

                NODE_FOUND = 0;

                NODE_TOO_BIG = 1;

                NODE_TOO_SMALL = 2;

                STOP_SEARCHING = 3;

                RED = 1;

                BLACK = 2;

                RedBlackTree = (function() {
                    function RedBlackTree(valuesToAdd) {
                        var value, _i, _len;
                        if (valuesToAdd == null) {
                            valuesToAdd = [];
                        }
                        /*
                         Pass an optional array to be turned into binary tree. **Note:** does not
                         accept duplicate, undefined and null.
                         */

                        this._root;
                        this.size = 0;
                        for (_i = 0, _len = valuesToAdd.length; _i < _len; _i++) {
                            value = valuesToAdd[_i];
                            if (value != null) {
                                this.add(value);
                            }
                        }
                    }

                    RedBlackTree.prototype.add = function(value) {
                        /*
                         Again, make sure to not pass a value already in the tree, or undefined, or
                         null.

                         _Returns:_ value added.
                         */

                        var currentNode, foundNode, nodeToInsert, _ref;
                        if (value == null) {
                            return;
                        }
                        this.size++;
                        nodeToInsert = {
                            value: value,
                            _color: RED
                        };
                        if (!this._root) {
                            this._root = nodeToInsert;
                        } else {
                            foundNode = _findNode(this._root, function(node) {
                                if (value === node.value) {
                                    return NODE_FOUND;
                                } else {
                                    if (value < node.value) {
                                        if (node._left) {
                                            return NODE_TOO_BIG;
                                        } else {
                                            nodeToInsert._parent = node;
                                            node._left = nodeToInsert;
                                            return STOP_SEARCHING;
                                        }
                                    } else {
                                        if (node._right) {
                                            return NODE_TOO_SMALL;
                                        } else {
                                            nodeToInsert._parent = node;
                                            node._right = nodeToInsert;
                                            return STOP_SEARCHING;
                                        }
                                    }
                                }
                            });
                            if (foundNode != null) {
                                return;
                            }
                        }
                        currentNode = nodeToInsert;
                        while (true) {
                            if (currentNode === this._root) {
                                currentNode._color = BLACK;
                                break;
                            }
                            if (currentNode._parent._color === BLACK) {
                                break;
                            }
                            if (((_ref = _uncleOf(currentNode)) != null ? _ref._color : void 0) === RED) {
                                currentNode._parent._color = BLACK;
                                _uncleOf(currentNode)._color = BLACK;
                                _grandParentOf(currentNode)._color = RED;
                                currentNode = _grandParentOf(currentNode);
                                continue;
                            }
                            if (!_isLeft(currentNode) && _isLeft(currentNode._parent)) {
                                this._rotateLeft(currentNode._parent);
                                currentNode = currentNode._left;
                            } else if (_isLeft(currentNode) && !_isLeft(currentNode._parent)) {
                                this._rotateRight(currentNode._parent);
                                currentNode = currentNode._right;
                            }
                            currentNode._parent._color = BLACK;
                            _grandParentOf(currentNode)._color = RED;
                            if (_isLeft(currentNode)) {
                                this._rotateRight(_grandParentOf(currentNode));
                            } else {
                                this._rotateLeft(_grandParentOf(currentNode));
                            }
                            break;
                        }
                        return value;
                    };

                    RedBlackTree.prototype.has = function(value) {
                        /*
                         _Returns:_ true or false.
                         */

                        var foundNode;
                        foundNode = _findNode(this._root, function(node) {
                            if (value === node.value) {
                                return NODE_FOUND;
                            } else if (value < node.value) {
                                return NODE_TOO_BIG;
                            } else {
                                return NODE_TOO_SMALL;
                            }
                        });
                        if (foundNode) {
                            return true;
                        } else {
                            return false;
                        }
                    };

                    RedBlackTree.prototype.peekMin = function() {
                        /*
                         Check the minimum value without removing it.

                         _Returns:_ the minimum value.
                         */

                        var _ref;
                        return (_ref = _peekMinNode(this._root)) != null ? _ref.value : void 0;
                    };

                    RedBlackTree.prototype.peekMax = function() {
                        /*
                         Check the maximum value without removing it.

                         _Returns:_ the maximum value.
                         */

                        var _ref;
                        return (_ref = _peekMaxNode(this._root)) != null ? _ref.value : void 0;
                    };

                    RedBlackTree.prototype.remove = function(value) {
                        /*
                         _Returns:_ the value removed, or undefined if the value's not found.
                         */

                        var foundNode;
                        foundNode = _findNode(this._root, function(node) {
                            if (value === node.value) {
                                return NODE_FOUND;
                            } else if (value < node.value) {
                                return NODE_TOO_BIG;
                            } else {
                                return NODE_TOO_SMALL;
                            }
                        });
                        if (!foundNode) {
                            return;
                        }
                        this._removeNode(this._root, foundNode);
                        this.size--;
                        return value;
                    };

                    RedBlackTree.prototype.removeMin = function() {
                        /*
                         _Returns:_ smallest item removed, or undefined if tree's empty.
                         */

                        var nodeToRemove, valueToReturn;
                        nodeToRemove = _peekMinNode(this._root);
                        if (!nodeToRemove) {
                            return;
                        }
                        valueToReturn = nodeToRemove.value;
                        this._removeNode(this._root, nodeToRemove);
                        return valueToReturn;
                    };

                    RedBlackTree.prototype.removeMax = function() {
                        /*
                         _Returns:_ biggest item removed, or undefined if tree's empty.
                         */

                        var nodeToRemove, valueToReturn;
                        nodeToRemove = _peekMaxNode(this._root);
                        if (!nodeToRemove) {
                            return;
                        }
                        valueToReturn = nodeToRemove.value;
                        this._removeNode(this._root, nodeToRemove);
                        return valueToReturn;
                    };

                    RedBlackTree.prototype._removeNode = function(root, node) {
                        var sibling, successor, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
                        if (node._left && node._right) {
                            successor = _peekMinNode(node._right);
                            node.value = successor.value;
                            node = successor;
                        }
                        successor = node._left || node._right;
                        if (!successor) {
                            successor = {
                                color: BLACK,
                                _right: void 0,
                                _left: void 0,
                                isLeaf: true
                            };
                        }
                        successor._parent = node._parent;
                        if ((_ref = node._parent) != null) {
                            _ref[_leftOrRight(node)] = successor;
                        }
                        if (node._color === BLACK) {
                            if (successor._color === RED) {
                                successor._color = BLACK;
                                if (!successor._parent) {
                                    this._root = successor;
                                }
                            } else {
                                while (true) {
                                    if (!successor._parent) {
                                        if (!successor.isLeaf) {
                                            this._root = successor;
                                        } else {
                                            this._root = void 0;
                                        }
                                        break;
                                    }
                                    sibling = _siblingOf(successor);
                                    if ((sibling != null ? sibling._color : void 0) === RED) {
                                        successor._parent._color = RED;
                                        sibling._color = BLACK;
                                        if (_isLeft(successor)) {
                                            this._rotateLeft(successor._parent);
                                        } else {
                                            this._rotateRight(successor._parent);
                                        }
                                    }
                                    sibling = _siblingOf(successor);
                                    if (successor._parent._color === BLACK && (!sibling || (sibling._color === BLACK && (!sibling._left || sibling._left._color === BLACK) && (!sibling._right || sibling._right._color === BLACK)))) {
                                        if (sibling != null) {
                                            sibling._color = RED;
                                        }
                                        if (successor.isLeaf) {
                                            successor._parent[_leftOrRight(successor)] = void 0;
                                        }
                                        successor = successor._parent;
                                        continue;
                                    }
                                    if (successor._parent._color === RED && (!sibling || (sibling._color === BLACK && (!sibling._left || ((_ref1 = sibling._left) != null ? _ref1._color : void 0) === BLACK) && (!sibling._right || ((_ref2 = sibling._right) != null ? _ref2._color : void 0) === BLACK)))) {
                                        if (sibling != null) {
                                            sibling._color = RED;
                                        }
                                        successor._parent._color = BLACK;
                                        break;
                                    }
                                    if ((sibling != null ? sibling._color : void 0) === BLACK) {
                                        if (_isLeft(successor) && (!sibling._right || sibling._right._color === BLACK) && ((_ref3 = sibling._left) != null ? _ref3._color : void 0) === RED) {
                                            sibling._color = RED;
                                            if ((_ref4 = sibling._left) != null) {
                                                _ref4._color = BLACK;
                                            }
                                            this._rotateRight(sibling);
                                        } else if (!_isLeft(successor) && (!sibling._left || sibling._left._color === BLACK) && ((_ref5 = sibling._right) != null ? _ref5._color : void 0) === RED) {
                                            sibling._color = RED;
                                            if ((_ref6 = sibling._right) != null) {
                                                _ref6._color = BLACK;
                                            }
                                            this._rotateLeft(sibling);
                                        }
                                        break;
                                    }
                                    sibling = _siblingOf(successor);
                                    sibling._color = successor._parent._color;
                                    if (_isLeft(successor)) {
                                        sibling._right._color = BLACK;
                                        this._rotateRight(successor._parent);
                                    } else {
                                        sibling._left._color = BLACK;
                                        this._rotateLeft(successor._parent);
                                    }
                                }
                            }
                        }
                        if (successor.isLeaf) {
                            return (_ref7 = successor._parent) != null ? _ref7[_leftOrRight(successor)] = void 0 : void 0;
                        }
                    };

                    RedBlackTree.prototype._rotateLeft = function(node) {
                        var _ref, _ref1;
                        if ((_ref = node._parent) != null) {
                            _ref[_leftOrRight(node)] = node._right;
                        }
                        node._right._parent = node._parent;
                        node._parent = node._right;
                        node._right = node._right._left;
                        node._parent._left = node;
                        if ((_ref1 = node._right) != null) {
                            _ref1._parent = node;
                        }
                        if (node._parent._parent == null) {
                            return this._root = node._parent;
                        }
                    };

                    RedBlackTree.prototype._rotateRight = function(node) {
                        var _ref, _ref1;
                        if ((_ref = node._parent) != null) {
                            _ref[_leftOrRight(node)] = node._left;
                        }
                        node._left._parent = node._parent;
                        node._parent = node._left;
                        node._left = node._left._right;
                        node._parent._right = node;
                        if ((_ref1 = node._left) != null) {
                            _ref1._parent = node;
                        }
                        if (node._parent._parent == null) {
                            return this._root = node._parent;
                        }
                    };

                    return RedBlackTree;

                })();

                _isLeft = function(node) {
                    return node === node._parent._left;
                };

                _leftOrRight = function(node) {
                    if (_isLeft(node)) {
                        return '_left';
                    } else {
                        return '_right';
                    }
                };

                _findNode = function(startingNode, comparator) {
                    var comparisonResult, currentNode, foundNode;
                    currentNode = startingNode;
                    foundNode = void 0;
                    while (currentNode) {
                        comparisonResult = comparator(currentNode);
                        if (comparisonResult === NODE_FOUND) {
                            foundNode = currentNode;
                            break;
                        }
                        if (comparisonResult === NODE_TOO_BIG) {
                            currentNode = currentNode._left;
                        } else if (comparisonResult === NODE_TOO_SMALL) {
                            currentNode = currentNode._right;
                        } else if (comparisonResult === STOP_SEARCHING) {
                            break;
                        }
                    }
                    return foundNode;
                };

                _peekMinNode = function(startingNode) {
                    return _findNode(startingNode, function(node) {
                        if (node._left) {
                            return NODE_TOO_BIG;
                        } else {
                            return NODE_FOUND;
                        }
                    });
                };

                _peekMaxNode = function(startingNode) {
                    return _findNode(startingNode, function(node) {
                        if (node._right) {
                            return NODE_TOO_SMALL;
                        } else {
                            return NODE_FOUND;
                        }
                    });
                };

                _grandParentOf = function(node) {
                    var _ref;
                    return (_ref = node._parent) != null ? _ref._parent : void 0;
                };

                _uncleOf = function(node) {
                    if (!_grandParentOf(node)) {
                        return;
                    }
                    if (_isLeft(node._parent)) {
                        return _grandParentOf(node)._right;
                    } else {
                        return _grandParentOf(node)._left;
                    }
                };

                _siblingOf = function(node) {
                    if (_isLeft(node)) {
                        return node._parent._right;
                    } else {
                        return node._parent._left;
                    }
                };

                module.exports = RedBlackTree;

            }).call(this);


            /***/ },
        /* 8 */
        /***/ function(module, exports, __webpack_require__) {

            /*
             Good for fast insertion/removal/lookup of strings.

             ## Overview example:

             ```js
             var trie = new Trie(['bear', 'beer']);
             trie.add('hello'); // => 'hello'
             trie.add('helloha!'); // => 'helloha!'
             trie.has('bears'); // => false
             trie.longestPrefixOf('beatrice'); // => 'bea'
             trie.wordsWithPrefix('hel'); // => ['hello', 'helloha!']
             trie.remove('beers'); // => undefined. 'beer' still exists
             trie.remove('Beer') // => undefined. Case-sensitive
             trie.remove('beer') // => 'beer'. Removed
             ```

             ## Properties:

             - size: The total number of words.
             */


            (function() {
                var Queue, Trie, WORD_END, _hasAtLeastNChildren,
                    __hasProp = {}.hasOwnProperty;

                Queue = __webpack_require__(6);

                WORD_END = 'end';

                Trie = (function() {
                    function Trie(words) {
                        var word, _i, _len;
                        if (words == null) {
                            words = [];
                        }
                        /*
                         Pass an optional array of strings to be inserted initially.
                         */

                        this._root = {};
                        this.size = 0;
                        for (_i = 0, _len = words.length; _i < _len; _i++) {
                            word = words[_i];
                            this.add(word);
                        }
                    }

                    Trie.prototype.add = function(word) {
                        /*
                         Add a whole string to the trie.

                         _Returns:_ the word added. Will return undefined (without adding the value)
                         if the word passed is null or undefined.
                         */

                        var currentNode, letter, _i, _len;
                        if (word == null) {
                            return;
                        }
                        this.size++;
                        currentNode = this._root;
                        for (_i = 0, _len = word.length; _i < _len; _i++) {
                            letter = word[_i];
                            if (currentNode[letter] == null) {
                                currentNode[letter] = {};
                            }
                            currentNode = currentNode[letter];
                        }
                        currentNode[WORD_END] = true;
                        return word;
                    };

                    Trie.prototype.has = function(word) {
                        /*
                         __Returns:_ true or false.
                         */

                        var currentNode, letter, _i, _len;
                        if (word == null) {
                            return false;
                        }
                        currentNode = this._root;
                        for (_i = 0, _len = word.length; _i < _len; _i++) {
                            letter = word[_i];
                            if (currentNode[letter] == null) {
                                return false;
                            }
                            currentNode = currentNode[letter];
                        }
                        if (currentNode[WORD_END]) {
                            return true;
                        } else {
                            return false;
                        }
                    };

                    Trie.prototype.longestPrefixOf = function(word) {
                        /*
                         Find all words containing the prefix. The word itself counts as a prefix.

                         ```js
                         var trie = new Trie;
                         trie.add('hello');
                         trie.longestPrefixOf('he'); // 'he'
                         trie.longestPrefixOf('hello'); // 'hello'
                         trie.longestPrefixOf('helloha!'); // 'hello'
                         ```

                         _Returns:_ the prefix string, or empty string if no prefix found.
                         */

                        var currentNode, letter, prefix, _i, _len;
                        if (word == null) {
                            return '';
                        }
                        currentNode = this._root;
                        prefix = '';
                        for (_i = 0, _len = word.length; _i < _len; _i++) {
                            letter = word[_i];
                            if (currentNode[letter] == null) {
                                break;
                            }
                            prefix += letter;
                            currentNode = currentNode[letter];
                        }
                        return prefix;
                    };

                    Trie.prototype.wordsWithPrefix = function(prefix) {
                        /*
                         Find all words containing the prefix. The word itself counts as a prefix.
                         **Watch out for edge cases.**

                         ```js
                         var trie = new Trie;
                         trie.wordsWithPrefix(''); // []. Check later case below.
                         trie.add('');
                         trie.wordsWithPrefix(''); // ['']
                         trie.add('he');
                         trie.add('hello');
                         trie.add('hell');
                         trie.add('bear');
                         trie.add('z');
                         trie.add('zebra');
                         trie.wordsWithPrefix('hel'); // ['hell', 'hello']
                         ```

                         _Returns:_ an array of strings, or empty array if no word found.
                         */

                        var accumulatedLetters, currentNode, letter, node, queue, subNode, words, _i, _len, _ref;
                        if (prefix == null) {
                            return [];
                        }
                        (prefix != null) || (prefix = '');
                        words = [];
                        currentNode = this._root;
                        for (_i = 0, _len = prefix.length; _i < _len; _i++) {
                            letter = prefix[_i];
                            currentNode = currentNode[letter];
                            if (currentNode == null) {
                                return [];
                            }
                        }
                        queue = new Queue();
                        queue.enqueue([currentNode, '']);
                        while (queue.size !== 0) {
                            _ref = queue.dequeue(), node = _ref[0], accumulatedLetters = _ref[1];
                            if (node[WORD_END]) {
                                words.push(prefix + accumulatedLetters);
                            }
                            for (letter in node) {
                                if (!__hasProp.call(node, letter)) continue;
                                subNode = node[letter];
                                queue.enqueue([subNode, accumulatedLetters + letter]);
                            }
                        }
                        return words;
                    };

                    Trie.prototype.remove = function(word) {
                        /*
                         _Returns:_ the string removed, or undefined if the word in its whole doesn't
                         exist. **Note:** this means removing `beers` when only `beer` exists will
                         return undefined and conserve `beer`.
                         */

                        var currentNode, i, letter, prefix, _i, _j, _len, _ref;
                        if (word == null) {
                            return;
                        }
                        currentNode = this._root;
                        prefix = [];
                        for (_i = 0, _len = word.length; _i < _len; _i++) {
                            letter = word[_i];
                            if (currentNode[letter] == null) {
                                return;
                            }
                            currentNode = currentNode[letter];
                            prefix.push([letter, currentNode]);
                        }
                        if (!currentNode[WORD_END]) {
                            return;
                        }
                        this.size--;
                        delete currentNode[WORD_END];
                        if (_hasAtLeastNChildren(currentNode, 1)) {
                            return word;
                        }
                        for (i = _j = _ref = prefix.length - 1; _ref <= 1 ? _j <= 1 : _j >= 1; i = _ref <= 1 ? ++_j : --_j) {
                            if (!_hasAtLeastNChildren(prefix[i][1], 1)) {
                                delete prefix[i - 1][1][prefix[i][0]];
                            } else {
                                break;
                            }
                        }
                        if (!_hasAtLeastNChildren(this._root[prefix[0][0]], 1)) {
                            delete this._root[prefix[0][0]];
                        }
                        return word;
                    };

                    return Trie;

                })();

                _hasAtLeastNChildren = function(node, n) {
                    var child, childCount;
                    if (n === 0) {
                        return true;
                    }
                    childCount = 0;
                    for (child in node) {
                        if (!__hasProp.call(node, child)) continue;
                        childCount++;
                        if (childCount >= n) {
                            return true;
                        }
                    }
                    return false;
                };

                module.exports = Trie;

            }).call(this);


            /***/ }
        /******/ ]);;angular.module('uiGmapgoogle-maps.wrapped')
        .service('uiGmapMarkerSpiderfier', [ 'uiGmapGoogleMapApi', function(GoogleMapApi) {
            var self = this;
            /* istanbul ignore next */
            +function(){

                /** @preserve OverlappingMarkerSpiderfier
                 https://github.com/jawj/OverlappingMarkerSpiderfier
                 Copyright (c) 2011 - 2013 George MacKerron
                 Released under the MIT licence: http://opensource.org/licenses/mit-license
                 Note: The Google Maps API v3 must be included *before* this code
                 */
                var hasProp = {}.hasOwnProperty,
                    slice = [].slice;

                this['OverlappingMarkerSpiderfier'] = (function() {
                    var ge, gm, j, lcH, lcU, len, mt, p, ref, twoPi, x;

                    p = _Class.prototype;

                    ref = [_Class, p];
                    for (j = 0, len = ref.length; j < len; j++) {
                        x = ref[j];
                        x['VERSION'] = '0.3.3';
                    }

                    gm = void 0;

                    ge = void 0;

                    mt = void 0;

                    twoPi = Math.PI * 2;

                    p['keepSpiderfied'] = false;

                    p['markersWontHide'] = false;

                    p['markersWontMove'] = false;

                    p['nearbyDistance'] = 20;

                    p['circleSpiralSwitchover'] = 9;

                    p['circleFootSeparation'] = 23;

                    p['circleStartAngle'] = twoPi / 12;

                    p['spiralFootSeparation'] = 26;

                    p['spiralLengthStart'] = 11;

                    p['spiralLengthFactor'] = 4;

                    p['spiderfiedZIndex'] = 1000;

                    p['usualLegZIndex'] = 10;

                    p['highlightedLegZIndex'] = 20;

                    p['event'] = 'click';

                    p['minZoomLevel'] = false;

                    p['legWeight'] = 1.5;

                    p['legColors'] = {
                        'usual': {},
                        'highlighted': {}
                    };

                    lcU = p['legColors']['usual'];

                    lcH = p['legColors']['highlighted'];

                    _Class['initializeGoogleMaps'] = function(google) {
                        gm = google.maps;
                        ge = gm.event;
                        mt = gm.MapTypeId;
                        lcU[mt.HYBRID] = lcU[mt.SATELLITE] = '#fff';
                        lcH[mt.HYBRID] = lcH[mt.SATELLITE] = '#f00';
                        lcU[mt.TERRAIN] = lcU[mt.ROADMAP] = '#444';
                        lcH[mt.TERRAIN] = lcH[mt.ROADMAP] = '#f00';
                        this.ProjHelper = function(map) {
                            return this.setMap(map);
                        };
                        this.ProjHelper.prototype = new gm.OverlayView();
                        return this.ProjHelper.prototype['draw'] = function() {};
                    };

                    function _Class(map1, opts) {
                        var e, k, l, len1, ref1, v;
                        this.map = map1;
                        if (opts == null) {
                            opts = {};
                        }
                        for (k in opts) {
                            if (!hasProp.call(opts, k)) continue;
                            v = opts[k];
                            this[k] = v;
                        }
                        this.projHelper = new this.constructor.ProjHelper(this.map);
                        this.initMarkerArrays();
                        this.listeners = {};
                        ref1 = ['click', 'zoom_changed', 'maptypeid_changed'];
                        for (l = 0, len1 = ref1.length; l < len1; l++) {
                            e = ref1[l];
                            ge.addListener(this.map, e, (function(_this) {
                                return function() {
                                    return _this['unspiderfy']();
                                };
                            })(this));
                        }
                    }

                    p.initMarkerArrays = function() {
                        this.markers = [];
                        return this.markerListenerRefs = [];
                    };

                    p['addMarker'] = function(marker) {
                        var listenerRefs;
                        if (marker['_oms'] != null) {
                            return this;
                        }
                        marker['_oms'] = true;
                        listenerRefs = [
                            ge.addListener(marker, this['event'], (function(_this) {
                                return function(event) {
                                    return _this.spiderListener(marker, event);
                                };
                            })(this))
                        ];
                        if (!this['markersWontHide']) {
                            listenerRefs.push(ge.addListener(marker, 'visible_changed', (function(_this) {
                                return function() {
                                    return _this.markerChangeListener(marker, false);
                                };
                            })(this)));
                        }
                        if (!this['markersWontMove']) {
                            listenerRefs.push(ge.addListener(marker, 'position_changed', (function(_this) {
                                return function() {
                                    return _this.markerChangeListener(marker, true);
                                };
                            })(this)));
                        }
                        this.markerListenerRefs.push(listenerRefs);
                        this.markers.push(marker);
                        return this;
                    };

                    p.markerChangeListener = function(marker, positionChanged) {
                        if ((marker['_omsData'] != null) && (positionChanged || !marker.getVisible()) && !((this.spiderfying != null) || (this.unspiderfying != null))) {
                            return this['unspiderfy'](positionChanged ? marker : null);
                        }
                    };

                    p['getMarkers'] = function() {
                        return this.markers.slice(0);
                    };

                    p['removeMarker'] = function(marker) {
                        var i, l, len1, listenerRef, listenerRefs;
                        if (marker['_omsData'] != null) {
                            this['unspiderfy']();
                        }
                        i = this.arrIndexOf(this.markers, marker);
                        if (i < 0) {
                            return this;
                        }
                        listenerRefs = this.markerListenerRefs.splice(i, 1)[0];
                        for (l = 0, len1 = listenerRefs.length; l < len1; l++) {
                            listenerRef = listenerRefs[l];
                            ge.removeListener(listenerRef);
                        }
                        delete marker['_oms'];
                        this.markers.splice(i, 1);
                        return this;
                    };

                    p['clearMarkers'] = function() {
                        var i, l, len1, len2, listenerRef, listenerRefs, marker, n, ref1;
                        this['unspiderfy']();
                        ref1 = this.markers;
                        for (i = l = 0, len1 = ref1.length; l < len1; i = ++l) {
                            marker = ref1[i];
                            listenerRefs = this.markerListenerRefs[i];
                            for (n = 0, len2 = listenerRefs.length; n < len2; n++) {
                                listenerRef = listenerRefs[n];
                                ge.removeListener(listenerRef);
                            }
                            delete marker['_oms'];
                        }
                        this.initMarkerArrays();
                        return this;
                    };

                    p['addListener'] = function(event, func) {
                        var base;
                        ((base = this.listeners)[event] != null ? base[event] : base[event] = []).push(func);
                        return this;
                    };

                    p['removeListener'] = function(event, func) {
                        var i;
                        i = this.arrIndexOf(this.listeners[event], func);
                        if (!(i < 0)) {
                            this.listeners[event].splice(i, 1);
                        }
                        return this;
                    };

                    p['clearListeners'] = function(event) {
                        this.listeners[event] = [];
                        return this;
                    };

                    p.trigger = function() {
                        var args, event, func, l, len1, ref1, ref2, results;
                        event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
                        ref2 = (ref1 = this.listeners[event]) != null ? ref1 : [];
                        results = [];
                        for (l = 0, len1 = ref2.length; l < len1; l++) {
                            func = ref2[l];
                            results.push(func.apply(null, args));
                        }
                        return results;
                    };

                    p.generatePtsCircle = function(count, centerPt) {
                        var angle, angleStep, circumference, i, l, legLength, ref1, results;
                        circumference = this['circleFootSeparation'] * (2 + count);
                        legLength = circumference / twoPi;
                        angleStep = twoPi / count;
                        results = [];
                        for (i = l = 0, ref1 = count; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
                            angle = this['circleStartAngle'] + i * angleStep;
                            results.push(new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle)));
                        }
                        return results;
                    };

                    p.generatePtsSpiral = function(count, centerPt) {
                        var angle, i, l, legLength, pt, ref1, results;
                        legLength = this['spiralLengthStart'];
                        angle = 0;
                        results = [];
                        for (i = l = 0, ref1 = count; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
                            angle += this['spiralFootSeparation'] / legLength + i * 0.0005;
                            pt = new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle));
                            legLength += twoPi * this['spiralLengthFactor'] / angle;
                            results.push(pt);
                        }
                        return results;
                    };

                    p.spiderListener = function(marker, event) {
                        var $this, clear, l, len1, m, mPt, markerPt, markerSpiderfied, nDist, nearbyMarkerData, nonNearbyMarkers, pxSq, ref1;
                        markerSpiderfied = marker['_omsData'] != null;
                        if (!(markerSpiderfied && this['keepSpiderfied'])) {
                            if (this['event'] === 'mouseover') {
                                $this = this;
                                clear = function() {
                                    return $this['unspiderfy']();
                                };
                                window.clearTimeout(p.timeout);
                                p.timeout = setTimeout(clear, 3000);
                            } else {
                                this['unspiderfy']();
                            }
                        }
                        if (markerSpiderfied || this.map.getStreetView().getVisible() || this.map.getMapTypeId() === 'GoogleEarthAPI') {
                            return this.trigger('click', marker, event);
                        } else {
                            nearbyMarkerData = [];
                            nonNearbyMarkers = [];
                            nDist = this['nearbyDistance'];
                            pxSq = nDist * nDist;
                            markerPt = this.llToPt(marker.position);
                            ref1 = this.markers;
                            for (l = 0, len1 = ref1.length; l < len1; l++) {
                                m = ref1[l];
                                if (!((m.map != null) && m.getVisible())) {
                                    continue;
                                }
                                mPt = this.llToPt(m.position);
                                if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
                                    nearbyMarkerData.push({
                                        marker: m,
                                        markerPt: mPt
                                    });
                                } else {
                                    nonNearbyMarkers.push(m);
                                }
                            }
                            if (nearbyMarkerData.length === 1) {
                                return this.trigger('click', marker, event);
                            } else {
                                return this.spiderfy(nearbyMarkerData, nonNearbyMarkers);
                            }
                        }
                    };

                    p['markersNearMarker'] = function(marker, firstOnly) {
                        var l, len1, m, mPt, markerPt, markers, nDist, pxSq, ref1, ref2, ref3;
                        if (firstOnly == null) {
                            firstOnly = false;
                        }
                        if (this.projHelper.getProjection() == null) {
                            throw "Must wait for 'idle' event on map before calling markersNearMarker";
                        }
                        nDist = this['nearbyDistance'];
                        pxSq = nDist * nDist;
                        markerPt = this.llToPt(marker.position);
                        markers = [];
                        ref1 = this.markers;
                        for (l = 0, len1 = ref1.length; l < len1; l++) {
                            m = ref1[l];
                            if (m === marker || (m.map == null) || !m.getVisible()) {
                                continue;
                            }
                            mPt = this.llToPt((ref2 = (ref3 = m['_omsData']) != null ? ref3.usualPosition : void 0) != null ? ref2 : m.position);
                            if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
                                markers.push(m);
                                if (firstOnly) {
                                    break;
                                }
                            }
                        }
                        return markers;
                    };

                    p['markersNearAnyOtherMarker'] = function() {
                        var i, i1, i2, l, len1, len2, len3, m, m1, m1Data, m2, m2Data, mData, n, nDist, pxSq, q, ref1, ref2, ref3, results;
                        if (this.projHelper.getProjection() == null) {
                            throw "Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";
                        }
                        nDist = this['nearbyDistance'];
                        pxSq = nDist * nDist;
                        mData = (function() {
                            var l, len1, ref1, ref2, ref3, results;
                            ref1 = this.markers;
                            results = [];
                            for (l = 0, len1 = ref1.length; l < len1; l++) {
                                m = ref1[l];
                                results.push({
                                    pt: this.llToPt((ref2 = (ref3 = m['_omsData']) != null ? ref3.usualPosition : void 0) != null ? ref2 : m.position),
                                    willSpiderfy: false
                                });
                            }
                            return results;
                        }).call(this);
                        ref1 = this.markers;
                        for (i1 = l = 0, len1 = ref1.length; l < len1; i1 = ++l) {
                            m1 = ref1[i1];
                            if (!((m1.map != null) && m1.getVisible())) {
                                continue;
                            }
                            m1Data = mData[i1];
                            if (m1Data.willSpiderfy) {
                                continue;
                            }
                            ref2 = this.markers;
                            for (i2 = n = 0, len2 = ref2.length; n < len2; i2 = ++n) {
                                m2 = ref2[i2];
                                if (i2 === i1) {
                                    continue;
                                }
                                if (!((m2.map != null) && m2.getVisible())) {
                                    continue;
                                }
                                m2Data = mData[i2];
                                if (i2 < i1 && !m2Data.willSpiderfy) {
                                    continue;
                                }
                                if (this.ptDistanceSq(m1Data.pt, m2Data.pt) < pxSq) {
                                    m1Data.willSpiderfy = m2Data.willSpiderfy = true;
                                    break;
                                }
                            }
                        }
                        ref3 = this.markers;
                        results = [];
                        for (i = q = 0, len3 = ref3.length; q < len3; i = ++q) {
                            m = ref3[i];
                            if (mData[i].willSpiderfy) {
                                results.push(m);
                            }
                        }
                        return results;
                    };

                    p.makeHighlightListenerFuncs = function(marker) {
                        return {
                            highlight: (function(_this) {
                                return function() {
                                    return marker['_omsData'].leg.setOptions({
                                        strokeColor: _this['legColors']['highlighted'][_this.map.mapTypeId],
                                        zIndex: _this['highlightedLegZIndex']
                                    });
                                };
                            })(this),
                            unhighlight: (function(_this) {
                                return function() {
                                    return marker['_omsData'].leg.setOptions({
                                        strokeColor: _this['legColors']['usual'][_this.map.mapTypeId],
                                        zIndex: _this['usualLegZIndex']
                                    });
                                };
                            })(this)
                        };
                    };

                    p.spiderfy = function(markerData, nonNearbyMarkers) {
                        var bodyPt, footLl, footPt, footPts, highlightListenerFuncs, leg, marker, md, nearestMarkerDatum, numFeet, spiderfiedMarkers;
                        if (this['minZoomLevel'] && this.map.getZoom() < this['minZoomLevel']) {
                            return false;
                        }
                        this.spiderfying = true;
                        numFeet = markerData.length;
                        bodyPt = this.ptAverage((function() {
                            var l, len1, results;
                            results = [];
                            for (l = 0, len1 = markerData.length; l < len1; l++) {
                                md = markerData[l];
                                results.push(md.markerPt);
                            }
                            return results;
                        })());
                        footPts = numFeet >= this['circleSpiralSwitchover'] ? this.generatePtsSpiral(numFeet, bodyPt).reverse() : this.generatePtsCircle(numFeet, bodyPt);
                        spiderfiedMarkers = (function() {
                            var l, len1, results;
                            results = [];
                            for (l = 0, len1 = footPts.length; l < len1; l++) {
                                footPt = footPts[l];
                                footLl = this.ptToLl(footPt);
                                nearestMarkerDatum = this.minExtract(markerData, (function(_this) {
                                    return function(md) {
                                        return _this.ptDistanceSq(md.markerPt, footPt);
                                    };
                                })(this));
                                marker = nearestMarkerDatum.marker;
                                leg = new gm.Polyline({
                                    map: this.map,
                                    path: [marker.position, footLl],
                                    strokeColor: this['legColors']['usual'][this.map.mapTypeId],
                                    strokeWeight: this['legWeight'],
                                    zIndex: this['usualLegZIndex']
                                });
                                marker['_omsData'] = {
                                    usualPosition: marker.position,
                                    leg: leg
                                };
                                if (this['legColors']['highlighted'][this.map.mapTypeId] !== this['legColors']['usual'][this.map.mapTypeId]) {
                                    highlightListenerFuncs = this.makeHighlightListenerFuncs(marker);
                                    marker['_omsData'].hightlightListeners = {
                                        highlight: ge.addListener(marker, 'mouseover', highlightListenerFuncs.highlight),
                                        unhighlight: ge.addListener(marker, 'mouseout', highlightListenerFuncs.unhighlight)
                                    };
                                }
                                marker.setPosition(footLl);
                                marker.setZIndex(Math.round(this['spiderfiedZIndex'] + footPt.y));
                                results.push(marker);
                            }
                            return results;
                        }).call(this);
                        delete this.spiderfying;
                        this.spiderfied = true;
                        return this.trigger('spiderfy', spiderfiedMarkers, nonNearbyMarkers);
                    };

                    p['unspiderfy'] = function(markerNotToMove) {
                        var l, len1, listeners, marker, nonNearbyMarkers, ref1, unspiderfiedMarkers;
                        if (markerNotToMove == null) {
                            markerNotToMove = null;
                        }
                        if (this.spiderfied == null) {
                            return this;
                        }
                        this.unspiderfying = true;
                        unspiderfiedMarkers = [];
                        nonNearbyMarkers = [];
                        ref1 = this.markers;
                        for (l = 0, len1 = ref1.length; l < len1; l++) {
                            marker = ref1[l];
                            if (marker['_omsData'] != null) {
                                marker['_omsData'].leg.setMap(null);
                                if (marker !== markerNotToMove) {
                                    marker.setPosition(marker['_omsData'].usualPosition);
                                }
                                marker.setZIndex(null);
                                listeners = marker['_omsData'].hightlightListeners;
                                if (listeners != null) {
                                    ge.removeListener(listeners.highlight);
                                    ge.removeListener(listeners.unhighlight);
                                }
                                delete marker['_omsData'];
                                unspiderfiedMarkers.push(marker);
                            } else {
                                nonNearbyMarkers.push(marker);
                            }
                        }
                        delete this.unspiderfying;
                        delete this.spiderfied;
                        this.trigger('unspiderfy', unspiderfiedMarkers, nonNearbyMarkers);
                        return this;
                    };

                    p.ptDistanceSq = function(pt1, pt2) {
                        var dx, dy;
                        dx = pt1.x - pt2.x;
                        dy = pt1.y - pt2.y;
                        return dx * dx + dy * dy;
                    };

                    p.ptAverage = function(pts) {
                        var l, len1, numPts, pt, sumX, sumY;
                        sumX = sumY = 0;
                        for (l = 0, len1 = pts.length; l < len1; l++) {
                            pt = pts[l];
                            sumX += pt.x;
                            sumY += pt.y;
                        }
                        numPts = pts.length;
                        return new gm.Point(sumX / numPts, sumY / numPts);
                    };

                    p.llToPt = function(ll) {
                        return this.projHelper.getProjection().fromLatLngToDivPixel(ll);
                    };

                    p.ptToLl = function(pt) {
                        return this.projHelper.getProjection().fromDivPixelToLatLng(pt);
                    };

                    p.minExtract = function(set, func) {
                        var bestIndex, bestVal, index, item, l, len1, val;
                        for (index = l = 0, len1 = set.length; l < len1; index = ++l) {
                            item = set[index];
                            val = func(item);
                            if ((typeof bestIndex === "undefined" || bestIndex === null) || val < bestVal) {
                                bestVal = val;
                                bestIndex = index;
                            }
                        }
                        return set.splice(bestIndex, 1)[0];
                    };

                    p.arrIndexOf = function(arr, obj) {
                        var i, l, len1, o;
                        if (arr.indexOf != null) {
                            return arr.indexOf(obj);
                        }
                        for (i = l = 0, len1 = arr.length; l < len1; i = ++l) {
                            o = arr[i];
                            if (o === obj) {
                                return i;
                            }
                        }
                        return -1;
                    };

                    return _Class;

                })();

            }.apply(self);

            GoogleMapApi.then(function(){
                self.OverlappingMarkerSpiderfier.initializeGoogleMaps(window.google);
            });
            return this.OverlappingMarkerSpiderfier;
        }]);
    ;/**
     * Performance overrides on MarkerClusterer custom to Angular Google Maps
     *
     * Created by Petr Bruna ccg1415 and Nick McCready on 7/13/14.
     */
    angular.module('uiGmapgoogle-maps.extensions')
        .service('uiGmapExtendMarkerClusterer',['uiGmapLodash', 'uiGmapPropMap', function (uiGmapLodash, PropMap) {
            return {
                init: _.once(function () {
                    (function () {
                        var __hasProp = {}.hasOwnProperty,
                            __extends = function (child, parent) {
                                for (var key in parent) {
                                    if (__hasProp.call(parent, key)) child[key] = parent[key];
                                }
                                function ctor() {
                                    this.constructor = child;
                                }

                                ctor.prototype = parent.prototype;
                                child.prototype = new ctor();
                                child.__super__ = parent.prototype;
                                return child;
                            };

                        window.NgMapCluster = (function (_super) {
                            __extends(NgMapCluster, _super);

                            function NgMapCluster(opts) {
                                NgMapCluster.__super__.constructor.call(this, opts);
                                this.markers_ = new PropMap();
                            }

                            /**
                             * Adds a marker to the cluster.
                             *
                             * @param {google.maps.Marker} marker The marker to be added.
                             * @return {boolean} True if the marker was added.
                             * @ignore
                             */
                            NgMapCluster.prototype.addMarker = function (marker) {
                                var i;
                                var mCount;
                                var mz;

                                if (this.isMarkerAlreadyAdded_(marker)) {
                                    var oldMarker = this.markers_.get(marker.key);
                                    if (oldMarker.getPosition().lat() == marker.getPosition().lat() && oldMarker.getPosition().lon() == marker.getPosition().lon()) //if nothing has changed
                                        return false;
                                }

                                if (!this.center_) {
                                    this.center_ = marker.getPosition();
                                    this.calculateBounds_();
                                } else {
                                    if (this.averageCenter_) {
                                        var l = this.markers_.length + 1;
                                        var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
                                        var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
                                        this.center_ = new google.maps.LatLng(lat, lng);
                                        this.calculateBounds_();
                                    }
                                }
                                marker.isAdded = true;
                                this.markers_.push(marker);

                                mCount = this.markers_.length;
                                mz = this.markerClusterer_.getMaxZoom();
                                if (mz !== null && this.map_.getZoom() > mz) {
                                    // Zoomed in past max zoom, so show the marker.
                                    if (marker.getMap() !== this.map_) {
                                        marker.setMap(this.map_);
                                    }
                                } else if (mCount < this.minClusterSize_) {
                                    // Min cluster size not reached so show the marker.
                                    if (marker.getMap() !== this.map_) {
                                        marker.setMap(this.map_);
                                    }
                                } else if (mCount === this.minClusterSize_) {
                                    // Hide the markers that were showing.
                                    this.markers_.each(function (m) {
                                        m.setMap(null);
                                    });
                                } else {
                                    marker.setMap(null);
                                }

                                //this.updateIcon_();
                                return true;
                            };

                            /**
                             * Determines if a marker has already been added to the cluster.
                             *
                             * @param {google.maps.Marker} marker The marker to check.
                             * @return {boolean} True if the marker has already been added.
                             */
                            NgMapCluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
                                return uiGmapLodash.isNullOrUndefined(this.markers_.get(marker.key));
                            };


                            /**
                             * Returns the bounds of the cluster.
                             *
                             * @return {google.maps.LatLngBounds} the cluster bounds.
                             * @ignore
                             */
                            NgMapCluster.prototype.getBounds = function () {
                                var i;
                                var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
                                this.getMarkers().each(function(m){
                                    bounds.extend(m.getPosition());
                                });
                                return bounds;
                            };


                            /**
                             * Removes the cluster from the map.
                             *
                             * @ignore
                             */
                            NgMapCluster.prototype.remove = function () {
                                this.clusterIcon_.setMap(null);
                                this.markers_ = new PropMap();
                                delete this.markers_;
                            };


                            return NgMapCluster;

                        })(Cluster);


                        window.NgMapMarkerClusterer = (function (_super) {
                            __extends(NgMapMarkerClusterer, _super);

                            function NgMapMarkerClusterer(map, opt_markers, opt_options) {
                                NgMapMarkerClusterer.__super__.constructor.call(this, map, opt_markers, opt_options);
                                this.markers_ = new PropMap();
                            }

                            /**
                             * Removes all clusters and markers from the map and also removes all markers
                             *  managed by the clusterer.
                             */
                            NgMapMarkerClusterer.prototype.clearMarkers = function () {
                                this.resetViewport_(true);
                                this.markers_ = new PropMap();
                            };
                            /**
                             * Removes a marker and returns true if removed, false if not.
                             *
                             * @param {google.maps.Marker} marker The marker to remove
                             * @return {boolean} Whether the marker was removed or not
                             */
                            NgMapMarkerClusterer.prototype.removeMarker_ = function (marker) {
                                if (!this.markers_.get(marker.key)) {
                                    return false;
                                }
                                marker.setMap(null);
                                this.markers_.remove(marker.key); // Remove the marker from the list of managed markers
                                return true;
                            };

                            /**
                             * Creates the clusters. This is done in batches to avoid timeout errors
                             *  in some browsers when there is a huge number of markers.
                             *
                             * @param {number} iFirst The index of the first marker in the batch of
                             *  markers to be added to clusters.
                             */
                            NgMapMarkerClusterer.prototype.createClusters_ = function (iFirst) {
                                var i, marker;
                                var mapBounds;
                                var cMarkerClusterer = this;
                                if (!this.ready_) {
                                    return;
                                }

                                // Cancel previous batch processing if we're working on the first batch:
                                if (iFirst === 0) {
                                    /**
                                     * This event is fired when the <code>MarkerClusterer</code> begins
                                     *  clustering markers.
                                     * @name MarkerClusterer#clusteringbegin
                                     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, 'clusteringbegin', this);

                                    if (typeof this.timerRefStatic !== 'undefined') {
                                        clearTimeout(this.timerRefStatic);
                                        delete this.timerRefStatic;
                                    }
                                }

                                // Get our current map view bounds.
                                // Create a new bounds object so we don't affect the map.
                                //
                                // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
                                if (this.getMap().getZoom() > 3) {
                                    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
                                        this.getMap().getBounds().getNorthEast());
                                } else {
                                    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
                                }
                                var bounds = this.getExtendedBounds(mapBounds);

                                var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

                                var _ms = this.markers_.values();
                                for (i = iFirst; i < iLast; i++) {
                                    marker = _ms[i];
                                    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
                                        if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
                                            this.addToClosestCluster_(marker);
                                        }
                                    }
                                }

                                if (iLast < this.markers_.length) {
                                    this.timerRefStatic = setTimeout(function () {
                                        cMarkerClusterer.createClusters_(iLast);
                                    }, 0);
                                } else {
                                    // custom addition by ui-gmap
                                    // update icon for all clusters
                                    for (i = 0; i < this.clusters_.length; i++) {
                                        this.clusters_[i].updateIcon_();
                                    }

                                    delete this.timerRefStatic;

                                    /**
                                     * This event is fired when the <code>MarkerClusterer</code> stops
                                     *  clustering markers.
                                     * @name MarkerClusterer#clusteringend
                                     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
                                     * @event
                                     */
                                    google.maps.event.trigger(this, 'clusteringend', this);
                                }
                            };

                            /**
                             * Adds a marker to a cluster, or creates a new cluster.
                             *
                             * @param {google.maps.Marker} marker The marker to add.
                             */
                            NgMapMarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
                                var i, d, cluster, center;
                                var distance = 40000; // Some large number
                                var clusterToAddTo = null;
                                for (i = 0; i < this.clusters_.length; i++) {
                                    cluster = this.clusters_[i];
                                    center = cluster.getCenter();
                                    if (center) {
                                        d = this.distanceBetweenPoints_(center, marker.getPosition());
                                        if (d < distance) {
                                            distance = d;
                                            clusterToAddTo = cluster;
                                        }
                                    }
                                }

                                if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
                                    clusterToAddTo.addMarker(marker);
                                } else {
                                    cluster = new NgMapCluster(this);
                                    cluster.addMarker(marker);
                                    this.clusters_.push(cluster);
                                }
                            };

                            /**
                             * Redraws all the clusters.
                             */
                            NgMapMarkerClusterer.prototype.redraw_ = function () {
                                this.createClusters_(0);
                            };


                            /**
                             * Removes all clusters from the map. The markers are also removed from the map
                             *  if <code>opt_hide</code> is set to <code>true</code>.
                             *
                             * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
                             *  from the map.
                             */
                            NgMapMarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
                                var i, marker;
                                // Remove all the clusters
                                for (i = 0; i < this.clusters_.length; i++) {
                                    this.clusters_[i].remove();
                                }
                                this.clusters_ = [];

                                // Reset the markers to not be added and to be removed from the map.
                                this.markers_.each(function (marker) {
                                    marker.isAdded = false;
                                    if (opt_hide) {
                                        marker.setMap(null);
                                    }
                                });
                            };

                            /**
                             * Extends an object's prototype by another's.
                             *
                             * @param {Object} obj1 The object to be extended.
                             * @param {Object} obj2 The object to extend with.
                             * @return {Object} The new extended object.
                             * @ignore
                             */
                            NgMapMarkerClusterer.prototype.extend = function (obj1, obj2) {
                                return (function (object) {
                                    var property;
                                    for (property in object.prototype) {
                                        if (property !== 'constructor')
                                            this.prototype[property] = object.prototype[property];
                                    }
                                    return this;
                                }).apply(obj1, [obj2]);
                            };
                            ////////////////////////////////////////////////////////////////////////////////
                            /*
                             Other overrides relevant to MarkerClusterPlus
                             */
                            ////////////////////////////////////////////////////////////////////////////////
                            /**
                             * Positions and shows the icon.
                             */
                            ClusterIcon.prototype.show = function () {
                                if (this.div_) {
                                    var img = "";
                                    // NOTE: values must be specified in px units
                                    var bp = this.backgroundPosition_.split(" ");
                                    var spriteH = parseInt(bp[0].trim(), 10);
                                    var spriteV = parseInt(bp[1].trim(), 10);
                                    var pos = this.getPosFromLatLng_(this.center_);
                                    this.div_.style.cssText = this.createCss(pos);
                                    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
                                    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
                                        img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
                                            ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
                                    }
                                    // ADDED FOR RETINA SUPPORT
                                    else {
                                        img += "width: " + this.width_ + "px;" + "height: " + this.height_ + "px;";
                                    }
                                    // END ADD
                                    img += "'>";
                                    this.div_.innerHTML = img + "<div style='" +
                                        "position: absolute;" +
                                        "top: " + this.anchorText_[0] + "px;" +
                                        "left: " + this.anchorText_[1] + "px;" +
                                        "color: " + this.textColor_ + ";" +
                                        "font-size: " + this.textSize_ + "px;" +
                                        "font-family: " + this.fontFamily_ + ";" +
                                        "font-weight: " + this.fontWeight_ + ";" +
                                        "font-style: " + this.fontStyle_ + ";" +
                                        "text-decoration: " + this.textDecoration_ + ";" +
                                        "text-align: center;" +
                                        "width: " + this.width_ + "px;" +
                                        "line-height:" + this.height_ + "px;" +
                                        "'>" + this.sums_.text + "</div>";
                                    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
                                        this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
                                    } else {
                                        this.div_.title = this.sums_.title;
                                    }
                                    this.div_.style.display = "";
                                }
                                this.visible_ = true;
                            };
                            //END OTHER OVERRIDES
                            ////////////////////////////////////////////////////////////////////////////////

                            return NgMapMarkerClusterer;

                        })(MarkerClusterer);
                    }).call(this);
                })
            };
        }]);
}( window,angular));
},{}],5:[function(require,module,exports){
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * A bug is fixed in this copied version: https://github.com/willdurand/BazingaJsTranslationBundle/issues/332
 * Fixed on line 336 - 339
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * @author William DURAND <william.durand1@gmail.com>
 * @license MIT Licensed
 */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('intl-messageformat'));
    }
    else if (typeof define === 'function' && define.amd) {
        define(['intl-messageformat'], factory);
    }
    else {
        root.Translator = factory(root.IntlMessageFormat);
    }
}(this, function (IntlMessageFormat) {
    "use strict";

    var _messages     = {},
        _fallbackLocale = 'en',
        _domains      = [],
        _sPluralRegex = new RegExp(/^\w+\: +(.+)$/),
        _cPluralRegex = new RegExp(/^\s*((\{\s*(\-?\d+[\s*,\s*\-?\d+]*)\s*\})|([\[\]])\s*(-Inf|\-?\d+)\s*,\s*(\+?Inf|\-?\d+)\s*([\[\]]))\s?(.+?)$/),
        _iPluralRegex = new RegExp(/^\s*(\{\s*(\-?\d+[\s*,\s*\-?\d+]*)\s*\})|([\[\]])\s*(-Inf|\-?\d+)\s*,\s*(\+?Inf|\-?\d+)\s*([\[\]])/),
        INTL_DOMAIN_SUFFIX = '+intl-icu';

    var Translator = {
        /**
         * The current locale.
         *
         * @type {String}
         * @api public
         */
        locale: get_current_locale(),

        /**
         * Fallback locale.
         *
         * @type {String}
         * @api public
         */
        fallback: _fallbackLocale,

        /**
         * Placeholder prefix.
         *
         * @type {String}
         * @api public
         */
        placeHolderPrefix: '%',

        /**
         * Placeholder suffix.
         *
         * @type {String}
         * @api public
         */
        placeHolderSuffix: '%',

        /**
         * Default domain.
         *
         * @type {String}
         * @api public
         */
        defaultDomain: 'messages',

        /**
         * Plural separator.
         *
         * @type {String}
         * @api public
         */
        pluralSeparator: '|',

        /**
         * Adds a translation entry.
         *
         * @param {String} id         The message id
         * @param {String} message    The message to register for the given id
         * @param {String} [domain]   The domain for the message or null to use the default
         * @param {String} [locale]   The locale or null to use the default
         * @return {Object}           Translator
         * @api public
         */
        add: function(id, message, domain, locale) {
            var _locale = locale || this.locale || this.fallback,
                _domain = domain || this.defaultDomain;

            if (!_messages[_locale]) {
                _messages[_locale] = {};
            }

            if (!_messages[_locale][_domain]) {
                _messages[_locale][_domain] = {};
            }

            _messages[_locale][_domain][id] = message;

            if (false === exists(_domains, _domain)) {
                _domains.push(_domain);
            }

            return this;
        },


        /**
         * Translates the given message.
         *
         * @param {String} id               The message id
         * @param {Object} [parameters]     An array of parameters for the message
         * @param {String} [domain]         The domain for the message or null to guess it
         * @param {String} [locale]         The locale or null to use the default
         * @return {String}                 The translated string
         * @api public
         */
        trans: function(id, parameters, domain, locale) {
            var _additionalReturn = {};
            var _message = get_message(
                id,
                domain,
                locale,
                this.locale,
                this.fallback,
                _additionalReturn
            );

            if (_additionalReturn.isICU) {
                if (typeof IntlMessageFormat === 'undefined') {
                    throw new Error('The dependency "IntlMessageFormat" is required to use ICU MessageFormat but it has not been found. Please read https://github.com/willdurand/BazingaJsTranslationBundle/blob/master/Resources/doc/index.md#using-icu-messageformat')
                }

                var mf = new IntlMessageFormat.IntlMessageFormat(_message, undefined, undefined, {ignoreTag: true});

                return mf.format(parameters || {});
            }

            return replace_placeholders(_message, parameters || {});
        },

        /**
         * Translates the given choice message by choosing a translation according to a number.
         *
         * @param {String} id               The message id
         * @param {Number} number           The number to use to find the indice of the message
         * @param {Object} [parameters]     An array of parameters for the message
         * @param {String} [domain]         The domain for the message or null to guess it
         * @param {String} [locale]         The locale or null to use the default
         * @return {String}                 The translated string
         * @api public
         */
        transChoice: function(id, number, parameters, domain, locale) {
            var _message = get_message(
                id,
                domain,
                locale,
                this.locale,
                this.fallback
            );

            var _number  = parseInt(number, 10);
            parameters = parameters || {};

            if (parameters.count === undefined) {
                parameters.count = number;
            }

            if (typeof _message !== 'undefined' && !isNaN(_number)) {
                _message = pluralize(
                    _message,
                    _number,
                    locale || this.locale || this.fallback
                );
            }

            return replace_placeholders(_message, parameters);
        },

        /**
         * Loads translations from JSON.
         *
         * @param {String} data     A JSON string or object literal
         * @return {Object}         Translator
         * @api public
         */
        fromJSON: function(data) {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }

            if (data.locale) {
                this.locale = data.locale;
            }

            if (data.fallback) {
                this.fallback = data.fallback;
            }

            if (data.defaultDomain) {
                this.defaultDomain = data.defaultDomain;
            }

            if (data.translations) {
                for (var locale in data.translations) {
                    for (var domain in data.translations[locale]) {
                        for (var id in data.translations[locale][domain]) {
                            this.add(id, data.translations[locale][domain][id], domain, locale);
                        }
                    }
                }
            }

            return this;
        },

        /**
         * @api public
         */
        reset: function() {
            _messages   = {};
            _domains    = [];
            this.locale = get_current_locale();
        }
    };

    /**
     * Replace placeholders in given message.
     *
     * **WARNING:** used placeholders are removed.
     *
     * @param {String} message      The translated message
     * @param {Object} placeholders The placeholders to replace
     * @return {String}             A human readable message
     * @api private
     */
    function replace_placeholders(message, placeholders) {
        var _i,
            _prefix = Translator.placeHolderPrefix,
            _suffix = Translator.placeHolderSuffix;

        for (_i in placeholders) {
            var _r = new RegExp(_prefix + _i + _suffix, 'g');

            if (_r.test(message)) {
                var _v = String(placeholders[_i]).replace(new RegExp('\\$', 'g'), '$$$$');
                message = message.replace(_r, _v);
            }
        }

        return message;
    }

    /**
     * Get the message based on its id, its domain, and its locale. If domain or
     * locale are not specified, it will try to find the message using fallbacks.
     *
     * @param {String} id               The message id
     * @param {String} domain           The domain for the message or null to guess it
     * @param {String} locale           The locale or null to use the default
     * @param {String} currentLocale    The current locale or null to use the default
     * @param {String} localeFallback   The fallback (default) locale
     * @param {Object} additionalReturn An object passed by reference, used to return more data than the message
     * @return {String}                 The right message if found, `undefined` otherwise
     * @api private
     */
    function get_message(id, domain, locale, currentLocale, localeFallback, additionalReturn) {
        var _locale = locale || currentLocale || localeFallback,
            _domain = domain,
            _additionalReturn = additionalReturn || {};

        var nationalLocaleFallback = _locale.split('_')[0];

        _additionalReturn.isICU = false;

        if (!(_locale in _messages)) {
            if (!(nationalLocaleFallback in _messages)) {
                if (!(localeFallback in _messages)) {
                    return id;
                }
                _locale = localeFallback;
            } else {
                _locale = nationalLocaleFallback;
            }
        }

        if (typeof _domain === 'undefined' || null === _domain) {
            for (var i = 0; i < _domains.length; i++) {
                if (has_message(_locale, _domains[i], id) ||
                    has_message(nationalLocaleFallback, _domains[i], id) ||
                    has_message(localeFallback, _domains[i], id)) {
                    _domain = _domains[i].replace(INTL_DOMAIN_SUFFIX, '');

                    break;
                }
            }
        }

        if (has_message(_locale, _domain + INTL_DOMAIN_SUFFIX, id)) {
            _additionalReturn.isICU = true;
            return _messages[_locale][_domain + INTL_DOMAIN_SUFFIX][id];
        }

        if (has_message(_locale, _domain, id)) {
            return _messages[_locale][_domain][id];
        }

        var _length, _parts, _last, _lastLength;

        while (_locale.length > 2) {
            _length     = _locale.length;
            _parts      = _locale.split(/[\s_]+/);
            _last       = _parts[_parts.length - 1];
            _lastLength = _last.length;

            if (1 === _parts.length) {
                break;
            }

            _locale = _locale.substring(0, _length - (_lastLength + 1));

            if (has_message(_locale, _domain, id)) {
                return _messages[_locale][_domain][id];
            }
        }

        if (has_message(nationalLocaleFallback, _domain + INTL_DOMAIN_SUFFIX, id)) {
            _additionalReturn.isICU = true;
            return _messages[nationalLocaleFallback][_domain + INTL_DOMAIN_SUFFIX][id];
        }

        if (has_message(localeFallback, _domain, id)) {
            return _messages[localeFallback][_domain][id];
        }

        return id;
    }

    /**
     * Just look for a specific locale / domain / id if the message is available,
     * helpful for message availability validation
     *
     * @param {String} locale           The locale
     * @param {String} domain           The domain for the message
     * @param {String} id               The message id
     * @return {Boolean}                Return `true` if message is available,
     *                      `               false` otherwise
     * @api private
     */
    function has_message(locale, domain, id) {
        if (!(locale in _messages)) {
            return false;
        }

        if (!(domain in _messages[locale])) {
            return false;
        }

        if (!(id in _messages[locale][domain])) {
            return false;
        }

        return true;
    }

    /**
     * The logic comes from the Symfony2 PHP Framework.
     *
     * Given a message with different plural translations separated by a
     * pipe (|), this method returns the correct portion of the message based
     * on the given number, the current locale and the pluralization rules
     * in the message itself.
     *
     * The message supports two different types of pluralization rules:
     *
     * interval: {0} There is no apples|{1} There is one apple|]1,Inf] There is %count% apples
     * indexed:  There is one apple|There is %count% apples
     *
     * The indexed solution can also contain labels (e.g. one: There is one apple).
     * This is purely for making the translations more clear - it does not
     * affect the functionality.
     *
     * The two methods can also be mixed:
     *     {0} There is no apples|one: There is one apple|more: There is %count% apples
     *
     * @param {String} message  The message id
     * @param {Number} number   The number to use to find the indice of the message
     * @param {String} locale   The locale
     * @return {String}         The message part to use for translation
     * @api private
     */
    function pluralize(message, number, locale) {
        var _p,
            _e,
            _explicitRules = [],
            _standardRules = [],
            _parts         = message.split(Translator.pluralSeparator),
            _matches       = [];

        for (_p = 0; _p < _parts.length; _p++) {
            var _part = _parts[_p];

            if (_cPluralRegex.test(_part)) {
                _matches = _part.match(_cPluralRegex);
                _explicitRules[_matches[0]] = _matches[_matches.length - 1];
            } else if (_sPluralRegex.test(_part)) {
                _matches = _part.match(_sPluralRegex);
                _standardRules.push(_matches[1]);
            } else {
                _standardRules.push(_part);
            }
        }

        for (_e in _explicitRules) {
            if (_iPluralRegex.test(_e)) {
                _matches = _e.match(_iPluralRegex);

                if (_matches[1]) {
                    var _ns = _matches[2].split(','),
                        _n;

                    for (_n in _ns) {
                        if (number == _ns[_n]) {
                            return _explicitRules[_e];
                        }
                    }
                } else {
                    var _leftNumber  = convert_number(_matches[4]);
                    var _rightNumber = convert_number(_matches[5]);

                    if (('[' === _matches[3] ? number >= _leftNumber : number > _leftNumber) &&
                        (']' === _matches[6] ? number <= _rightNumber : number < _rightNumber)) {
                        return _explicitRules[_e];
                    }
                }
            }
        }

        return _standardRules[plural_position(number, locale)] || _standardRules[0] || undefined;
    }

    /**
     * The logic comes from the Symfony2 PHP Framework.
     *
     * Convert number as String, "Inf" and "-Inf"
     * values to number values.
     *
     * @param {String} number   A literal number
     * @return {Number}         The int value of the number
     * @api private
     */
    function convert_number(number) {
        if ('-Inf' === number) {
            return Number.NEGATIVE_INFINITY;
        } else if ('+Inf' === number || 'Inf' === number) {
            return Number.POSITIVE_INFINITY;
        }

        return parseInt(number, 10);
    }

    /**
     * The logic comes from the Symfony2 PHP Framework.
     *
     * Returns the plural position to use for the given locale and number.
     *
     * @param {Number} number  The number to use to find the indice of the message
     * @param {String} locale  The locale
     * @return {Number}        The plural position
     * @api private
     */
    function plural_position(number, locale) {
        var _locale = locale;

        if ('pt_BR' === _locale) {
            _locale = 'xbr';
        }

        if (_locale.length > 3) {
            _locale = _locale.split('_')[0];
        }

        switch (_locale) {
            case 'bo':
            case 'dz':
            case 'id':
            case 'ja':
            case 'jv':
            case 'ka':
            case 'km':
            case 'kn':
            case 'ko':
            case 'ms':
            case 'th':
            case 'tr':
            case 'vi':
            case 'zh':
                return 0;
            case 'af':
            case 'az':
            case 'bn':
            case 'bg':
            case 'ca':
            case 'da':
            case 'de':
            case 'el':
            case 'en':
            case 'eo':
            case 'es':
            case 'et':
            case 'eu':
            case 'fa':
            case 'fi':
            case 'fo':
            case 'fur':
            case 'fy':
            case 'gl':
            case 'gu':
            case 'ha':
            case 'he':
            case 'hu':
            case 'is':
            case 'it':
            case 'ku':
            case 'lb':
            case 'ml':
            case 'mn':
            case 'mr':
            case 'nah':
            case 'nb':
            case 'ne':
            case 'nl':
            case 'nn':
            case 'no':
            case 'om':
            case 'or':
            case 'pa':
            case 'pap':
            case 'ps':
            case 'pt':
            case 'so':
            case 'sq':
            case 'sv':
            case 'sw':
            case 'ta':
            case 'te':
            case 'tk':
            case 'ur':
            case 'zu':
                return (number == 1) ? 0 : 1;

            case 'am':
            case 'bh':
            case 'fil':
            case 'fr':
            case 'gun':
            case 'hi':
            case 'ln':
            case 'mg':
            case 'nso':
            case 'xbr':
            case 'ti':
            case 'wa':
                return ((number === 0) || (number == 1)) ? 0 : 1;

            case 'be':
            case 'bs':
            case 'hr':
            case 'ru':
            case 'sr':
            case 'uk':
                return ((number % 10 == 1) && (number % 100 != 11)) ? 0 : (((number % 10 >= 2) && (number % 10 <= 4) && ((number % 100 < 10) || (number % 100 >= 20))) ? 1 : 2);

            case 'cs':
            case 'sk':
                return (number == 1) ? 0 : (((number >= 2) && (number <= 4)) ? 1 : 2);

            case 'ga':
                return (number == 1) ? 0 : ((number == 2) ? 1 : 2);

            case 'lt':
                return ((number % 10 == 1) && (number % 100 != 11)) ? 0 : (((number % 10 >= 2) && ((number % 100 < 10) || (number % 100 >= 20))) ? 1 : 2);

            case 'sl':
                return (number % 100 == 1) ? 0 : ((number % 100 == 2) ? 1 : (((number % 100 == 3) || (number % 100 == 4)) ? 2 : 3));

            case 'mk':
                return (number % 10 == 1) ? 0 : 1;

            case 'mt':
                return (number == 1) ? 0 : (((number === 0) || ((number % 100 > 1) && (number % 100 < 11))) ? 1 : (((number % 100 > 10) && (number % 100 < 20)) ? 2 : 3));

            case 'lv':
                return (number === 0) ? 0 : (((number % 10 == 1) && (number % 100 != 11)) ? 1 : 2);

            case 'pl':
                return (number == 1) ? 0 : (((number % 10 >= 2) && (number % 10 <= 4) && ((number % 100 < 12) || (number % 100 > 14))) ? 1 : 2);

            case 'cy':
                return (number == 1) ? 0 : ((number == 2) ? 1 : (((number == 8) || (number == 11)) ? 2 : 3));

            case 'ro':
                return (number == 1) ? 0 : (((number === 0) || ((number % 100 > 0) && (number % 100 < 20))) ? 1 : 2);

            case 'ar':
                return (number === 0) ? 0 : ((number == 1) ? 1 : ((number == 2) ? 2 : (((number >= 3) && (number <= 10)) ? 3 : (((number >= 11) && (number <= 99)) ? 4 : 5))));

            default:
                return 0;
        }
    }

    /**
     * @type {Array}        An array
     * @type {String}       An element to compare
     * @return {Boolean}    Return `true` if `array` contains `element`,
     *                      `false` otherwise
     * @api private
     */
    function exists(array, element) {
        for (var i = 0; i < array.length; i++) {
            if (element === array[i]) {
                return true;
            }
        }

        return false;
    }

    /**
     * Get the current application's locale based on the `lang` attribute
     * on the `html` tag.
     *
     * @return {String}     The current application's locale
     * @api private
     */
    function get_current_locale() {
        if (typeof document !== 'undefined') {
            return document.documentElement.lang.replace('-', '_');
        }
        else {
            return _fallbackLocale;
        }
    }

    return Translator;
}));

},{"intl-messageformat":30}],6:[function(require,module,exports){
/*! angular-shims-placeholder - v0.4.6 - 2015-10-21
 * https://github.com/cvn/angular-shims-placeholder
 * Copyright (c) 2015 Chad von Nau; Licensed MIT */
(function(angular, document, undefined) {
    'use strict';

    angular.module('ng.shims.placeholder', [])
        .service('placeholderSniffer', ['$document', function($document){
            this.emptyClassName = 'empty',
                this.hasPlaceholder = function() {
                    // test for native placeholder support
                    var test = $document[0].createElement('input');
                    return (test.placeholder !== void 0);
                };
        }])
        .directive('placeholder', ['$timeout', '$document', '$interpolate', '$injector', 'placeholderSniffer', function($timeout, $document, $interpolate, $injector, placeholderSniffer) {
            if (placeholderSniffer.hasPlaceholder()) return {};

            var documentListenersApplied = false,
                angularVersion = parseFloat(angular.version.full);

            // load $animate if available, to coordinate with other directives that use it
            try {
                var $animate = $injector.get('$animate');
            } catch (e) {}

            // No native support for attribute placeholder
            return {
                restrict: 'A',
                require: '?ngModel',
                // run after ngModel (0) and BOOLEAN_ATTR (100) directives.
                // priority order was reversed in Angular 1.2, so we must account for this
                priority: (angularVersion >= 1.2) ? 110 : -10,
                link: function(scope, elem, attrs, ngModel) {
                    var orig_val = getValue(),
                        domElem = elem[0],
                        elemType = domElem.nodeName.toLowerCase(),
                        isInput = elemType === 'input' || elemType === 'textarea',
                        is_pwd = attrs.type === 'password',
                        text = attrs.placeholder || '',
                        emptyClassName = placeholderSniffer.emptyClassName,
                        hiddenClassName = 'ng-hide',
                        clone;

                    if (!isInput) { return; }

                    attrs.$observe('placeholder', function (newValue) {
                        changePlaceholder(newValue);
                    });

                    if (is_pwd) { setupPasswordPlaceholder(); }

                    // init
                    setValue(orig_val);

                    // on focus, replace auto-label with empty field
                    elem.bind('focus', function() {
                        if (elem.hasClass(emptyClassName)) {
                            elem.val('');
                            elem.removeClass(emptyClassName);
                            domElem.select(); // IE8/9 show text cursor after tabbing in
                        }
                    });

                    // on blur, show placeholder if necessary
                    elem.bind('blur', updateValue);

                    // handler for model-less inputs to interact with non-angular code
                    if (!ngModel) {
                        elem.bind('change', function (event) {
                            changePlaceholder($interpolate(elem.attr('placeholder') || '')(scope), event);
                        });
                    }

                    // model -> view
                    if (ngModel) {
                        ngModel.$render = function() {
                            setValue(ngModel.$viewValue);
                            // IE8/9: show text cursor after updating value while
                            // focused, this happens when tabbing into a field, and the
                            // deferred keydown handler from the previous field fires
                            //
                            // TODO: remove when tab key behavior is fixed in
                            // angular core
                            if (isActiveElement(domElem) && !elem.val()) {
                                domElem.select();
                            }
                        };
                    }

                    if (!documentListenersApplied) {
                        // cancel selection of placeholder text on disabled elements
                        // disabled elements do not emit selectstart events in IE8/IE9,
                        // so bind to $document and catch the event as it bubbles
                        $document.bind('selectstart', function (e) {
                            var elmn = angular.element(e.target);
                            if (elmn.hasClass(emptyClassName) && elmn.prop('disabled')) {
                                e.preventDefault();
                            }
                        });
                        documentListenersApplied = true;
                    }

                    function updateValue(event) {
                        var val = elem.val();

                        // don't update from placeholder, helps debounce
                        if (elem.hasClass(emptyClassName) && val && val === text) { return; }

                        conditionalDefer(function(){ setValue(val); }, event);
                    }

                    function conditionalDefer(callback, event) {
                        // IE8/9: ngModel uses a keydown handler with deferrered
                        // execution to check for changes to the input. this $timeout
                        // prevents callback from firing before the keydown handler,
                        // which is an issue when tabbing out of an input.
                        // the conditional tests IE version, matches $sniffer.
                        //
                        // TODO: remove this function when tab key behavior is fixed in
                        // angular core
                        if (document.documentMode <= 11 && event) {
                            $timeout(callback, 0);
                        } else {
                            callback();
                        }
                    }

                    function setValue(val) {
                        if (!val && val !== 0 && !isActiveElement(domElem)) {
                            // show placeholder when necessary
                            elem.addClass(emptyClassName);
                            elem.val(!is_pwd ? text : '');
                        } else {
                            // otherwise set input to actual value
                            elem.removeClass(emptyClassName);
                            elem.val(val);
                        }
                        if (is_pwd) {
                            updatePasswordPlaceholder();
                            if ($animate) {
                                asyncUpdatePasswordPlaceholder();
                            }
                        }
                    }

                    function getValue() {
                        if (ngModel) {
                            // use eval because $viewValue isn't ready during init
                            // TODO: this might not to work during unit tests, investigate
                            return scope.$eval(attrs.ngModel) || '';
                        }
                        return getDomValue() || '';
                    }

                    // IE8/9: elem.val() on an empty field sometimes returns the
                    // placeholder value, so return an empty string instead
                    // http://stackoverflow.com/q/11208417/490592
                    // I believe IE is persisting the field value across refreshes
                    // TODO: vs `elem.attr('value')`
                    function getDomValue() {
                        var val = elem.val();
                        if (val === attrs.placeholder) {
                            val = '';
                        }
                        return val;
                    }

                    function changePlaceholder(value, event) {
                        if (elem.hasClass(emptyClassName) && elem.val() === text) {
                            elem.val('');
                        }
                        text = value;
                        updateValue(event);
                    }

                    // IE9: getting activeElement in an iframe raises error
                    // http://tjvantoll.com/2013/08/30/bugs-with-document-activeelement-in-internet-explorer/
                    function isActiveElement(elmn) {
                        var result = false;
                        try {
                            result = elmn === document.activeElement;
                        } catch (error) {}
                        return result;
                    }

                    function setAttrConditional(elmn, attr, enable, value) {
                        if (enable) {
                            elmn.attr(attr, value);
                        } else {
                            elmn.removeAttr(attr);
                        }
                    }

                    // IE8: password inputs cannot display text, and inputs cannot
                    // change type, so create a new element to display placeholder
                    function setupPasswordPlaceholder() {
                        clone = angular.element('<input type="text" value="'+text+'"/>');
                        stylePasswordPlaceholder();
                        hideElement(clone);
                        clone.addClass(emptyClassName)
                            .bind('focus', hidePasswordPlaceholderAndFocus);
                        domElem.parentNode.insertBefore(clone[0], domElem);

                        // keep password placeholder in sync with original element.
                        // update element after $watches
                        var watchAttrs = [
                            attrs.ngDisabled,
                            attrs.ngReadonly,
                            attrs.ngRequired,
                            attrs.ngShow,
                            attrs.ngHide
                        ];
                        for (var i = 0; i < watchAttrs.length; i++) {
                            if (watchAttrs[i]) {
                                scope.$watch(watchAttrs[i], flexibleUpdatePasswordPlaceholder);
                            }
                        }
                    }

                    function updatePasswordPlaceholder() {
                        stylePasswordPlaceholder();
                        if (isNgHidden()) {
                            // force hide the placeholder when element is hidden by
                            // ngShow/ngHide. we cannot rely on stylePasswordPlaceholder
                            // above to copy the ng-hide class, because the ngShow/ngHide
                            // $watch functions apply the ng-hide class with $animate,
                            // so the class is not applied when our $watch executes
                            hideElement(clone);
                        } else if (elem.hasClass(emptyClassName) && domElem !== document.activeElement) {
                            showPasswordPlaceholder();
                        } else {
                            hidePasswordPlaceholder();
                        }
                    }
                    // update element after animation and animation-aware directives
                    function asyncUpdatePasswordPlaceholder() {
                        if (angularVersion >= 1.3) {
                            $animate.addClass(elem, '').then(updatePasswordPlaceholder);
                        } else {
                            $animate.addClass(elem, '', updatePasswordPlaceholder);
                        }
                    }
                    function flexibleUpdatePasswordPlaceholder() {
                        if ($animate) {
                            asyncUpdatePasswordPlaceholder();
                        } else {
                            updatePasswordPlaceholder();
                        }
                    }

                    function stylePasswordPlaceholder() {
                        clone.val(text);
                        // chaining was failing in v1.0.8
                        clone.attr('class', elem.attr('class') || '')
                            .attr('style', elem.attr('style') || '')
                            .prop('disabled', elem.prop('disabled'))
                            .prop('readOnly', elem.prop('readOnly'))
                            .prop('required', elem.prop('required'));
                        setAttrConditional(clone, 'unselectable', elem.attr('unselectable') === 'on', 'on');
                        setAttrConditional(clone, 'tabindex', elem.attr('tabindex') !== undefined, elem.attr('tabindex'));
                    }

                    function showElement(elmn) {
                        if (angularVersion >= 1.2) {
                            elmn.removeClass(hiddenClassName);
                        } else {
                            elmn.css('display', '');
                        }
                    }

                    function hideElement(elmn) {
                        if (angularVersion >= 1.2) {
                            elmn.addClass(hiddenClassName);
                        } else {
                            elmn.css('display', 'none');
                        }
                    }

                    function showPasswordPlaceholder() {
                        hideElement(elem);
                        showElement(clone);
                    }

                    function hidePasswordPlaceholder() {
                        hideElement(clone);
                        showElement(elem);
                    }

                    function hidePasswordPlaceholderAndFocus() {
                        hidePasswordPlaceholder();
                        domElem.focus();
                    }

                    function isNgHidden() {
                        var hasNgShow = typeof attrs.ngShow !== 'undefined',
                            hasNgHide = typeof attrs.ngHide !== 'undefined';
                        if (hasNgShow || hasNgHide) {
                            return (hasNgShow && !scope.$eval(attrs.ngShow)) ||
                                (hasNgHide && scope.$eval(attrs.ngHide));
                        } else {
                            return false;
                        }
                    }

                }
            };
        }]);

})(window.angular, window.document);

},{}],7:[function(require,module,exports){
'use strict';

angular.module('b2bRegistrationFlowBundle.services').factory('CountryBusinessTypesRepository', ['$resource',
    function ($resource) {
        return $resource('/companies/country/:countryId/businessTypes.json', {
            countryId: '@countryId',
        }, {
            get: {method: 'GET', isArray: true},
        });
    }]);

},{}],8:[function(require,module,exports){
var module = angular.module('sdLocalStorageHelper', ['ngStorage']);
module.service('sdLocalStorageHelper', function ($localStorage) {
    return {
        get: function (objName, dataObject) {
            var data = $localStorage[objName];
            if ((null !== data && typeof data !== 'undefined') && typeof dataObject !== 'undefined') {
                angular.forEach(dataObject, function(value, key) {
                    dataObject[key] = data[key] || dataObject[key];
                });
                angular.forEach(data, function(value, key) {
                    dataObject[key] = data[key] || dataObject[key];
                });
            }
            return dataObject;
        },
        set: function (objName, data) {

            $localStorage[objName] = data;
        },
        reset: function () {
            $localStorage.$reset();
        }
    }
});

},{}],9:[function(require,module,exports){
angular.module('sdDuplicatedEmailValidation', []).directive('sdDuplicatedEmailValidation', function ($http, $q) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {

            var efficientValidateRequest = debounce(function (deferred, modelValue) {
                if (modelValue === undefined) {
                    deferred.resolve();
                    return;
                }

                var remotePromise = $http.jsonp(attr.sdDuplicatedEmailValidation, {
                    params: {
                        'value': modelValue,
                        'companyId': attr.sdCompanyId,
                        'callback': 'JSON_CALLBACK'
                    }
                });

                remotePromise.success(function (value) {
                    if (value === false && modelValue !== '') {
                        deferred.reject();
                    } else {
                        deferred.resolve();
                    }
                });

                remotePromise.error(function () {
                    deferred.reject();
                });
            }, 1000);

            var validate = function (modelValue) {
                var deferred = $q.defer();
                efficientValidateRequest(deferred, modelValue);
                return deferred.promise;
            };

            ngModel.$asyncValidators.duplicated = function (modelValue) {
                return validate(modelValue);
            };
        }
    }
});

},{}],10:[function(require,module,exports){
angular.module('sdGroupRequiredValidator', []).directive('sdGroupRequiredValidator', function () {
    var groups = {};

    function isGroupRequired(groupName) {
        var group = groups[groupName];
        if (!group) return false;

        var keys = Object.keys(group);

        return keys.every(function (key, index, array) {
            return (key === 'isRequired') || !group[key];
        });
    }

    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {},
        link: function (scope, elem, attrs, ctrl) {

            if (!ctrl || !attrs.sdGroupRequiredValidator) return;

            var groupName = attrs.sdGroupRequiredValidator;

            if (groups[groupName] === undefined) {
                groups[groupName] = {isRequired: true};
            }

            var group = scope.group = groups[groupName];

            scope.$on('$destroy', function () {
                delete(group[scope.$id]);
                // if (Object.keys(group).length <= 1) {
                //     delete(groups[groupName]);
                // }
            });

            function updateValidity() {
                var isValid = !group.isRequired;

                ctrl.$setValidity('required', isValid);
            }

            function validate(value) {
                group[scope.$id] = !ctrl.$isEmpty(value);
                group.isRequired = isGroupRequired(groupName);

                updateValidity();
                return value;
            }

            ctrl.$parsers.push(validate);
            ctrl.$formatters.push(validate);
            scope.$watch('group.isRequired', updateValidity);
        }
    };

});
},{}],11:[function(require,module,exports){
/*globals b2bFreetrialConstraint:true */
angular.module('sdLondonValidator', []).directive('sdLondonValidator', function(){
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs) {

            if (typeof b2bFreetrialConstraint.radiusMaxLondon === 'undefined') {
                return;
            }
            if (typeof b2bFreetrialConstraint.orginalRadiusMin === 'undefined') {
                b2bFreetrialConstraint.orginalRadiusMin = b2bFreetrialConstraint.radiusMin;
                b2bFreetrialConstraint.orginalRadiusMax = b2bFreetrialConstraint.radiusMax;
            }
            const londonRegex = /^(E|EC|N|NW|SE|SW|W|WC|BR|CR|DA|EN|HA|IG|KT|RM|SM|TW|UB|WD)\d{1,2}/i;
            scope.$watch(attrs.sdLondonValidator, function(newVal) {
                if (typeof newVal === 'undefined') {
                    return;
                }
                const isLondonPostcode = londonRegex.test(newVal);
                if (isLondonPostcode) {
                    b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.radiusMinLondon;
                    b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.radiusMaxLondon;
                } else {
                    b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.orginalRadiusMin;
                    b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.orginalRadiusMax;
                }
                scope.data.radius = b2bFreetrialConstraint.radiusMax;
            });
        }
    }
});

},{}],12:[function(require,module,exports){
angular.module('sdPostcodeValidator', []).directive('sdPostcodeValidator', function ($http, $q) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var url = attrs['sdPostcodeValidator'];

            var efficientValidateRequest = debounce(function (deferred, modelValue) {
                if (modelValue === undefined) {
                    deferred.resolve();
                    return;
                }

                var remotePromise = $http.jsonp(url+'/'+modelValue, {
                    params: {
                        'callback': 'JSON_CALLBACK'
                    }
                });

                remotePromise.success(function (value) {
                    if (value === false && modelValue !== '') {
                        deferred.reject();
                    } else {
                        deferred.resolve();
                    }
                });

                remotePromise.error(function () {
                    deferred.reject();
                });
            }, 500);

            var validate = function (modelValue, viewValue) {
                var deferred = $q.defer();
                efficientValidateRequest(deferred, modelValue);
                return deferred.promise;
            };

            if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 3)) {

                ctrl.$asyncValidators.postcode = function (modelValue, viewValue) {
                    var promise = validate(modelValue);
                    return promise;
                };
            } else {
                scope.$watch('model', function (newVal, oldVal) {

                    if (newVal === oldVal) {
                        return;
                    }

                    validate(newVal).then(function () {
                        ctrl.$setValidity('postcode', true);
                    }, function () {
                        ctrl.$setValidity('postcode', false);
                    });
                });
            }
        }
    }
});

},{}],13:[function(require,module,exports){
angular.module('sdRadiusValidator', []).directive('sdRadiusValidator', function ($http, $q, $parse) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var postcodeModel = $parse(attrs.sdRadiusValidatorPostcode);
            var countryModel = $parse(attrs.sdRadiusValidatorCountry);
            var radiusModel = $parse(attrs.sdRadiusValidatorRadius);
            var baseUrl = attrs.sdRadiusValidator;

            var efficientValidateRequest = debounce(function (deferred) {
                var radius = radiusModel(scope) ? radiusModel(scope) : window.b2bFreetrialConstraint.radiusMax;
                var postcode = postcodeModel(scope);
                var country = countryModel(scope);
                var remotePromise = $http.jsonp(baseUrl+'/'+ radius+'/'+ postcode+'/'+ country, {
                    params: {
                        'callback': 'JSON_CALLBACK'
                    }
                });

                remotePromise.success(function (value) {
                    if (value.success) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                });

                remotePromise.error(function () {
                    deferred.reject();
                });
            }, 500);

            var validate = function () {
                var deferred = $q.defer();
                efficientValidateRequest(deferred);
                return deferred.promise;
            };

            scope.$watch(attrs.sdRadiusValidatorRadius, function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }
                validate().then(function () {
                    ctrl.$setValidity('postcode', true);
                }, function () {
                    ctrl.$setValidity('postcode', false);
                });
            });
            if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 3)) {
                ctrl.$asyncValidators.postcode = function (modelValue, viewValue) {
                    if (modelValue === '') {
                        return $q.resolve();
                    }
                    var promise = validate();
                    return promise;
                };
            } else {
                scope.$watch(attrs.sdRadiusValidatorPostcode, function (newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }

                    validate().then(function () {
                        ctrl.$setValidity('postcode', true);
                    }, function () {
                        ctrl.$setValidity('postcode', false);
                    });
                });
            }
        }
    }
});

},{}],14:[function(require,module,exports){
angular.module('sdRemoteValidation', []).directive('sdRemoteValidation', function ($http, $q) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        require: 'ngModel',
        scope: {
            model: '=ngModel',
            url: '@sdRemoteValidation'
        },
        link: function (scope, element, attrs, ctrl) {

            var efficientValidateRequest = debounce(function (deferred, modelValue) {
                if (modelValue === undefined) {
                    deferred.resolve();
                    return;
                }

                var remotePromise = $http.jsonp(scope.url, {
                    params: {
                        'value': modelValue,
                        'callback': 'JSON_CALLBACK'
                    }
                });

                remotePromise.success(function (value) {
                    if (value === false && modelValue !== '') {
                        deferred.reject();
                    } else {
                        deferred.resolve();
                    }
                });

                remotePromise.error(function () {
                    deferred.reject();
                });
            }, 500);


            var validate = function (modelValue, viewValue) {
                var deferred = $q.defer();
                efficientValidateRequest(deferred, modelValue);
                return deferred.promise;
            };

            if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 3)) {

                ctrl.$asyncValidators.remote = function (modelValue, viewValue) {
                    var promise = validate(modelValue);
                    return promise;
                };
            } else {
                scope.$watch('model', function (newVal, oldVal) {

                    if (newVal === oldVal) {
                        return;
                    }

                    validate(newVal).then(function () {
                        ctrl.$setValidity('remote', true);
                    }, function () {
                        ctrl.$setValidity('remote', false);
                    });
                });
            }
        }
    }
});

},{}],15:[function(require,module,exports){
var angularMultiStepForm = (function (angular$1) {
    'use strict';

    angular$1 = 'default' in angular$1 ? angular$1['default'] : angular$1;

    var multiStepContainer = ['$animate', '$q', '$controller', 'multiStepForm', 'FormStep', 'formStepElement', multiStepContainer$1];

    /**
     * @ngdoc    directive
     * @name     multiStepForm:multiStepContainer
     *
     * @requires $scope
     * @requires $q
     * @requires $controller
     * @requires multiStepForm:multiStepForm
     * @requires multiStepForm:FormStep
     * @requires multiStepForm:formStepElement
     *
     * @scope
     * @description Multi step directive (overall container)
     */
    function multiStepContainer$1($animate, $q, $controller, multiStepForm, FormStep, formStepElement) {
        return {
            restrict: 'EA',
            scope: true,
            /**
             * @ngdoc    controller
             * @name     multiStepForm:MultiStepFormCtrl
             *
             * @requires $scope
             * @requires multiStepForm:multiStepForm
             *
             * @description Controls a multi step form and track progress.
             */
            controller: ['$scope', function ($scope) {
                /**
                 * @ngdoc    function
                 * @methodOf multiStepForm:MultiStepFormCtrl
                 *
                 * @description Register the step container element. This method
                 *              is invoked in the post link function of directive
                 *              {@link multiStepForm:formStepContainer formStepContainer}
                 * @param {JQLite} elm The step form container
                 */
                this.setStepContainer = function (elm) {
                    this.stepContainer = elm;
                };
            }],
            link: {
                pre: function preLink(scope, element, attrs) {
                    /**
                     * @ngdoc       property
                     * @propertyOf  multiStepForm:MultiStepFormContainer
                     * @description The form steps
                     * @type  {FormStep[]}
                     */
                    scope.formSteps = scope.$eval(attrs.steps).map(function (step) {
                        return new FormStep(step);
                    });

                    /**
                     * @ngdoc       property
                     * @propertyOf  multiStepForm:MultiStepFormContainer
                     * @description The form step titles
                     * @type  {String[]}
                     */
                    scope.stepTitles = scope.formSteps.map(function (step) {
                        return step.title;
                    });
                },
                post: function postLink(scope, element, attrs, controller) {
                    // Add .multi-step-container class
                    element.addClass('multi-step-container');
                    // Callbacks
                    var onFinish = attrs.onFinish ? resolve(attrs.onFinish) : defaultResolve;
                    var onCancel = attrs.onCancel ? resolve(attrs.onCancel) : defaultResolve;
                    var onStepChange = attrs.onStepChange ? function () {
                        return scope.$eval(attrs.onStepChange);
                    } : angular$1.noop;
                    // Step container (populated by child post link function)
                    var stepContainer = controller.stepContainer;
                    var multiStepFormInstance = multiStepForm(scope.$eval(attrs.searchId));

                    // Augment scope
                    multiStepFormInstance.augmentScope(scope);

                    // Controller
                    if (attrs.controller) {
                        var customController = $controller(attrs.controller, {
                            $scope: scope,
                            $element: element,
                            multiStepFormInstance: multiStepFormInstance
                        });
                        // controllerAs
                        if (attrs.controllerAs) {
                            scope[attrs.controllerAs] = customController;
                        }
                    }

                    // Initial step
                    var initialStep = scope.$eval(attrs.initialStep);

                    var currentLeaveAnimation = void 0,
                        currentEnterAnimation = void 0,
                        currentStepScope = void 0,
                        currentStepElement = void 0,
                        isDeferredResolved = false;

                    // Resolve any outstanding promises on destroy
                    scope.$on('$destroy', function () {
                        if (!isDeferredResolved) {
                            isDeferredResolved = true;
                            multiStepFormInstance.deferred.reject();
                        }
                    });

                    // Initialise and start the multi step form
                    multiStepFormInstance.start(scope.formSteps).then(onFinish, onCancel, function (data) {
                        var step = data.newStep;
                        var previousStep = data.oldStep;
                        var direction = angular$1.isDefined(previousStep) ? step < previousStep ? 'step-backward' : 'step-forward' : 'step-initial';

                        var formStep = scope.formSteps[step - 1];
                        // Create new step element (promise)
                        var newStepElement = formStepElement(formStep, multiStepFormInstance, scope);

                        // Add direction class to the parent container;
                        stepContainer.removeClass('step-forward step-backward step-initial').addClass(direction);

                        // Cancel current leave animation if any
                        if (currentLeaveAnimation) {
                            $animate.cancel(currentLeaveAnimation);
                        }
                        // Cancel current enter animation if any
                        if (currentEnterAnimation) {
                            $animate.cancel(currentEnterAnimation);
                        }
                        // Destroy current scope
                        if (currentStepScope) {
                            currentStepScope.$destroy();
                        }
                        // Leave current step if any
                        if (currentStepElement) {
                            currentLeaveAnimation = $animate.leave(currentStepElement);
                        }
                        // Enter new step when new step element is ready
                        newStepElement.then(function (step) {
                            onStepChange();
                            currentStepScope = step.scope;
                            currentStepElement = step.element;
                            currentStepElement.scrollTop = 0;
                            stepContainer.scrollTop = 0;
                            currentEnterAnimation = $animate.enter(currentStepElement, stepContainer);
                        }, function () {
                            throw new Error('Could not load step ' + step);
                        });
                    });

                    // Initialise currentStep
                    multiStepFormInstance.setInitialIndex(initialStep);

                    // Default resolution function
                    function defaultResolve() {
                        $animate.leave(element);
                        isDeferredResolved = true;
                        scope.$destroy();
                    }

                    // On promise resolution
                    function resolve(fn) {
                        return function () {
                            isDeferredResolved = true;
                            scope.$eval(fn);
                        };
                    }
                }
            }
        };
    }

    var formStepValidity = ['$parse', formStepValidity$1];

    /**
     * @ngdoc    directive
     * @name     multiStepForm:formStepValidity
     *
     * @restrict A
     * @description Notify the multi step form instance of a change of validity of a step.
     *              This directive can be used on a form element or within a form.
     */
    function formStepValidity$1($parse) {
        return {
            restrict: 'A',
            require: '^form',
            link: function postLink(scope, element, attrs, formCtrl) {
                // The callback to call when a change of validity
                // is detected
                var validtyChangeCallback = attrs.formStepValidity ? $parse(attrs.formStepValidity).bind(scope, scope) : scope.$setValidity;

                // Watch the form validity
                scope.$watch(function () {
                    return formCtrl.$valid;
                }, function (val) {
                    // Check if defined
                    if (angular$1.isDefined(val)) {
                        validtyChangeCallback(val);
                    }
                });
            }
        };
    }

    /**
     * @ngdoc    directive
     * @name     multiStepForm:stepContainer
     *
     * @requires multiStepForm:stepContainer
     *
     * @restrict A
     * @description The container for form steps. It registers itself with the multi step container.
     *              {@link multiStepForm:multiStepContainer multiStepContainer}
     */
    function stepContainer() {
        return {
            restrict: 'EA',
            require: '^^multiStepContainer',
            scope: false,
            link: function postLink(scope, element, attrs, multiStepCtrl) {
                element.addClass('multi-step-body');
                multiStepCtrl.setStepContainer(element);
            }
        };
    }

    var formStepElement = ['$compile', '$controller', '$http', '$injector', '$q', '$templateCache', formStepElement$1];

    /**
     * @ngdoc   function
     * @name    multiStepForm:formStepElement
     *
     * @requires $rootScope
     * @requires $controller
     *
     * @description A factory function for creating form step elements
     *              (using controller, template and resolve)
     */
    function formStepElement$1($compile, $controller, $http, $injector, $q, $templateCache) {
        /**
         * Resolve the template of a form step
         * @param  {FormStep} formStep The form step object
         * @return {Promise|String}    A promise containing the template
         */
        function resolveTemplate(formStep) {
            if (formStep.template) {
                // If function or array, use $injector to get template value
                return angular$1.isFunction(formStep.template) || angular$1.isArray(formStep.template) ? $injector.$invoke(formStep.template) : formStep.template;
            }
            // Use templateUrl
            var templateUrl =
                // If function or array, use $injector to get templateUrl value
                angular$1.isFunction(formStep.templateUrl) || angular$1.isArray(formStep.templateUrl) ? $injector.$invoke(formStep.templateUrl) : formStep.templateUrl;
            // Request templateUrl using $templateCache
            return $http.get(templateUrl, { cache: $templateCache });
        }

        /**
         * Create a new scope with the multiStepContainer being the parent scope.
         * augmented with multi step form control methods.
         * @param  {FormStep} formStep The form step object
         * @param  {FormStep} formStep The form step object
         * @return {Object} The form step scope
         */
        function getScope(scope, formStep, multiStepFormInstance) {
            var stepScope = scope.$new(formStep.isolatedScope);
            // Augment scope with multi step form instance methods
            multiStepFormInstance.augmentScope(stepScope);

            return stepScope;
        }

        /**
         * Create a form step element, compiled with controller and dependencies resolved
         *
         * @param  {FormStep} formStep            The form step object
         * @param  {Object} multiStepFormInstance The multi step form instance
         * @param  {Object} multiStepFormScope    The scope instance of the multi step form
         * @return {Promise}                      A promise containing the form step element
         */
        return function formStepElementFactory(formStep, multiStepFormInstance, multiStepFormScope) {
            var formStepElement = angular$1.element('<div>').addClass('form-step');

            var controller = void 0,
                template = void 0,
                promisesHash = {};

            // Get template
            promisesHash.$template = resolveTemplate(formStep);

            // Get resolve
            angular$1.forEach(formStep.resolve, function (resolveVal, resolveName) {
                promisesHash[resolveName] =
                    // angular.isString(resolveVal) ?
                    // $injector.get(resolveVal) :
                    $injector.invoke(resolveVal);
            });

            // After all locals are resolved (template and "resolves") //
            return $q.all(promisesHash).then(function (locals) {
                // Extend formStep locals with resolved locals
                locals = angular$1.extend({}, formStep.locals, locals);
                // Load template inside element
                locals.$template = locals.$template.data || locals.$template;
                formStepElement.html(locals.$template);
                // Create scope
                var formStepScope = getScope(multiStepFormScope, formStep, multiStepFormInstance);

                if (formStep.controller) {
                    // Create form step scope
                    locals.$scope = formStepScope;
                    // Add multi step form service instance to local injectables
                    locals.multiStepFormInstance = multiStepFormInstance;
                    // Add multi step form scope to local injectables if isolated
                    if (formStep.isolatedScope) {
                        locals.multiStepFormScope = multiStepFormScope;
                    }
                    // Instanciate controller
                    controller = $controller(formStep.controller, locals);
                    // controllerAs
                    if (formStep.controllerAs) {
                        formStepScope[formStep.controllerAs] = controller;
                    }
                    formStepElement.data('$stepController', controller);
                    // formStepElement.children().data('$ngControllerController', controller);
                }

                // Compile form step element and link with scope
                $compile(formStepElement)(formStepScope);

                // Return element and scope
                return {
                    element: formStepElement,
                    scope: formStepScope
                };
            });
        };
    }

    /**
     * @ngdoc       object
     * @name        multiStepForm:FormStep
     *
     * @description A constructor for creating form steps
     * @error       If no template or templateUrl properties are supplied
     */
    function FormStep() {
        return function FormStep(config) {
            if (!config.template && !config.templateUrl) {
                throw new Error('Either template or templateUrl properties have to be provided for' + ' multi step form' + config.title);
            }

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description The form step title
             * @type {String}
             */
            this.title = config.title;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description The form step additional data
             * @type {Object}
             */
            this.data = config.data || {};

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description The form step controller
             * @type {String|Function|Array}
             */
            this.controller = config.controller;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description An identifier name for a reference to the controller
             * @type {String}
             */
            this.controllerAs = config.controllerAs;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description The form step template
             * @type {String}
             */
            this.template = config.template;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description The form step template URL
             * @type {String}
             */
            this.templateUrl = config.templateUrl;

            /**
             * Whether or not the form step should have an isolated scope
             * @type {Boolean}
             */
            this.isolatedScope = config.isolatedScope || false;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:resolve
             *
             * @description The form step resolve map (same use than for routes)
             * @type {Object}
             */
            this.resolve = config.resolve || {};

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:resolve
             *
             * @description The form step locals map (same than resolve but for non deferred values)
             *              Note: resolve also works with non deferred values
             * @type {Object}
             */
            this.locals = config.locals || {};

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description Whether or not this form step contains a form
             * @type {Boolean}
             */
            this.hasForm = config.hasForm || false;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description Whether or not this form step is valid.
             *              Form validity can been fed back using a specific directive.
             *              {@link multiStepForm:formStepValidity formStepValidity}
             * @type {Boolean}
             */
            this.valid = false;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:FormStep
             *
             * @description Whether or not this step has been visited
             *              (i.e. the user has moved to the next step)
             * @type {Boolean}
             */
            this.visited = false;
        };
    }

    var multiStepForm = ['$q', '$location', '$rootScope', multiStepForm$1];

    /**
     * @ngdoc       function
     * @name        multiStepForm:multiStepForm
     *
     * @requires    $q
     * @requires    multiStepForm:FormStep
     *
     * @description A service returning an instance per multi step form.
     *              The instance of the service is injected in each step controller.
     */
    function multiStepForm$1($q, $location, $rootScope) {
        function MultiFormStep(searchId) {
            var _this = this;

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:multiStepForm
             *
             * @description The location search property name to store the active step index.
             * @type {String}
             */
            this.searchId = searchId;
            // If the search id is defined,
            if (angular.isDefined(searchId)) {
                $rootScope.$on('$locationChangeSuccess', function (event) {
                    var searchIndex = parseInt($location.search()[_this.searchId]);

                    if (!isNaN(searchIndex) && _this.activeIndex !== searchIndex) {
                        // Synchronise
                        _this.setActiveIndex(parseInt(searchIndex));
                    }
                });
            }

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:multiStepForm
             *
             * @description The form steps
             * @type {Array}
             */
            this.steps = [];

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:multiStepForm
             *
             * @description Return the form steps
             * @return {Array}
             */
            this.getSteps = function () {
                return this.steps;
            };

            /**
             * @ngdoc       property
             * @propertyOf  multiStepForm:multiStepForm
             *
             * @description The multi-step form deferred object
             * @type {Deferred}
             */
            this.deferred = $q.defer();

            /**
             * @ngdoc         method
             * @methodOf      multiStepForm:multiStepForm
             *
             * @description   Initialise the form steps and start
             * @error         If no steps are provided
             * @param  {Array}   steps The form steps
             * @return {Promise} A promise which will be resolved when all steps are passed,
             *                   and rejected if the user cancel the multi step form.
             */
            this.start = function (steps) {
                if (!steps || !steps.length) {
                    throw new Error('At least one step has to be defined');
                }
                // Initialise steps
                this.steps = steps;
                // Return promise
                return this.deferred.promise;
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Cancel this multi step form
             * @type {Array}
             */
            this.cancel = function () {
                this.deferred.reject('cancelled');
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Finish this multi step form (success)
             */
            this.finish = function () {
                this.deferred.resolve();
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Return the multi form current step
             * @return {Number} The active step index (starting at 1)
             */
            this.getActiveIndex = function () {
                return this.activeIndex;
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Initialise the multi step form instance with
             *              an initial index
             * @param {Number} step The index to start with
             */
            this.setInitialIndex = function (initialStep) {
                var searchIndex = void 0;
                // Initial step in markup has the priority
                // to override any manually entered URL
                if (angular.isDefined(initialStep)) {
                    return this.setActiveIndex(initialStep);
                }
                // Otherwise use search ID if applicable
                if (this.searchId) {
                    searchIndex = parseInt($location.search()[this.searchId]);
                    if (!isNaN(searchIndex)) {
                        return this.setActiveIndex(searchIndex);
                    }
                }
                // Otherwise set to 1
                this.setActiveIndex(1);
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Set the current step to the provided value and notify
             * @param {Number} step The step index (starting at 1)
             */
            this.setActiveIndex = function (step) {
                if (this.searchId) {
                    // Update $location
                    if (this.activeIndex) {
                        $location.search(this.searchId, step);
                    } else {
                        // Replace current one
                        $location.search(this.searchId, step).replace();
                    }
                }
                // Notify deferred object
                this.deferred.notify({
                    newStep: step,
                    oldStep: this.activeIndex
                });
                // Update activeIndex
                this.activeIndex = step;
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Return the active form step object
             * @return {FormStep} The active form step
             */
            this.getActiveStep = function () {
                if (this.activeIndex) {
                    return this.steps[this.activeIndex - 1];
                }
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Check if the current step is the first step
             * @return {Boolean} Whether or not the current step is the first step
             */
            this.isFirst = function () {
                return this.activeIndex === 1;
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Check if the current step is the last step
             * @return {Boolean} Whether or not the current step is the last step
             */
            this.isLast = function () {
                return this.activeIndex === this.steps.length;
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Go to the next step, if not the last step
             */
            this.nextStep = function () {
                if (!this.isLast()) {
                    this.setActiveIndex(this.activeIndex + 1);
                }
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Go to the next step, if not the first step
             */
            this.previousStep = function () {
                if (!this.isFirst()) {
                    this.setActiveIndex(this.activeIndex - 1);
                }
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Go to the next step, if not the first step
             */
            this.setValidity = function (isValid, stepIndex) {
                var step = this.steps[(stepIndex || this.activeIndex) - 1];

                if (step) {
                    step.valid = isValid;
                }
            };

            /**
             * @ngdoc       method
             * @methodOf    multiStepForm:multiStepForm
             *
             * @description Augment a scope with useful methods from this object
             * @param {Object} scope The scope to augment
             */
            this.augmentScope = function (scope) {
                var _this2 = this;

                ['cancel', 'finish', 'getActiveIndex', 'setActiveIndex', 'getActiveStep', 'getSteps', 'nextStep', 'previousStep', 'isFirst', 'isLast', 'setValidity'].forEach(function (method) {
                    scope['$' + method] = _this2[method].bind(_this2);
                });
            };
        }

        return function multiStepFormProvider(searchId) {
            return new MultiFormStep(searchId);
        };
    }

    /**
     * @ngdoc module
     * @name  multiStepForm
     */
    var multiStepFormModule = angular$1.module('multiStepForm', [/*'ngAnimate'*/]);

    multiStepFormModule.directive('formStepValidity', formStepValidity).directive('multiStepContainer', multiStepContainer).directive('stepContainer', stepContainer).factory('formStepElement', formStepElement).factory('FormStep', FormStep).factory('multiStepForm', multiStepForm);

    return multiStepFormModule;

}(angular));

},{}],16:[function(require,module,exports){
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.2 - 2015-10-17
 * License: MIT
 */
angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.transition","ui.bootstrap.typeahead"]),angular.module("ui.bootstrap.tpls",["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.collapse",[]).directive("collapse",["$animate",function(a){return{link:function(b,c,d){function e(){c.removeClass("collapse").addClass("collapsing").attr("aria-expanded",!0).attr("aria-hidden",!1),a.addClass(c,"in",{to:{height:c[0].scrollHeight+"px"}}).then(f)}function f(){c.removeClass("collapsing"),c.css({height:"auto"})}function g(){return c.hasClass("collapse")||c.hasClass("in")?(c.css({height:c[0].scrollHeight+"px"}).removeClass("collapse").addClass("collapsing").attr("aria-expanded",!1).attr("aria-hidden",!0),void a.removeClass(c,"in",{to:{height:"0"}}).then(h)):h()}function h(){c.css({height:"0"}),c.removeClass("collapsing"),c.addClass("collapse")}b.$watch(d.collapse,function(a){a?g():e()})}}}]),angular.module("ui.bootstrap.accordion",["ui.bootstrap.collapse"]).constant("accordionConfig",{closeOthers:!0}).controller("AccordionController",["$scope","$attrs","accordionConfig",function(a,b,c){this.groups=[],this.closeOthers=function(d){var e=angular.isDefined(b.closeOthers)?a.$eval(b.closeOthers):c.closeOthers;e&&angular.forEach(this.groups,function(a){a!==d&&(a.isOpen=!1)})},this.addGroup=function(a){var b=this;this.groups.push(a),a.$on("$destroy",function(c){b.removeGroup(a)})},this.removeGroup=function(a){var b=this.groups.indexOf(a);-1!==b&&this.groups.splice(b,1)}}]).directive("accordion",function(){return{restrict:"EA",controller:"AccordionController",transclude:!0,replace:!1,templateUrl:"template/accordion/accordion.html"}}).directive("accordionGroup",function(){return{require:"^accordion",restrict:"EA",transclude:!0,replace:!0,templateUrl:"template/accordion/accordion-group.html",scope:{heading:"@",isOpen:"=?",isDisabled:"=?"},controller:function(){this.setHeading=function(a){this.heading=a}},link:function(a,b,c,d){d.addGroup(a),a.$watch("isOpen",function(b){b&&d.closeOthers(a)}),a.toggleOpen=function(){a.isDisabled||(a.isOpen=!a.isOpen)}}}}).directive("accordionHeading",function(){return{restrict:"EA",transclude:!0,template:"",replace:!0,require:"^accordionGroup",link:function(a,b,c,d,e){d.setHeading(e(a,angular.noop))}}}).directive("accordionTransclude",function(){return{require:"^accordionGroup",link:function(a,b,c,d){a.$watch(function(){return d[c.accordionTransclude]},function(a){a&&(b.find("span").html(""),b.find("span").append(a))})}}}),angular.module("ui.bootstrap.alert",[]).controller("AlertController",["$scope","$attrs",function(a,b){a.closeable=!!b.close,this.close=a.close}]).directive("alert",function(){return{restrict:"EA",controller:"AlertController",templateUrl:"template/alert/alert.html",transclude:!0,replace:!0,scope:{type:"@",close:"&"}}}).directive("dismissOnTimeout",["$timeout",function(a){return{require:"alert",link:function(b,c,d,e){a(function(){e.close()},parseInt(d.dismissOnTimeout,10))}}}]),angular.module("ui.bootstrap.bindHtml",[]).value("$bindHtmlUnsafeSuppressDeprecated",!1).directive("bindHtmlUnsafe",["$log","$bindHtmlUnsafeSuppressDeprecated",function(a,b){return function(c,d,e){b||a.warn("bindHtmlUnsafe is now deprecated. Use ngBindHtml instead"),d.addClass("ng-binding").data("$binding",e.bindHtmlUnsafe),c.$watch(e.bindHtmlUnsafe,function(a){d.html(a||"")})}}]),angular.module("ui.bootstrap.buttons",[]).constant("buttonConfig",{activeClass:"active",toggleEvent:"click"}).controller("ButtonsController",["buttonConfig",function(a){this.activeClass=a.activeClass||"active",this.toggleEvent=a.toggleEvent||"click"}]).directive("btnRadio",function(){return{require:["btnRadio","ngModel"],controller:"ButtonsController",link:function(a,b,c,d){var e=d[0],f=d[1];f.$render=function(){b.toggleClass(e.activeClass,angular.equals(f.$modelValue,a.$eval(c.btnRadio)))},b.bind(e.toggleEvent,function(){if(!("disabled"in c)){var d=b.hasClass(e.activeClass);(!d||angular.isDefined(c.uncheckable))&&a.$apply(function(){f.$setViewValue(d?null:a.$eval(c.btnRadio)),f.$render()})}})}}}).directive("btnCheckbox",function(){return{require:["btnCheckbox","ngModel"],controller:"ButtonsController",link:function(a,b,c,d){function e(){return g(c.btnCheckboxTrue,!0)}function f(){return g(c.btnCheckboxFalse,!1)}function g(b,c){var d=a.$eval(b);return angular.isDefined(d)?d:c}var h=d[0],i=d[1];i.$render=function(){b.toggleClass(h.activeClass,angular.equals(i.$modelValue,e()))},b.bind(h.toggleEvent,function(){"disabled"in c||a.$apply(function(){i.$setViewValue(b.hasClass(h.activeClass)?f():e()),i.$render()})})}}}),angular.module("ui.bootstrap.carousel",[]).constant("ANIMATE_CSS",angular.version.minor>=4).controller("CarouselController",["$scope","$element","$interval","$animate","ANIMATE_CSS",function(a,b,c,d,e){function f(b,c,f){r||(angular.extend(b,{direction:f,active:!0}),angular.extend(m.currentSlide||{},{direction:f,active:!1}),d.enabled()&&!a.noTransition&&!a.$currentTransition&&b.$element&&(b.$element.data(p,b.direction),a.$currentTransition=!0,e?d.on("addClass",b.$element,function(b,c){a.$currentTransition=null,a.$currentTransition||d.off("addClass",b)}):b.$element.one("$animate:close",function(){a.$currentTransition=null})),m.currentSlide=b,q=c,h())}function g(a){if(angular.isUndefined(n[a].index))return n[a];var b;n.length;for(b=0;b<n.length;++b)if(n[b].index==a)return n[b]}function h(){i();var b=+a.interval;!isNaN(b)&&b>0&&(k=c(j,b))}function i(){k&&(c.cancel(k),k=null)}function j(){var b=+a.interval;l&&!isNaN(b)&&b>0&&n.length?a.next():a.pause()}var k,l,m=this,n=m.slides=a.slides=[],o="uib-noTransition",p="uib-slideDirection",q=-1;m.currentSlide=null;var r=!1;m.select=a.select=function(b,c){var d=m.indexOfSlide(b);void 0===c&&(c=d>m.getCurrentIndex()?"next":"prev"),b&&b!==m.currentSlide&&!a.$currentTransition&&f(b,d,c)},a.$on("$destroy",function(){r=!0}),m.getCurrentIndex=function(){return m.currentSlide&&angular.isDefined(m.currentSlide.index)?+m.currentSlide.index:q},m.indexOfSlide=function(a){return angular.isDefined(a.index)?+a.index:n.indexOf(a)},a.next=function(){var b=(m.getCurrentIndex()+1)%n.length;return 0===b&&a.noWrap()?void a.pause():m.select(g(b),"next")},a.prev=function(){var b=m.getCurrentIndex()-1<0?n.length-1:m.getCurrentIndex()-1;return a.noWrap()&&b===n.length-1?void a.pause():m.select(g(b),"prev")},a.isActive=function(a){return m.currentSlide===a},a.$watch("interval",h),a.$on("$destroy",i),a.play=function(){l||(l=!0,h())},a.pause=function(){a.noPause||(l=!1,i())},m.addSlide=function(b,c){!n.length&&c&&c.data(p,"next"),b.$element=c,n.push(b),1===n.length||b.active?(m.select(n[n.length-1]),1==n.length&&a.play()):b.active=!1},m.removeSlide=function(a){angular.isDefined(a.index)&&n.sort(function(a,b){return+a.index>+b.index});var b=n.indexOf(a);n.splice(b,1),n.length>0&&a.active?b>=n.length?m.select(n[b-1]):m.select(n[b]):q>b&&q--,0===n.length&&(m.currentSlide=null)},a.$watch("noTransition",function(a){b.data(o,a)})}]).directive("carousel",[function(){return{restrict:"EA",transclude:!0,replace:!0,controller:"CarouselController",require:"carousel",templateUrl:"template/carousel/carousel.html",scope:{interval:"=",noTransition:"=",noPause:"=",noWrap:"&"}}}]).directive("slide",function(){return{require:"^carousel",restrict:"EA",transclude:!0,replace:!0,templateUrl:"template/carousel/slide.html",scope:{active:"=?",index:"=?"},link:function(a,b,c,d){d.addSlide(a,b),a.$on("$destroy",function(){d.removeSlide(a)}),a.$watch("active",function(b){b&&d.select(a)})}}}).animation(".item",["$injector","$animate","ANIMATE_CSS",function(a,b,c){function d(a,b,c){a.removeClass(b),c&&c()}var e="uib-noTransition",f="uib-slideDirection",g=c?a.get("$animateCss"):null;return{beforeAddClass:function(a,c,h){if("active"==c&&a.parent()&&!a.parent().data(e)){var i=!1,j=a.data(f),k="next"==j?"left":"right",l=d.bind(this,a,k+" "+j,h);return a.addClass(j),g?g(a,{addClass:k}).start().done(l):b.addClass(a,k).then(function(){i||l(),h()}),function(){i=!0}}h()},beforeRemoveClass:function(a,c,h){if("active"===c&&a.parent()&&!a.parent().data(e)){var i=!1,j=a.data(f),k="next"==j?"left":"right",l=d.bind(this,a,k,h);return g?g(a,{addClass:k}).start().done(l):b.addClass(a,k).then(function(){i||l(),h()}),function(){i=!0}}h()}}}]),angular.module("ui.bootstrap.dateparser",[]).service("dateParser",["$log","$locale","orderByFilter",function(a,b,c){function d(a){var b=[],d=a.split("");return angular.forEach(g,function(c,e){var f=a.indexOf(e);if(f>-1){a=a.split(""),d[f]="("+c.regex+")",a[f]="$";for(var g=f+1,h=f+e.length;h>g;g++)d[g]="",a[g]="$";a=a.join(""),b.push({index:f,apply:c.apply})}}),{regex:new RegExp("^"+d.join("")+"$"),map:c(b,"index")}}function e(a,b,c){return 1>c?!1:1===b&&c>28?29===c&&(a%4===0&&a%100!==0||a%400===0):3===b||5===b||8===b||10===b?31>c:!0}var f=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.parsers={};var g={yyyy:{regex:"\\d{4}",apply:function(a){this.year=+a}},yy:{regex:"\\d{2}",apply:function(a){this.year=+a+2e3}},y:{regex:"\\d{1,4}",apply:function(a){this.year=+a}},MMMM:{regex:b.DATETIME_FORMATS.MONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.MONTH.indexOf(a)}},MMM:{regex:b.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.SHORTMONTH.indexOf(a)}},MM:{regex:"0[1-9]|1[0-2]",apply:function(a){this.month=a-1}},M:{regex:"[1-9]|1[0-2]",apply:function(a){this.month=a-1}},dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},EEEE:{regex:b.DATETIME_FORMATS.DAY.join("|")},EEE:{regex:b.DATETIME_FORMATS.SHORTDAY.join("|")},HH:{regex:"(?:0|1)[0-9]|2[0-3]",apply:function(a){this.hours=+a}},H:{regex:"1?[0-9]|2[0-3]",apply:function(a){this.hours=+a}},mm:{regex:"[0-5][0-9]",apply:function(a){this.minutes=+a}},m:{regex:"[0-9]|[1-5][0-9]",apply:function(a){this.minutes=+a}},sss:{regex:"[0-9][0-9][0-9]",apply:function(a){this.milliseconds=+a}},ss:{regex:"[0-5][0-9]",apply:function(a){this.seconds=+a}},s:{regex:"[0-9]|[1-5][0-9]",apply:function(a){this.seconds=+a}}};this.parse=function(c,g,h){if(!angular.isString(c)||!g)return c;g=b.DATETIME_FORMATS[g]||g,g=g.replace(f,"\\$&"),this.parsers[g]||(this.parsers[g]=d(g));var i=this.parsers[g],j=i.regex,k=i.map,l=c.match(j);if(l&&l.length){var m,n;angular.isDate(h)&&!isNaN(h.getTime())?m={year:h.getFullYear(),month:h.getMonth(),date:h.getDate(),hours:h.getHours(),minutes:h.getMinutes(),seconds:h.getSeconds(),milliseconds:h.getMilliseconds()}:(h&&a.warn("dateparser:","baseDate is not a valid date"),m={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0});for(var o=1,p=l.length;p>o;o++){var q=k[o-1];q.apply&&q.apply.call(m,l[o])}return e(m.year,m.month,m.date)&&(n=new Date(m.year,m.month,m.date,m.hours,m.minutes,m.seconds,m.milliseconds||0)),n}}}]),angular.module("ui.bootstrap.position",[]).factory("$position",["$document","$window",function(a,b){function c(a,c){return a.currentStyle?a.currentStyle[c]:b.getComputedStyle?b.getComputedStyle(a)[c]:a.style[c]}function d(a){return"static"===(c(a,"position")||"static")}var e=function(b){for(var c=a[0],e=b.offsetParent||c;e&&e!==c&&d(e);)e=e.offsetParent;return e||c};return{position:function(b){var c=this.offset(b),d={top:0,left:0},f=e(b[0]);f!=a[0]&&(d=this.offset(angular.element(f)),d.top+=f.clientTop-f.scrollTop,d.left+=f.clientLeft-f.scrollLeft);var g=b[0].getBoundingClientRect();return{width:g.width||b.prop("offsetWidth"),height:g.height||b.prop("offsetHeight"),top:c.top-d.top,left:c.left-d.left}},offset:function(c){var d=c[0].getBoundingClientRect();return{width:d.width||c.prop("offsetWidth"),height:d.height||c.prop("offsetHeight"),top:d.top+(b.pageYOffset||a[0].documentElement.scrollTop),left:d.left+(b.pageXOffset||a[0].documentElement.scrollLeft)}},positionElements:function(a,b,c,d){var e,f,g,h,i=c.split("-"),j=i[0],k=i[1]||"center";e=d?this.offset(a):this.position(a),f=b.prop("offsetWidth"),g=b.prop("offsetHeight");var l={center:function(){return e.left+e.width/2-f/2},left:function(){return e.left},right:function(){return e.left+e.width}},m={center:function(){return e.top+e.height/2-g/2},top:function(){return e.top},bottom:function(){return e.top+e.height}};switch(j){case"right":h={top:m[k](),left:l[j]()};break;case"left":h={top:m[k](),left:e.left-f};break;case"bottom":h={top:m[j](),left:l[k]()};break;default:h={top:e.top-g,left:l[k]()}}return h}}}]),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.position"]).constant("datepickerConfig",{formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",datepickerMode:"day",minMode:"day",maxMode:"year",showWeeks:!0,startingDay:0,yearRange:20,minDate:null,maxDate:null,shortcutPropagation:!1}).controller("DatepickerController",["$scope","$attrs","$parse","$interpolate","$log","dateFilter","datepickerConfig",function(a,b,c,d,e,f,g){var h=this,i={$setViewValue:angular.noop};this.modes=["day","month","year"],angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","minMode","maxMode","showWeeks","startingDay","yearRange","shortcutPropagation"],function(c,e){h[c]=angular.isDefined(b[c])?8>e?d(b[c])(a.$parent):a.$parent.$eval(b[c]):g[c]}),angular.forEach(["minDate","maxDate"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(a){h[d]=a?new Date(a):null,h.refreshView()}):h[d]=g[d]?new Date(g[d]):null}),a.datepickerMode=a.datepickerMode||g.datepickerMode,a.maxMode=h.maxMode,a.uniqueId="datepicker-"+a.$id+"-"+Math.floor(1e4*Math.random()),angular.isDefined(b.initDate)?(this.activeDate=a.$parent.$eval(b.initDate)||new Date,a.$parent.$watch(b.initDate,function(a){a&&(i.$isEmpty(i.$modelValue)||i.$invalid)&&(h.activeDate=a,h.refreshView())})):this.activeDate=new Date,a.isActive=function(b){return 0===h.compare(b.date,h.activeDate)?(a.activeDateId=b.uid,!0):!1},this.init=function(a){i=a,i.$render=function(){h.render()}},this.render=function(){if(i.$viewValue){var a=new Date(i.$viewValue),b=!isNaN(a);b?this.activeDate=a:e.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')}this.refreshView()},this.refreshView=function(){if(this.element){this._refreshView();var a=i.$viewValue?new Date(i.$viewValue):null;i.$setValidity("date-disabled",!a||this.element&&!this.isDisabled(a))}},this.createDateObject=function(a,b){var c=i.$viewValue?new Date(i.$viewValue):null;return{date:a,label:f(a,b),selected:c&&0===this.compare(a,c),disabled:this.isDisabled(a),current:0===this.compare(a,new Date),customClass:this.customClass(a)}},this.isDisabled=function(c){return this.minDate&&this.compare(c,this.minDate)<0||this.maxDate&&this.compare(c,this.maxDate)>0||b.dateDisabled&&a.dateDisabled({date:c,mode:a.datepickerMode})},this.customClass=function(b){return a.customClass({date:b,mode:a.datepickerMode})},this.split=function(a,b){for(var c=[];a.length>0;)c.push(a.splice(0,b));return c},this.fixTimeZone=function(a){var b=a.getHours();a.setHours(23===b?b+2:0)},a.select=function(b){if(a.datepickerMode===h.minMode){var c=i.$viewValue?new Date(i.$viewValue):new Date(0,0,0,0,0,0,0);c.setFullYear(b.getFullYear(),b.getMonth(),b.getDate()),i.$setViewValue(c),i.$render()}else h.activeDate=b,a.datepickerMode=h.modes[h.modes.indexOf(a.datepickerMode)-1]},a.move=function(a){var b=h.activeDate.getFullYear()+a*(h.step.years||0),c=h.activeDate.getMonth()+a*(h.step.months||0);h.activeDate.setFullYear(b,c,1),h.refreshView()},a.toggleMode=function(b){b=b||1,a.datepickerMode===h.maxMode&&1===b||a.datepickerMode===h.minMode&&-1===b||(a.datepickerMode=h.modes[h.modes.indexOf(a.datepickerMode)+b])},a.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var j=function(){h.element[0].focus()};a.$on("datepicker.focus",j),a.keydown=function(b){var c=a.keys[b.which];if(c&&!b.shiftKey&&!b.altKey)if(b.preventDefault(),h.shortcutPropagation||b.stopPropagation(),"enter"===c||"space"===c){if(h.isDisabled(h.activeDate))return;a.select(h.activeDate),j()}else!b.ctrlKey||"up"!==c&&"down"!==c?(h.handleKeyDown(c,b),h.refreshView()):(a.toggleMode("up"===c?1:-1),j())}}]).directive("datepicker",function(){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/datepicker.html",scope:{datepickerMode:"=?",dateDisabled:"&",customClass:"&",shortcutPropagation:"&?"},require:["datepicker","?^ngModel"],controller:"DatepickerController",link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f)}}}).directive("daypicker",["dateFilter",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/day.html",require:"^datepicker",link:function(b,c,d,e){function f(a,b){return 1!==b||a%4!==0||a%100===0&&a%400!==0?i[b]:29}function g(a,b){for(var c,d=new Array(b),f=new Date(a),g=0;b>g;)c=new Date(f),e.fixTimeZone(c),d[g++]=c,f.setDate(f.getDate()+1);return d}function h(a){var b=new Date(a);b.setDate(b.getDate()+4-(b.getDay()||7));var c=b.getTime();return b.setMonth(0),b.setDate(1),Math.floor(Math.round((c-b)/864e5)/7)+1}b.showWeeks=e.showWeeks,e.step={months:1},e.element=c;var i=[31,28,31,30,31,30,31,31,30,31,30,31];e._refreshView=function(){var c=e.activeDate.getFullYear(),d=e.activeDate.getMonth(),f=new Date(c,d,1),i=e.startingDay-f.getDay(),j=i>0?7-i:-i,k=new Date(f);j>0&&k.setDate(-j+1);for(var l=g(k,42),m=0;42>m;m++)l[m]=angular.extend(e.createDateObject(l[m],e.formatDay),{secondary:l[m].getMonth()!==d,uid:b.uniqueId+"-"+m});b.labels=new Array(7);for(var n=0;7>n;n++)b.labels[n]={abbr:a(l[n].date,e.formatDayHeader),full:a(l[n].date,"EEEE")};if(b.title=a(e.activeDate,e.formatDayTitle),b.rows=e.split(l,7),b.showWeeks){b.weekNumbers=[];for(var o=(11-e.startingDay)%7,p=b.rows.length,q=0;p>q;q++)b.weekNumbers.push(h(b.rows[q][o].date))}},e.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth(),a.getDate())-new Date(b.getFullYear(),b.getMonth(),b.getDate())},e.handleKeyDown=function(a,b){var c=e.activeDate.getDate();if("left"===a)c-=1;else if("up"===a)c-=7;else if("right"===a)c+=1;else if("down"===a)c+=7;else if("pageup"===a||"pagedown"===a){var d=e.activeDate.getMonth()+("pageup"===a?-1:1);e.activeDate.setMonth(d,1),c=Math.min(f(e.activeDate.getFullYear(),e.activeDate.getMonth()),c)}else"home"===a?c=1:"end"===a&&(c=f(e.activeDate.getFullYear(),e.activeDate.getMonth()));e.activeDate.setDate(c)},e.refreshView()}}}]).directive("monthpicker",["dateFilter",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/month.html",require:"^datepicker",link:function(b,c,d,e){e.step={years:1},e.element=c,e._refreshView=function(){for(var c,d=new Array(12),f=e.activeDate.getFullYear(),g=0;12>g;g++)c=new Date(f,g,1),e.fixTimeZone(c),d[g]=angular.extend(e.createDateObject(c,e.formatMonth),{uid:b.uniqueId+"-"+g});b.title=a(e.activeDate,e.formatMonthTitle),b.rows=e.split(d,3)},e.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth())-new Date(b.getFullYear(),b.getMonth())},e.handleKeyDown=function(a,b){var c=e.activeDate.getMonth();if("left"===a)c-=1;else if("up"===a)c-=3;else if("right"===a)c+=1;else if("down"===a)c+=3;else if("pageup"===a||"pagedown"===a){var d=e.activeDate.getFullYear()+("pageup"===a?-1:1);e.activeDate.setFullYear(d)}else"home"===a?c=0:"end"===a&&(c=11);e.activeDate.setMonth(c)},e.refreshView()}}}]).directive("yearpicker",["dateFilter",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/year.html",require:"^datepicker",link:function(a,b,c,d){function e(a){return parseInt((a-1)/f,10)*f+1}var f=d.yearRange;d.step={years:f},d.element=b,d._refreshView=function(){for(var b,c=new Array(f),g=0,h=e(d.activeDate.getFullYear());f>g;g++)b=new Date(h+g,0,1),d.fixTimeZone(b),c[g]=angular.extend(d.createDateObject(b,d.formatYear),{uid:a.uniqueId+"-"+g});a.title=[c[0].label,c[f-1].label].join(" - "),a.rows=d.split(c,5)},d.compare=function(a,b){return a.getFullYear()-b.getFullYear()},d.handleKeyDown=function(a,b){var c=d.activeDate.getFullYear();"left"===a?c-=1:"up"===a?c-=5:"right"===a?c+=1:"down"===a?c+=5:"pageup"===a||"pagedown"===a?c+=("pageup"===a?-1:1)*d.step.years:"home"===a?c=e(d.activeDate.getFullYear()):"end"===a&&(c=e(d.activeDate.getFullYear())+f-1),d.activeDate.setFullYear(c)},d.refreshView()}}}]).constant("datepickerPopupConfig",{datepickerPopup:"yyyy-MM-dd",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},currentText:"Today",clearText:"Clear",closeText:"Done",closeOnDateSelection:!0,appendToBody:!1,showButtonBar:!0}).directive("datepickerPopup",["$compile","$parse","$document","$position","dateFilter","dateParser","datepickerPopupConfig","$timeout",function(a,b,c,d,e,f,g,h){return{restrict:"EA",require:"ngModel",scope:{isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&",customClass:"&"},link:function(i,j,k,l){function m(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function n(a){if(angular.isNumber(a)&&(a=new Date(a)),a){if(angular.isDate(a)&&!isNaN(a))return a;if(angular.isString(a)){var b=f.parse(a,p,i.date);return isNaN(b)?void 0:b}return void 0}return null}function o(a,b){var c=a||b;if(!k.ngRequired&&!c)return!0;if(angular.isNumber(c)&&(c=new Date(c)),c){if(angular.isDate(c)&&!isNaN(c))return!0;if(angular.isString(c)){var d=f.parse(c,p);return!isNaN(d)}return!1}return!0}var p,q=angular.isDefined(k.closeOnDateSelection)?i.$parent.$eval(k.closeOnDateSelection):g.closeOnDateSelection,r=angular.isDefined(k.datepickerAppendToBody)?i.$parent.$eval(k.datepickerAppendToBody):g.appendToBody;i.showButtonBar=angular.isDefined(k.showButtonBar)?i.$parent.$eval(k.showButtonBar):g.showButtonBar,i.getText=function(a){return i[a+"Text"]||g[a+"Text"]};var s=!1;if(g.html5Types[k.type]?(p=g.html5Types[k.type],s=!0):(p=k.datepickerPopup||g.datepickerPopup,k.$observe("datepickerPopup",function(a,b){var c=a||g.datepickerPopup;if(c!==p&&(p=c,l.$modelValue=null,!p))throw new Error("datepickerPopup must have a date format specified.")})),!p)throw new Error("datepickerPopup must have a date format specified.");if(s&&k.datepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");var t=angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");t.attr({"ng-model":"date","ng-change":"dateSelection(date)"});var u=angular.element(t.children()[0]);if(s&&"month"==k.type&&(u.attr("datepicker-mode",'"month"'),u.attr("min-mode","month")),k.datepickerOptions){var v=i.$parent.$eval(k.datepickerOptions);v&&v.initDate&&(i.initDate=v.initDate,u.attr("init-date","initDate"),delete v.initDate),angular.forEach(v,function(a,b){u.attr(m(b),a)})}i.watchData={},angular.forEach(["minDate","maxDate","datepickerMode","initDate","shortcutPropagation"],function(a){if(k[a]){var c=b(k[a]);if(i.$parent.$watch(c,function(b){i.watchData[a]=b}),u.attr(m(a),"watchData."+a),"datepickerMode"===a){var d=c.assign;i.$watch("watchData."+a,function(a,b){angular.isFunction(d)&&a!==b&&d(i.$parent,a)})}}}),k.dateDisabled&&u.attr("date-disabled","dateDisabled({ date: date, mode: mode })"),k.showWeeks&&u.attr("show-weeks",k.showWeeks),k.customClass&&u.attr("custom-class","customClass({ date: date, mode: mode })"),s?l.$formatters.push(function(a){return i.date=a,a}):(l.$$parserName="date",l.$validators.date=o,l.$parsers.unshift(n),l.$formatters.push(function(a){return i.date=a,l.$isEmpty(a)?a:e(a,p)})),i.dateSelection=function(a){angular.isDefined(a)&&(i.date=a);var b=i.date?e(i.date,p):null;j.val(b),l.$setViewValue(b),q&&(i.isOpen=!1,j[0].focus())},l.$viewChangeListeners.push(function(){i.date=f.parse(l.$viewValue,p,i.date)});var w=function(a){i.isOpen&&!j[0].contains(a.target)&&i.$apply(function(){i.isOpen=!1})},x=function(a){27===a.which&&i.isOpen?(a.preventDefault(),a.stopPropagation(),i.$apply(function(){i.isOpen=!1}),j[0].focus()):40!==a.which||i.isOpen||(a.preventDefault(),a.stopPropagation(),i.$apply(function(){i.isOpen=!0}))};j.bind("keydown",x),i.keydown=function(a){27===a.which&&(i.isOpen=!1,j[0].focus())},i.$watch("isOpen",function(a){a?(i.position=r?d.offset(j):d.position(j),i.position.top=i.position.top+j.prop("offsetHeight"),h(function(){i.$broadcast("datepicker.focus"),c.bind("click",w)},0,!1)):c.unbind("click",w)}),i.select=function(a){if("today"===a){var b=new Date;angular.isDate(i.date)?(a=new Date(i.date),a.setFullYear(b.getFullYear(),b.getMonth(),b.getDate())):a=new Date(b.setHours(0,0,0,0))}i.dateSelection(a)},i.close=function(){i.isOpen=!1,j[0].focus()};var y=a(t)(i);t.remove(),r?c.find("body").append(y):j.after(y),i.$on("$destroy",function(){i.isOpen===!0&&i.$apply(function(){i.isOpen=!1}),y.remove(),j.unbind("keydown",x),c.unbind("click",w)})}}}]).directive("datepickerPopupWrap",function(){return{restrict:"EA",replace:!0,transclude:!0,templateUrl:"template/datepicker/popup.html"}}),angular.module("ui.bootstrap.dropdown",["ui.bootstrap.position"]).constant("dropdownConfig",{openClass:"open"}).service("dropdownService",["$document","$rootScope",function(a,b){var c=null;this.open=function(b){c||(a.bind("click",d),a.bind("keydown",e)),c&&c!==b&&(c.isOpen=!1),c=b},this.close=function(b){c===b&&(c=null,a.unbind("click",d),a.unbind("keydown",e))};var d=function(a){if(c&&(!a||"disabled"!==c.getAutoClose())){var d=c.getToggleElement();if(!(a&&d&&d[0].contains(a.target))){var e=c.getDropdownElement();a&&"outsideClick"===c.getAutoClose()&&e&&e[0].contains(a.target)||(c.isOpen=!1,b.$$phase||c.$apply())}}},e=function(a){27===a.which?(c.focusToggleElement(),d()):c.isKeynavEnabled()&&/(38|40)/.test(a.which)&&c.isOpen&&(a.preventDefault(),a.stopPropagation(),c.focusDropdownEntry(a.which))}}]).controller("DropdownController",["$scope","$attrs","$parse","dropdownConfig","dropdownService","$animate","$position","$document","$compile","$templateRequest",function(a,b,c,d,e,f,g,h,i,j){var k,l,m=this,n=a.$new(),o=d.openClass,p=angular.noop,q=b.onToggle?c(b.onToggle):angular.noop,r=!1,s=!1;this.init=function(d){m.$element=d,b.isOpen&&(l=c(b.isOpen),p=l.assign,a.$watch(l,function(a){n.isOpen=!!a})),r=angular.isDefined(b.dropdownAppendToBody),s=angular.isDefined(b.keyboardNav),r&&m.dropdownMenu&&(h.find("body").append(m.dropdownMenu),d.on("$destroy",function(){m.dropdownMenu.remove()}))},this.toggle=function(a){return n.isOpen=arguments.length?!!a:!n.isOpen},this.isOpen=function(){return n.isOpen},n.getToggleElement=function(){return m.toggleElement},n.getAutoClose=function(){return b.autoClose||"always"},n.getElement=function(){return m.$element},n.isKeynavEnabled=function(){return s},n.focusDropdownEntry=function(a){var b=m.dropdownMenu?angular.element(m.dropdownMenu).find("a"):angular.element(m.$element).find("ul").eq(0).find("a");switch(a){case 40:angular.isNumber(m.selectedOption)?m.selectedOption=m.selectedOption===b.length-1?m.selectedOption:m.selectedOption+1:m.selectedOption=0;break;case 38:if(!angular.isNumber(m.selectedOption))return;m.selectedOption=0===m.selectedOption?0:m.selectedOption-1}b[m.selectedOption].focus()},n.getDropdownElement=function(){return m.dropdownMenu},n.focusToggleElement=function(){m.toggleElement&&m.toggleElement[0].focus()},n.$watch("isOpen",function(b,c){if(r&&m.dropdownMenu){var d=g.positionElements(m.$element,m.dropdownMenu,"bottom-left",!0),h={top:d.top+"px",display:b?"block":"none"},l=m.dropdownMenu.hasClass("dropdown-menu-right");l?(h.left="auto",h.right=window.innerWidth-(d.left+m.$element.prop("offsetWidth"))+"px"):(h.left=d.left+"px",h.right="auto"),m.dropdownMenu.css(h)}if(f[b?"addClass":"removeClass"](m.$element,o).then(function(){angular.isDefined(b)&&b!==c&&q(a,{open:!!b})}),b)m.dropdownMenuTemplateUrl&&j(m.dropdownMenuTemplateUrl).then(function(a){k=n.$new(),i(a.trim())(k,function(a){var b=a;m.dropdownMenu.replaceWith(b),m.dropdownMenu=b})}),n.focusToggleElement(),e.open(n);else{if(m.dropdownMenuTemplateUrl){k&&k.$destroy();var s=angular.element('<ul class="dropdown-menu"></ul>');m.dropdownMenu.replaceWith(s),m.dropdownMenu=s}e.close(n),m.selectedOption=null}angular.isFunction(p)&&p(a,b)}),a.$on("$locationChangeSuccess",function(){"disabled"!==n.getAutoClose()&&(n.isOpen=!1)}),a.$on("$destroy",function(){n.$destroy()})}]).directive("dropdown",function(){return{controller:"DropdownController",link:function(a,b,c,d){d.init(b),b.addClass("dropdown")}}}).directive("dropdownMenu",function(){return{restrict:"AC",require:"?^dropdown",link:function(a,b,c,d){if(d){var e=c.templateUrl;e&&(d.dropdownMenuTemplateUrl=e),d.dropdownMenu||(d.dropdownMenu=b)}}}}).directive("keyboardNav",function(){return{restrict:"A",require:"?^dropdown",link:function(a,b,c,d){b.bind("keydown",function(a){if(-1!==[38,40].indexOf(a.which)){a.preventDefault(),a.stopPropagation();var c=angular.element(b).find("a");switch(a.keyCode){case 40:angular.isNumber(d.selectedOption)?d.selectedOption=d.selectedOption===c.length-1?d.selectedOption:d.selectedOption+1:d.selectedOption=0;break;case 38:d.selectedOption=0===d.selectedOption?0:d.selectedOption-1}c[d.selectedOption].focus()}})}}}).directive("dropdownToggle",function(){return{require:"?^dropdown",link:function(a,b,c,d){if(d){b.addClass("dropdown-toggle"),d.toggleElement=b;var e=function(e){e.preventDefault(),b.hasClass("disabled")||c.disabled||a.$apply(function(){d.toggle()})};b.bind("click",e),b.attr({"aria-haspopup":!0,"aria-expanded":!1}),a.$watch(d.isOpen,function(a){b.attr("aria-expanded",!!a)}),a.$on("$destroy",function(){b.unbind("click",e)})}}}}),angular.module("ui.bootstrap.modal",[]).factory("$$stackedMap",function(){return{createNew:function(){var a=[];return{add:function(b,c){a.push({key:b,value:c})},get:function(b){for(var c=0;c<a.length;c++)if(b==a[c].key)return a[c]},keys:function(){for(var b=[],c=0;c<a.length;c++)b.push(a[c].key);return b},top:function(){return a[a.length-1]},remove:function(b){for(var c=-1,d=0;d<a.length;d++)if(b==a[d].key){c=d;break}return a.splice(c,1)[0]},removeTop:function(){return a.splice(a.length-1,1)[0]},length:function(){return a.length}}}}}).directive("modalBackdrop",["$animate","$modalStack",function(a,b){function c(c,d,e){e.modalInClass&&(a.addClass(d,e.modalInClass),c.$on(b.NOW_CLOSING_EVENT,function(b,c){var f=c();a.removeClass(d,e.modalInClass).then(f)}))}return{restrict:"EA",replace:!0,templateUrl:"template/modal/backdrop.html",compile:function(a,b){return a.addClass(b.backdropClass),c}}}]).directive("modalWindow",["$modalStack","$q","$animate",function(a,b,c){return{restrict:"EA",scope:{index:"@"},
replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/modal/window.html"},link:function(d,e,f){e.addClass(f.windowClass||""),d.size=f.size,d.close=function(b){var c=a.getTop();c&&c.value.backdrop&&"static"!=c.value.backdrop&&b.target===b.currentTarget&&(b.preventDefault(),b.stopPropagation(),a.dismiss(c.key,"backdrop click"))},d.$isRendered=!0;var g=b.defer();f.$observe("modalRender",function(a){"true"==a&&g.resolve()}),g.promise.then(function(){f.modalInClass&&(c.addClass(e,f.modalInClass),d.$on(a.NOW_CLOSING_EVENT,function(a,b){var d=b();c.removeClass(e,f.modalInClass).then(d)}));var b=e[0].querySelectorAll("[autofocus]");b.length?b[0].focus():e[0].focus();var g=a.getTop();g&&a.modalRendered(g.key)})}}}]).directive("modalAnimationClass",[function(){return{compile:function(a,b){b.modalAnimation&&a.addClass(b.modalAnimationClass)}}}]).directive("modalTransclude",function(){return{link:function(a,b,c,d,e){e(a.$parent,function(a){b.empty(),b.append(a)})}}}).factory("$modalStack",["$animate","$timeout","$document","$compile","$rootScope","$q","$$stackedMap",function(a,b,c,d,e,f,g){function h(){for(var a=-1,b=q.keys(),c=0;c<b.length;c++)q.get(b[c]).value.backdrop&&(a=c);return a}function i(a,b){var d=c.find("body").eq(0),e=q.get(a).value;q.remove(a),k(e.modalDomEl,e.modalScope,function(){d.toggleClass(p,q.length()>0)}),j(),b&&b.focus?b.focus():d.focus()}function j(){if(m&&-1==h()){var a=n;k(m,n,function(){a=null}),m=void 0,n=void 0}}function k(b,c,d){function e(){e.done||(e.done=!0,a.leave(b),c.$destroy(),d&&d())}var g,h=null,i=function(){return g||(g=f.defer(),h=g.promise),function(){g.resolve()}};return c.$broadcast(r.NOW_CLOSING_EVENT,i),f.when(h).then(e)}function l(a,b,c){return!a.value.modalScope.$broadcast("modal.closing",b,c).defaultPrevented}var m,n,o,p="modal-open",q=g.createNew(),r={NOW_CLOSING_EVENT:"modal.stack.now-closing"},s=0,t="a[href], area[href], input:not([disabled]), button:not([disabled]),select:not([disabled]), textarea:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable=true]";return e.$watch(h,function(a){n&&(n.index=a)}),c.bind("keydown",function(a){var b=q.top();if(b&&b.value.keyboard)switch(a.which){case 27:a.preventDefault(),e.$apply(function(){r.dismiss(b.key,"escape key press")});break;case 9:r.loadFocusElementList(b);var c=!1;a.shiftKey?r.isFocusInFirstItem(a)&&(c=r.focusLastFocusableElement()):r.isFocusInLastItem(a)&&(c=r.focusFirstFocusableElement()),c&&(a.preventDefault(),a.stopPropagation())}}),r.open=function(a,b){var f=c[0].activeElement;q.add(a,{deferred:b.deferred,renderDeferred:b.renderDeferred,modalScope:b.scope,backdrop:b.backdrop,keyboard:b.keyboard});var g=c.find("body").eq(0),i=h();if(i>=0&&!m){n=e.$new(!0),n.index=i;var j=angular.element('<div modal-backdrop="modal-backdrop"></div>');j.attr("backdrop-class",b.backdropClass),b.animation&&j.attr("modal-animation","true"),m=d(j)(n),g.append(m)}var k=angular.element('<div modal-window="modal-window"></div>');k.attr({"template-url":b.windowTemplateUrl,"window-class":b.windowClass,size:b.size,index:q.length()-1,animate:"animate"}).html(b.content),b.animation&&k.attr("modal-animation","true");var l=d(k)(b.scope);q.top().value.modalDomEl=l,q.top().value.modalOpener=f,g.append(l),g.addClass(p),r.clearFocusListCache()},r.close=function(a,b){var c=q.get(a);return c&&l(c,b,!0)?(c.value.deferred.resolve(b),i(a,c.value.modalOpener),!0):!c},r.dismiss=function(a,b){var c=q.get(a);return c&&l(c,b,!1)?(c.value.deferred.reject(b),i(a,c.value.modalOpener),!0):!c},r.dismissAll=function(a){for(var b=this.getTop();b&&this.dismiss(b.key,a);)b=this.getTop()},r.getTop=function(){return q.top()},r.modalRendered=function(a){var b=q.get(a);b&&b.value.renderDeferred.resolve()},r.focusFirstFocusableElement=function(){return o.length>0?(o[0].focus(),!0):!1},r.focusLastFocusableElement=function(){return o.length>0?(o[o.length-1].focus(),!0):!1},r.isFocusInFirstItem=function(a){return o.length>0?(a.target||a.srcElement)==o[0]:!1},r.isFocusInLastItem=function(a){return o.length>0?(a.target||a.srcElement)==o[o.length-1]:!1},r.clearFocusListCache=function(){o=[],s=0},r.loadFocusElementList=function(a){if((void 0===o||!o.length0)&&a){var b=a.value.modalDomEl;b&&b.length&&(o=b[0].querySelectorAll(t))}},r}]).provider("$modal",function(){var a={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$injector","$rootScope","$q","$templateRequest","$controller","$modalStack",function(b,c,d,e,f,g){function h(a){return a.template?d.when(a.template):e(angular.isFunction(a.templateUrl)?a.templateUrl():a.templateUrl)}function i(a){var c=[];return angular.forEach(a,function(a){(angular.isFunction(a)||angular.isArray(a))&&c.push(d.when(b.invoke(a)))}),c}var j={};return j.open=function(b){var e=d.defer(),j=d.defer(),k=d.defer(),l={result:e.promise,opened:j.promise,rendered:k.promise,close:function(a){return g.close(l,a)},dismiss:function(a){return g.dismiss(l,a)}};if(b=angular.extend({},a.options,b),b.resolve=b.resolve||{},!b.template&&!b.templateUrl)throw new Error("One of template or templateUrl options is required.");var m=d.all([h(b)].concat(i(b.resolve)));return m.then(function(a){var d=(b.scope||c).$new();d.$close=l.close,d.$dismiss=l.dismiss;var h,i={},j=1;b.controller&&(i.$scope=d,i.$modalInstance=l,angular.forEach(b.resolve,function(b,c){i[c]=a[j++]}),h=f(b.controller,i),b.controllerAs&&(b.bindToController&&angular.extend(h,d),d[b.controllerAs]=h)),g.open(l,{scope:d,deferred:e,renderDeferred:k,content:a[0],animation:b.animation,backdrop:b.backdrop,keyboard:b.keyboard,backdropClass:b.backdropClass,windowClass:b.windowClass,windowTemplateUrl:b.windowTemplateUrl,size:b.size})},function(a){e.reject(a)}),m.then(function(){j.resolve(!0)},function(a){j.reject(a)}),l},j}]};return a}),angular.module("ui.bootstrap.pagination",[]).controller("PaginationController",["$scope","$attrs","$parse",function(a,b,c){var d=this,e={$setViewValue:angular.noop},f=b.numPages?c(b.numPages).assign:angular.noop;this.init=function(g,h){e=g,this.config=h,e.$render=function(){d.render()},b.itemsPerPage?a.$parent.$watch(c(b.itemsPerPage),function(b){d.itemsPerPage=parseInt(b,10),a.totalPages=d.calculateTotalPages()}):this.itemsPerPage=h.itemsPerPage,a.$watch("totalItems",function(){a.totalPages=d.calculateTotalPages()}),a.$watch("totalPages",function(b){f(a.$parent,b),a.page>b?a.selectPage(b):e.$render()})},this.calculateTotalPages=function(){var b=this.itemsPerPage<1?1:Math.ceil(a.totalItems/this.itemsPerPage);return Math.max(b||0,1)},this.render=function(){a.page=parseInt(e.$viewValue,10)||1},a.selectPage=function(b,c){var d=!a.ngDisabled||!c;d&&a.page!==b&&b>0&&b<=a.totalPages&&(c&&c.target&&c.target.blur(),e.$setViewValue(b),e.$render())},a.getText=function(b){return a[b+"Text"]||d.config[b+"Text"]},a.noPrevious=function(){return 1===a.page},a.noNext=function(){return a.page===a.totalPages}}]).constant("paginationConfig",{itemsPerPage:10,boundaryLinks:!1,directionLinks:!0,firstText:"First",previousText:"Previous",nextText:"Next",lastText:"Last",rotate:!0}).directive("pagination",["$parse","paginationConfig",function(a,b){return{restrict:"EA",scope:{totalItems:"=",firstText:"@",previousText:"@",nextText:"@",lastText:"@",ngDisabled:"="},require:["pagination","?ngModel"],controller:"PaginationController",templateUrl:"template/pagination/pagination.html",replace:!0,link:function(c,d,e,f){function g(a,b,c){return{number:a,text:b,active:c}}function h(a,b){var c=[],d=1,e=b,f=angular.isDefined(k)&&b>k;f&&(l?(d=Math.max(a-Math.floor(k/2),1),e=d+k-1,e>b&&(e=b,d=e-k+1)):(d=(Math.ceil(a/k)-1)*k+1,e=Math.min(d+k-1,b)));for(var h=d;e>=h;h++){var i=g(h,h,h===a);c.push(i)}if(f&&!l){if(d>1){var j=g(d-1,"...",!1);c.unshift(j)}if(b>e){var m=g(e+1,"...",!1);c.push(m)}}return c}var i=f[0],j=f[1];if(j){var k=angular.isDefined(e.maxSize)?c.$parent.$eval(e.maxSize):b.maxSize,l=angular.isDefined(e.rotate)?c.$parent.$eval(e.rotate):b.rotate;c.boundaryLinks=angular.isDefined(e.boundaryLinks)?c.$parent.$eval(e.boundaryLinks):b.boundaryLinks,c.directionLinks=angular.isDefined(e.directionLinks)?c.$parent.$eval(e.directionLinks):b.directionLinks,i.init(j,b),e.maxSize&&c.$parent.$watch(a(e.maxSize),function(a){k=parseInt(a,10),i.render()});var m=i.render;i.render=function(){m(),c.page>0&&c.page<=c.totalPages&&(c.pages=h(c.page,c.totalPages))}}}}}]).constant("pagerConfig",{itemsPerPage:10,previousText:"« Previous",nextText:"Next »",align:!0}).directive("pager",["pagerConfig",function(a){return{restrict:"EA",scope:{totalItems:"=",previousText:"@",nextText:"@"},require:["pager","?ngModel"],controller:"PaginationController",templateUrl:"template/pagination/pager.html",replace:!0,link:function(b,c,d,e){var f=e[0],g=e[1];g&&(b.align=angular.isDefined(d.align)?b.$parent.$eval(d.align):a.align,f.init(g,a))}}}]),angular.module("ui.bootstrap.tooltip",["ui.bootstrap.position","ui.bootstrap.bindHtml"]).provider("$tooltip",function(){function a(a){var b=/[A-Z]/g,c="-";return a.replace(b,function(a,b){return(b?c:"")+a.toLowerCase()})}var b={placement:"top",animation:!0,popupDelay:0,useContentExp:!1},c={mouseenter:"mouseleave",click:"click",focus:"blur"},d={};this.options=function(a){angular.extend(d,a)},this.setTriggers=function(a){angular.extend(c,a)},this.$get=["$window","$compile","$timeout","$document","$position","$interpolate",function(e,f,g,h,i,j){return function(e,k,l,m){function n(a){var b=a||m.trigger||l,d=c[b]||b;return{show:b,hide:d}}m=angular.extend({},b,d,m);var o=a(e),p=j.startSymbol(),q=j.endSymbol(),r="<div "+o+'-popup title="'+p+"title"+q+'" '+(m.useContentExp?'content-exp="contentExp()" ':'content="'+p+"content"+q+'" ')+'placement="'+p+"placement"+q+'" popup-class="'+p+"popupClass"+q+'" animation="animation" is-open="isOpen"origin-scope="origScope" ></div>';return{restrict:"EA",compile:function(a,b){var c=f(r);return function(a,b,d,f){function j(){F.isOpen?o():l()}function l(){(!E||a.$eval(d[k+"Enable"]))&&(t(),F.popupDelay?B||(B=g(p,F.popupDelay,!1),B.then(function(a){a()})):p()())}function o(){a.$apply(function(){q()})}function p(){return B=null,A&&(g.cancel(A),A=null),(m.useContentExp?F.contentExp():F.content)?(r(),y.css({top:0,left:0,display:"block"}),F.$digest(),G(),F.isOpen=!0,F.$apply(),G):angular.noop}function q(){F.isOpen=!1,g.cancel(B),B=null,F.animation?A||(A=g(s,500)):s()}function r(){y&&s(),z=F.$new(),y=c(z,function(a){C?h.find("body").append(a):b.after(a)}),m.useContentExp&&z.$watch("contentExp()",function(a){H(),!a&&F.isOpen&&q()})}function s(){A=null,y&&(y.remove(),y=null),z&&(z.$destroy(),z=null)}function t(){u(),v(),w()}function u(){F.popupClass=d[k+"Class"]}function v(){var a=d[k+"Placement"];F.placement=angular.isDefined(a)?a:m.placement}function w(){var a=d[k+"PopupDelay"],b=parseInt(a,10);F.popupDelay=isNaN(b)?m.popupDelay:b}function x(){var a=d[k+"Trigger"];I(),D=n(a),D.show===D.hide?b.bind(D.show,j):(b.bind(D.show,l),b.bind(D.hide,o))}var y,z,A,B,C=angular.isDefined(m.appendToBody)?m.appendToBody:!1,D=n(void 0),E=angular.isDefined(d[k+"Enable"]),F=a.$new(!0),G=function(){if(y){var a=i.positionElements(b,y,F.placement,C);a.top+="px",a.left+="px",y.css(a)}},H=function(){g(G,0,!1)};F.origScope=a,F.isOpen=!1,F.contentExp=function(){return a.$eval(d[e])},m.useContentExp||d.$observe(e,function(a){F.content=a,H(),!a&&F.isOpen&&q()}),d.$observe("disabled",function(a){a&&F.isOpen&&q()}),d.$observe(k+"Title",function(a){F.title=a,H()}),d.$observe(k+"Placement",function(){F.isOpen&&g(function(){v(),p()()},0,!1)});var I=function(){b.unbind(D.show,l),b.unbind(D.hide,o)};x();var J=a.$eval(d[k+"Animation"]);F.animation=angular.isDefined(J)?!!J:m.animation;var K=a.$eval(d[k+"AppendToBody"]);C=angular.isDefined(K)?K:C,C&&a.$on("$locationChangeSuccess",function(){F.isOpen&&q()}),a.$on("$destroy",function(){g.cancel(A),g.cancel(B),I(),s(),F=null})}}}}}]}).directive("tooltipTemplateTransclude",["$animate","$sce","$compile","$templateRequest",function(a,b,c,d){return{link:function(e,f,g){var h,i,j,k=e.$eval(g.tooltipTemplateTranscludeScope),l=0,m=function(){i&&(i.remove(),i=null),h&&(h.$destroy(),h=null),j&&(a.leave(j).then(function(){i=null}),i=j,j=null)};e.$watch(b.parseAsResourceUrl(g.tooltipTemplateTransclude),function(b){var g=++l;b?(d(b,!0).then(function(d){if(g===l){var e=k.$new(),i=d,n=c(i)(e,function(b){m(),a.enter(b,f)});h=e,j=n,h.$emit("$includeContentLoaded",b)}},function(){g===l&&(m(),e.$emit("$includeContentError",b))}),e.$emit("$includeContentRequested",b)):m()}),e.$on("$destroy",m)}}}]).directive("tooltipClasses",function(){return{restrict:"A",link:function(a,b,c){a.placement&&b.addClass(a.placement),a.popupClass&&b.addClass(a.popupClass),a.animation()&&b.addClass(c.tooltipAnimationClass)}}}).directive("tooltipPopup",function(){return{restrict:"EA",replace:!0,scope:{content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-popup.html"}}).directive("tooltip",["$tooltip",function(a){return a("tooltip","tooltip","mouseenter")}]).directive("tooltipTemplatePopup",function(){return{restrict:"EA",replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/tooltip/tooltip-template-popup.html"}}).directive("tooltipTemplate",["$tooltip",function(a){return a("tooltipTemplate","tooltip","mouseenter",{useContentExp:!0})}]).directive("tooltipHtmlPopup",function(){return{restrict:"EA",replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-html-popup.html"}}).directive("tooltipHtml",["$tooltip",function(a){return a("tooltipHtml","tooltip","mouseenter",{useContentExp:!0})}]).directive("tooltipHtmlUnsafePopup",function(){return{restrict:"EA",replace:!0,scope:{content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-html-unsafe-popup.html"}}).value("tooltipHtmlUnsafeSuppressDeprecated",!1).directive("tooltipHtmlUnsafe",["$tooltip","tooltipHtmlUnsafeSuppressDeprecated","$log",function(a,b,c){return b||c.warn("tooltip-html-unsafe is now deprecated. Use tooltip-html or tooltip-template instead."),a("tooltipHtmlUnsafe","tooltip","mouseenter")}]),angular.module("ui.bootstrap.popover",["ui.bootstrap.tooltip"]).directive("popoverTemplatePopup",function(){return{restrict:"EA",replace:!0,scope:{title:"@",contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/popover/popover-template.html"}}).directive("popoverTemplate",["$tooltip",function(a){return a("popoverTemplate","popover","click",{useContentExp:!0})}]).directive("popoverHtmlPopup",function(){return{restrict:"EA",replace:!0,scope:{contentExp:"&",title:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover-html.html"}}).directive("popoverHtml",["$tooltip",function(a){return a("popoverHtml","popover","click",{useContentExp:!0})}]).directive("popoverPopup",function(){return{restrict:"EA",replace:!0,scope:{title:"@",content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover.html"}}).directive("popover",["$tooltip",function(a){return a("popover","popover","click")}]),angular.module("ui.bootstrap.progressbar",[]).constant("progressConfig",{animate:!0,max:100}).controller("ProgressController",["$scope","$attrs","progressConfig",function(a,b,c){var d=this,e=angular.isDefined(b.animate)?a.$parent.$eval(b.animate):c.animate;this.bars=[],a.max=angular.isDefined(a.max)?a.max:c.max,this.addBar=function(b,c){e||c.css({transition:"none"}),this.bars.push(b),b.max=a.max,b.$watch("value",function(a){b.recalculatePercentage()}),b.recalculatePercentage=function(){b.percent=+(100*b.value/b.max).toFixed(2);var a=0;d.bars.forEach(function(b){a+=b.percent}),a>100&&(b.percent-=a-100)},b.$on("$destroy",function(){c=null,d.removeBar(b)})},this.removeBar=function(a){this.bars.splice(this.bars.indexOf(a),1)},a.$watch("max",function(b){d.bars.forEach(function(b){b.max=a.max,b.recalculatePercentage()})})}]).directive("progress",function(){return{restrict:"EA",replace:!0,transclude:!0,controller:"ProgressController",require:"progress",scope:{max:"=?"},templateUrl:"template/progressbar/progress.html"}}).directive("bar",function(){return{restrict:"EA",replace:!0,transclude:!0,require:"^progress",scope:{value:"=",type:"@"},templateUrl:"template/progressbar/bar.html",link:function(a,b,c,d){d.addBar(a,b)}}}).directive("progressbar",function(){return{restrict:"EA",replace:!0,transclude:!0,controller:"ProgressController",scope:{value:"=",max:"=?",type:"@"},templateUrl:"template/progressbar/progressbar.html",link:function(a,b,c,d){d.addBar(a,angular.element(b.children()[0]))}}}),angular.module("ui.bootstrap.rating",[]).constant("ratingConfig",{max:5,stateOn:null,stateOff:null,titles:["one","two","three","four","five"]}).controller("RatingController",["$scope","$attrs","ratingConfig",function(a,b,c){var d={$setViewValue:angular.noop};this.init=function(e){d=e,d.$render=this.render,d.$formatters.push(function(a){return angular.isNumber(a)&&a<<0!==a&&(a=Math.round(a)),a}),this.stateOn=angular.isDefined(b.stateOn)?a.$parent.$eval(b.stateOn):c.stateOn,this.stateOff=angular.isDefined(b.stateOff)?a.$parent.$eval(b.stateOff):c.stateOff;var f=angular.isDefined(b.titles)?a.$parent.$eval(b.titles):c.titles;this.titles=angular.isArray(f)&&f.length>0?f:c.titles;var g=angular.isDefined(b.ratingStates)?a.$parent.$eval(b.ratingStates):new Array(angular.isDefined(b.max)?a.$parent.$eval(b.max):c.max);a.range=this.buildTemplateObjects(g)},this.buildTemplateObjects=function(a){for(var b=0,c=a.length;c>b;b++)a[b]=angular.extend({index:b},{stateOn:this.stateOn,stateOff:this.stateOff,title:this.getTitle(b)},a[b]);return a},this.getTitle=function(a){return a>=this.titles.length?a+1:this.titles[a]},a.rate=function(b){!a.readonly&&b>=0&&b<=a.range.length&&(d.$setViewValue(d.$viewValue===b?0:b),d.$render())},a.enter=function(b){a.readonly||(a.value=b),a.onHover({value:b})},a.reset=function(){a.value=d.$viewValue,a.onLeave()},a.onKeydown=function(b){/(37|38|39|40)/.test(b.which)&&(b.preventDefault(),b.stopPropagation(),a.rate(a.value+(38===b.which||39===b.which?1:-1)))},this.render=function(){a.value=d.$viewValue}}]).directive("rating",function(){return{restrict:"EA",require:["rating","ngModel"],scope:{readonly:"=?",onHover:"&",onLeave:"&"},controller:"RatingController",templateUrl:"template/rating/rating.html",replace:!0,link:function(a,b,c,d){var e=d[0],f=d[1];e.init(f)}}}),angular.module("ui.bootstrap.tabs",[]).controller("TabsetController",["$scope",function(a){var b=this,c=b.tabs=a.tabs=[];b.select=function(a){angular.forEach(c,function(b){b.active&&b!==a&&(b.active=!1,b.onDeselect())}),a.active=!0,a.onSelect()},b.addTab=function(a){c.push(a),1===c.length&&a.active!==!1?a.active=!0:a.active?b.select(a):a.active=!1},b.removeTab=function(a){var e=c.indexOf(a);if(a.active&&c.length>1&&!d){var f=e==c.length-1?e-1:e+1;b.select(c[f])}c.splice(e,1)};var d;a.$on("$destroy",function(){d=!0})}]).directive("tabset",function(){return{restrict:"EA",transclude:!0,replace:!0,scope:{type:"@"},controller:"TabsetController",templateUrl:"template/tabs/tabset.html",link:function(a,b,c){a.vertical=angular.isDefined(c.vertical)?a.$parent.$eval(c.vertical):!1,a.justified=angular.isDefined(c.justified)?a.$parent.$eval(c.justified):!1}}}).directive("tab",["$parse","$log",function(a,b){return{require:"^tabset",restrict:"EA",replace:!0,templateUrl:"template/tabs/tab.html",transclude:!0,scope:{active:"=?",heading:"@",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},link:function(c,d,e,f,g){c.$watch("active",function(a){a&&f.select(c)}),c.disabled=!1,e.disable&&c.$parent.$watch(a(e.disable),function(a){c.disabled=!!a}),e.disabled&&(b.warn('Use of "disabled" attribute has been deprecated, please use "disable"'),c.$parent.$watch(a(e.disabled),function(a){c.disabled=!!a})),c.select=function(){c.disabled||(c.active=!0)},f.addTab(c),c.$on("$destroy",function(){f.removeTab(c)}),c.$transcludeFn=g}}}]).directive("tabHeadingTransclude",[function(){return{restrict:"A",require:"^tab",link:function(a,b,c,d){a.$watch("headingElement",function(a){a&&(b.html(""),b.append(a))})}}}]).directive("tabContentTransclude",function(){function a(a){return a.tagName&&(a.hasAttribute("tab-heading")||a.hasAttribute("data-tab-heading")||"tab-heading"===a.tagName.toLowerCase()||"data-tab-heading"===a.tagName.toLowerCase())}return{restrict:"A",require:"^tabset",link:function(b,c,d){var e=b.$eval(d.tabContentTransclude);e.$transcludeFn(e.$parent,function(b){angular.forEach(b,function(b){a(b)?e.headingElement=b:c.append(b)})})}}}),angular.module("ui.bootstrap.timepicker",[]).constant("timepickerConfig",{hourStep:1,minuteStep:1,showMeridian:!0,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0}).controller("TimepickerController",["$scope","$attrs","$parse","$log","$locale","timepickerConfig",function(a,b,c,d,e,f){function g(){var b=parseInt(a.hours,10),c=a.showMeridian?b>0&&13>b:b>=0&&24>b;return c?(a.showMeridian&&(12===b&&(b=0),a.meridian===p[1]&&(b+=12)),b):void 0}function h(){var b=parseInt(a.minutes,10);return b>=0&&60>b?b:void 0}function i(a){return angular.isDefined(a)&&a.toString().length<2?"0"+a:a.toString()}function j(a){k(),o.$setViewValue(new Date(n)),l(a)}function k(){o.$setValidity("time",!0),a.invalidHours=!1,a.invalidMinutes=!1}function l(b){var c=n.getHours(),d=n.getMinutes();a.showMeridian&&(c=0===c||12===c?12:c%12),a.hours="h"===b?c:i(c),"m"!==b&&(a.minutes=i(d)),a.meridian=n.getHours()<12?p[0]:p[1]}function m(a){var b=new Date(n.getTime()+6e4*a);n.setHours(b.getHours(),b.getMinutes()),j()}var n=new Date,o={$setViewValue:angular.noop},p=angular.isDefined(b.meridians)?a.$parent.$eval(b.meridians):f.meridians||e.DATETIME_FORMATS.AMPMS;this.init=function(c,d){o=c,o.$render=this.render,o.$formatters.unshift(function(a){return a?new Date(a):null});var e=d.eq(0),g=d.eq(1),h=angular.isDefined(b.mousewheel)?a.$parent.$eval(b.mousewheel):f.mousewheel;h&&this.setupMousewheelEvents(e,g);var i=angular.isDefined(b.arrowkeys)?a.$parent.$eval(b.arrowkeys):f.arrowkeys;i&&this.setupArrowkeyEvents(e,g),a.readonlyInput=angular.isDefined(b.readonlyInput)?a.$parent.$eval(b.readonlyInput):f.readonlyInput,this.setupInputEvents(e,g)};var q=f.hourStep;b.hourStep&&a.$parent.$watch(c(b.hourStep),function(a){q=parseInt(a,10)});var r=f.minuteStep;b.minuteStep&&a.$parent.$watch(c(b.minuteStep),function(a){r=parseInt(a,10)}),a.showMeridian=f.showMeridian,b.showMeridian&&a.$parent.$watch(c(b.showMeridian),function(b){if(a.showMeridian=!!b,o.$error.time){var c=g(),d=h();angular.isDefined(c)&&angular.isDefined(d)&&(n.setHours(c),j())}else l()}),this.setupMousewheelEvents=function(b,c){var d=function(a){a.originalEvent&&(a=a.originalEvent);var b=a.wheelDelta?a.wheelDelta:-a.deltaY;return a.detail||b>0};b.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementHours():a.decrementHours()),b.preventDefault()}),c.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementMinutes():a.decrementMinutes()),b.preventDefault()})},this.setupArrowkeyEvents=function(b,c){b.bind("keydown",function(b){38===b.which?(b.preventDefault(),a.incrementHours(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementHours(),a.$apply())}),c.bind("keydown",function(b){38===b.which?(b.preventDefault(),a.incrementMinutes(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementMinutes(),a.$apply())})},this.setupInputEvents=function(b,c){if(a.readonlyInput)return a.updateHours=angular.noop,void(a.updateMinutes=angular.noop);var d=function(b,c){o.$setViewValue(null),o.$setValidity("time",!1),angular.isDefined(b)&&(a.invalidHours=b),angular.isDefined(c)&&(a.invalidMinutes=c)};a.updateHours=function(){var a=g();angular.isDefined(a)?(n.setHours(a),j("h")):d(!0)},b.bind("blur",function(b){!a.invalidHours&&a.hours<10&&a.$apply(function(){a.hours=i(a.hours)})}),a.updateMinutes=function(){var a=h();angular.isDefined(a)?(n.setMinutes(a),j("m")):d(void 0,!0)},c.bind("blur",function(b){!a.invalidMinutes&&a.minutes<10&&a.$apply(function(){a.minutes=i(a.minutes)})})},this.render=function(){var a=o.$viewValue;isNaN(a)?(o.$setValidity("time",!1),d.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(a&&(n=a),k(),l())},a.showSpinners=angular.isDefined(b.showSpinners)?a.$parent.$eval(b.showSpinners):f.showSpinners,a.incrementHours=function(){m(60*q)},a.decrementHours=function(){m(60*-q)},a.incrementMinutes=function(){m(r)},a.decrementMinutes=function(){m(-r)},a.toggleMeridian=function(){m(720*(n.getHours()<12?1:-1))}}]).directive("timepicker",function(){return{restrict:"EA",require:["timepicker","?^ngModel"],controller:"TimepickerController",replace:!0,scope:{},templateUrl:"template/timepicker/timepicker.html",link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f,b.find("input"))}}}),angular.module("ui.bootstrap.transition",[]).value("$transitionSuppressDeprecated",!1).factory("$transition",["$q","$timeout","$rootScope","$log","$transitionSuppressDeprecated",function(a,b,c,d,e){function f(a){for(var b in a)if(void 0!==h.style[b])return a[b]}e||d.warn("$transition is now deprecated. Use $animate from ngAnimate instead.");var g=function(d,e,f){f=f||{};var h=a.defer(),i=g[f.animation?"animationEndEventName":"transitionEndEventName"],j=function(a){c.$apply(function(){d.unbind(i,j),h.resolve(d)})};return i&&d.bind(i,j),b(function(){angular.isString(e)?d.addClass(e):angular.isFunction(e)?e(d):angular.isObject(e)&&d.css(e),i||h.resolve(d)}),h.promise.cancel=function(){i&&d.unbind(i,j),h.reject("Transition cancelled")},h.promise},h=document.createElement("trans"),i={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"},j={WebkitTransition:"webkitAnimationEnd",MozTransition:"animationend",OTransition:"oAnimationEnd",transition:"animationend"};return g.transitionEndEventName=f(i),g.animationEndEventName=f(j),g}]),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.position","ui.bootstrap.bindHtml"]).factory("typeaheadParser",["$parse",function(a){var b=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(c){var d=c.match(b);if(!d)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+c+'".');return{itemName:d[3],source:a(d[4]),viewMapper:a(d[2]||d[1]),modelMapper:a(d[1])}}}}]).directive("typeahead",["$compile","$parse","$q","$timeout","$document","$window","$rootScope","$position","typeaheadParser",function(a,b,c,d,e,f,g,h,i){var j=[9,13,27,38,40],k=200;return{require:"ngModel",link:function(l,m,n,o){function p(){G.moveInProgress||(G.moveInProgress=!0,G.$digest()),N&&d.cancel(N),N=d(function(){G.matches.length&&q(),G.moveInProgress=!1,G.$digest()},k)}function q(){G.position=B?h.offset(m):h.position(m),G.position.top+=m.prop("offsetHeight")}var r=l.$eval(n.typeaheadMinLength);r||0===r||(r=1);var s,t,u=l.$eval(n.typeaheadWaitMs)||0,v=l.$eval(n.typeaheadEditable)!==!1,w=b(n.typeaheadLoading).assign||angular.noop,x=b(n.typeaheadOnSelect),y=angular.isDefined(n.typeaheadSelectOnBlur)?l.$eval(n.typeaheadSelectOnBlur):!1,z=b(n.typeaheadNoResults).assign||angular.noop,A=n.typeaheadInputFormatter?b(n.typeaheadInputFormatter):void 0,B=n.typeaheadAppendToBody?l.$eval(n.typeaheadAppendToBody):!1,C=l.$eval(n.typeaheadFocusFirst)!==!1,D=n.typeaheadSelectOnExact?l.$eval(n.typeaheadSelectOnExact):!1,E=b(n.ngModel).assign,F=i.parse(n.typeahead),G=l.$new();l.$on("$destroy",function(){G.$destroy()});var H="typeahead-"+G.$id+"-"+Math.floor(1e4*Math.random());m.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":H});var I=angular.element("<div typeahead-popup></div>");I.attr({id:H,matches:"matches",active:"activeIdx",select:"select(activeIdx)","move-in-progress":"moveInProgress",query:"query",position:"position"}),angular.isDefined(n.typeaheadTemplateUrl)&&I.attr("template-url",n.typeaheadTemplateUrl);var J=function(){G.matches=[],G.activeIdx=-1,m.attr("aria-expanded",!1)},K=function(a){return H+"-option-"+a};G.$watch("activeIdx",function(a){0>a?m.removeAttr("aria-activedescendant"):m.attr("aria-activedescendant",K(a))});var L=function(a,b){return G.matches.length>b&&a?a.toUpperCase()===G.matches[b].label.toUpperCase():!1},M=function(a){var b={$viewValue:a};w(l,!0),z(l,!1),c.when(F.source(l,b)).then(function(c){var d=a===o.$viewValue;if(d&&s)if(c&&c.length>0){G.activeIdx=C?0:-1,z(l,!1),G.matches.length=0;for(var e=0;e<c.length;e++)b[F.itemName]=c[e],G.matches.push({id:K(e),label:F.viewMapper(G,b),model:c[e]});G.query=a,q(),m.attr("aria-expanded",!0),D&&1===G.matches.length&&L(a,0)&&G.select(0)}else J(),z(l,!0);d&&w(l,!1)},function(){J(),w(l,!1),z(l,!0)})};B&&(angular.element(f).bind("resize",p),e.find("body").bind("scroll",p));var N;G.moveInProgress=!1,J(),G.query=void 0;var O,P=function(a){O=d(function(){M(a)},u)},Q=function(){O&&d.cancel(O)};o.$parsers.unshift(function(a){return s=!0,0===r||a&&a.length>=r?u>0?(Q(),P(a)):M(a):(w(l,!1),Q(),J()),v?a:a?void o.$setValidity("editable",!1):(o.$setValidity("editable",!0),a)}),o.$formatters.push(function(a){var b,c,d={};return v||o.$setValidity("editable",!0),A?(d.$model=a,A(l,d)):(d[F.itemName]=a,b=F.viewMapper(l,d),d[F.itemName]=void 0,c=F.viewMapper(l,d),b!==c?b:a)}),G.select=function(a){var b,c,e={};t=!0,e[F.itemName]=c=G.matches[a].model,b=F.modelMapper(l,e),E(l,b),o.$setValidity("editable",!0),o.$setValidity("parse",!0),x(l,{$item:c,$model:b,$label:F.viewMapper(l,e)}),J(),d(function(){m[0].focus()},0,!1)},m.bind("keydown",function(a){if(0!==G.matches.length&&-1!==j.indexOf(a.which)){if(-1===G.activeIdx&&(9===a.which||13===a.which))return J(),void G.$digest();a.preventDefault(),40===a.which?(G.activeIdx=(G.activeIdx+1)%G.matches.length,G.$digest()):38===a.which?(G.activeIdx=(G.activeIdx>0?G.activeIdx:G.matches.length)-1,G.$digest()):13===a.which||9===a.which?G.$apply(function(){G.select(G.activeIdx)}):27===a.which&&(a.stopPropagation(),J(),G.$digest())}}),m.bind("blur",function(){y&&G.matches.length&&-1!==G.activeIdx&&!t&&(t=!0,G.$apply(function(){G.select(G.activeIdx)})),s=!1,t=!1});var R=function(a){m[0]!==a.target&&3!==a.which&&0!==G.matches.length&&(J(),g.$$phase||G.$digest())};e.bind("click",R),l.$on("$destroy",function(){e.unbind("click",R),B&&S.remove(),I.remove()});var S=a(I)(G);B?e.find("body").append(S):m.after(S)}}}]).directive("typeaheadPopup",function(){return{restrict:"EA",scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&"},replace:!0,templateUrl:"template/typeahead/typeahead-popup.html",link:function(a,b,c){a.templateUrl=c.templateUrl,a.isOpen=function(){return a.matches.length>0},a.isActive=function(b){return a.active==b},a.selectActive=function(b){a.active=b},a.selectMatch=function(b){a.select({activeIdx:b})}}}}).directive("typeaheadMatch",["$templateRequest","$compile","$parse",function(a,b,c){return{restrict:"EA",scope:{index:"=",match:"=",query:"="},link:function(d,e,f){var g=c(f.templateUrl)(d.$parent)||"template/typeahead/typeahead-match.html";a(g).then(function(a){b(a.trim())(d,function(a){e.replaceWith(a)})})}}}]).filter("typeaheadHighlight",function(){function a(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}return function(b,c){return c?(""+b).replace(new RegExp(a(c),"gi"),"<strong>$&</strong>"):b}}),angular.module("template/accordion/accordion-group.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion-group.html",'<div class="panel panel-default">\n  <div class="panel-heading">\n    <h4 class="panel-title">\n      <a href="#" tabindex="0" class="accordion-toggle" ng-click="$event.preventDefault(); toggleOpen()" accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div class="panel-collapse collapse" collapse="!isOpen">\n	  <div class="panel-body" ng-transclude></div>\n  </div>\n</div>\n');
}]),angular.module("template/accordion/accordion.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion.html",'<div class="panel-group" ng-transclude></div>')}]),angular.module("template/alert/alert.html",[]).run(["$templateCache",function(a){a.put("template/alert/alert.html",'<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissible\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close($event)">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n')}]),angular.module("template/carousel/carousel.html",[]).run(["$templateCache",function(a){a.put("template/carousel/carousel.html",'<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n    <ol class="carousel-indicators" ng-show="slides.length > 1">\n        <li ng-repeat="slide in slides | orderBy:\'index\' track by $index" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>\n    </ol>\n    <div class="carousel-inner" ng-transclude></div>\n    <a class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1"><span class="glyphicon glyphicon-chevron-left"></span></a>\n    <a class="right carousel-control" ng-click="next()" ng-show="slides.length > 1"><span class="glyphicon glyphicon-chevron-right"></span></a>\n</div>\n')}]),angular.module("template/carousel/slide.html",[]).run(["$templateCache",function(a){a.put("template/carousel/slide.html",'<div ng-class="{\n    \'active\': active\n  }" class="item text-center" ng-transclude></div>\n')}]),angular.module("template/datepicker/datepicker.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/datepicker.html",'<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <daypicker ng-switch-when="day" tabindex="0"></daypicker>\n  <monthpicker ng-switch-when="month" tabindex="0"></monthpicker>\n  <yearpicker ng-switch-when="year" tabindex="0"></yearpicker>\n</div>')}]),angular.module("template/datepicker/day.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/day.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/month.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/month.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/popup.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/popup.html",'<ul class="dropdown-menu" ng-if="isOpen" style="display: block" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n	<li ng-transclude></li>\n	<li ng-if="showButtonBar" style="padding:10px 9px 2px">\n		<span class="btn-group pull-left">\n			<button type="button" class="btn btn-sm btn-info" ng-click="select(\'today\')">{{ getText(\'current\') }}</button>\n			<button type="button" class="btn btn-sm btn-danger" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n		</span>\n		<button type="button" class="btn btn-sm btn-success pull-right" ng-click="close()">{{ getText(\'close\') }}</button>\n	</li>\n</ul>\n')}]),angular.module("template/datepicker/year.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/year.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/modal/backdrop.html",[]).run(["$templateCache",function(a){a.put("template/modal/backdrop.html",'<div class="modal-backdrop"\n     modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n')}]),angular.module("template/modal/window.html",[]).run(["$templateCache",function(a){a.put("template/modal/window.html",'<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n    modal-animation-class="fade"\n    modal-in-class="in"\n	ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}" ng-click="close($event)">\n    <div class="modal-dialog" ng-class="size ? \'modal-\' + size : \'\'"><div class="modal-content" modal-transclude></div></div>\n</div>\n')}]),angular.module("template/pagination/pager.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pager.html",'<ul class="pager">\n  <li ng-class="{disabled: noPrevious(), previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext(), next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>')}]),angular.module("template/pagination/pagination.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pagination.html",'<ul class="pagination">\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}"><a href ng-click="selectPage(1, $event)">{{::getText(\'first\')}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}"><a href ng-click="selectPage(totalPages, $event)">{{::getText(\'last\')}}</a></li>\n</ul>\n')}]),angular.module("template/tooltip/tooltip-html-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-html-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-html-unsafe-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-html-unsafe-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" bind-html-unsafe="content"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-template-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-template-popup.html",'<div class="tooltip"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner"\n    tooltip-template-transclude="contentExp()"\n    tooltip-template-transclude-scope="originScope()"></div>\n</div>\n')}]),angular.module("template/popover/popover-html.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover-html.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind-html="contentExp()"></div>\n  </div>\n</div>\n')}]),angular.module("template/popover/popover-template.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover-template.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content"\n        tooltip-template-transclude="contentExp()"\n        tooltip-template-transclude-scope="originScope()"></div>\n  </div>\n</div>\n')}]),angular.module("template/popover/popover.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover.html",'<div class="popover"\n  tooltip-animation-class="fade"\n  tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n')}]),angular.module("template/progressbar/bar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/bar.html",'<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" ng-transclude></div>\n')}]),angular.module("template/progressbar/progress.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progress.html",'<div class="progress" ng-transclude></div>')}]),angular.module("template/progressbar/progressbar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progressbar.html",'<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" ng-transclude></div>\n</div>\n')}]),angular.module("template/rating/rating.html",[]).run(["$templateCache",function(a){a.put("template/rating/rating.html",'<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <i ng-repeat="r in range track by $index" ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')" ng-attr-title="{{r.title}}" >\n        <span class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    </i>\n</span>\n')}]),angular.module("template/tabs/tab.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tab.html",'<li ng-class="{active: active, disabled: disabled}">\n  <a href="#" ng-click="$event.preventDefault(); select()" tab-heading-transclude>{{heading}}</a>\n</li>\n')}]),angular.module("template/tabs/tabset.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tabset.html",'<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n')}]),angular.module("template/timepicker/timepicker.html",[]).run(["$templateCache",function(a){a.put("template/timepicker/timepicker.html",'<table>\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="incrementHours()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="incrementMinutes()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group" ng-class="{\'has-error\': invalidHours}">\n        <input style="width:50px;" type="text" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2">\n      </td>\n      <td>:</td>\n      <td class="form-group" ng-class="{\'has-error\': invalidMinutes}">\n        <input style="width:50px;" type="text" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2">\n      </td>\n      <td ng-show="showMeridian"><button type="button" class="btn btn-default text-center" ng-click="toggleMeridian()">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="decrementHours()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="decrementMinutes()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-match.html",'<a href="#" ng-click="$event.preventDefault()" tabindex="-1" bind-html-unsafe="match.label | typeaheadHighlight:query"></a>\n')}]),angular.module("template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}">\n        <div typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),!angular.$$csp()&&angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');
},{}],17:[function(require,module,exports){
/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 * https://github.com/vitalets/checklist-model
 * License: MIT http://opensource.org/licenses/MIT
 */

angular.module('checklist-model', [])
    .directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
        // contains
        function contains(arr, item, comparator) {
            if (angular.isArray(arr)) {
                for (var i = arr.length; i--;) {
                    if (comparator(arr[i], item)) {
                        return true;
                    }
                }
            }
            return false;
        }

        // add
        function add(arr, item, comparator) {
            arr = angular.isArray(arr) ? arr : [];
            if(!contains(arr, item, comparator)) {
                arr.push(item);
            }
            return arr;
        }

        // remove
        function remove(arr, item, comparator) {
            if (angular.isArray(arr)) {
                for (var i = arr.length; i--;) {
                    if (comparator(arr[i], item)) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
            return arr;
        }

        // http://stackoverflow.com/a/19228302/1458162
        function postLinkFn(scope, elem, attrs) {
            // exclude recursion, but still keep the model
            var checklistModel = attrs.checklistModel;
            attrs.$set("checklistModel", null);
            // compile with `ng-model` pointing to `checked`
            $compile(elem)(scope);
            attrs.$set("checklistModel", checklistModel);

            // getter for original model
            var checklistModelGetter = $parse(checklistModel);
            var checklistChange = $parse(attrs.checklistChange);
            var checklistBeforeChange = $parse(attrs.checklistBeforeChange);
            var ngModelGetter = $parse(attrs.ngModel);



            var comparator = angular.equals;

            if (attrs.hasOwnProperty('checklistComparator')){
                if (attrs.checklistComparator[0] == '.') {
                    var comparatorExpression = attrs.checklistComparator.substring(1);
                    comparator = function (a, b) {
                        return a[comparatorExpression] === b[comparatorExpression];
                    };

                } else {
                    comparator = $parse(attrs.checklistComparator)(scope.$parent);
                }
            }

            // watch UI checked change
            scope.$watch(attrs.ngModel, function(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }

                if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                    ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator));
                    return;
                }

                setValueInChecklistModel(getChecklistValue(), newValue);

                if (checklistChange) {
                    checklistChange(scope);
                }
            });

            // watches for value change of checklistValue (Credit to @blingerson)
            scope.$watch(getChecklistValue, function(newValue, oldValue) {
                if( newValue != oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true ) {
                    var current = checklistModelGetter(scope.$parent);
                    checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator));
                    checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator));
                }
            });

            function getChecklistValue() {
                return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
            }

            function setValueInChecklistModel(value, checked) {
                var current = checklistModelGetter(scope.$parent);
                if (angular.isFunction(checklistModelGetter.assign)) {
                    if (checked === true) {
                        checklistModelGetter.assign(scope.$parent, add(current, value, comparator));
                    } else {
                        checklistModelGetter.assign(scope.$parent, remove(current, value, comparator));
                    }
                }

            }

            // declare one function to be used for both $watch functions
            function setChecked(newArr, oldArr) {
                if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                    setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope));
                    return;
                }
                ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator));
            }

            // watch original model change
            // use the faster $watchCollection method if it's available
            if (angular.isFunction(scope.$parent.$watchCollection)) {
                scope.$parent.$watchCollection(checklistModel, setChecked);
            } else {
                scope.$parent.$watch(checklistModel, setChecked, true);
            }
        }

        return {
            restrict: 'A',
            priority: 1000,
            terminal: true,
            scope: true,
            compile: function(tElement, tAttrs) {

                if (!tAttrs.checklistValue && !tAttrs.value) {
                    throw 'You should provide `value` or `checklist-value`.';
                }

                // by default ngModel is 'checked', so we set it if not specified
                if (!tAttrs.ngModel) {
                    // local scope var storing individual checkbox model
                    tAttrs.$set("ngModel", "checked");
                }

                return postLinkFn;
            }
        };
    }]);
},{}],18:[function(require,module,exports){
"use strict";
//
// Main
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategies = void 0;
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
exports.default = memoize;
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
exports.strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

},{}],19:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBestPattern = void 0;
var time_data_generated_1 = require("./time-data.generated");
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
exports.getBestPattern = getBestPattern;
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = time_data_generated_1.timeData[regionTag || ''] ||
        time_data_generated_1.timeData[languageTag || ''] ||
        time_data_generated_1.timeData["".concat(languageTag, "-001")] ||
        time_data_generated_1.timeData['001'];
    return hourCycles[0];
}

},{"./time-data.generated":24}],20:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorKind = void 0;
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind = exports.ErrorKind || (exports.ErrorKind = {}));

},{}],21:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var tslib_1 = require("tslib");
var error_1 = require("./error");
var parser_1 = require("./parser");
var types_1 = require("./types");
function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if ((0, types_1.isSelectElement)(el) || (0, types_1.isPluralElement)(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if ((0, types_1.isNumberElement)(el) && (0, types_1.isNumberSkeleton)(el.style)) {
            delete el.style.location;
        }
        else if (((0, types_1.isDateElement)(el) || (0, types_1.isTimeElement)(el)) &&
            (0, types_1.isDateTimeSkeleton)(el.style)) {
            delete el.style.location;
        }
        else if ((0, types_1.isTagElement)(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0, tslib_1.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new parser_1.Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(error_1.ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}
exports.parse = parse;
(0, tslib_1.__exportStar)(require("./types"), exports);

},{"./error":20,"./parser":22,"./types":25,"tslib":34}],22:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
var tslib_1 = require("tslib");
var error_1 = require("./error");
var types_1 = require("./types");
var regex_generated_1 = require("./regex.generated");
var icu_skeleton_parser_1 = require("@formatjs/icu-skeleton-parser");
var date_time_pattern_generator_1 = require("./date-time-pattern-generator");
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(regex_generated_1.SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(regex_generated_1.SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: types_1.TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(error_1.ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: types_1.TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(error_1.ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: types_1.TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(error_1.ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: types_1.TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(error_1.ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(error_1.ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: types_1.TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(error_1.ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: types_1.TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(error_1.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = (0, date_time_pattern_generator_1.getBestPattern)(skeleton, this.locale);
                        }
                        var style = {
                            type: types_1.SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? (0, icu_skeleton_parser_1.parseDateTimeSkeleton)(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? types_1.TYPE.date : types_1.TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? types_1.TYPE.number
                            : argType === 'date'
                                ? types_1.TYPE.date
                                : types_1.TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, tslib_1.__assign)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, error_1.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: types_1.TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: types_1.TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(error_1.ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(error_1.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, icu_skeleton_parser_1.parseNumberSkeletonFromString)(skeleton);
        }
        catch (e) {
            return this.error(error_1.ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: types_1.SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? (0, icu_skeleton_parser_1.parseNumberSkeleton)(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, error_1.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? error_1.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : error_1.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(error_1.ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
exports.Parser = Parser;
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

},{"./date-time-pattern-generator":19,"./error":20,"./regex.generated":23,"./types":25,"@formatjs/icu-skeleton-parser":27,"tslib":34}],23:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITE_SPACE_REGEX = exports.SPACE_SEPARATOR_REGEX = void 0;
// @generated from regex-gen.ts
exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{}],24:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeData = void 0;
// @generated from time-data-gen.ts
// prettier-ignore  
exports.timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

},{}],25:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNumberElement = exports.createLiteralElement = exports.isDateTimeSkeleton = exports.isNumberSkeleton = exports.isTagElement = exports.isPoundElement = exports.isPluralElement = exports.isSelectElement = exports.isTimeElement = exports.isDateElement = exports.isNumberElement = exports.isArgumentElement = exports.isLiteralElement = exports.SKELETON_TYPE = exports.TYPE = void 0;
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE = exports.TYPE || (exports.TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE = exports.SKELETON_TYPE || (exports.SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
exports.isLiteralElement = isLiteralElement;
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
exports.isArgumentElement = isArgumentElement;
function isNumberElement(el) {
    return el.type === TYPE.number;
}
exports.isNumberElement = isNumberElement;
function isDateElement(el) {
    return el.type === TYPE.date;
}
exports.isDateElement = isDateElement;
function isTimeElement(el) {
    return el.type === TYPE.time;
}
exports.isTimeElement = isTimeElement;
function isSelectElement(el) {
    return el.type === TYPE.select;
}
exports.isSelectElement = isSelectElement;
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
exports.isPluralElement = isPluralElement;
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
exports.isPoundElement = isPoundElement;
function isTagElement(el) {
    return el.type === TYPE.tag;
}
exports.isTagElement = isTagElement;
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
exports.isNumberSkeleton = isNumberSkeleton;
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
exports.isDateTimeSkeleton = isDateTimeSkeleton;
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
exports.createLiteralElement = createLiteralElement;
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}
exports.createNumberElement = createNumberElement;

},{}],26:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateTimeSkeleton = void 0;
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}
exports.parseDateTimeSkeleton = parseDateTimeSkeleton;

},{}],27:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./date-time"), exports);
(0, tslib_1.__exportStar)(require("./number"), exports);

},{"./date-time":26,"./number":28,"tslib":34}],28:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumberSkeleton = exports.parseNumberSkeletonFromString = void 0;
var tslib_1 = require("tslib");
var regex_generated_1 = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_1.WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
exports.parseNumberSkeletonFromString = parseNumberSkeletonFromString;
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}
exports.parseNumberSkeleton = parseNumberSkeleton;

},{"./regex.generated":29,"tslib":34}],29:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITE_SPACE_REGEX = void 0;
// @generated from regex-gen.ts
exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{}],30:[function(require,module,exports){
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("./src/core");
(0, tslib_1.__exportStar)(require("./src/formatters"), exports);
(0, tslib_1.__exportStar)(require("./src/core"), exports);
(0, tslib_1.__exportStar)(require("./src/error"), exports);
exports.default = core_1.IntlMessageFormat;

},{"./src/core":31,"./src/error":32,"./src/formatters":33,"tslib":34}],31:[function(require,module,exports){
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlMessageFormat = void 0;
var tslib_1 = require("tslib");
var icu_messageformat_parser_1 = require("@formatjs/icu-messageformat-parser");
var fast_memoize_1 = (0, tslib_1.__importStar)(require("@formatjs/fast-memoize"));
var formatters_1 = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, tslib_1.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0, fast_memoize_1.default)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: fast_memoize_1.strategies.variadic,
        }),
        getDateTimeFormat: (0, fast_memoize_1.default)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: fast_memoize_1.strategies.variadic,
        }),
        getPluralRules: (0, fast_memoize_1.default)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: fast_memoize_1.strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== formatters_1.PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0, formatters_1.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = icu_messageformat_parser_1.parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());
exports.IntlMessageFormat = IntlMessageFormat;

},{"./formatters":33,"@formatjs/fast-memoize":18,"@formatjs/icu-messageformat-parser":21,"tslib":34}],32:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingValueError = exports.InvalidValueTypeError = exports.InvalidValueError = exports.FormatError = exports.ErrorCode = void 0;
var tslib_1 = require("tslib");
var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
exports.FormatError = FormatError;
var InvalidValueError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
exports.InvalidValueError = InvalidValueError;
var InvalidValueTypeError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
exports.InvalidValueTypeError = InvalidValueTypeError;
var MissingValueError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));
exports.MissingValueError = MissingValueError;

},{"tslib":34}],33:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToParts = exports.isFormatXMLElementFn = exports.PART_TYPE = void 0;
var icu_messageformat_parser_1 = require("@formatjs/icu-messageformat-parser");
var error_1 = require("./error");
var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE = exports.PART_TYPE || (exports.PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
exports.isFormatXMLElementFn = isFormatXMLElementFn;
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, icu_messageformat_parser_1.isLiteralElement)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, icu_messageformat_parser_1.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, icu_messageformat_parser_1.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new error_1.MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if ((0, icu_messageformat_parser_1.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, icu_messageformat_parser_1.isDateElement)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0, icu_messageformat_parser_1.isDateTimeSkeleton)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0, icu_messageformat_parser_1.isTimeElement)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0, icu_messageformat_parser_1.isDateTimeSkeleton)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0, icu_messageformat_parser_1.isNumberElement)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0, icu_messageformat_parser_1.isNumberSkeleton)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0, icu_messageformat_parser_1.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new error_1.InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0, icu_messageformat_parser_1.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new error_1.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, icu_messageformat_parser_1.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new error_1.FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", error_1.ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new error_1.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}
exports.formatToParts = formatToParts;

},{"./error":32,"@formatjs/icu-messageformat-parser":21}],34:[function(require,module,exports){
(function (global){(function (){
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global global, define, System, Reflect, Promise */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __metadata;
var __awaiter;
var __generator;
var __exportStar;
var __values;
var __read;
var __spread;
var __spreadArrays;
var __spreadArray;
var __await;
var __asyncGenerator;
var __asyncDelegator;
var __asyncValues;
var __makeTemplateObject;
var __importStar;
var __importDefault;
var __classPrivateFieldGet;
var __classPrivateFieldSet;
var __classPrivateFieldIn;
var __createBinding;
(function (factory) {
    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
    if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function (exports) { factory(createExporter(root, createExporter(exports))); });
    }
    else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
    }
    else {
        factory(createExporter(root));
    }
    function createExporter(exports, previous) {
        if (exports !== root) {
            if (typeof Object.create === "function") {
                Object.defineProperty(exports, "__esModule", { value: true });
            }
            else {
                exports.__esModule = true;
            }
        }
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };

    __extends = function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    __exportStar = function(m, o) {
        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
    };

    __createBinding = Object.create ? (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
            desc = { enumerable: true, get: function() { return m[k]; } };
        }
        Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });

    __values = function (o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };

    __read = function (o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    };

    /** @deprecated */
    __spread = function () {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    };

    /** @deprecated */
    __spreadArrays = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    __spreadArray = function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };

    __await = function (v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    };

    __asyncGenerator = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    };

    __asyncDelegator = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    };

    __asyncValues = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    };

    __makeTemplateObject = function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    var __setModuleDefault = Object.create ? (function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
    }) : function(o, v) {
        o["default"] = v;
    };

    __importStar = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    };

    __importDefault = function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };

    __classPrivateFieldGet = function (receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
    };

    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
    };

    __classPrivateFieldIn = function (state, receiver) {
        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__spreadArray", __spreadArray);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],35:[function(require,module,exports){
'use strict';

var b2bRegistrationFlowBundle = angular.module('b2bRegistrationFlowBundle', [
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ui.bootstrap',
    'checklist-model',
    'ng.shims.placeholder',
    'sdGroupRequiredValidator',
    'sdPostcodeValidator',
    'sdLondonValidator',
    'sdRadiusValidator',
    'sdFormPendingIndicator',
    'sdPostcodeAutoComplete',
    'sdRemoteValidation',
    'sdDuplicatedEmailValidation',
    'boxuk.translation',
    'ngSanitize',
    'multiStepForm',
    'uiGmapgoogle-maps',
    'sdLocalStorageHelper',
    'b2bRegistrationFlowBundle.services',
]);

angular.module('b2bRegistrationFlowBundle.services', []);

b2bRegistrationFlowBundle.value('cgBusyDefaults', {
    message: '',
    templateUrl: '/companies/loading-mask.html'
});

angular.module('b2bRegistrationFlowBundle').constant('stepsConfig', {
    home: [
        {
            controller: 'WorkingAreasController',
            templateUrl: 'working-areas.html',
            title: 'working-areas',
            hasForm: true
        },
        {
            controller: 'FieldOfStudyController',
            templateUrl: 'field-of-study.html',
            title: 'field-of-study',
            hasForm: true
        },
        {
            controller: 'MultipleSitesLeadTypesController',
            templateUrl: 'multiple-sites-lead-types.html',
            title: 'multiple-sites-lead-types',
            hasForm: true
        },
        {
            controller: 'CompanyInformationController',
            templateUrl: 'company-information.html',
            title: 'company-information',
            hasForm: true
        },
        {
            controller: 'CompanyInformationController',
            templateUrl: 'personal-information.html',
            title: 'personal-information',
            hasForm: true
        },
    ],
    move: [
        {
            controller: 'LeadTypesController',
            templateUrl: 'lead-types.html',
            title: 'lead-types',
            hasForm: true
        },
        {
            controller: 'WorkingAreasController',
            templateUrl: 'working-areas.html',
            title: 'working-areas',
            hasForm: true
        },
        {
            controller: 'CompanyInformationController',
            templateUrl: 'company-details.html',
            title: 'company-details',
            hasForm: true
        },
        {
            controller: 'CompanyInformationController',
            templateUrl: 'contact-person.html',
            title: 'contact-person',
            hasForm: true
        }
    ]
});

b2bRegistrationFlowBundle.filter('keys', function () {
    return function (input) {
        if (!angular.isObject(input)) {
            throw Error("Usage of non-objects with keylength filter!!")
        }
        return Object.keys(input).length;
    }
});

b2bRegistrationFlowBundle.filter('orderObjectBy', function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            return (a[field] > b[field] ? 1 : -1);
        });
        if (reverse) filtered.reverse();
        return filtered;
    };
});

b2bRegistrationFlowBundle.config(function ($interpolateProvider, $locationProvider, $compileProvider) {
    if ("prod" === 'production') {
        $compileProvider.debugInfoEnabled(false);
    }

    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');

    if (window.history && window.history.pushState) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
    else {
        //Fix for IE9
        $locationProvider.html5Mode(false).hashPrefix('!');
    }
});

//Services
require('./steps/working-areas/location/location-maps-service.js');

// Controllers
require('./steps/company-multiple-sites-controller.js');
require('./steps/company-registration-controller.js');
require('./steps/company-registration-controller-move.js');
require('./sd-ng-indetermidiate.js');
require('./steps/step-controller.js');
require('./steps/getting-started-controller.js');
require('./steps/company-information-controller.js');
require('./steps/field-of-study.js');
require('./steps/multiple-sites-lead-types.js');
require('./steps/lead-types-controller');
require('./steps/working-areas/working-areas-controller.js');
require('./thank-you-page-controller.js');
require('../private/directive/sd-form-pending-indicator.js');
require('../private/directive/sd-postcode-auto-complete.js');

require('../../../../app/Resources/private/libraries/skydreams/validator/sd-london-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/validator/sd-group-required-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/validator/sd-postcode-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/validator/sd-radius-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/validator/sd-remote-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/validator/sd-duplicated-email-validator.js');
require('../../../../app/Resources/private/libraries/skydreams/services/sd-local-storage-helper.js');
require('../../../../app/Resources/private/libraries/skydreams/service/CountryBusinessTypesRepository.js');
require('../../../../app/Resources/private/libraries/troch/angular-multi-step-form.js');
require('../../../../app/Resources/private/libraries/cvn/angular-shims-placeholder/angular-shims-placeholder.js');
require('../../../../app/Resources/private/libraries/ui-bootstrap/ui-bootstrap-tpls-0.13.2.min.js');
require('../../../../app/Resources/private/libraries/vitalets/checklist-model/checklist-model.js');
require('../../../../app/Resources/private/libraries/angular-symfony-translation/angular-symfony-translation.min.js');
require('../../../../app/Resources/private/libraries/angular-ui/angular-google-maps.js');
require('../../../../app/Resources/private/libraries/angular-simple-logger/angular-simple-logger.min.js');

// Components
require('../views/Components/PostalCode/postalcode-typeahead.component.js');
require('./steps/working-areas/sticky-button.js');

//Maps
require('./steps/working-areas/location/location-map-directive.js');

},{"../../../../app/Resources/private/libraries/angular-simple-logger/angular-simple-logger.min.js":2,"../../../../app/Resources/private/libraries/angular-symfony-translation/angular-symfony-translation.min.js":3,"../../../../app/Resources/private/libraries/angular-ui/angular-google-maps.js":4,"../../../../app/Resources/private/libraries/cvn/angular-shims-placeholder/angular-shims-placeholder.js":6,"../../../../app/Resources/private/libraries/skydreams/service/CountryBusinessTypesRepository.js":7,"../../../../app/Resources/private/libraries/skydreams/services/sd-local-storage-helper.js":8,"../../../../app/Resources/private/libraries/skydreams/validator/sd-duplicated-email-validator.js":9,"../../../../app/Resources/private/libraries/skydreams/validator/sd-group-required-validator.js":10,"../../../../app/Resources/private/libraries/skydreams/validator/sd-london-validator.js":11,"../../../../app/Resources/private/libraries/skydreams/validator/sd-postcode-validator.js":12,"../../../../app/Resources/private/libraries/skydreams/validator/sd-radius-validator.js":13,"../../../../app/Resources/private/libraries/skydreams/validator/sd-remote-validator.js":14,"../../../../app/Resources/private/libraries/troch/angular-multi-step-form.js":15,"../../../../app/Resources/private/libraries/ui-bootstrap/ui-bootstrap-tpls-0.13.2.min.js":16,"../../../../app/Resources/private/libraries/vitalets/checklist-model/checklist-model.js":17,"../private/directive/sd-form-pending-indicator.js":36,"../private/directive/sd-postcode-auto-complete.js":37,"../views/Components/PostalCode/postalcode-typeahead.component.js":53,"./sd-ng-indetermidiate.js":38,"./steps/company-information-controller.js":39,"./steps/company-multiple-sites-controller.js":40,"./steps/company-registration-controller-move.js":41,"./steps/company-registration-controller.js":42,"./steps/field-of-study.js":43,"./steps/getting-started-controller.js":44,"./steps/lead-types-controller":45,"./steps/multiple-sites-lead-types.js":46,"./steps/step-controller.js":47,"./steps/working-areas/location/location-map-directive.js":48,"./steps/working-areas/location/location-maps-service.js":49,"./steps/working-areas/sticky-button.js":50,"./steps/working-areas/working-areas-controller.js":51,"./thank-you-page-controller.js":52}],36:[function(require,module,exports){
'use strict';

angular.module('sdFormPendingIndicator', []).directive('sdFormPendingIndicator', function () {
    return {
        restrict: 'A',
        require: '^form',
        link: function postLink(scope, element, attrs, formCtrl) {
            // Watch the form pending state
            scope.$watch(function () {
                return formCtrl.$pending;
            }, function (val) {
                scope.formStatus.pending = val;
            });
        }
    };
});

},{}],37:[function(require,module,exports){
angular.module('sdPostcodeAutoComplete', []).directive('sdPostcodeAutoComplete', function ($http, $q, $locale) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    var POSTCODE_INVALID_POSTCODE_FORMAT = 2;
    var POSTCODE_NO_REGION_FOUND = 5;
    var POSTCODE_SERVER_ERROR = 4;
    var efficientAutocomplete = debounce(function (value, scope) {

        if (typeof scope.address_postal_code === 'undefined' || scope.address_postal_code === '' || scope.address_postal_code === null) {
            return;
        }

        if (typeof scope.address_house_number === 'undefined' || scope.address_house_number === '' || scope.address_house_number === null) {
            return;
        }

        $http.jsonp(scope.url + scope.address_postal_code + '/' + scope.address_house_number, {
            params: {
                'callback': 'JSON_CALLBACK',
                'locale': $locale.localeID
            }
        }).success(function (data) {

            if (data.status === POSTCODE_NO_REGION_FOUND || data.status === POSTCODE_INVALID_POSTCODE_FORMAT || data.status === POSTCODE_SERVER_ERROR) {
                return;
            }

            if (typeof data.city !== 'undefined' && data.city !== null) {
                scope.address_locality = data.city;
            }

            if (typeof data.address !== 'undefined' && data.address !== null) {
                scope.address_street_name = data.address;
            }
        });
    }, 500);

    return {
        require: 'ngModel',
        scope: {
            model: '=ngModel',
            url: '@url',
            address_postal_code: '=addresspostalcode',
            address_street_name: '=addressstreetname',
            address_locality: '=addresslocality',
            address_house_number: '=addresshousenumber',
        },
        link: function (scope, element, attrs, ctrl) {
            scope.$watch('model', function (value) {
                if (angular.isDefined(value)) {
                    efficientAutocomplete(value, scope, ctrl);
                }
            });
        }
    };
});

},{}],38:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').directive('sdNgIndeterminate', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['sdNgIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});

},{}],39:[function(require,module,exports){
/*globals countryId:true */
angular.module('b2bRegistrationFlowBundle').controller('CompanyInformationController', function ($scope, $timeout, $resource, $sessionStorage, spContactEmailSessionKey, TranslationService, CountryBusinessTypesRepository, multiStepFormInstance) {


    $scope.COMPANY_INFORMATION_SCREEN_COC_SEARCH = 'coc_search';
    $scope.COMPANY_INFORMATION_SCREEN_MANUAL_FORM = 'manual_form';

    $scope.company_information = $scope.company_information || {};
    $scope.companyInformationScreen = $scope.COMPANY_INFORMATION_SCREEN_COC_SEARCH;

    if ($scope.$parent && $scope.$parent.registerStepController) {
        $scope.$parent.registerStepController(multiStepFormInstance.getActiveIndex(), $scope);
    }

    $scope.getGAFormData = function () {

        let formData = {};
        Object.keys($scope.company_information).forEach(function(key) {
            if (key.startsWith('data')) {
                let normalizedKey = key.replace('data.', '');
                formData[normalizedKey] = $scope.company_information[key].$modelValue;
            }
        });

        // START: Required for experiment: feature.b2b_registration_coc_search
        if ($scope.company_lookup_selected === true) {
            formData = {
                companyname: $scope.data.companyname,
                company_number: $scope.data.company_number,
            };
        }

        if ($scope.company_lookup_selected === false) {
            formData = {
                companyname: $scope.data.companyname,
                company_number: $scope.data.company_number,
                address_house_number: $scope.data.address_house_number,
                address_postal_code: $scope.data.address_postal_code,
                address_street_name: $scope.data.address_street_name,
                address_locality: $scope.data.address_locality,
            };
        }
        // END: Required for experiment: feature.b2b_registration_coc_search

        return formData;
    }

    $scope.getGAFormErrorData = function () {

        let errorsData = [];
        let formData = $scope.getCurrentStepData();

        Object.keys(formData).forEach(function(key) {
            const formField = formData[key];
            if (formField.$invalid) {
                let fieldError = formField.$error;
                errorsData.push({
                    error_field: key,
                    error_type: fieldError ? Object.keys(fieldError)[0] : 'unknown'
                });
            }
        });

        return errorsData;
    }

    $scope.getCurrentStepData = function () {
        let formData = []
        Object.keys($scope.company_information).forEach(function(key) {
            if (key.startsWith('data')) {
                let normalizedKey = key.replace('data.', '');
                formData[normalizedKey] = $scope.company_information[key];
            }
        });

        return formData;
    }

    $timeout(function () {
        if (!$scope.data.address_postal_code || $scope.data.address_postal_code.length === 0) {
            $scope.data.address_postal_code = $scope.data.radius_postcode;
        }

        var dataFieldKeys = Object.keys($scope.company_information).filter(function (item) {
            return item.indexOf('data.') > -1;
        });
        var asyncValidationFields = ['data.address_postal_code', 'data.contact_email', 'data.contact_telephone'];
        dataFieldKeys.forEach(function (key) {
            var field = $scope['company_information'][key];
            if (field.$modelValue && field.$modelValue.length > 0) {
                field.$setTouched();
                field.$validate();
                if (asyncValidationFields.includes(key)) {
                    field.$setViewValue(field.$modelValue);
                }
            }
        });
    });

    $scope.switchToManualCompanyInformationForm = function () {
        $scope.company_lookup_selected = false;
        $scope.prefillCompanyNameOrCocNumber();
        $scope.companyInformationScreen = $scope.COMPANY_INFORMATION_SCREEN_MANUAL_FORM;
    }

    $scope.$watch('data.address_street_name', function () {
        $scope.updateAddress();
    });
    $scope.$watch('data.address_house_number', function () {
        $scope.updateAddress();
    });

    $scope.updateAddress = function () {
        if ($scope.data.address_street_name !== undefined && $scope.data.address_house_number !== undefined) {
            $scope.data.address_address_line1 = $scope.data.address_street_name + ' ' + $scope.data.address_house_number;
        }
    };

    $scope.$watch('data.contact_email', function () {
        $sessionStorage[spContactEmailSessionKey] = $scope.data.contact_email;
    });

    $scope.$watch('data.business_type', function (newValue) {
        if ($scope.countryBusinessTypes && !$scope.countryBusinessTypes[newValue]) {
            $scope.data.company_number = undefined;
        }
    });

    CountryBusinessTypesRepository.get({countryId: countryId}).$promise.then(function (data) {
        $scope.companyNumberRequired = true;
        $scope.countryBusinessTypes = [];
        angular.forEach(data, function (value, key) {
            if (Number.isInteger(key)) {
                $scope.countryBusinessTypes[value.name] = value.companyNumberRequired;
                if (!value.companyNumberRequired) {
                    $scope.companyNumberRequired = false;
                }
            }
        });
        if (Object.keys($scope.countryBusinessTypes).length > 0) {
            $scope.updateCompanyNumberField();
        }
    });

    $scope.updateCompanyNumberField = function () {
        $scope.companyNumberRequired = $scope.countryBusinessTypes[$scope.data.business_type];
    };

    $scope.getCompanyNumberLabel = function () {
        if ($scope.data.business_type) {
            return TranslationService.trans('b2b_homedeal.registration_flow.company-information.company_number.' + $scope.data.business_type);
        }

        return TranslationService.trans('b2b_homedeal.registration_flow.company-information.company_number.default');
    }

    $scope.companySearchResultAvailable = false;
    $scope.searchResultCompanies = [];
    $scope.manualInputNeededFromUser = false;

    const companySearchResource = $resource('/companies/coc/search', {}, {
        search: {method: 'GET', isArray: true}
    });

    $scope.searchCompany = function () {
        const companySearchInput = $scope.data.company_search_input;
        if (!companySearchInput || companySearchInput.length < 3) return;

        companySearchResource.search({query: companySearchInput}).$promise
            .then(function (response) {

                if (response.length === 0) {
                    $scope.switchToManualCompanyInformationForm();
                    $scope.manualInputNeededFromUser = true;
                }
                $scope.searchResultCompanies = response;
                $scope.companySearchResultAvailable = true;
            })
            .catch(function (error) {
                $scope.switchToManualCompanyInformationForm();
                console.error('Error fetching companies:', error);
            });
    };

    $scope.selectCompany = function (company) {
        $scope.company_lookup_selected = true;
        $scope.data.companyname = company.name;
        $scope.data.company_number = company.cocNumber;
    };

    $scope.prefillCompanyNameOrCocNumber = function () {
        const companySearchInput = ($scope.data.company_search_input || '').trim();
        if (/^[0-9]+$/.test(companySearchInput)) {
            $scope.data.company_number = companySearchInput;
            $scope.data.companyname = undefined;
        } else {
            $scope.data.companyname = companySearchInput;
            $scope.data.company_number = undefined;
        }
    }

    // todo: can we load this data only for the countries that need it?
    $scope.states = $resource('/companies/states.json').query();
});

},{}],40:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('CompanyMultipleSitesController', function ($scope, $http, $window, $controller, sdLocalStorageHelper, $location, $attrs) {

    angular.extend($controller('CompanyRegistrationController', {
        $scope: $scope
    }));

    $scope.data = {
        'filters': [],
        'promo_codes': '',
        'area_tool': '',
        'radius_postcode': '',
        'radius': '30',
        'regions': [],
        'subRegions': [],
        'types': [],
        'fieldsOfStudy': [],
        'labels': [],
        'multipleTypes': {},
        'companyId': '',
    };

    $scope.data = sdLocalStorageHelper.get('b2bFormDetails', $scope.data);
    $scope.allCategories = JSON.parse($attrs.categories);

    function noCategorySelectedYet() {
        return !$scope.data.fieldsOfStudy || $scope.data.fieldsOfStudy.length === 0;
    }

    //Only one category available for this site
    function isSingleCategorySite() {
        return $scope.allCategories.length === 1;
    }

    //Category is provided in the URL
    function hasCategoryInUrl() {
        return $location.search().category && parseInt($location.search().category) > 0;
    }

    function getTypesForCategory(categoryId) {
        let category = $scope.allCategories.find(category => category.site.id === parseInt(categoryId));
        if (category) {
            return category.site.types;
        }
        return [];
    }

    function setPreselectedCategory(categoryId) {
        $scope.data.fieldsOfStudy = [categoryId.toString()];
        $scope.data.multipleTypes = $scope.data.multipleTypes || {};
        if (!$scope.data.multipleTypes[categoryId]) {
            $scope.data.multipleTypes[categoryId] = getTypesForCategory(categoryId);
        }
    }

    if (isSingleCategorySite()) {
        //remove step 2 from the flow when there is only one category available for site
        $scope.steps = $scope.steps.filter((step) => step.title !== 'field-of-study');
    }

    if (noCategorySelectedYet()) {
        if (isSingleCategorySite()) {
            setPreselectedCategory($scope.allCategories[0].site.id);
        } else if (hasCategoryInUrl()) {
            setPreselectedCategory($location.search().category);
        }
    }

    let referral = $location.search().referral;
    let referralEmail = $location.search().email;
    if (angular.isDefined(referral) && angular.isDefined(referralEmail)) {
        $scope.data.referralCompanyId = referral
        $scope.data.email = referralEmail
        sdLocalStorageHelper.set('referralDetails', {
            referralEmail: referralEmail,
            referralCompanyId: referral
        });
    }
});

},{}],41:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('CompanyRegistrationControllerMove', function ($scope, $controller, stepsConfig, $http, skyapi, $window, $timeout, $interval, TranslationService) {
    angular.extend(this, $controller('CompanyRegistrationController', {$scope: $scope}));

    $scope.showSignIn = true;
    $scope.loadingTansKey = TranslationService.trans('b2b_move_registration.step.loading.account_creation');
    $scope.showMoveLoading = false;
    $scope.steps = stepsConfig.move
    let stopLoadingTrigger = false;

    $scope.createCompany = function (params, enhanceDataLayerCallback) {

        $scope.formStatus.submitting = true;
        if (!params.types || params.types.length === 0) {
            params.types = Object.values(params.multipleTypes).flat();
        }

        showMoveLoadingPage();

        $http.post($scope.submitUrl, params).success(function (data, status) {
            if (status < 200 && status >= 300) {
                $scope.handleError(params);
                return;
            }

            enhanceDataLayerCallback(params, data);

            const loadingCheck = $interval(function () {
                if (stopLoadingTrigger) {
                    $interval.cancel(loadingCheck);
                    sendVirtualPageViewEvent($window.location.origin, '/companies/subscribe/success');

                    var dataLayerDelay = 500;
                    setTimeout(function() {
                        $window.location = data.user_activation_url;
                    }, dataLayerDelay);
                }
            }, 100);
        })
    }

    function showMoveLoadingPage() {
        $timeout(function () {
            $window.scrollTo(0,0);
            $scope.showMoveLoading = true;
            $scope.showSignIn = false;
        }, 500).then(function () {
            startLoadingTextChange();
        });
    }

    function startLoadingTextChange() {
        const loadingTansKeys = ['b2b_move_registration.step.loading.transfer_information', 'b2b_move_registration.step.loading.assigning_manager'];
        let count = 0;
        const loadingTextChange = $interval(function () {
            if (count <= 1) {
                $scope.loadingTansKey = TranslationService.trans(loadingTansKeys[count]);
                count++;
            } else {
                stopLoadingTrigger = true;
                $interval.cancel(loadingTextChange);
            }
        }, 2500);
    }

    function sendVirtualPageViewEvent(origin, successUrl) {
        const fullURL = origin + successUrl;
        // Google Tag Manager virtual page view event to register conversion
        $window.dataLayer = $window.dataLayer || [];
        $window.dataLayer.push({
            'event': 'page_view',
            'page_location': fullURL,
        });
        // Bing Ads UET virtual page view event to register conversion
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'page_view', {
            'page_path': successUrl,
            'page_location': fullURL
        });
    }
});

},{}],42:[function(require,module,exports){
/*globals reApplyB2bEnabled:true, UC_UI:readonly*/

angular.module('b2bRegistrationFlowBundle')
    .controller('CompanyRegistrationController', function ($scope, $http, $window, sdLocalStorageHelper, $filter,
                                                           stepsConfig, $timeout, $cookies, skyapi) {

        $scope.formStatus = {};
        $scope.data = {
            'prename': '',
            'name': '',
            'contact_email': '',
            'filters': [],
            'promo_codes': '',
            'area_tool': '',
            'radius_postcode': '',
            'radius': '',
            'regions': [],
            'subRegions': [],
            'types': [],
        };

        $scope.userData = {};
        $scope.data = sdLocalStorageHelper.get('b2bFormDetails', $scope.data);

        $scope.$watchCollection('data', function () {
            sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
        });

        $scope.clearUserData = function () {
            $scope.userData = {};
        };

        $scope.stepsData = {
            version: 1, // 'Versioning added to avoid mixed structure of local storage when migrating between structures'
            areaSelectionSummary: {},
            allChildrenUnchecked: true,
            areas_panel_type: ''
        };

        $scope.hintsState = {
            'lead-types': {
                'lead-type': false
            },
            'working-areas': {
                'areas_panel_type': false
            },
            'company-details': {
                'data.company_number': false,
                'data.contact_email': false,
                'data.contact_telephone': false
            }
        };

        $scope.steps = stepsConfig.home;
        $scope.submitUrl = skyapi + '/companies/create-company';

        $scope.submitCompanyRegistration = function () {
            var params = angular.copy($scope.data);

            var cookieMap = {
                'b2b_utm_converted': 'b2b_utm_converted',
                'b2b_utm_original': 'b2b_utm_original',
                'b2c_utm_original': 'b2c_utm_original',
                'gclid': 'gclid',
                'gbraid': 'gbraid',
                'wbraid': 'wbraid',
                // https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
                '_fbc': '_fbc',
                '_fbp': '_fbp',
            };

            var cookieParams = {};
            Object.entries($cookies.getAll()).map(function (arr) {
                if (typeof cookieMap[arr[0]] != 'undefined') {
                    cookieParams[cookieMap[arr[0]]] = arr[1];
                }
            });

            angular.extend(params, {
                'callback_': 'JSON_CALLBACK',
                'method_': 'jsonp',
                'authcode': angular.element('[data-authcode]').attr('data-authcode'),
            }, $scope.data, cookieParams, getCookieConsentData());

            if ($scope.countryIso === 'BE') {
                params.regions = cleanUpBERegionIds(params);
            }

            params.businessUnit = angular.element('body').attr('data-businessUnit');
            angular.extend(params, getExperimentData());

            submitForm(params);
        };

        function getCookieConsentData() {
            if (typeof UC_UI === 'undefined') {
                return {};
            }
            let serviceInfo = UC_UI.getServicesBaseInfo();
            const map = {
                'Google Ads': 'google-ads',
                'Facebook Pixel': 'facebook-pixel'
            };
            let result = {}
            angular.forEach(serviceInfo, function (value) {
                if (value.name in map) {
                    result[map[value.name]] = value.consent.status;
                }
            });

            return {
                'cookie-consent': result
            };
        }

        function cleanUpBERegionIds(params) {
            return params.regions
                .filter(function (region) {
                    return region.indexOf('_') > -1;
                })
                .map(function (region) {
                    return region.split('_')[1];
                });
        }

    function enhanceDataLayer(params, createCompanyResponse) {

        let dataLayerObject = {
            event: "form_success",
            form_name: "business_registration",
            eid_sha256: createCompanyResponse.emailHash,
            form_id: $('[data-b2b-form-authcode]').attr('data-b2b-form-authcode'),
            company: {
                company_id: createCompanyResponse.companyId,
                company_name: params.companyname,
                business_type: params.business_type,
                number_of_employees: params.number_of_employees,
                contact_email: params.contact_email,
                contact_telephone: params.contact_telephone,
                contact_website: params.contact_website,
                product_group: createCompanyResponse.categories,
            },
            business_unit: params.businessUnit,
            company_address: {
                country_iso: createCompanyResponse.address.country_iso,
            },
            lead_details: {
                targeting_area: {
                    type: params.area_tool,
                    unit_system: createCompanyResponse.unit_system,
                    radius_value: 'N/A',
                    radius_location: 'N/A',
                }
            },
            form_step: $scope.steps.length,
            form_total_steps: $scope.steps.length,
            form_step_name: $scope.steps[$scope.steps.length-1].title,
        };

        let abVersion  = document.body.getAttribute('data-ab');
        if (abVersion) {
            dataLayerObject.ab_test_variant = abVersion;
        }

        if (params.area_tool === 'radius') {
            dataLayerObject.lead_details.targeting_area.radius_value = params.radius;
            dataLayerObject.lead_details.targeting_area.radius_location = params.location.label;
        }

        for (const [key, value] of Object.entries(params)) {
            if (key.startsWith('address_')) {
                dataLayerObject.company_address[key] = value;
            }
        }

        if (params.businessUnit === 'move') {
            dataLayerObject.lead_details.removals_interest = createCompanyResponse.includedTypes.movers;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerObject);
    }

        function submitForm(params) {
            if (typeof reApplyB2bEnabled !== 'undefined' && reApplyB2bEnabled) {
                $scope.formStatus.submitting = true;
                $scope.checkDuplicateCompany().success(function (response) {
                    if (response.email) {
                        $scope.userData.duplicateEmail = response.email;
                        $http.post('/companies/duplicate-registration', {'userHashId': response.userHashId, 'companyHashId': response.companyHashId}).success(function () {
                            $scope.formStatus.submitting = false;
                        })
                    } else {
                        $scope.createCompany(params, enhanceDataLayer);
                    }
                })
            } else {
                $scope.createCompany(params, enhanceDataLayer);
            }
        }

        $scope.createCompany = function (params, enhanceDataLayerCallback) {

            $scope.formStatus.submitting = true;
            if (!params.types || params.types.length === 0) {
                params.types = Object.values(params.multipleTypes).flat();
            }

            $http.post($scope.submitUrl, params).success(function (data, status) {
                if (status < 200 && status >= 300) {
                    handleError(params);
                    return;
                }

            enhanceDataLayerCallback(params, data);

                var dataLayerDelay = 500;
                setTimeout(function () {
                    params.businessUnit === 'home' ? $window.location = data.user_activation_url : $window.location = $scope.successUrl;
                }, dataLayerDelay);
            })
        }

        /**
         * Retries to send the form submission once. Shows an error message to the user if the second attempt fails.
         */
        function handleError(params) {
            $scope.submitErrorCount = $scope.submitErrorCount + 1;
            switch ($scope.submitErrorCount) {
                case 1: // Retry..
                    submitForm(params);
                    break;
                case 2: // Warn user
                default:
                    $scope.formStatus.submitting = false;
                    $scope.submitErrorCount = 0;
                    window.alert('We are unable to send your quote request at this time. Please try again in a few minutes.');
                    break;
            }
        }

        $scope.checkDuplicateCompany = function () {
            let email = $scope.data.contact_email;
            let companyNumber = $scope.data.company_number || null;
            let phoneNumber = $scope.data.contact_telephone;
            return $http.get('/companies/get-duplicate-account-data?' +
                'email=' + encodeURIComponent(email) +
                '&companyNumber=' + encodeURIComponent(companyNumber) +
                '&phoneNumber=' + encodeURIComponent(phoneNumber) +
                '&countryIso=' + $scope.countryIso);
        }

        $scope.toggleHint = function (step, question) {
            $scope.hintsState[step][question] = !$scope.hintsState[step][question];
            if ($scope.hintsState[step][question]) {
                $timeout(() => {
                    document.body.addEventListener('click', () => {
                        $scope.hintsState[step][question] = false;
                        $scope.$apply()
                    }, {once: true});
                }, 1);
            }
        };

        function getExperimentData() {
            let data = {};
            let ab_test = document.body.dataset.ab;
            let ab_test_optimize_id = document.body.dataset.abTestOptimizeId;
            let optimizeVariantIndex = undefined;

            if (window.google_optimize && ab_test_optimize_id) {
                optimizeVariantIndex = window.google_optimize.get(ab_test_optimize_id);
                if (typeof optimizeVariantIndex !== 'undefined') {
                    const active_variant = String.fromCharCode(optimizeVariantIndex + 64 + 1).toLowerCase();
                    if (active_variant !== document.body.dataset.abTestVersion.toLowerCase()) {
                        console.error(`Incorrect google optimize version detected. Expected(optimize): ${active_variant}, actual: ${document.body.dataset.abTestVersion}`);
                    }
                }
            }
            if (ab_test) {
                data['ab_test'] = ab_test;
            }

            if (typeof optimizeVariantIndex !== 'undefined') {
                data['ab_test_optimize_id'] = ab_test_optimize_id;
            }

            return data;
        }

        $scope.resetCompanyNumber = function () {
            $scope.data.company_number = null;
            $scope.data.company_number2 = null;
        }
    });

},{}],43:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('FieldOfStudyController', function ($scope, multiStepFormInstance, TranslationService, sdLocalStorageHelper) {
    $scope.$watchCollection('data.types', function () {
        sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
    });

    $scope.studyFieldsMax = 6;

    if ($scope.$parent && $scope.$parent.registerStepController) {
        $scope.$parent.registerStepController(multiStepFormInstance.getActiveIndex(), $scope);
    }

    $scope.getGAFormData = function () {
        return {
            category_ids: $scope.data.fieldsOfStudy.map(Number),
        };
    }

    $scope.getGAFormErrorData = function () {
        return {
            0: {
                error_field: 'category_ids',
                error_type: 'required',
            }
        };
    };

    $scope.showAddFieldButton = function () {
        return $scope.data.fieldsOfStudy.length < $scope.studyFieldsMax;
    };

    $scope.addField = function () {
        var index = $scope.data.fieldsOfStudy.length;
        if (index < $scope.studyFieldsMax) {
            $scope.data.fieldsOfStudy[index] = '';
            var label;
            if (index < 3) {
                label = TranslationService.trans('b2b_homedeal.registration_flow.field-of-study.label_'+index);
            } else {
                label = TranslationService.trans('b2b_homedeal.registration_flow.field-of-study.label_more');
            }

            $scope.data.labels[index] = label;
        }
        multiStepFormInstance.getActiveStep().submitted = false;
    };

    $scope.removeField = function (key) {
        if ($scope.data.fieldsOfStudy.length > 1) {
            $scope.data.fieldsOfStudy.splice(key, 1);
        }
    };

    $scope.$watchCollection('data.fieldsOfStudy', function (newValue, oldValue) {
        oldValue.forEach(function (id) {
            if (newValue.indexOf(id) === -1) {
                delete($scope.data.multipleTypes[id]);
            }
        });

        $scope.data.fieldsOfStudy.forEach(function (fieldId) {
            if (!angular.isDefined($scope.data.multipleTypes[fieldId]) || $scope.data.multipleTypes[fieldId].length === 0) {
                $scope.data.multipleTypes[fieldId] = $scope.getTypesForCategory(fieldId);
            }
        });
    });

    $scope.selected = function (typeId) {
        return $scope.data.fieldsOfStudy.includes(typeId.toString());
    };

    if ($scope.data.fieldsOfStudy.length < 1) {
        $scope.addField();
    }

    $scope.isCategoryPreselected = function (typeId, index) {
        return ($scope.data.fieldsOfStudy[index] == typeId);
    };

    $scope.getTypesForCategory = function (categoryId) {
        let category = $scope.allCategories.find(category => category.site.id === parseInt(categoryId));
        if (category) {
            return category.site.types;
        }
        return [];
    }
});

},{}],44:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('GettingStartedController', function ($scope, $cookies, sdLocalStorageHelper) {
    // Retrieve hero form details saved in cookie
    var b2bFormDetails = sdLocalStorageHelper.get('b2bFormDetails', $scope.data);
    var referralDetails = sdLocalStorageHelper.get('referralDetails', $scope.data);

    $scope.data.prename = b2bFormDetails.prename;
    $scope.data.name = b2bFormDetails.name;
    $scope.data.contact_email = b2bFormDetails.contact_email;

    if (angular.isDefined(referralDetails) && angular.isDefined(referralDetails.referralEmail) && angular.isDefined(referralDetails.referralCompanyId)) {
        $scope.data.referralEmail = referralDetails.email;
        $scope.data.referralCompanyId = referralDetails.referral;
    }
});

},{}],45:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('LeadTypesController', function ($scope, multiStepFormInstance, sdLocalStorageHelper, $timeout, TranslationService) {

    const pianoTypeName = 'piano';

    $scope.validationHintMessage = undefined;
    $scope.pianoSelected = false;

    if ($scope.$parent && $scope.$parent.registerStepController) {
        $scope.$parent.registerStepController(multiStepFormInstance.getActiveIndex(), $scope);
    }

    $scope.getGAFormData = function () {
        return {
            types: $scope.data.types,
        };
    }

    $scope.getGAFormErrorData = function () {
        let errorsData = [];

        errorsData.push({
            error_field: 'types',
            error_type: 'required',
        });

        return errorsData;
    };

    $scope.$watchCollection('data.types', function () {
        sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
        setFormValidity();
        $scope.validationHintMessage = getValidationHintMessage();
        $scope.pianoSelected = hasPianoTypeSelected();
    });

    $scope.toggleCheckbox = function(typeId, event) {
        var input = angular.element(event.currentTarget).find('input');
        var checked = input[0].checked;

        $timeout(function () {
            var idx = $scope.data.types.indexOf(typeId);
            if (idx >= 0 && checked) {
                $scope.data.types.splice(idx, 1);
            }
            if (idx < 0 && !checked) {
                $scope.data.types.push(typeId);
            }
        });
    };

    $scope.stopPropagation = function (event) {
        event.stopPropagation();
        event.preventDefault();
    };

    $scope.checked = function (typeId) {
        return $scope.data.types.indexOf(typeId) !== -1;
    };

    function hasPianoTypeSelected() {
        return $scope.data.types.filter(function (typeId) {
            return $scope.typesMap[typeId] === pianoTypeName
        }).length > 0;
    }

    function setFormValidity() {
        if ($scope.data.types.length === 0) {
            $scope.lead_types.$setValidity('required', false);
        } else {
            $scope.lead_types.$setValidity('required', true);
        }
    }

    function getValidationHintMessage() {
        if ($scope.data.types.length === 0 || (hasPianoTypeSelected() && $scope.data.types.length === 1)) {
            return undefined;
        }

        $scope.data.types.sort(function(a, b) {
            return a - b;
        });

        let typeKeysArray = $scope.data.types
            .filter(function (typeId) { //Filtering selected type to exclude piano since it's handled separately
                return $scope.typesMap[typeId] !== pianoTypeName;
            })
            .map(function (typeId) {
                return $scope.typesMap[typeId];
            })
        const translationKey = 'b2b_move_registration.step.lead_types.validation_hint.' + typeKeysArray.join('_');
        return TranslationService.trans(translationKey);
    }
});

},{}],46:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('MultipleSitesLeadTypesController', function ($scope, sdLocalStorageHelper, multiStepFormInstance) {

    $scope.$watchCollection('data.fieldsOfStudy', function () {
        sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
    });

    if ($scope.$parent && $scope.$parent.registerStepController) {
        $scope.$parent.registerStepController(multiStepFormInstance.getActiveIndex(), $scope);
    }

    $scope.getGAFormData = function () {

        const gaData = { categories: {} };
        let data = $scope.data.multipleTypes;

        for (const categoryId in data) {
            gaData.categories[categoryId] = {
                types: data[categoryId]
            };
        }

        return gaData;
    }

    $scope.getGAFormErrorData = function () {
        let errorsData = [];
        const categories = $scope.getGAFormData().categories;

        for (const categoryId in categories) {
            const types = categories[categoryId].types;
            if (types.length === 0) {
                errorsData.push({
                    error_field: `category_${categoryId}_types`,
                    error_type: 'required',
                });
            }
        }

        return errorsData;
    };

    $scope.siteAdded = function (id) {
        return $scope.data.fieldsOfStudy.indexOf(id.toString()) > -1;
    };
});

},{}],47:[function(require,module,exports){
/*globals ga:true */

angular.module('b2bRegistrationFlowBundle').controller('stepController', function ($rootScope, $scope, $http, multiStepFormInstance, TranslationService, $timeout, sdLocalStorageHelper, $anchorScroll, $window) {
    sdLocalStorageHelper.get('referralDetails', $scope.data);

    $scope.stepControllers = {};
    $scope.wentBack = false;
    $scope.registerStepController = function(index, ctrlScope) {
        $scope.stepControllers[index] = ctrlScope;
    };

    $scope.onProgressBarClick = function (index, step) {
        if (multiStepFormInstance.getActiveIndex() > index) {
            sendFormInteractionEvent('return');
            multiStepFormInstance.setActiveIndex(step);
        }
    }

    $scope.completedSteps = {};
    sdLocalStorageHelper.get('b2bFormCompletedSteps', $scope.completedSteps);
    $scope.$watchCollection('completedSteps', function () {
        sdLocalStorageHelper.set('b2bFormCompletedSteps', $scope.completedSteps);
    });

    $timeout(function () {
        activate();
    }, 1);

    function activate() {
        switchToPreviousNotVisitedStep();
        subscribeGAStepTrackChange();
    }

    $scope.isStepValid = function () {
        return (!multiStepFormInstance.getActiveStep().hasForm || multiStepFormInstance.getActiveStep().valid);
    };

    function markCurrentStepsAsCompleted() {
        const currentStep = multiStepFormInstance.getActiveStep();
        $scope.completedSteps[currentStep.title] = true;
    }

    $scope.progress = function () {
        $scope.wentBack = false;
        multiStepFormInstance.getActiveStep().submitted = true

        if ($scope.formStatus.pending) {
            $scope.formStatus.submitting = true;
            var unwatch = $scope.$watch('formStatus.pending', function (pending) {
                if (!pending) {
                    unwatch();
                    $scope.formStatus.submitting = false;
                    $scope.progress();
                }
            });
            return;
        }

        if (!$scope.isStepValid()) {
            sendFormInteractionEvent('error');
            scrollToInvalidQuestion();
            return;
        }

        sendFormInteractionEvent('submit');

        markCurrentStepsAsCompleted();
        if (multiStepFormInstance.isLast()) {
            $scope.submitCompanyRegistration();
            return;
        }
        multiStepFormInstance.nextStep();
    };

    $scope.goToPreviousStep = function () {
        sendFormInteractionEvent('return');
        $scope.wentBack = true;

        multiStepFormInstance.previousStep();
    }

    function sendFormInteractionEvent(interactionType) {
        try {

            if (!['submit', 'return', 'view', 'error'].includes(interactionType)) {
                console.error('Error sending form interaction event: Invalid interaction type: ' + interactionType);

                return;
            }

            let gaFormInteractionData = getFormInteractionDataLayerObject(interactionType);
            const ctrl = $scope.stepControllers[multiStepFormInstance.getActiveIndex()];
            if (['submit', 'error'].includes(interactionType)) {
                gaFormInteractionData.form_value = ctrl.getGAFormData()
            }

            if (['error'].includes(interactionType)) {
                gaFormInteractionData.error_data = ctrl.getGAFormErrorData()
            }

            $window.dataLayer = $window.dataLayer || [];
            $window.dataLayer.push(gaFormInteractionData);

        } catch (e) {
            console.error('Error sending form interaction event: ', e);
        }
    }

    function getFormInteractionDataLayerObject(interactionType) {
        let data = {
            event: 'form_interaction',
            form_id: $('[data-b2b-form-authcode]').attr('data-b2b-form-authcode'),
            form_name: 'business_registration',
            form_interaction: interactionType,
            form_step: multiStepFormInstance.getActiveIndex(),
            form_step_name: multiStepFormInstance.getActiveStep().title,
            form_total_steps: multiStepFormInstance.getSteps().length,
        };

        let abVersion  = document.body.getAttribute('data-ab');
        if (abVersion) {
            data.ab_test_variant = abVersion;
        }

        return data;
    }

    function scrollToInvalidQuestion()
    {
        var scrollElement;
        var invalidQuestions = $('input.ng-invalid:visible, select.ng-invalid:visible, textarea.ng-invalid:visible, input.ng-pending');
        if (invalidQuestions.length > 0) {
            var firstInvalidQuestion = invalidQuestions.first();
            if (firstInvalidQuestion.closest('.form-group').length > 0) {
                scrollElement = firstInvalidQuestion.closest('.form-group').get(0);
            } else {
                scrollElement = firstInvalidQuestion.get(0);
            }
        }

        if (scrollElement) {
            scrollElement.scrollIntoView({behavior: 'smooth'});
        }
    }

    $scope.getCurrentStep = function () {
        return multiStepFormInstance.activeIndex;
    }

    $scope.getStepsNumbers = function () {
        return Array.from(Array(multiStepFormInstance.steps.length).keys());
    }

    $scope.getNextStepName = function () {
        return multiStepFormInstance.isLast() ? null : multiStepFormInstance.getSteps()[multiStepFormInstance.getActiveIndex()].title;
    };

    $scope.getPreviousStepName = function () {
        return multiStepFormInstance.isFirst() ? null : multiStepFormInstance.getSteps()[multiStepFormInstance.getActiveIndex() - 2].title;
    };

    $scope.stepChange = function () {
        $scope.scrollToTop();
        sendFormInteractionEvent('view');
    };

    $scope.scrollToTop = function () {
        var formStep = document.getElementsByClassName('form-step')[0];

        if (typeof formStep !== 'undefined') {
            window.scrollTo(0, formStep.offsetTop);
        }
    };

    $scope.onStepChange = function () {
        $rootScope.activeIndex = multiStepFormInstance.getActiveIndex();
        $anchorScroll('registration-header');

        sendFormInteractionEvent('view');
    };

    function subscribeGAStepTrackChange() {
        // that is not done inside of stepChange() to not send an event on the initial controller loading
        multiStepFormInstance.deferred.promise.then(null, null, function (state) {
            if (angular.isDefined(state.newStep)) {
                $timeout(function () {
                    if (typeof ga !== 'undefined' && typeof ga.getAll === 'function') {
                        var trackers = ga.getAll();
                        for (var key in trackers) {
                            trackers[key].send('pageview', {'location': window.location.href});
                        }
                    }
                }, 10);
            }
        });
    }

    function switchToPreviousNotVisitedStep() {
        const currentIndex = multiStepFormInstance.getActiveIndex();

        // iterate over multiStepFormInstance.getSteps(), and if any step before the current one is not completed,
        // call multiStepFormInstance.setActiveIndex with the index and stop loop
        // Step is completed if title is resent in the completedSteps
        for (let i = 0; i < currentIndex; i++) {
            let step = multiStepFormInstance.getSteps()[i];
            if (typeof $scope.completedSteps[step.title] === 'undefined') {
                multiStepFormInstance.setActiveIndex(i+1); // setActiveIndex is 1-based
                break;
            }
        }
    }
});

},{}],48:[function(require,module,exports){
/*globals google*/
angular.module('b2bRegistrationFlowBundle').directive('locationGoogleMap', function () {
    return {
        restrict: 'AE',
        scope: {
            updateresults: "&",
            radius: '=radius',
            location: '=location',
            place: '=place',
            iso: '@',
        },
        template: '<div id="map" style="width: 100%; height: 400px">' +
            '</div>',
        replace: true,
        controller: function ($scope, $element, $window, $http, googleMapLocationApi) {

            let map;
            let circle;
            let marker;

            function removeExistingPlaceAutoCompleteContainers() {
                const elements = document.querySelectorAll('.pac-container');
                for (const e of elements) {
                    e.remove();
                }
            }

            function initMap(initialCenter) {
                const googleMap = $element[0];

                map = new google.maps.Map(googleMap, {
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    center: initialCenter,
                    zoom: 7
                });

                const card = document.getElementById("pac-card");
                const input = document.getElementById("pac-input");

                const options = {
                    fields: ["formatted_address", "geometry", "name"],
                    strictBounds: false,
                    componentRestrictions:  { country: $scope.iso },
                };

                map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);

                const autocomplete = new google.maps.places.Autocomplete(input, options);

                // Bind the map's bounds (viewport) property to the autocomplete object,
                // so that the autocomplete requests use the current map bounds for the
                // bounds option in the request.
                autocomplete.bindTo("bounds", map);

                marker = new google.maps.Marker({
                    map,
                    anchorPoint: new google.maps.Point(0, -29),
                });

                autocomplete.addListener("place_changed", () => {
                    $scope.place = autocomplete.getPlace();

                    if (!$scope.place.geometry || !$scope.place.geometry.location) {
                        return;
                    }
                    $scope.location = $scope.place.formatted_address;

                    placeLoaded();
                });

                if ($scope.location) {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ address: $scope.location }, function(results, status) {
                        if (status === 'OK' && results[0]) {
                            const location = results[0].geometry.location;
                            $scope.place = {
                                formatted_address: results[0].formatted_address,
                                geometry: {
                                    location: location,
                                    viewport: results[0].geometry.viewport
                                }
                            };

                            // Need to call $apply because we're inside a callback
                            $scope.$apply(() => {
                                placeLoaded();
                            });
                        }
                    });
                }
            }

            var placeLoaded = function () {
                updateLocationResult(
                    $scope.place.geometry.location.lat(),
                    $scope.place.geometry.location.lng(),
                    $scope.place.formatted_address
                );

                // Create or update the circle
                if (!circle) {
                    circle = new google.maps.Circle({
                        strokeColor: '#77abe9',
                        strokeOpacity: 0.75,
                        fillColor: '#77abe9',
                        fillOpacity: 0.25,
                        map: map,
                        radius: getRadius(),
                    });
                }

                updateCircle();

                marker.setPosition($scope.place.geometry.location);
                marker.setVisible(true);
                map.setZoom(8);
            }

            var updateLocationResult = function (lat, long, address) {
                $scope.updateresults(
                    {
                        $value: {
                            lat: lat,
                            long: long,
                            address: address,
                        }
                    });
            }

            removeExistingPlaceAutoCompleteContainers();

            //Timeout added as all HTML elements required by google widget must be loaded at first
            setTimeout(() => {
                const geocoder = new google.maps.Geocoder();

                geocoder.geocode({ componentRestrictions: { country: $scope.iso } }, function(results, status) {
                    if (status === 'OK' && results[0]) {
                        const location = results[0].geometry.location;
                        const center = {
                            lat: location.lat(),
                            lng: location.lng()
                        };
                        googleMapLocationApi.then(() => initMap(center));
                    } else {
                        // fallback to neutral default
                        googleMapLocationApi.then(() => initMap({ lat: 0, lng: 0 }));
                    }
                });
            }, 500);

            var getRadius = function() {
                if(!$scope.radius || $scope.radius < $window.b2bFreetrialConstraint.radiusMin) {
                    return $window.b2bFreetrialConstraint.radiusMin * window.unitMultiplier;
                }
                if ($scope.radius > $window.b2bFreetrialConstraint.radiusMax) {
                    return $window.b2bFreetrialConstraint.radiusMax * window.unitMultiplier;
                }
                return $scope.radius * window.unitMultiplier;
            };

            $scope.$watch('radius', function () {
                if (typeof map === 'undefined' || !$scope.place) {
                    return;
                }
                circle.setRadius(getRadius());
                map.fitBounds(circle.getBounds());
            });

            var updateCircle = function () {
                if (!$scope.place || !circle) return;

                const location = $scope.place.geometry.location;

                if ($scope.place.geometry.viewport) {
                    map.fitBounds($scope.place.geometry.viewport);
                } else {
                    map.setCenter(location);
                }

                circle.setMap(map);
                circle.setCenter(location);
                map.fitBounds(circle.getBounds());
            };
        }
    };
});

},{}],49:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').service('googleMapLocationApi', function googleMapLocationApi($window, $q) {

    $window.initAutocomplete = function () {
        deferred.resolve();
    };

    var s = document.createElement('script');
    s.src = '//maps.googleapis.com/maps/api/js?language=' + $window.siteLanguage
        + '&callback=initAutocomplete&key=' + $window.google_api_key
        + '&libraries=places';
    document.body.appendChild(s);

    var deferred = $q.defer();

    return deferred.promise;
});

},{}],50:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').directive('stickyButton', function () {
    return function($scope, element) {
        let toggleVisibility = function() {
            let navigationPanel = document.querySelector('.navigation');

            let isNavigationInVisible = navigationPanel.getBoundingClientRect().top < 0 || navigationPanel.getBoundingClientRect().bottom > window.innerHeight;
            if (isNavigationInVisible) {
                element.addClass('d-block');
                element.removeClass('d-none');
            } else {
                element.addClass('d-none');
                element.removeClass('d-block');
            }
        };
        document.addEventListener('scroll', toggleVisibility, true);
        //Adding a timeout for the map to load
        $scope.$watch('data.radius_postcode', function () {setTimeout(toggleVisibility, 500)}, true);
    };
});

},{}],51:[function(require,module,exports){
/*globals b2bFreetrialConstraint:true google:true */

angular.module('b2bRegistrationFlowBundle').controller('WorkingAreasController', function ($scope, $modal, sdLocalStorageHelper, $localStorage, multiStepFormInstance) {

    versionLocalStorage();

    if ($scope.$parent && $scope.$parent.registerStepController) {
        $scope.$parent.registerStepController(multiStepFormInstance.getActiveIndex(), $scope);
    }

    $scope.getGAFormData = function () {

        let formData = {};
        if ($scope.data.area_tool === 'regions') {

            const regionIds = [];
            const subRegionIds = [];

            $scope.data.regions.forEach(item => {
                const [region, subregion] = item.split('_');
                if (!regionIds.includes(region)) {
                    regionIds.push(region);
                }
                if (subregion) {
                    subRegionIds.push(subregion);
                }
            });

            formData = {
                area_tool: $scope.data.area_tool,
                regions: regionIds,
                subRegions: subRegionIds,
            }
        }

        if ($scope.data.area_tool === 'radius') {
            formData = {
                area_tool: $scope.data.area_tool,
                radius: $scope.data.radius,
                location: $scope.data.location.label,
            }
        }

        return formData;
    }

    $scope.getGAFormErrorData = function () {
        return {
            0: {
                error_field: $scope.data.area_tool ? $scope.data.area_tool : 'area_tool',
                error_type: 'required',
            }
        };
    };

    let isLondon = false;
    let savedDistanceUnit = '';

    $scope.stepsData = sdLocalStorageHelper.get('stepsData', $scope.stepsData);
    $scope.stepsData.freetrialConstraints = b2bFreetrialConstraint;

    $scope.showMap = false;
    $scope.stateIdMap = [];
    $scope.showEmptyResultMessage = false;
    $scope.areasLoaded = false;

    if ($scope.stepsData.areas_panel_type === 'radius') {
        $scope.data.area_tool = 'radius';
    }

    $scope.$watchCollection('stepsData', function () {
        sdLocalStorageHelper.set('stepsData', $scope.stepsData);
    });

    $scope.$watchCollection(['data.regions', 'data.subRegions'], function () {
        sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
    });
    
    $scope.$watch('stepsData.areas_panel_type', function (newPanel, currentPanel) {
        if ($scope.data.area_tool === '') {
            $scope.data.area_tool = newPanel;
        }

        if (newPanel !== currentPanel) {
            $scope.data.area_tool = newPanel;
        }
    });

    //todo: remove this function after BE area check is re-designed
    $scope.updateRegionModel = function (checked, subRegions, currentParentId) {
        if (checked) {
            const subRegionsArray = subRegions.split('_');
            const regionId = $scope.data.regions[0].substring(0, 2);
            $scope.data.regions = [];
            $scope.data.regions.push(regionId);
            subRegionsArray.forEach(function (subRegionId) {
                subRegionId = regionId + '_' + subRegionId;
                $scope.data.regions.push(subRegionId);
            });
        } else {
            if ($scope.data.regions[0] && $scope.data.regions[0].substring(0, 2) == currentParentId) {
                $scope.data.regions = [];
            }
        }
    };

    $scope.changeParent = function (parentRegionId, subRegionIds) {
        const subRegionIdsArray = subRegionIds.split('|');
        const count = subRegionSelectedCount(parentRegionId, subRegionIdsArray);

        if (count === 0) {
            $scope.uncheckRegion(parentRegionId);
        }

        if (count === subRegionIdsArray.length && $scope.data.regions.indexOf(parentRegionId) === -1) {
            $scope.data.regions.push(parentRegionId);
        }
    };

    $scope.notNumericArea = function (id) {
        return isNaN(id);
    };

    $scope.updateSelectionSummary = function (checked, state, region) {
        let index;
        if (checked) {
            if (!(state in $scope.stepsData.areaSelectionSummary)) {
                $scope.stepsData.areaSelectionSummary[state] = [];
            }
            index = $scope.stepsData.areaSelectionSummary[state].indexOf(region);
            if (index === -1) {
                $scope.stepsData.areaSelectionSummary[state].push(region);
            }
        } else if (Object.prototype.hasOwnProperty.call($scope.stepsData.areaSelectionSummary, state)) {
            index = $scope.stepsData.areaSelectionSummary[state].indexOf(region);
            if (index > -1) {
                $scope.stepsData.areaSelectionSummary[state].splice(index, 1);
            }

            if ($scope.stepsData.areaSelectionSummary[state].length === 0) {
                delete $scope.stepsData.areaSelectionSummary[state];
            }
        }
    };

    $scope.selected = function (typeId) {
        return $scope.data.fieldsOfStudy.includes(typeId.toString());
    };

    $scope.isCategoryPreselected = function (typeId, index) {
        return ($scope.data.fieldsOfStudy[index] == typeId);
    };

    $scope.shouldChange = function (checked, level, country, selectedRegionId, selectedSubRegionId, isParent) {
        const regionsSelected = $scope.data.regions;
        if (angular.isDefined(isParent)) {
            isParent = (isParent === 'true');

            if (isParent && !$scope.stepsData.allChildrenUnchecked) {
                return true;
            }

            if (!isParent && !$scope.stepsData.allChildrenUnchecked) {
                return false;
            }
        }

        if (angular.isDefined(selectedSubRegionId) && angular.isDefined(selectedRegionId)) {
            return !(checked && hasExceededMaxParentRegions(regionsSelected, selectedRegionId));
        }

        return !(checked && hasExceededMaxTopRegions(country, regionsSelected, level, selectedRegionId, selectedSubRegionId));
    };

    $scope.isIndeterminate = function (regionId, subRegionIds) {
        const subRegionIdsArray = subRegionIds.split('|');

        const count = subRegionSelectedCount(regionId, subRegionIdsArray);

        return count > 0 && count < subRegionIdsArray.length;
    };

    $scope.uncheckRegion = function (state, region) {
        let predicateId = state;

        if ($scope.notNumericArea(state)) {
            predicateId = $scope.stateIdMap[state + '->' + region];
        }

        $scope.data.regions = $scope.data.regions.filter(function (regionId) {
            if (regionId !== predicateId) {
                return regionId;
            }
        });

        $scope.updateSelectionSummary(false, state, region);
    };

    $scope.checkMaxReached = function (checked, level, country, selectedRegionId, selectedSubRegionId) {
        const regionsSelected = $scope.data.regions;
        const modalConfig = {
            templateUrl: '/companies/move-redesign/company-registration-area-warning-max-modal.html',
            windowClass: 'show',
            backdropClass: 'show'
        };

        if (angular.isDefined(selectedSubRegionId)) {
            if (checked && hasExceededMaxParentRegions(regionsSelected, selectedRegionId)) {
                $modal.open(modalConfig);
            }
        } else if (checked && hasExceededMaxTopRegions(country, regionsSelected, level, selectedRegionId, selectedSubRegionId)) {
            $modal.open(modalConfig);
        }
    };

    $scope.prepareRadiusOptions = function (distanceUnit) {
        $scope.setFreeTrialRadiusDistance();
        savedDistanceUnit = distanceUnit;
        const divider = isLondon ? 1 : 5;
        const range = Array
            .from(
                {length: $scope.stepsData.freetrialConstraints.radiusMax - $scope.stepsData.freetrialConstraints.radiusMin + 1},
                (_, i) => $scope.stepsData.freetrialConstraints.radiusMax - i);
        $scope.radiusOptions = range
            .filter(optionNumber => {
                if (optionNumber % divider === 0 && optionNumber !== 0) {
                    return optionNumber;
                }
            })
            .map(optionNumber => {
                return {
                    value: optionNumber,
                    text: `${optionNumber} ${savedDistanceUnit}`
                }
            });
        //Setting first option as selected in radius select
        $scope.data.radius = $scope.radiusOptions[0].value;
    }

    $scope.setFreeTrialRadiusDistance = function () {
        if (typeof b2bFreetrialConstraint.orginalRadiusMin === 'undefined') {
            b2bFreetrialConstraint.orginalRadiusMin = b2bFreetrialConstraint.radiusMin;
            b2bFreetrialConstraint.orginalRadiusMax = b2bFreetrialConstraint.radiusMax;
        }
        if (isLondon) {
            b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.radiusMinLondon;
            b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.radiusMaxLondon;
        } else {
            b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.orginalRadiusMin;
            b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.orginalRadiusMax;
        }
    }

    $scope.checkIfLondon = function (location) {
        if (location.address.toUpperCase().includes('LONDON')) {
            isLondon = true;
            $scope.prepareRadiusOptions(savedDistanceUnit);
        } else {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                location: {
                    lat: $scope.data.location.lat,
                    lng: $scope.data.location.long,
                }
            }).then(({results}) => {
                if (results && results[0]) {
                    const filteredPostCode = results.find(({types}) => types[0] === 'postal_code').address_components[0].long_name;
                    const londonRegex = /^(E|EC|N|NW|SE|SW|W|WC|BR|CR|DA|EN|HA|IG|KT|RM|SM|TW|UB|WD)\d{1,2}/i;
                    if (londonRegex.test(filteredPostCode)) {
                        isLondon = true;
                        $scope.prepareRadiusOptions(savedDistanceUnit);
                    } else {
                        isLondon = false;
                        $scope.prepareRadiusOptions(savedDistanceUnit);
                    }
                }
            })
                .catch((error) => console.error(error));
        }
    }

    $scope.onAreasLoaded = function () {
        $scope.areasLoaded = true;
    }

    $scope.onLocationResultUpdated = function ($value) {
        if (!$scope.data.location) {

            $scope.data.location = {
                label: $scope.data.place ? $scope.data.place.formatted_address : $scope.data.radius_postcode
            };
        }


        $scope.data.location.lat = typeof ($value.lat) === 'function' ? $value.lat() : $value.lat;
        $scope.data.location.long = typeof ($value.long) === 'function' ? $value.long() : $value.long;
        $scope.showEmptyResultMessage = false;
        if ($value.lat && $value.long && $scope.working_areas['data.location.label']) {
            $scope.showMap = true;
            $scope.working_areas['data.location.label'].$invalid = false;
            if (this.brandName === 'getamover.co.uk') {
                $scope.checkIfLondon($value);
            }
        }

        // Add timeout to prevent: "Error: [$rootScope:inprog] $digest already in progress"
        // $scope.$apply(); added to force $scope update after triggering that in a directive
        setTimeout(function () {
            $scope.$apply();
        }, 200);
    };

    $scope.onInputFocusLost = function () {
        $scope.showEmptyResultMessage = false;
        setTimeout(function () {
            if (!$scope.data.location.lat || !$scope.data.location.long) {
                $scope.working_areas['data.location.label'].$invalid = true;
                $scope.working_areas['data.location.label'].$error = {required: true};

                $scope.$apply();
            }
        }, 200);
    }

    $scope.handleUserLocationInput = function () {
        let element = $scope['working_areas']['data.location.label'];
        if (!(element.$dirty) || !$scope.data.location.label) {
            $scope.showEmptyResultMessage = false
            return;
        }

        setTimeout(() => {
            const dropdownList = document.getElementsByClassName('pac-container')[0];
            $scope.showEmptyResultMessage = dropdownList.childElementCount === 0;
            $scope.$apply();
        }, 200);
    }

    $scope.updateLocation = function () {
        if ($scope.data.location) {
            $scope.data.location.label = $scope.data.place ? $scope.data.place.formatted_address : $scope.data.radius_postcode;
        }
    };

    function hasExceededMaxParentRegions(regionsSelected, selectedRegionId) {
        if (regionsSelected.length === 0) {
            return false;
        }
        let currentParentId = regionsSelected[0].substring(0, 2);
        return (!(selectedRegionId == currentParentId));
    }

    function hasExceededMaxTopRegions(country, regionsSelected, level, selectedRegionId) {
        const countriesMax = ['DE', 'ES', 'FR', 'IT', 'AE'];
        if (countriesMax.indexOf(country) > -1 && hasExceededCountryMaxTopRegions(regionsSelected, selectedRegionId, country)) {
            return true;
        }
        return regionsSelected.length >= b2bFreetrialConstraint.levelMax[level];
    }

    function hasExceededCountryMaxTopRegions(regionsSelected, selectedRegionId, country) {
        let regionsIds = [];

        switch (country) {
            case 'DE':
                regionsIds = ['42167', '42174', '42180'];
                break;
            case 'ES':
                regionsIds = ['25856', '25875'];
                break;
            case 'FR':
                regionsIds = ['15121', '16194', '16232', '16274', '15235', '15357', '16108', '16321'];
                break;
            case 'IT':
                regionsIds = ['21141', '22337'];
                break;
            case 'AE':
                regionsIds = ['108275', '108276'];
                break;
        }

        let i = 0;

        // AE does not allow selecting two defined regions at the same time
        if (country === 'AE') {
            for (; i < regionsSelected.length; i++) {
                if (regionsSelected[i] !== selectedRegionId && regionsIds.indexOf(regionsSelected[i]) >= 0 && regionsIds.indexOf(selectedRegionId) >= 0) {
                    return true;
                }
            }
            return false;
        }

        // rest of the exceptions countries does not allow any regions except defined ones
        for (; i < regionsSelected.length; i++) {
            if (regionsIds.indexOf(regionsSelected[i]) >= 0 || regionsIds.indexOf(selectedRegionId) >= 0) {
                return true;
            }
        }
        return false;
    }

    function versionLocalStorage() {
        const localStorageData = $localStorage['stepsData'];

        if (localStorageData && $scope.stepsData.version !== localStorageData.version) {
            sdLocalStorageHelper.set('stepsData', undefined);
            $scope.data.regions = [];
            $scope.stepsData.areas_panel_type = $scope.data.area_tool;
        }
    }

    function subRegionSelectedCount(regionId, subRegionIdsArray) {
        return subRegionIdsArray.reduce(function (acc, item) {
            const searchId = regionId + '_' + item;
            if ($scope.data.regions.indexOf(searchId) > -1) {
                acc++;
            }
            return acc;
        }, 0);
    }
});

},{}],52:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').controller('ThankYouPageController', function ($scope, $sessionStorage, spContactEmailSessionKey) {
    $scope.registeredEmail = $sessionStorage[spContactEmailSessionKey];
});

},{}],53:[function(require,module,exports){
angular.module('b2bRegistrationFlowBundle').component('b2bPostalCodeTypeahead', {
    templateUrl: 'b2b-post-code-typeahead-template.html',
    bindings: {
        data: '=',
        formControl: '<',
        propertyName: '@',
        translations: '@',
        typeaheadUrl: '@',
        validationUrl: '@'
    },
    controller: function ($scope, $http, $timeout) {
        var ctrl = this;
        ctrl.minLength = 4;
        ctrl.postalCodeSelected = '';
        ctrl.formControl = undefined;
        ctrl.translationObject = undefined;
        var propPathArray = [];
        var timeoutReference = undefined;
        var lastSelectedTypeaheadItem = undefined;

        $timeout(function () {
            activate();
        }, 1);

        function activate() {
            ctrl.translationObject = JSON.parse(ctrl.translations);
            propPathArray = ctrl.propertyName.split('.');
            if (propPathArray.length >= 2 && ctrl.data[propPathArray[1]]) {
                ctrl.postalCodeSelected = ctrl.data[propPathArray[1]];
                lastSelectedTypeaheadItem = ctrl.postalCodeSelected;
                ctrl.formControl.$setDirty();
                ctrl.validate(ctrl.postalCodeSelected, false);
            }
        }

        ctrl.getPostalCodes = function (viewValue) {
            return $http.jsonp(ctrl.typeaheadUrl, {
                params: {
                    'callback': 'JSON_CALLBACK',
                    'query': viewValue
                }
            }).then(function (response) {
                return response.data.map(function (item) {
                    item.region = JSON.parse(item.region);
                    return item;
                });
            });
        };

        ctrl.onItemSelect = function (item) {
            if (timeoutReference) {
                // here we canceling the blur validation which is triggered once user click on some element
                $timeout.cancel(timeoutReference);
            }
            ctrl.data[propPathArray[1]] = item.region.postcode;
            ctrl.postalCodeSelected = item.region.postcode;
            lastSelectedTypeaheadItem = item.region.postcode;
            ctrl.formControl.$setValidity('postcode', true);
            ctrl.validate(item.region.postcode, false);
        };

        ctrl.validate = function (postalCode, blur) {
            if (blur && (ctrl.postalCodeSelected && ctrl.postalCodeSelected.length < ctrl.minLength)) {
                ctrl.formControl.$setValidity('postcode', false);
                _validatePostcodeAsync(postalCode);
            } else if (blur) {
                timeoutReference = $timeout(function () {
                    _validatePostcodeAsync(postalCode);
                }, 200);
            } else {
                _validatePostcodeAsync(postalCode);
            }
        };

        ctrl.triggerChange = function () {
            if (
                ctrl.postalCodeSelected &&
                lastSelectedTypeaheadItem !== ctrl.postalCodeSelected &&
                ctrl.postalCodeSelected.length >= ctrl.minLength
            ) {
                var tmpPostalcodeStorage = ctrl.postalCodeSelected;
                ctrl.loadingPostcodes = true;
                ctrl.formControl.$setViewValue(' ');
                ctrl.formControl.$setPristine();
                $timeout(function () {
                    ctrl.formControl.$setViewValue(tmpPostalcodeStorage);
                    ctrl.formControl.$setPristine();
                });
            }

            lastSelectedTypeaheadItem = ctrl.postalCodeSelected;
        };

        function _validatePostcodeAsync(postalCode) {
            var url = ctrl.validationUrl + '/' + postalCode;
            $http.jsonp(url, {params: {'callback': 'JSON_CALLBACK'}})
                .then(function (response) {
                    $timeout.cancel(timeoutReference);
                    if (response.data) {
                        ctrl.formControl.$setPristine();
                    } else {
                        ctrl.formControl.$setDirty();
                    }
                    ctrl.formControl.$setValidity('postcode', response.data);
                }, function (error) {
                    $timeout.cancel(timeoutReference);
                    console.error(error); // eslint-disable-line no-console
                });
        }
    }
});

},{}]},{},[1]);
